{
  "level": "mt06a",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt06a",
    "objects": "AREAS.E3:mt06a.e3",
    "mesh": "TREES.E3:mt06a.e3"
  },
  "spawn_point": {
    "position": [
      -325.3128839726785,
      -2302.6208446743763,
      632.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -325.3128839726785,
      -2202.6208446743763,
      632.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -504.10089111328125,
      -2427.0,
      608.0
    ],
    "bbox_max": [
      -166.0,
      -2023.8939208984375,
      774.9957885742188
    ],
    "vertex_count": 2152,
    "vertices": [
      [
        -239.537109375,
        -2243.242431640625,
        629.0
      ],
      [
        -239.537109375,
        -2243.242431640625,
        660.0
      ],
      [
        -235.00689697265625,
        -2268.0,
        627.9925537109375
      ],
      [
        -235.00689697265625,
        -2268.0,
        642.8208618164062
      ],
      [
        -235.00689697265625,
        -2268.0,
        642.8208618164062
      ],
      [
        -236.58865356445312,
        -2268.0,
        644.1360473632812
      ],
      [
        -235.00689697265625,
        -2268.0,
        627.9925537109375
      ],
      [
        -236.58865356445312,
        -2268.0,
        628.7816162109375
      ],
      [
        -237.02639770507812,
        -2268.0,
        660.0
      ],
      [
        -237.02639770507812,
        -2268.0,
        644.5
      ],
      [
        -237.02639770507812,
        -2268.0,
        644.5
      ],
      [
        -237.02639770507812,
        -2268.0,
        629.0
      ],
      [
        -237.02639770507812,
        -2268.0,
        660.0
      ],
      [
        -239.537109375,
        -2265.92919921875,
        660.0
      ],
      [
        -239.537109375,
        -2268.0,
        660.0
      ],
      [
        -239.537109375,
        -2265.92919921875,
        660.0
      ],
      [
        -239.537109375,
        -2257.697509765625,
        660.0
      ],
      [
        -239.537109375,
        -2257.697509765625,
        660.0
      ],
      [
        -239.537109375,
        -2249.33642578125,
        660.0
      ],
      [
        -239.537109375,
        -2249.33642578125,
        660.0
      ],
      [
        -239.537109375,
        -2243.242431640625,
        660.0
      ],
      [
        -239.537109375,
        -2265.92919921875,
        629.0
      ],
      [
        -237.02639770507812,
        -2268.0,
        629.0
      ],
      [
        -239.537109375,
        -2268.0,
        629.0
      ],
      [
        -239.537109375,
        -2257.697509765625,
        629.0
      ],
      [
        -239.537109375,
        -2265.92919921875,
        629.0
      ],
      [
        -239.537109375,
        -2249.33642578125,
        629.0
      ],
      [
        -239.537109375,
        -2257.697509765625,
        629.0
      ],
      [
        -239.537109375,
        -2243.242431640625,
        629.0
      ],
      [
        -239.537109375,
        -2249.33642578125,
        629.0
      ],
      [
        -238.14285278320312,
        -2260.731689453125,
        645.0
      ],
      [
        -199.0,
        -2331.5,
        648.0
      ],
      [
        -199.0,
        -2314.0,
        648.0
      ],
      [
        -166.0,
        -2331.188232421875,
        648.0
      ],
      [
        -166.0,
        -2332.47265625,
        646.2020263671875
      ],
      [
        -166.0,
        -2333.5,
        644.7635498046875
      ],
      [
        -166.0,
        -2332.47265625,
        646.2020263671875
      ],
      [
        -177.0,
        -2333.3759765625,
        648.0
      ],
      [
        -177.0,
        -2333.44482421875,
        647.903564453125
      ],
      [
        -177.0,
        -2333.5,
        647.826416015625
      ],
      [
        -177.0,
        -2333.44482421875,
        647.903564453125
      ],
      [
        -166.0,
        -2331.18798828125,
        638.0
      ],
      [
        -166.0,
        -2332.472412109375,
        639.7982177734375
      ],
      [
        -166.0,
        -2333.5,
        641.2367553710938
      ],
      [
        -166.0,
        -2332.472412109375,
        639.7982177734375
      ],
      [
        -177.0,
        -2333.44482421875,
        638.096435546875
      ],
      [
        -177.0,
        -2333.3759765625,
        638.0
      ],
      [
        -177.0,
        -2333.5,
        638.173583984375
      ],
      [
        -177.0,
        -2333.44482421875,
        638.096435546875
      ],
      [
        -177.0,
        -2333.5,
        641.7001953125
      ],
      [
        -166.0,
        -2333.5,
        641.7000732421875
      ],
      [
        -177.0,
        -2331.5,
        638.0
      ],
      [
        -166.0,
        -2331.5,
        638.4368286132812
      ],
      [
        -177.0,
        -2312.0,
        641.7000732421875
      ],
      [
        -166.0,
        -2312.0,
        641.7000732421875
      ],
      [
        -177.0,
        -2314.0,
        638.0
      ],
      [
        -166.0,
        -2314.0,
        638.0
      ],
      [
        -216.0,
        -2316.5,
        638.0
      ],
      [
        -216.0,
        -2329.0,
        638.0
      ],
      [
        -216.0,
        -2329.0,
        648.0
      ],
      [
        -216.0,
        -2316.5,
        648.0
      ],
      [
        -199.0,
        -2314.0,
        648.0
      ],
      [
        -207.0,
        -2314.0,
        648.0
      ],
      [
        -216.0,
        -2314.0,
        644.5
      ],
      [
        -216.0,
        -2314.0,
        641.5
      ],
      [
        -216.0,
        -2331.5,
        641.5
      ],
      [
        -216.0,
        -2331.5,
        644.5
      ],
      [
        -216.0,
        -2329.0,
        638.0
      ],
      [
        -216.0,
        -2331.5,
        641.5
      ],
      [
        -216.0,
        -2329.0,
        648.0
      ],
      [
        -216.0,
        -2331.5,
        644.5
      ],
      [
        -216.0,
        -2314.0,
        641.5
      ],
      [
        -216.0,
        -2316.5,
        638.0
      ],
      [
        -216.0,
        -2316.5,
        648.0
      ],
      [
        -216.0,
        -2314.0,
        644.5
      ],
      [
        -239.537109375,
        -2329.0,
        648.0
      ],
      [
        -239.537109375,
        -2316.5,
        648.0
      ],
      [
        -239.537109375,
        -2291.60009765625,
        729.9993286132812
      ],
      [
        -239.537109375,
        -2291.60009765625,
        712.0
      ],
      [
        -239.537109375,
        -2291.60009765625,
        730.021484375
      ],
      [
        -239.537109375,
        -2291.60009765625,
        729.9993286132812
      ],
      [
        -239.537109375,
        -2289.39990234375,
        712.0
      ],
      [
        -239.537109375,
        -2289.39990234375,
        729.9993286132812
      ],
      [
        -239.537109375,
        -2289.39990234375,
        729.9993286132812
      ],
      [
        -239.537109375,
        -2289.39990234375,
        730.021484375
      ],
      [
        -239.537109375,
        -2271.757568359375,
        660.0
      ],
      [
        -239.537109375,
        -2271.757568359375,
        648.0
      ],
      [
        -237.02639770507812,
        -2268.0,
        648.0
      ],
      [
        -239.537109375,
        -2271.757568359375,
        660.0
      ],
      [
        -239.537109375,
        -2304.60009765625,
        729.9993286132812
      ],
      [
        -239.537109375,
        -2304.60009765625,
        712.0
      ],
      [
        -239.537109375,
        -2304.60009765625,
        730.021484375
      ],
      [
        -239.537109375,
        -2304.60009765625,
        729.9993286132812
      ],
      [
        -239.537109375,
        -2302.39990234375,
        712.0
      ],
      [
        -239.537109375,
        -2302.39990234375,
        729.9993286132812
      ],
      [
        -239.537109375,
        -2302.39990234375,
        729.9993286132812
      ],
      [
        -239.537109375,
        -2302.39990234375,
        730.021484375
      ],
      [
        -239.537109375,
        -2314.0,
        641.5
      ],
      [
        -239.537109375,
        -2316.5,
        638.0
      ],
      [
        -239.537109375,
        -2276.70458984375,
        641.7517700195312
      ],
      [
        -239.537109375,
        -2276.70458984375,
        627.35107421875
      ],
      [
        -239.537109375,
        -2271.757568359375,
        644.5
      ],
      [
        -239.537109375,
        -2276.70458984375,
        641.7517700195312
      ],
      [
        -239.537109375,
        -2271.757568359375,
        644.5
      ],
      [
        -239.537109375,
        -2276.70458984375,
        627.35107421875
      ],
      [
        -239.537109375,
        -2271.757568359375,
        629.0
      ],
      [
        -239.537109375,
        -2271.757568359375,
        629.0
      ],
      [
        -239.537109375,
        -2316.5,
        638.0
      ],
      [
        -239.537109375,
        -2329.0,
        638.0
      ],
      [
        -239.537109375,
        -2329.0,
        638.0
      ],
      [
        -239.537109375,
        -2331.5,
        641.5
      ],
      [
        -239.537109375,
        -2329.0,
        648.0
      ],
      [
        -239.537109375,
        -2331.5,
        644.5
      ],
      [
        -239.537109375,
        -2316.5,
        648.0
      ],
      [
        -239.537109375,
        -2314.0,
        644.5
      ],
      [
        -239.537109375,
        -2331.5,
        641.5
      ],
      [
        -239.537109375,
        -2331.5,
        644.5
      ],
      [
        -239.537109375,
        -2314.0,
        644.5
      ],
      [
        -239.537109375,
        -2314.0,
        641.5
      ],
      [
        -406.1270751953125,
        -2077.14501953125,
        639.28125
      ],
      [
        -420.776611328125,
        -2085.60302734375,
        639.28125
      ],
      [
        -420.776611328125,
        -2085.60302734375,
        639.28125
      ],
      [
        -504.10089111328125,
        -2133.71044921875,
        639.28125
      ],
      [
        -313.8933410644531,
        -2023.8939208984375,
        645.2787475585938
      ],
      [
        -393.90704345703125,
        -2070.08984375,
        640.161865234375
      ],
      [
        -406.1270751953125,
        -2077.14501953125,
        639.28125
      ],
      [
        -393.90704345703125,
        -2070.08984375,
        640.161865234375
      ],
      [
        -308.0,
        -2415.0,
        618.0
      ],
      [
        -308.0,
        -2425.0,
        618.0
      ],
      [
        -310.0,
        -2427.0,
        620.0
      ],
      [
        -310.0,
        -2427.0,
        618.0
      ],
      [
        -310.0,
        -2424.0,
        618.0
      ],
      [
        -310.0,
        -2424.0,
        620.0
      ],
      [
        -308.0,
        -2424.0,
        618.0
      ],
      [
        -308.0,
        -2424.0,
        620.0
      ],
      [
        -310.0,
        -2424.0,
        620.0
      ],
      [
        -310.0,
        -2424.0,
        618.0
      ],
      [
        -325.0,
        -2427.0,
        618.0
      ],
      [
        -325.0,
        -2427.0,
        620.0
      ],
      [
        -325.0,
        -2424.0,
        620.0
      ],
      [
        -325.0,
        -2424.0,
        618.0
      ],
      [
        -325.0,
        -2424.0,
        618.0
      ],
      [
        -325.0,
        -2424.0,
        620.0
      ],
      [
        -327.0,
        -2424.0,
        620.0
      ],
      [
        -327.0,
        -2424.0,
        618.0
      ],
      [
        -308.0,
        -2415.0,
        608.0
      ],
      [
        -308.0,
        -2425.0,
        608.0
      ],
      [
        -310.0,
        -2427.0,
        608.0
      ],
      [
        -310.0,
        -2424.0,
        608.0
      ],
      [
        -308.0,
        -2424.0,
        608.0
      ],
      [
        -310.0,
        -2424.0,
        608.0
      ],
      [
        -325.0,
        -2427.0,
        608.0
      ],
      [
        -325.0,
        -2424.0,
        608.0
      ],
      [
        -325.0,
        -2424.0,
        608.0
      ],
      [
        -327.0,
        -2424.0,
        608.0
      ],
      [
        -447.0,
        -2287.60009765625,
        644.0
      ],
      [
        -447.0,
        -2287.60009765625,
        666.0
      ],
      [
        -447.0,
        -2287.60009765625,
        708.0
      ],
      [
        -447.0,
        -2287.60009765625,
        730.0
      ],
      [
        -447.0,
        -2287.60009765625,
        666.0
      ],
      [
        -447.0,
        -2287.60009765625,
        708.0
      ],
      [
        -450.5,
        -2291.0,
        666.0
      ],
      [
        -450.5,
        -2291.0,
        644.0
      ],
      [
        -450.5,
        -2291.0,
        730.0
      ],
      [
        -450.5,
        -2291.0,
        708.0
      ],
      [
        -450.5,
        -2291.0,
        708.0
      ],
      [
        -450.5,
        -2291.0,
        666.0
      ],
      [
        -447.0,
        -2291.0,
        644.0
      ],
      [
        -450.5,
        -2291.0,
        644.0
      ],
      [
        -447.0,
        -2287.60009765625,
        644.0
      ],
      [
        -447.0,
        -2287.60009765625,
        730.0
      ],
      [
        -450.5,
        -2291.0,
        730.0
      ],
      [
        -447.0,
        -2291.0,
        730.0
      ],
      [
        -440.5,
        -2287.60009765625,
        644.0
      ],
      [
        -440.5,
        -2287.60009765625,
        666.0
      ],
      [
        -440.5,
        -2287.60009765625,
        708.0
      ],
      [
        -440.5,
        -2287.60009765625,
        730.0
      ],
      [
        -440.5,
        -2287.60009765625,
        666.0
      ],
      [
        -440.5,
        -2287.60009765625,
        708.0
      ],
      [
        -437.0,
        -2291.0,
        644.0
      ],
      [
        -440.5,
        -2291.0,
        644.0
      ],
      [
        -440.5,
        -2287.60009765625,
        644.0
      ],
      [
        -437.0,
        -2291.0,
        730.0
      ],
      [
        -440.5,
        -2287.60009765625,
        730.0
      ],
      [
        -440.5,
        -2291.0,
        730.0
      ],
      [
        -447.0,
        -2306.0,
        666.0
      ],
      [
        -447.0,
        -2306.0,
        644.0
      ],
      [
        -447.0,
        -2306.0,
        730.0
      ],
      [
        -447.0,
        -2306.0,
        708.0
      ],
      [
        -447.0,
        -2306.0,
        708.0
      ],
      [
        -447.0,
        -2306.0,
        666.0
      ],
      [
        -450.5,
        -2302.60009765625,
        666.0
      ],
      [
        -450.5,
        -2302.60009765625,
        644.0
      ],
      [
        -450.5,
        -2302.60009765625,
        730.0
      ],
      [
        -450.5,
        -2302.60009765625,
        708.0
      ],
      [
        -450.5,
        -2302.60009765625,
        708.0
      ],
      [
        -450.5,
        -2302.60009765625,
        666.0
      ],
      [
        -447.0,
        -2306.0,
        644.0
      ],
      [
        -450.5,
        -2302.60009765625,
        644.0
      ],
      [
        -447.0,
        -2302.60009765625,
        644.0
      ],
      [
        -450.5,
        -2302.60009765625,
        730.0
      ],
      [
        -447.0,
        -2306.0,
        730.0
      ],
      [
        -447.0,
        -2302.60009765625,
        730.0
      ],
      [
        -447.0,
        -2291.0,
        644.0
      ],
      [
        -447.0,
        -2291.0,
        730.0
      ],
      [
        -440.5,
        -2306.0,
        666.0
      ],
      [
        -440.5,
        -2306.0,
        644.0
      ],
      [
        -440.5,
        -2306.0,
        730.0
      ],
      [
        -440.5,
        -2306.0,
        708.0
      ],
      [
        -440.5,
        -2306.0,
        708.0
      ],
      [
        -440.5,
        -2306.0,
        666.0
      ],
      [
        -437.0,
        -2302.60009765625,
        644.0
      ],
      [
        -440.5,
        -2306.0,
        644.0
      ],
      [
        -440.5,
        -2302.60009765625,
        644.0
      ],
      [
        -437.0,
        -2302.60009765625,
        730.0
      ],
      [
        -440.5,
        -2302.60009765625,
        730.0
      ],
      [
        -440.5,
        -2306.0,
        730.0
      ],
      [
        -447.0,
        -2302.60009765625,
        644.0
      ],
      [
        -447.0,
        -2302.60009765625,
        730.0
      ],
      [
        -342.8050537109375,
        -2205.08349609375,
        641.0
      ],
      [
        -327.21661376953125,
        -2196.083740234375,
        641.0
      ],
      [
        -379.841552734375,
        -2136.734619140625,
        641.0
      ],
      [
        -374.341552734375,
        -2146.2607421875,
        641.0
      ],
      [
        -362.217041015625,
        -2139.2607421875,
        641.0
      ],
      [
        -367.717041015625,
        -2129.734619140625,
        641.0
      ],
      [
        -379.109375,
        -2134.00244140625,
        641.0
      ],
      [
        -377.464111328125,
        -2133.052490234375,
        641.0
      ],
      [
        -372.26806640625,
        -2130.052490234375,
        641.0
      ],
      [
        -370.44921875,
        -2129.00244140625,
        641.0
      ],
      [
        -378.614013671875,
        -2131.060546875,
        641.0
      ],
      [
        -377.464111328125,
        -2133.052490234375,
        641.0
      ],
      [
        -373.41796875,
        -2128.060546875,
        641.0
      ],
      [
        -372.26806640625,
        -2130.052490234375,
        641.0
      ],
      [
        -367.717041015625,
        -2129.734619140625,
        641.0
      ],
      [
        -370.44921875,
        -2129.00244140625,
        641.0
      ],
      [
        -379.841552734375,
        -2136.734619140625,
        641.0
      ],
      [
        -379.109375,
        -2134.00244140625,
        641.0
      ],
      [
        -337.0892333984375,
        -2201.783447265625,
        665.0
      ],
      [
        -344.53717041015625,
        -2206.083740234375,
        648.0
      ],
      [
        -344.53717041015625,
        -2206.083740234375,
        648.0
      ],
      [
        -342.8050537109375,
        -2205.08349609375,
        641.0
      ],
      [
        -332.8458251953125,
        -2199.33349609375,
        665.0
      ],
      [
        -325.3114318847656,
        -2194.983642578125,
        648.0
      ],
      [
        -330.6023254394531,
        -2179.897705078125,
        642.21435546875
      ],
      [
        -335.6024475097656,
        -2171.237548828125,
        642.2142944335938
      ],
      [
        -335.6023864746094,
        -2171.2373046875,
        642.21435546875
      ],
      [
        -325.3114318847656,
        -2194.983642578125,
        648.0
      ],
      [
        -327.2166748046875,
        -2196.083740234375,
        641.0
      ],
      [
        -420.0,
        -2268.0,
        637.0
      ],
      [
        -406.0,
        -2268.0,
        637.0
      ],
      [
        -327.0,
        -2268.0,
        626.0
      ],
      [
        -327.0,
        -2268.0,
        637.0
      ],
      [
        -309.0,
        -2268.0,
        626.0
      ],
      [
        -309.0,
        -2268.0,
        637.0
      ],
      [
        -307.0,
        -2268.0,
        620.0
      ],
      [
        -309.0,
        -2268.0,
        626.0
      ],
      [
        -249.64556884765625,
        -2268.0,
        629.0
      ],
      [
        -239.537109375,
        -2268.0,
        629.0
      ],
      [
        -277.177734375,
        -2239.822265625,
        637.0
      ],
      [
        -260.0,
        -2258.5,
        637.0
      ],
      [
        -260.0,
        -2258.5,
        637.0
      ],
      [
        -255.67189025878906,
        -2268.0,
        629.0
      ],
      [
        -255.67189025878906,
        -2268.0,
        637.0
      ],
      [
        -274.32330322265625,
        -2242.92578125,
        629.0
      ],
      [
        -274.35546875,
        -2242.9482421875,
        637.0
      ],
      [
        -274.32330322265625,
        -2242.92578125,
        637.0
      ],
      [
        -259.5,
        -2232.5,
        637.0
      ],
      [
        -269.067138671875,
        -2234.403076171875,
        637.0
      ],
      [
        -249.932861328125,
        -2234.403076171875,
        637.0
      ],
      [
        -259.5,
        -2232.5,
        637.0
      ],
      [
        -249.932861328125,
        -2234.403076171875,
        637.0
      ],
      [
        -241.822265625,
        -2239.822265625,
        637.0
      ],
      [
        -266.844970703125,
        -2237.72900390625,
        637.0
      ],
      [
        -241.822265625,
        -2239.822265625,
        637.0
      ],
      [
        -239.537109375,
        -2243.242431640625,
        637.0
      ],
      [
        -291.47369384765625,
        -2266.0,
        626.7631225585938
      ],
      [
        -290.0999450683594,
        -2258.0,
        626.5
      ],
      [
        -291.0,
        -2266.0,
        626.5
      ],
      [
        -290.0999450683594,
        -2266.0,
        626.5
      ],
      [
        -291.0,
        -2268.0,
        626.5
      ],
      [
        -290.0999450683594,
        -2268.0,
        626.5
      ],
      [
        -291.47369384765625,
        -2266.0,
        626.7631225585938
      ],
      [
        -291.0,
        -2268.0,
        627.0
      ],
      [
        -291.47369384765625,
        -2268.0,
        626.7631225585938
      ],
      [
        -305.0,
        -2268.0,
        619.9999389648438
      ],
      [
        -304.0,
        -2268.0,
        619.9999389648438
      ],
      [
        -291.0,
        -2268.0,
        626.5
      ],
      [
        -266.2532043457031,
        -2268.0,
        637.0
      ],
      [
        -266.2532043457031,
        -2268.0,
        620.0
      ],
      [
        -291.0,
        -2268.0,
        627.0
      ],
      [
        -286.5,
        -2268.0,
        627.0
      ],
      [
        -286.5,
        -2268.0,
        626.5
      ],
      [
        -286.5,
        -2268.0,
        627.0
      ],
      [
        -286.5,
        -2268.0,
        626.5
      ],
      [
        -329.0,
        -2268.0,
        620.0
      ],
      [
        -327.0,
        -2268.0,
        626.0
      ],
      [
        -398.9736328125,
        -2268.0,
        629.0
      ],
      [
        -386.35443115234375,
        -2268.0,
        629.0
      ],
      [
        -400.99310302734375,
        -2268.0,
        627.9925537109375
      ],
      [
        -398.9736328125,
        -2268.0,
        629.0
      ],
      [
        -400.99310302734375,
        -2268.0,
        627.9925537109375
      ],
      [
        -400.99310302734375,
        -2268.0,
        629.0
      ],
      [
        -376.0,
        -2258.5,
        637.0
      ],
      [
        -358.822265625,
        -2239.822265625,
        637.0
      ],
      [
        -380.3280944824219,
        -2268.0,
        629.0
      ],
      [
        -376.0,
        -2258.5,
        637.0
      ],
      [
        -380.3280944824219,
        -2268.0,
        637.0
      ],
      [
        -361.6766052246094,
        -2242.926025390625,
        637.0
      ],
      [
        -361.64453125,
        -2242.9482421875,
        637.0
      ],
      [
        -361.6766052246094,
        -2242.926025390625,
        629.0
      ],
      [
        -399.596923828125,
        -2267.067138671875,
        637.0
      ],
      [
        -401.5,
        -2257.5,
        637.0
      ],
      [
        -400.99310302734375,
        -2268.0,
        637.0
      ],
      [
        -399.596923828125,
        -2267.067138671875,
        637.0
      ],
      [
        -366.932861328125,
        -2234.403076171875,
        637.0
      ],
      [
        -376.5,
        -2232.5,
        637.0
      ],
      [
        -376.5,
        -2232.5,
        637.0
      ],
      [
        -386.067138671875,
        -2234.403076171875,
        637.0
      ],
      [
        -401.5,
        -2257.5,
        637.0
      ],
      [
        -399.596923828125,
        -2247.932861328125,
        637.0
      ],
      [
        -399.596923828125,
        -2247.932861328125,
        637.0
      ],
      [
        -394.177734375,
        -2239.822265625,
        637.0
      ],
      [
        -394.177734375,
        -2239.822265625,
        637.0
      ],
      [
        -386.067138671875,
        -2234.403076171875,
        637.0
      ],
      [
        -369.155029296875,
        -2237.72900390625,
        637.0
      ],
      [
        -344.5263366699219,
        -2266.0,
        626.76318359375
      ],
      [
        -345.0,
        -2266.0,
        626.5
      ],
      [
        -345.90008544921875,
        -2258.0,
        626.5
      ],
      [
        -345.90008544921875,
        -2266.0,
        626.5
      ],
      [
        -345.0,
        -2268.0,
        626.5
      ],
      [
        -345.90008544921875,
        -2268.0,
        626.5
      ],
      [
        -345.0,
        -2268.0,
        627.0
      ],
      [
        -344.5263366699219,
        -2266.0,
        626.76318359375
      ],
      [
        -344.5263366699219,
        -2268.0,
        626.76318359375
      ],
      [
        -331.0,
        -2268.0,
        619.9999389648438
      ],
      [
        -345.0,
        -2268.0,
        626.5
      ],
      [
        -332.0,
        -2268.0,
        619.9999389648438
      ],
      [
        -369.7467956542969,
        -2268.0,
        637.0
      ],
      [
        -369.7467956542969,
        -2268.0,
        620.0
      ],
      [
        -349.5,
        -2268.0,
        627.0
      ],
      [
        -345.0,
        -2268.0,
        627.0
      ],
      [
        -349.5,
        -2268.0,
        626.5
      ],
      [
        -349.5,
        -2268.0,
        627.0
      ],
      [
        -349.5,
        -2268.0,
        626.5
      ],
      [
        -249.932861328125,
        -2280.596923828125,
        637.0
      ],
      [
        -241.822265625,
        -2275.177734375,
        637.0
      ],
      [
        -249.932861328125,
        -2280.596923828125,
        637.0
      ],
      [
        -241.822265625,
        -2275.177734375,
        637.0
      ],
      [
        -239.537109375,
        -2276.70458984375,
        637.0
      ],
      [
        -239.537109375,
        -2273.651123046875,
        628.368896484375
      ],
      [
        -309.0,
        -2283.377685546875,
        626.0
      ],
      [
        -309.0,
        -2283.377685546875,
        637.0
      ],
      [
        -307.0,
        -2282.54931640625,
        620.0
      ],
      [
        -309.0,
        -2283.377685546875,
        626.0
      ],
      [
        -304.0931701660156,
        -2366.310791015625,
        632.5
      ],
      [
        -305.30987548828125,
        -2365.806640625,
        632.5
      ],
      [
        -326.0800476074219,
        -2357.199951171875,
        632.5
      ],
      [
        -305.30987548828125,
        -2365.806640625,
        632.5
      ],
      [
        -365.14208984375,
        -2354.35791015625,
        637.0
      ],
      [
        -351.0,
        -2348.5,
        637.0
      ],
      [
        -371.0,
        -2368.5,
        637.0
      ],
      [
        -365.14208984375,
        -2354.35791015625,
        637.0
      ],
      [
        -348.06207275390625,
        -2349.4931640625,
        637.0
      ],
      [
        -336.969970703125,
        -2354.087646484375,
        637.0
      ],
      [
        -351.0,
        -2349.166748046875,
        637.0
      ],
      [
        -346.75732421875,
        -2350.924072265625,
        637.0
      ],
      [
        -337.3292541503906,
        -2354.829345703125,
        637.0
      ],
      [
        -346.75732421875,
        -2350.924072265625,
        637.0
      ],
      [
        -351.0,
        -2349.166748046875,
        637.0
      ],
      [
        -355.24267578125,
        -2350.924072265625,
        637.0
      ],
      [
        -355.24267578125,
        -2350.924072265625,
        637.0
      ],
      [
        -364.6707458496094,
        -2354.829345703125,
        637.0
      ],
      [
        -331.6666564941406,
        -2368.5,
        637.0
      ],
      [
        -333.4239807128906,
        -2364.25732421875,
        637.0
      ],
      [
        -333.4239807128906,
        -2364.25732421875,
        637.0
      ],
      [
        -337.3292541503906,
        -2354.829345703125,
        637.0
      ],
      [
        -348.06207275390625,
        -2349.4931640625,
        637.0
      ],
      [
        -350.5743408203125,
        -2348.46630859375,
        637.0
      ],
      [
        -350.5743408203125,
        -2348.46630859375,
        637.0
      ],
      [
        -351.0,
        -2348.5,
        637.0
      ],
      [
        -329.699951171875,
        -2356.802978515625,
        637.0
      ],
      [
        -327.0379638671875,
        -2356.802978515625,
        637.0
      ],
      [
        -326.0800476074219,
        -2357.199951171875,
        632.5
      ],
      [
        -335.87060546875,
        -2354.54296875,
        637.0
      ],
      [
        -329.699951171875,
        -2356.802978515625,
        637.0
      ],
      [
        -335.87060546875,
        -2354.54296875,
        637.0
      ],
      [
        -304.0931701660156,
        -2366.310791015625,
        635.0
      ],
      [
        -304.0931701660156,
        -2366.310791015625,
        632.5
      ],
      [
        -304.3333435058594,
        -2368.5,
        637.0
      ],
      [
        -303.8150634765625,
        -2366.426025390625,
        635.9776611328125
      ],
      [
        -303.5242004394531,
        -2366.54638671875,
        637.0
      ],
      [
        -304.0931701660156,
        -2366.310791015625,
        635.0
      ],
      [
        -303.8150634765625,
        -2366.426025390625,
        635.9776611328125
      ],
      [
        -285.0,
        -2348.5,
        637.0
      ],
      [
        -270.85791015625,
        -2354.35791015625,
        637.0
      ],
      [
        -265.0,
        -2368.5,
        637.0
      ],
      [
        -270.85791015625,
        -2354.35791015625,
        637.0
      ],
      [
        -309.92059326171875,
        -2357.199951171875,
        632.5
      ],
      [
        -318.00030517578125,
        -2360.548095703125,
        632.5
      ],
      [
        -300.1300354003906,
        -2354.54296875,
        637.0
      ],
      [
        -287.9385681152344,
        -2349.4931640625,
        637.0
      ],
      [
        -306.30126953125,
        -2356.802978515625,
        637.0
      ],
      [
        -300.1300354003906,
        -2354.54296875,
        637.0
      ],
      [
        -308.962646484375,
        -2356.802978515625,
        637.0
      ],
      [
        -306.30126953125,
        -2356.802978515625,
        637.0
      ],
      [
        -309.92059326171875,
        -2357.199951171875,
        632.5
      ],
      [
        -299.2821044921875,
        -2354.696044921875,
        632.5
      ],
      [
        -285.0,
        -2349.166748046875,
        637.0
      ],
      [
        -289.24267578125,
        -2350.924072265625,
        637.0
      ],
      [
        -289.24267578125,
        -2350.924072265625,
        637.0
      ],
      [
        -298.6707458496094,
        -2354.829345703125,
        637.0
      ],
      [
        -285.0,
        -2349.166748046875,
        637.0
      ],
      [
        -280.75732421875,
        -2350.924072265625,
        637.0
      ],
      [
        -271.3292541503906,
        -2354.829345703125,
        637.0
      ],
      [
        -280.75732421875,
        -2350.924072265625,
        637.0
      ],
      [
        -302.5760192871094,
        -2364.25732421875,
        637.0
      ],
      [
        -298.6707458496094,
        -2354.829345703125,
        637.0
      ],
      [
        -302.5760192871094,
        -2364.25732421875,
        637.0
      ],
      [
        -287.9385681152344,
        -2349.4931640625,
        637.0
      ],
      [
        -285.4256591796875,
        -2348.46630859375,
        637.0
      ],
      [
        -285.0,
        -2348.5,
        637.0
      ],
      [
        -285.4256591796875,
        -2348.46630859375,
        637.0
      ],
      [
        -307.0,
        -2280.384521484375,
        620.0
      ],
      [
        -420.0,
        -2293.0,
        637.0
      ],
      [
        -420.0,
        -2268.0,
        637.0
      ],
      [
        -386.067138671875,
        -2280.596923828125,
        637.0
      ],
      [
        -403.75439453125,
        -2269.844970703125,
        629.0
      ],
      [
        -400.99310302734375,
        -2268.0,
        629.0
      ],
      [
        -386.067138671875,
        -2280.596923828125,
        637.0
      ],
      [
        -394.177734375,
        -2275.177734375,
        637.0
      ],
      [
        -403.75439453125,
        -2269.844970703125,
        637.0
      ],
      [
        -402.9565734863281,
        -2269.31201171875,
        637.0
      ],
      [
        -402.9565734863281,
        -2269.31201171875,
        629.0
      ],
      [
        -290.0,
        -2274.0,
        627.0
      ],
      [
        -290.0,
        -2268.0,
        627.0
      ],
      [
        -346.00006103515625,
        -2268.0,
        627.0
      ],
      [
        -346.00006103515625,
        -2274.0,
        627.0
      ],
      [
        -359.069580078125,
        -2339.0,
        709.0
      ],
      [
        -359.069580078125,
        -2339.0,
        712.0
      ],
      [
        -359.0697021484375,
        -2339.0,
        637.0
      ],
      [
        -359.0697021484375,
        -2339.0,
        653.0
      ],
      [
        -359.069580078125,
        -2339.0,
        709.0
      ],
      [
        -359.0697021484375,
        -2339.0,
        653.0
      ],
      [
        -365.697998046875,
        -2355.699951171875,
        660.5
      ],
      [
        -365.697998046875,
        -2355.699951171875,
        637.0
      ],
      [
        -349.6744689941406,
        -2348.395263671875,
        641.2283325195312
      ],
      [
        -349.67431640625,
        -2348.3955078125,
        658.5668334960938
      ],
      [
        -351.0,
        -2355.699951171875,
        660.5
      ],
      [
        -363.800048828125,
        -2355.699951171875,
        660.5
      ],
      [
        -348.558349609375,
        -2349.511474609375,
        660.5
      ],
      [
        -351.0,
        -2355.699951171875,
        660.5
      ],
      [
        -342.3699035644531,
        -2355.699951171875,
        660.5
      ],
      [
        -363.800048828125,
        -2355.699951171875,
        660.5
      ],
      [
        -365.697998046875,
        -2355.699951171875,
        660.5
      ],
      [
        -351.0,
        -2355.699951171875,
        641.0
      ],
      [
        -363.55413818359375,
        -2355.699951171875,
        641.0
      ],
      [
        -351.0,
        -2355.699951171875,
        641.0
      ],
      [
        -345.1446533203125,
        -2352.92529296875,
        641.0
      ],
      [
        -342.3700256347656,
        -2355.699951171875,
        641.0
      ],
      [
        -363.55413818359375,
        -2355.699951171875,
        641.0
      ],
      [
        -363.6019592285156,
        -2355.699951171875,
        640.9405517578125
      ],
      [
        -363.6019592285156,
        -2355.699951171875,
        640.9405517578125
      ],
      [
        -363.800048828125,
        -2355.699951171875,
        640.6943969726562
      ],
      [
        -345.1446533203125,
        -2352.92529296875,
        641.0
      ],
      [
        -347.4204406738281,
        -2350.6494140625,
        637.0
      ],
      [
        -348.9324035644531,
        -2349.137451171875,
        637.0
      ],
      [
        -349.93731689453125,
        -2348.726806640625,
        637.0
      ],
      [
        -349.1820068359375,
        -2348.8876953125,
        638.4221801757812
      ],
      [
        -349.7230529785156,
        -2348.399169921875,
        641.0
      ],
      [
        -349.6343994140625,
        -2348.435302734375,
        641.0
      ],
      [
        -348.558349609375,
        -2349.511474609375,
        660.5
      ],
      [
        -349.67431640625,
        -2348.3955078125,
        658.5668334960938
      ],
      [
        -349.6744689941406,
        -2348.395263671875,
        641.2283325195312
      ],
      [
        -276.930419921875,
        -2339.0,
        709.0
      ],
      [
        -276.930419921875,
        -2339.0,
        712.0
      ],
      [
        -276.930419921875,
        -2339.0,
        637.0
      ],
      [
        -276.930419921875,
        -2339.0,
        653.0
      ],
      [
        -276.930419921875,
        -2339.0,
        709.0
      ],
      [
        -276.930419921875,
        -2339.0,
        653.0
      ],
      [
        -270.302001953125,
        -2355.699951171875,
        637.0
      ],
      [
        -270.302001953125,
        -2355.699951171875,
        660.5
      ],
      [
        -286.32513427734375,
        -2348.394775390625,
        658.567626953125
      ],
      [
        -286.3252258300781,
        -2348.394775390625,
        641.226806640625
      ],
      [
        -285.0,
        -2355.699951171875,
        660.5
      ],
      [
        -272.199951171875,
        -2355.699951171875,
        660.5
      ],
      [
        -287.44195556640625,
        -2349.511474609375,
        660.5
      ],
      [
        -293.6302795410156,
        -2355.699951171875,
        660.5
      ],
      [
        -285.0,
        -2355.699951171875,
        660.5
      ],
      [
        -270.302001953125,
        -2355.699951171875,
        660.5
      ],
      [
        -272.199951171875,
        -2355.699951171875,
        660.5
      ],
      [
        -285.0,
        -2355.699951171875,
        641.0
      ],
      [
        -272.44586181640625,
        -2355.699951171875,
        641.0
      ],
      [
        -290.8558044433594,
        -2352.925537109375,
        641.0
      ],
      [
        -285.0,
        -2355.699951171875,
        641.0
      ],
      [
        -293.6302185058594,
        -2355.699951171875,
        641.0
      ],
      [
        -272.44586181640625,
        -2355.699951171875,
        641.0
      ],
      [
        -272.3980407714844,
        -2355.699951171875,
        640.9405517578125
      ],
      [
        -272.199951171875,
        -2355.699951171875,
        640.6943969726562
      ],
      [
        -272.3980407714844,
        -2355.699951171875,
        640.9405517578125
      ],
      [
        -290.8558044433594,
        -2352.925537109375,
        641.0
      ],
      [
        -288.5799255371094,
        -2350.649658203125,
        637.0
      ],
      [
        -286.0624694824219,
        -2348.7265625,
        637.0
      ],
      [
        -287.0677490234375,
        -2349.13720703125,
        637.0
      ],
      [
        -286.8179931640625,
        -2348.887451171875,
        638.4217529296875
      ],
      [
        -286.2769470214844,
        -2348.398681640625,
        641.0
      ],
      [
        -286.3650817871094,
        -2348.4345703125,
        641.0
      ],
      [
        -287.4419250488281,
        -2349.511474609375,
        660.5
      ],
      [
        -286.32513427734375,
        -2348.394775390625,
        658.567626953125
      ],
      [
        -286.3252258300781,
        -2348.394775390625,
        641.226806640625
      ],
      [
        -332.71160888671875,
        -2355.699951171875,
        637.0
      ],
      [
        -347.8773193359375,
        -2348.16796875,
        649.5
      ],
      [
        -347.8773193359375,
        -2348.16796875,
        650.49609375
      ],
      [
        -347.8773193359375,
        -2348.16796875,
        649.5
      ],
      [
        -347.8773193359375,
        -2348.16796875,
        656.0
      ],
      [
        -333.47784423828125,
        -2355.699951171875,
        662.3888549804688
      ],
      [
        -333.47784423828125,
        -2355.699951171875,
        664.5
      ],
      [
        -333.47784423828125,
        -2355.699951171875,
        662.3888549804688
      ],
      [
        -336.302001953125,
        -2355.699951171875,
        664.5
      ],
      [
        -336.302001953125,
        -2355.699951171875,
        663.7877197265625
      ],
      [
        -333.47784423828125,
        -2355.699951171875,
        664.5
      ],
      [
        -336.302001953125,
        -2355.699951171875,
        664.5
      ],
      [
        -348.4486083984375,
        -2349.621337890625,
        660.5
      ],
      [
        -336.302001953125,
        -2355.699951171875,
        663.66943359375
      ],
      [
        -349.67431640625,
        -2348.3955078125,
        658.4395141601562
      ],
      [
        -338.199951171875,
        -2355.699951171875,
        660.5
      ],
      [
        -336.302001953125,
        -2355.699951171875,
        660.5
      ],
      [
        -338.199951171875,
        -2355.699951171875,
        660.5
      ],
      [
        -336.302001953125,
        -2355.699951171875,
        660.5
      ],
      [
        -349.6743469238281,
        -2348.3955078125,
        656.0
      ],
      [
        -347.8773193359375,
        -2348.16796875,
        656.0
      ],
      [
        -338.44586181640625,
        -2355.699951171875,
        641.0
      ],
      [
        -338.3980407714844,
        -2355.699951171875,
        640.9405517578125
      ],
      [
        -338.199951171875,
        -2355.699951171875,
        640.6943969726562
      ],
      [
        -338.3980407714844,
        -2355.699951171875,
        640.9405517578125
      ],
      [
        -338.44586181640625,
        -2355.699951171875,
        641.0
      ],
      [
        -338.199951171875,
        -2355.699951171875,
        640.6943969726562
      ],
      [
        -336.9686279296875,
        -2355.699951171875,
        637.0
      ],
      [
        -303.289306640625,
        -2355.699951171875,
        637.0
      ],
      [
        -288.1221923828125,
        -2348.16748046875,
        649.5
      ],
      [
        -288.1221923828125,
        -2348.16748046875,
        649.5
      ],
      [
        -288.1221923828125,
        -2348.16748046875,
        650.4846801757812
      ],
      [
        -288.1221923828125,
        -2348.16748046875,
        656.0
      ],
      [
        -302.52215576171875,
        -2355.699951171875,
        664.5
      ],
      [
        -302.52215576171875,
        -2355.699951171875,
        662.3888549804688
      ],
      [
        -302.52215576171875,
        -2355.699951171875,
        662.3888549804688
      ],
      [
        -299.697998046875,
        -2355.699951171875,
        664.5
      ],
      [
        -299.697998046875,
        -2355.699951171875,
        663.7841186523438
      ],
      [
        -299.697998046875,
        -2355.699951171875,
        664.5
      ],
      [
        -302.52215576171875,
        -2355.699951171875,
        664.5
      ],
      [
        -287.5519714355469,
        -2349.62158203125,
        660.5
      ],
      [
        -299.697998046875,
        -2355.699951171875,
        663.66552734375
      ],
      [
        -286.32513427734375,
        -2348.394775390625,
        658.4400634765625
      ],
      [
        -297.800048828125,
        -2355.699951171875,
        660.5
      ],
      [
        -299.697998046875,
        -2355.699951171875,
        660.5
      ],
      [
        -297.800048828125,
        -2355.699951171875,
        660.5
      ],
      [
        -299.697998046875,
        -2355.699951171875,
        660.5
      ],
      [
        -286.32513427734375,
        -2348.394775390625,
        656.0
      ],
      [
        -288.1221923828125,
        -2348.16748046875,
        656.0
      ],
      [
        -297.55413818359375,
        -2355.699951171875,
        641.0
      ],
      [
        -297.6019592285156,
        -2355.699951171875,
        640.9405517578125
      ],
      [
        -297.6019592285156,
        -2355.699951171875,
        640.9405517578125
      ],
      [
        -297.800048828125,
        -2355.699951171875,
        640.6943969726562
      ],
      [
        -297.55413818359375,
        -2355.699951171875,
        641.0
      ],
      [
        -297.800048828125,
        -2355.699951171875,
        640.6943969726562
      ],
      [
        -299.0313720703125,
        -2355.699951171875,
        637.0
      ],
      [
        -287.44775390625,
        -2342.578125,
        649.5
      ],
      [
        -287.44775390625,
        -2342.578125,
        649.5
      ],
      [
        -284.665771484375,
        -2346.7353515625,
        649.5
      ],
      [
        -318.2650451660156,
        -2350.796142578125,
        649.5
      ],
      [
        -348.55615234375,
        -2342.578125,
        649.5
      ],
      [
        -348.55615234375,
        -2342.578125,
        649.5
      ],
      [
        -351.334228515625,
        -2346.7353515625,
        649.5
      ],
      [
        -318.0042724609375,
        -2350.796142578125,
        649.4287719726562
      ],
      [
        -319.11553955078125,
        -2355.699951171875,
        656.0
      ],
      [
        -287.44775390625,
        -2342.578125,
        656.0
      ],
      [
        -284.665771484375,
        -2346.7353515625,
        656.0
      ],
      [
        -341.53460693359375,
        -2350.796142578125,
        656.0
      ],
      [
        -348.55615234375,
        -2342.578125,
        656.0
      ],
      [
        -351.334228515625,
        -2346.7353515625,
        656.0
      ],
      [
        -319.2059631347656,
        -2351.4560546875,
        690.0
      ],
      [
        -317.2940368652344,
        -2351.4560546875,
        690.0
      ],
      [
        -318.2499694824219,
        -2349.6875,
        687.5
      ],
      [
        -318.2499694824219,
        -2349.6875,
        690.0
      ],
      [
        -319.5,
        -2347.374755859375,
        687.5
      ],
      [
        -319.5,
        -2347.374755859375,
        690.0
      ],
      [
        -319.5,
        -2347.374755859375,
        687.5
      ],
      [
        -319.5,
        -2347.374755859375,
        690.0
      ],
      [
        -317.0,
        -2339.0,
        690.0
      ],
      [
        -317.0,
        -2339.0,
        687.5
      ],
      [
        -319.5,
        -2339.0,
        687.5
      ],
      [
        -317.0,
        -2339.0,
        687.5
      ],
      [
        -319.5,
        -2339.0,
        690.0
      ],
      [
        -317.0,
        -2339.0,
        690.0
      ],
      [
        -319.5,
        -2339.0,
        687.5
      ],
      [
        -319.5,
        -2339.0,
        690.0
      ],
      [
        -308.451171875,
        -2273.305419921875,
        712.0
      ],
      [
        -327.900634765625,
        -2273.304931640625,
        712.0
      ],
      [
        -294.6983947753906,
        -2306.50732421875,
        712.0
      ],
      [
        -294.697998046875,
        -2287.057861328125,
        712.0
      ],
      [
        -341.653076171875,
        -2287.05810546875,
        712.0
      ],
      [
        -341.653564453125,
        -2306.507568359375,
        712.0
      ],
      [
        -318.5,
        -2320.260009765625,
        704.0
      ],
      [
        -327.900390625,
        -2320.260009765625,
        712.0
      ],
      [
        -318.5,
        -2320.260009765625,
        712.0
      ],
      [
        -327.900634765625,
        -2273.304931640625,
        712.0
      ],
      [
        -341.653076171875,
        -2287.05810546875,
        712.0
      ],
      [
        -336.6533203125,
        -2297.0,
        663.0
      ],
      [
        -331.6534423828125,
        -2297.0,
        663.0
      ],
      [
        -318.5,
        -2278.30517578125,
        663.0
      ],
      [
        -318.5,
        -2283.304931640625,
        663.0
      ],
      [
        -330.8057861328125,
        -2297.0,
        663.0
      ],
      [
        -318.5,
        -2284.152587890625,
        663.0
      ],
      [
        -318.5,
        -2297.0,
        663.0
      ],
      [
        -328.7605895996094,
        -2297.0,
        638.0
      ],
      [
        -327.6781921386719,
        -2297.0,
        638.0
      ],
      [
        -318.5,
        -2286.84716796875,
        638.0
      ],
      [
        -318.5,
        -2287.84716796875,
        638.0
      ],
      [
        -327.6781921386719,
        -2297.0,
        638.0
      ],
      [
        -318.5,
        -2287.84716796875,
        638.0
      ],
      [
        -318.5,
        -2297.0,
        638.0
      ],
      [
        -318.5,
        -2286.84716796875,
        637.0
      ],
      [
        -318.5,
        -2286.84716796875,
        638.0
      ],
      [
        -328.7605895996094,
        -2297.0,
        637.0
      ],
      [
        -328.7605895996094,
        -2297.0,
        638.0
      ],
      [
        -318.5,
        -2287.30517578125,
        655.0
      ],
      [
        -327.6531982421875,
        -2297.0,
        655.0
      ],
      [
        -318.5,
        -2297.0,
        655.0
      ],
      [
        -331.6534423828125,
        -2297.0,
        663.0
      ],
      [
        -330.6533203125,
        -2297.0,
        658.0
      ],
      [
        -318.5,
        -2283.304931640625,
        663.0
      ],
      [
        -318.5,
        -2284.30517578125,
        658.0
      ],
      [
        -330.6533203125,
        -2297.0,
        658.0
      ],
      [
        -327.6531982421875,
        -2297.0,
        655.0
      ],
      [
        -318.5,
        -2284.30517578125,
        658.0
      ],
      [
        -318.5,
        -2287.30517578125,
        655.0
      ],
      [
        -336.6533203125,
        -2297.0,
        664.0
      ],
      [
        -333.6534423828125,
        -2297.0,
        664.0
      ],
      [
        -318.5,
        -2278.30517578125,
        664.0
      ],
      [
        -318.5,
        -2281.304931640625,
        664.0
      ],
      [
        -336.6533203125,
        -2297.0,
        664.0
      ],
      [
        -336.6533203125,
        -2297.0,
        663.0
      ],
      [
        -318.97412109375,
        -2278.30517578125,
        664.0
      ],
      [
        -318.5,
        -2278.30517578125,
        663.0
      ],
      [
        -318.5,
        -2278.30517578125,
        663.6647338867188
      ],
      [
        -331.8057861328125,
        -2297.0,
        664.0
      ],
      [
        -330.8057861328125,
        -2297.0,
        663.0
      ],
      [
        -318.5,
        -2283.152587890625,
        664.0
      ],
      [
        -318.5,
        -2284.152587890625,
        663.0
      ],
      [
        -318.5,
        -2278.30517578125,
        664.0
      ],
      [
        -331.6534423828125,
        -2297.0,
        694.0
      ],
      [
        -341.6533203125,
        -2297.0,
        704.0
      ],
      [
        -318.5,
        -2283.304931640625,
        694.0
      ],
      [
        -318.5,
        -2273.30517578125,
        704.0
      ],
      [
        -331.81494140625,
        -2291.13330078125,
        712.0
      ],
      [
        -323.825439453125,
        -2283.143310546875,
        712.0
      ],
      [
        -331.8150634765625,
        -2297.0,
        696.8034057617188
      ],
      [
        -331.8150634765625,
        -2297.0,
        703.3182373046875
      ],
      [
        -331.8150634765625,
        -2297.0,
        705.3182373046875
      ],
      [
        -331.8150634765625,
        -2297.0,
        712.0
      ],
      [
        -331.81494140625,
        -2291.13330078125,
        712.0
      ],
      [
        -318.5,
        -2283.143310546875,
        696.8034057617188
      ],
      [
        -318.5,
        -2283.143310546875,
        703.3182373046875
      ],
      [
        -318.5,
        -2283.143310546875,
        705.3182373046875
      ],
      [
        -323.825439453125,
        -2283.143310546875,
        712.0
      ],
      [
        -318.5,
        -2283.143310546875,
        712.0
      ],
      [
        -320.621337890625,
        -2294.878662109375,
        712.0
      ],
      [
        -318.5,
        -2294.0,
        712.0
      ],
      [
        -321.5,
        -2297.0,
        712.0
      ],
      [
        -320.621337890625,
        -2294.878662109375,
        712.0
      ],
      [
        -329.9674072265625,
        -2297.0,
        703.3182373046875
      ],
      [
        -331.8150634765625,
        -2297.0,
        703.3182373046875
      ],
      [
        -318.5,
        -2284.990966796875,
        703.3182373046875
      ],
      [
        -318.5,
        -2283.143310546875,
        703.3182373046875
      ],
      [
        -329.9674072265625,
        -2297.0,
        703.3182373046875
      ],
      [
        -329.9674072265625,
        -2297.0,
        705.3182373046875
      ],
      [
        -318.5,
        -2284.990966796875,
        703.3182373046875
      ],
      [
        -318.5,
        -2284.990966796875,
        705.3182373046875
      ],
      [
        -329.9324951171875,
        -2291.9130859375,
        692.2789916992188
      ],
      [
        -323.0456848144531,
        -2285.025634765625,
        692.2792358398438
      ],
      [
        -321.2511291503906,
        -2283.143310546875,
        696.8034057617188
      ],
      [
        -329.9674072265625,
        -2297.0,
        694.8182373046875
      ],
      [
        -329.9324951171875,
        -2291.9130859375,
        692.2789916992188
      ],
      [
        -329.9326171875,
        -2297.0,
        692.2791137695312
      ],
      [
        -323.0456848144531,
        -2285.025634765625,
        692.2792358398438
      ],
      [
        -318.5,
        -2284.990966796875,
        694.8182373046875
      ],
      [
        -318.5,
        -2285.02587890625,
        692.2793579101562
      ],
      [
        -318.5,
        -2283.143310546875,
        696.8034057617188
      ],
      [
        -318.5,
        -2284.990966796875,
        694.8182373046875
      ],
      [
        -318.5,
        -2283.304931640625,
        690.2816162109375
      ],
      [
        -318.5,
        -2283.304931640625,
        694.0
      ],
      [
        -318.5,
        -2285.0703125,
        689.0333251953125
      ],
      [
        -331.6534423828125,
        -2297.0,
        694.0
      ],
      [
        -331.6534423828125,
        -2297.0,
        689.8990478515625
      ],
      [
        -329.88287353515625,
        -2297.0,
        688.6470336914062
      ],
      [
        -331.650146484375,
        -2296.85400390625,
        690.0
      ],
      [
        -331.650146484375,
        -2297.0,
        690.0
      ],
      [
        -331.796142578125,
        -2297.0,
        690.0
      ],
      [
        -333.6534423828125,
        -2297.0,
        674.0
      ],
      [
        -331.6534423828125,
        -2297.0,
        684.0
      ],
      [
        -333.6534423828125,
        -2297.0,
        664.0
      ],
      [
        -333.6534423828125,
        -2297.0,
        674.0
      ],
      [
        -318.5,
        -2281.304931640625,
        674.0
      ],
      [
        -318.5,
        -2283.304931640625,
        684.0
      ],
      [
        -321.9739990234375,
        -2281.304931640625,
        664.0
      ],
      [
        -321.98919677734375,
        -2281.304931640625,
        674.0
      ],
      [
        -331.8162841796875,
        -2297.0,
        673.786865234375
      ],
      [
        -331.8057861328125,
        -2297.0,
        664.0
      ],
      [
        -318.5,
        -2283.1474609375,
        668.0
      ],
      [
        -318.5,
        -2283.1474609375,
        666.0
      ],
      [
        -318.5,
        -2283.14208984375,
        673.786865234375
      ],
      [
        -318.5,
        -2283.152587890625,
        664.0
      ],
      [
        -318.5,
        -2281.304931640625,
        664.0
      ],
      [
        -318.5,
        -2281.304931640625,
        674.0
      ],
      [
        -320.9277038574219,
        -2285.04638671875,
        690.766845703125
      ],
      [
        -329.9118347167969,
        -2294.03125,
        690.7666625976562
      ],
      [
        -329.8162841796875,
        -2297.0,
        683.786865234375
      ],
      [
        -331.8162841796875,
        -2297.0,
        673.786865234375
      ],
      [
        -329.8162841796875,
        -2297.0,
        683.786865234375
      ],
      [
        -318.5,
        -2285.14208984375,
        683.786865234375
      ],
      [
        -318.5,
        -2283.14208984375,
        673.786865234375
      ],
      [
        -318.5,
        -2285.14208984375,
        683.786865234375
      ],
      [
        -325.75848388671875,
        -2285.304931640625,
        694.0
      ],
      [
        -329.6532897949219,
        -2289.199951171875,
        694.0
      ],
      [
        -318.5,
        -2283.304931640625,
        684.0
      ],
      [
        -319.5,
        -2276.218017578125,
        687.5
      ],
      [
        -318.5,
        -2283.3046875,
        687.5
      ],
      [
        -318.5,
        -2275.218017578125,
        687.5
      ],
      [
        -318.5,
        -2283.3046875,
        690.0
      ],
      [
        -319.5,
        -2276.218017578125,
        690.0
      ],
      [
        -318.5,
        -2275.218017578125,
        690.0
      ],
      [
        -319.5,
        -2276.218017578125,
        690.0
      ],
      [
        -319.5,
        -2276.218017578125,
        687.5
      ],
      [
        -319.5,
        -2273.30517578125,
        690.0
      ],
      [
        -319.5,
        -2273.30517578125,
        687.5
      ],
      [
        -318.5,
        -2273.30517578125,
        687.5
      ],
      [
        -319.5,
        -2273.30517578125,
        687.5
      ],
      [
        -319.5,
        -2273.30517578125,
        690.0
      ],
      [
        -318.5,
        -2273.30517578125,
        690.0
      ],
      [
        -331.6534423828125,
        -2297.0,
        684.0
      ],
      [
        -341.6533203125,
        -2296.0,
        687.5
      ],
      [
        -341.6533203125,
        -2296.0,
        690.0
      ],
      [
        -331.650146484375,
        -2297.0,
        687.5
      ],
      [
        -341.6533203125,
        -2296.0,
        687.5
      ],
      [
        -341.6533508300781,
        -2297.0,
        687.5
      ],
      [
        -341.6533203125,
        -2296.0,
        690.0
      ],
      [
        -341.6533508300781,
        -2297.0,
        690.0
      ],
      [
        -341.653564453125,
        -2306.507568359375,
        712.0
      ],
      [
        -327.900390625,
        -2320.260009765625,
        712.0
      ],
      [
        -318.5,
        -2315.26025390625,
        663.0
      ],
      [
        -318.5,
        -2310.260009765625,
        663.0
      ],
      [
        -318.5,
        -2309.41259765625,
        663.0
      ],
      [
        -318.5,
        -2308.989013671875,
        638.0
      ],
      [
        -318.5,
        -2307.989013671875,
        638.0
      ],
      [
        -318.5,
        -2307.989013671875,
        638.0
      ],
      [
        -318.5,
        -2308.989013671875,
        637.0
      ],
      [
        -318.5,
        -2308.989013671875,
        638.0
      ],
      [
        -318.5,
        -2306.260009765625,
        655.0
      ],
      [
        -318.5,
        -2310.260009765625,
        663.0
      ],
      [
        -318.5,
        -2309.260009765625,
        658.0
      ],
      [
        -318.5,
        -2309.260009765625,
        658.0
      ],
      [
        -318.5,
        -2306.260009765625,
        655.0
      ],
      [
        -318.5,
        -2310.260009765625,
        694.0
      ],
      [
        -318.5,
        -2320.260009765625,
        704.0
      ],
      [
        -323.8251953125,
        -2310.421630859375,
        712.0
      ],
      [
        -331.815185546875,
        -2302.43212890625,
        712.0
      ],
      [
        -331.815185546875,
        -2302.43212890625,
        712.0
      ],
      [
        -318.5,
        -2310.421630859375,
        696.8033447265625
      ],
      [
        -318.5,
        -2310.421630859375,
        703.3181762695312
      ],
      [
        -318.5,
        -2310.421630859375,
        705.3181762695312
      ],
      [
        -318.5,
        -2310.421630859375,
        712.0
      ],
      [
        -323.8251953125,
        -2310.421630859375,
        712.0
      ],
      [
        -320.621337890625,
        -2299.121337890625,
        712.0
      ],
      [
        -321.5,
        -2297.0,
        712.0
      ],
      [
        -318.5,
        -2300.0,
        712.0
      ],
      [
        -320.621337890625,
        -2299.121337890625,
        712.0
      ],
      [
        -318.5,
        -2308.573974609375,
        703.3181762695312
      ],
      [
        -318.5,
        -2310.421630859375,
        703.3181762695312
      ],
      [
        -318.5,
        -2308.573974609375,
        703.3181762695312
      ],
      [
        -318.5,
        -2308.573974609375,
        705.3181762695312
      ],
      [
        -323.0454406738281,
        -2308.539306640625,
        692.2789916992188
      ],
      [
        -329.9327392578125,
        -2301.65234375,
        692.2791748046875
      ],
      [
        -329.9327392578125,
        -2301.65234375,
        692.2791748046875
      ],
      [
        -329.9326171875,
        -2297.0,
        692.2791137695312
      ],
      [
        -318.5,
        -2308.573974609375,
        694.8181762695312
      ],
      [
        -323.0454406738281,
        -2308.539306640625,
        692.279052734375
      ],
      [
        -318.5,
        -2308.5390625,
        692.2789306640625
      ],
      [
        -318.5,
        -2310.260009765625,
        694.0
      ],
      [
        -318.5,
        -2310.260009765625,
        690.281982421875
      ],
      [
        -318.5,
        -2308.49462890625,
        689.0336303710938
      ],
      [
        -331.6534423828125,
        -2297.0,
        690.2060546875
      ],
      [
        -329.8871154785156,
        -2297.0,
        688.9570922851562
      ],
      [
        -318.5,
        -2312.26025390625,
        664.0
      ],
      [
        -318.5,
        -2310.460205078125,
        664.0
      ],
      [
        -318.5,
        -2315.26025390625,
        664.0
      ],
      [
        -318.5,
        -2312.26025390625,
        664.0
      ],
      [
        -318.9735412597656,
        -2315.26025390625,
        664.0
      ],
      [
        -318.5,
        -2315.26025390625,
        663.6651611328125
      ],
      [
        -318.5,
        -2315.26025390625,
        663.0
      ],
      [
        -318.5,
        -2310.41259765625,
        664.0
      ],
      [
        -318.5,
        -2309.41259765625,
        663.0
      ],
      [
        -318.5,
        -2315.26025390625,
        664.0
      ],
      [
        -318.5,
        -2312.26025390625,
        674.0
      ],
      [
        -318.5,
        -2310.260009765625,
        684.0
      ],
      [
        -321.98651123046875,
        -2312.26025390625,
        672.5554809570312
      ],
      [
        -321.97357177734375,
        -2312.26025390625,
        664.0
      ],
      [
        -321.9887390136719,
        -2312.26025390625,
        674.0
      ],
      [
        -321.98651123046875,
        -2312.26025390625,
        672.5554809570312
      ],
      [
        -328.1180419921875,
        -2303.467041015625,
        692.2791137695312
      ],
      [
        -321.9280090332031,
        -2312.26025390625,
        674.0
      ],
      [
        -321.9884033203125,
        -2312.26025390625,
        673.7864990234375
      ],
      [
        -320.9271545410156,
        -2308.5185546875,
        690.7666015625
      ],
      [
        -318.5,
        -2312.26025390625,
        674.0
      ],
      [
        -318.5,
        -2312.26025390625,
        672.0
      ],
      [
        -318.5,
        -2308.4228515625,
        683.786865234375
      ],
      [
        -318.5,
        -2312.26025390625,
        672.0
      ],
      [
        -318.5,
        -2310.494384765625,
        672.0
      ],
      [
        -318.5,
        -2308.4228515625,
        683.786865234375
      ],
      [
        -318.5,
        -2310.423095703125,
        673.786865234375
      ],
      [
        -318.5,
        -2310.423095703125,
        673.786865234375
      ],
      [
        -318.5,
        -2310.460205078125,
        672.0
      ],
      [
        -318.5,
        -2310.460205078125,
        672.0
      ],
      [
        -329.6535339355469,
        -2304.365234375,
        694.0
      ],
      [
        -325.75872802734375,
        -2308.259765625,
        694.0
      ],
      [
        -318.5,
        -2310.260009765625,
        684.0
      ],
      [
        -318.5,
        -2310.260009765625,
        687.5
      ],
      [
        -319.5,
        -2317.3466796875,
        687.5
      ],
      [
        -318.5,
        -2318.3466796875,
        687.5
      ],
      [
        -319.5,
        -2317.3466796875,
        690.0
      ],
      [
        -318.5,
        -2310.260009765625,
        690.0
      ],
      [
        -318.5,
        -2318.3466796875,
        690.0
      ],
      [
        -319.5,
        -2317.3466796875,
        687.5
      ],
      [
        -319.5,
        -2317.3466796875,
        690.0
      ],
      [
        -319.5,
        -2320.260009765625,
        687.5
      ],
      [
        -319.5,
        -2320.260009765625,
        690.0
      ],
      [
        -319.5,
        -2320.260009765625,
        687.5
      ],
      [
        -318.5,
        -2320.260009765625,
        687.5
      ],
      [
        -319.5,
        -2320.260009765625,
        690.0
      ],
      [
        -318.5,
        -2320.260009765625,
        690.0
      ],
      [
        -341.65338134765625,
        -2298.5,
        690.0
      ],
      [
        -341.65338134765625,
        -2298.5,
        687.5
      ],
      [
        -341.65338134765625,
        -2298.5,
        687.5
      ],
      [
        -341.65338134765625,
        -2298.5,
        690.0
      ],
      [
        -318.5,
        -2339.0,
        687.5
      ],
      [
        -318.5,
        -2339.0,
        690.0
      ],
      [
        -308.450927734375,
        -2320.260009765625,
        712.0
      ],
      [
        -294.697998046875,
        -2287.057861328125,
        712.0
      ],
      [
        -308.451171875,
        -2273.305419921875,
        712.0
      ],
      [
        -299.6982421875,
        -2297.0,
        663.0
      ],
      [
        -304.6982421875,
        -2297.0,
        663.0
      ],
      [
        -305.5457763671875,
        -2297.0,
        663.0
      ],
      [
        -318.5,
        -2297.0,
        663.0
      ],
      [
        -307.2394104003906,
        -2297.0,
        638.0
      ],
      [
        -308.3218078613281,
        -2297.0,
        638.0
      ],
      [
        -318.5,
        -2297.0,
        638.0
      ],
      [
        -308.3218078613281,
        -2297.0,
        638.0
      ],
      [
        -307.2394104003906,
        -2297.0,
        637.0
      ],
      [
        -307.2394104003906,
        -2297.0,
        638.0
      ],
      [
        -318.5,
        -2297.0,
        655.0
      ],
      [
        -308.698486328125,
        -2297.0,
        655.0
      ],
      [
        -304.6982421875,
        -2297.0,
        663.0
      ],
      [
        -305.6983642578125,
        -2297.0,
        658.0
      ],
      [
        -305.6983642578125,
        -2297.0,
        658.0
      ],
      [
        -308.698486328125,
        -2297.0,
        655.0
      ],
      [
        -299.6982421875,
        -2297.0,
        664.0
      ],
      [
        -302.6981201171875,
        -2297.0,
        664.0
      ],
      [
        -299.6982421875,
        -2295.984130859375,
        664.0
      ],
      [
        -299.6982421875,
        -2297.0,
        663.0
      ],
      [
        -299.6982421875,
        -2297.0,
        663.28173828125
      ],
      [
        -304.5457763671875,
        -2297.0,
        664.0
      ],
      [
        -305.5457763671875,
        -2297.0,
        663.0
      ],
      [
        -299.6982421875,
        -2297.0,
        664.0
      ],
      [
        -304.6982421875,
        -2297.0,
        694.0
      ],
      [
        -294.6982421875,
        -2297.0,
        704.0
      ],
      [
        -312.5263671875,
        -2283.1435546875,
        712.0
      ],
      [
        -304.53662109375,
        -2291.133056640625,
        712.0
      ],
      [
        -312.5263671875,
        -2283.1435546875,
        712.0
      ],
      [
        -304.53662109375,
        -2297.0,
        696.8034057617188
      ],
      [
        -304.53662109375,
        -2297.0,
        703.3182373046875
      ],
      [
        -304.53662109375,
        -2297.0,
        705.3182373046875
      ],
      [
        -304.53662109375,
        -2291.133056640625,
        712.0
      ],
      [
        -304.53662109375,
        -2297.0,
        712.0
      ],
      [
        -316.378662109375,
        -2294.878662109375,
        712.0
      ],
      [
        -315.5,
        -2297.0,
        712.0
      ],
      [
        -318.5,
        -2294.0,
        712.0
      ],
      [
        -316.378662109375,
        -2294.878662109375,
        712.0
      ],
      [
        -306.38427734375,
        -2297.0,
        703.3182373046875
      ],
      [
        -304.53662109375,
        -2297.0,
        703.3182373046875
      ],
      [
        -306.38427734375,
        -2297.0,
        703.3182373046875
      ],
      [
        -306.38427734375,
        -2297.0,
        705.3182373046875
      ],
      [
        -313.3061218261719,
        -2285.02587890625,
        692.2791748046875
      ],
      [
        -306.4190673828125,
        -2291.912841796875,
        692.2791137695312
      ],
      [
        -315.1010437011719,
        -2283.1435546875,
        696.8033447265625
      ],
      [
        -313.3061218261719,
        -2285.02587890625,
        692.2791748046875
      ],
      [
        -318.5,
        -2285.02587890625,
        692.279296875
      ],
      [
        -306.4190673828125,
        -2291.912841796875,
        692.2791137695312
      ],
      [
        -306.38427734375,
        -2297.0,
        694.8182373046875
      ],
      [
        -306.4190673828125,
        -2297.0,
        692.2791137695312
      ],
      [
        -304.6982421875,
        -2297.0,
        689.8987426757812
      ],
      [
        -304.6982421875,
        -2297.0,
        694.0
      ],
      [
        -306.46881103515625,
        -2297.0,
        688.646728515625
      ],
      [
        -304.68994140625,
        -2297.0,
        690.0
      ],
      [
        -304.68994140625,
        -2296.864990234375,
        690.0
      ],
      [
        -304.554931640625,
        -2297.0,
        690.0
      ],
      [
        -318.5,
        -2283.304931640625,
        689.8235473632812
      ],
      [
        -318.5,
        -2285.07666015625,
        688.57080078125
      ],
      [
        -318.250732421875,
        -2283.3046875,
        690.0
      ],
      [
        -318.5,
        -2283.055419921875,
        690.0
      ],
      [
        -302.6981201171875,
        -2297.0,
        674.0
      ],
      [
        -304.6982421875,
        -2297.0,
        684.0
      ],
      [
        -302.69805908203125,
        -2292.984619140625,
        664.0
      ],
      [
        -302.69805908203125,
        -2292.969482421875,
        674.0
      ],
      [
        -304.5352783203125,
        -2297.0,
        673.786865234375
      ],
      [
        -304.5457763671875,
        -2297.0,
        664.0
      ],
      [
        -302.6981201171875,
        -2297.0,
        664.0
      ],
      [
        -302.6981201171875,
        -2297.0,
        674.0
      ],
      [
        -315.4241943359375,
        -2285.046630859375,
        690.7669067382812
      ],
      [
        -306.4397888183594,
        -2294.03076171875,
        690.766845703125
      ],
      [
        -306.535400390625,
        -2297.0,
        683.786865234375
      ],
      [
        -304.5352783203125,
        -2297.0,
        673.786865234375
      ],
      [
        -306.535400390625,
        -2297.0,
        683.786865234375
      ],
      [
        -306.697998046875,
        -2289.2001953125,
        694.0
      ],
      [
        -310.5931091308594,
        -2285.30517578125,
        694.0
      ],
      [
        -304.6982421875,
        -2297.0,
        684.0
      ],
      [
        -297.06927490234375,
        -2296.0,
        687.5
      ],
      [
        -304.68994140625,
        -2297.0,
        687.5
      ],
      [
        -296.0692138671875,
        -2297.0,
        687.5
      ],
      [
        -297.06939697265625,
        -2296.0,
        690.0
      ],
      [
        -296.0691833496094,
        -2297.0,
        690.0
      ],
      [
        -297.06939697265625,
        -2296.0,
        690.0
      ],
      [
        -297.06927490234375,
        -2296.0,
        687.5
      ],
      [
        -294.6983947753906,
        -2296.0,
        690.0
      ],
      [
        -294.69842529296875,
        -2296.0,
        687.5
      ],
      [
        -294.6983947753906,
        -2296.0,
        690.0
      ],
      [
        -294.69842529296875,
        -2297.0,
        690.0
      ],
      [
        -294.6984558105469,
        -2297.0,
        687.5
      ],
      [
        -294.69842529296875,
        -2296.0,
        687.5
      ],
      [
        -317.0,
        -2273.30517578125,
        687.5
      ],
      [
        -317.0,
        -2273.30517578125,
        690.0
      ],
      [
        -317.0,
        -2273.30517578125,
        687.5
      ],
      [
        -317.0,
        -2273.30517578125,
        690.0
      ],
      [
        -308.450927734375,
        -2320.260009765625,
        712.0
      ],
      [
        -294.6983947753906,
        -2306.50732421875,
        712.0
      ],
      [
        -299.6982421875,
        -2297.580322265625,
        664.0
      ],
      [
        -299.6982421875,
        -2297.0,
        663.5897216796875
      ],
      [
        -304.53662109375,
        -2302.43212890625,
        712.0
      ],
      [
        -312.5263671875,
        -2310.421875,
        712.0
      ],
      [
        -312.5263671875,
        -2310.421875,
        712.0
      ],
      [
        -304.53662109375,
        -2302.43212890625,
        712.0
      ],
      [
        -315.5,
        -2297.0,
        712.0
      ],
      [
        -316.378662109375,
        -2299.121337890625,
        712.0
      ],
      [
        -316.378662109375,
        -2299.121337890625,
        712.0
      ],
      [
        -318.5,
        -2300.0,
        712.0
      ],
      [
        -306.4190673828125,
        -2301.65234375,
        692.2791748046875
      ],
      [
        -313.3061218261719,
        -2308.53955078125,
        692.2791748046875
      ],
      [
        -313.3061218261719,
        -2308.53955078125,
        692.2791748046875
      ],
      [
        -318.5,
        -2308.5390625,
        692.2789916992188
      ],
      [
        -306.4190673828125,
        -2301.65234375,
        692.2791748046875
      ],
      [
        -306.4190673828125,
        -2297.0,
        692.2791137695312
      ],
      [
        -304.6982421875,
        -2297.0,
        690.2062377929688
      ],
      [
        -306.4645690917969,
        -2297.0,
        688.957275390625
      ],
      [
        -318.5,
        -2310.260009765625,
        689.8231811523438
      ],
      [
        -318.5,
        -2308.48828125,
        688.5704345703125
      ],
      [
        -318.24993896484375,
        -2310.260009765625,
        690.0
      ],
      [
        -318.5,
        -2310.510009765625,
        690.0
      ],
      [
        -302.69818115234375,
        -2300.580322265625,
        664.0
      ],
      [
        -302.69818115234375,
        -2300.595458984375,
        674.0
      ],
      [
        -306.4397888183594,
        -2299.534423828125,
        690.7669677734375
      ],
      [
        -315.4239501953125,
        -2308.5185546875,
        690.7669067382812
      ],
      [
        -318.5,
        -2310.516845703125,
        672.0
      ],
      [
        -310.5927429199219,
        -2308.259765625,
        694.0
      ],
      [
        -306.69830322265625,
        -2304.365234375,
        694.0
      ],
      [
        -298.0047302246094,
        -2298.5,
        690.0
      ],
      [
        -296.5048522949219,
        -2297.0,
        690.0
      ],
      [
        -298.0047302246094,
        -2298.5,
        687.5
      ],
      [
        -296.5048828125,
        -2297.0,
        687.5
      ],
      [
        -298.0047607421875,
        -2298.5,
        687.5
      ],
      [
        -298.0047302246094,
        -2298.5,
        690.0
      ],
      [
        -294.698486328125,
        -2298.5,
        687.5
      ],
      [
        -294.6984558105469,
        -2298.5,
        690.0
      ],
      [
        -294.6984558105469,
        -2298.5,
        690.0
      ],
      [
        -294.698486328125,
        -2298.5,
        687.5
      ],
      [
        -317.0,
        -2320.260009765625,
        690.0
      ],
      [
        -317.0,
        -2320.260009765625,
        687.5
      ],
      [
        -318.5,
        -2320.260009765625,
        687.5
      ],
      [
        -317.0,
        -2320.260009765625,
        687.5
      ],
      [
        -317.0,
        -2320.260009765625,
        690.0
      ],
      [
        -318.5,
        -2320.260009765625,
        690.0
      ],
      [
        -376.84716796875,
        -2319.005126953125,
        637.0
      ],
      [
        -376.84716796875,
        -2319.005126953125,
        638.002197265625
      ],
      [
        -376.84716796875,
        -2319.005126953125,
        654.5
      ],
      [
        -376.84716796875,
        -2319.005126953125,
        652.0
      ],
      [
        -376.84716796875,
        -2314.728759765625,
        652.0
      ],
      [
        -376.84716796875,
        -2319.005126953125,
        652.0
      ],
      [
        -376.84716796875,
        -2319.005126953125,
        638.002197265625
      ],
      [
        -376.84716796875,
        -2314.728759765625,
        638.002197265625
      ],
      [
        -376.84716796875,
        -2314.728759765625,
        638.002197265625
      ],
      [
        -376.84716796875,
        -2314.728759765625,
        652.0
      ],
      [
        -376.84716796875,
        -2335.287353515625,
        652.0
      ],
      [
        -376.84716796875,
        -2335.287353515625,
        637.0
      ],
      [
        -376.84716796875,
        -2333.12939453125,
        654.5
      ],
      [
        -376.84716796875,
        -2319.005126953125,
        654.5
      ],
      [
        -376.84716796875,
        -2334.370849609375,
        653.0589599609375
      ],
      [
        -376.84716796875,
        -2333.12939453125,
        654.5
      ],
      [
        -376.84716796875,
        -2335.287353515625,
        652.0
      ],
      [
        -376.84716796875,
        -2334.370849609375,
        653.0589599609375
      ],
      [
        -371.9436950683594,
        -2273.303955078125,
        709.0
      ],
      [
        -371.9436950683594,
        -2273.303955078125,
        712.0
      ],
      [
        -371.9436950683594,
        -2273.303955078125,
        637.0
      ],
      [
        -371.9436950683594,
        -2273.303955078125,
        644.0
      ],
      [
        -371.9436950683594,
        -2273.303955078125,
        709.0
      ],
      [
        -371.9436950683594,
        -2273.303955078125,
        660.0
      ],
      [
        -376.84716796875,
        -2282.430908203125,
        660.0
      ],
      [
        -376.84716796875,
        -2282.430908203125,
        645.0
      ],
      [
        -376.84716796875,
        -2282.430908203125,
        660.0
      ],
      [
        -372.0025634765625,
        -2273.3037109375,
        660.0
      ],
      [
        -376.84716796875,
        -2273.3037109375,
        660.0
      ],
      [
        -372.0026550292969,
        -2273.3037109375,
        645.0
      ],
      [
        -376.84716796875,
        -2282.430908203125,
        645.0
      ],
      [
        -376.84716796875,
        -2273.3037109375,
        645.0
      ],
      [
        -372.0025634765625,
        -2273.3037109375,
        660.0
      ],
      [
        -372.0026550292969,
        -2273.3037109375,
        657.0
      ],
      [
        -372.0026550292969,
        -2273.3037109375,
        649.0
      ],
      [
        -372.0026550292969,
        -2273.3037109375,
        645.0
      ],
      [
        -372.0026550292969,
        -2273.3037109375,
        657.0
      ],
      [
        -375.0616760253906,
        -2280.831298828125,
        657.0
      ],
      [
        -371.94366455078125,
        -2273.3037109375,
        657.0
      ],
      [
        -372.0026550292969,
        -2273.3037109375,
        649.0
      ],
      [
        -371.94366455078125,
        -2273.3037109375,
        649.0
      ],
      [
        -375.0616760253906,
        -2280.831298828125,
        649.0
      ],
      [
        -375.0616760253906,
        -2280.831298828125,
        649.0
      ],
      [
        -375.0616760253906,
        -2280.831298828125,
        657.0
      ],
      [
        -376.840087890625,
        -2300.5,
        687.5
      ],
      [
        -376.840087890625,
        -2300.5,
        690.0
      ],
      [
        -376.840087890625,
        -2296.0,
        692.0
      ],
      [
        -376.840087890625,
        -2296.0,
        670.5
      ],
      [
        -371.9436950683594,
        -2273.303955078125,
        644.0
      ],
      [
        -366.635986328125,
        -2273.30419921875,
        647.0
      ],
      [
        -371.9436950683594,
        -2273.303955078125,
        660.0
      ],
      [
        -366.635986328125,
        -2273.30419921875,
        660.0
      ],
      [
        -366.6358947753906,
        -2273.30419921875,
        649.0
      ],
      [
        -366.635986328125,
        -2273.30419921875,
        647.0
      ],
      [
        -366.635986328125,
        -2273.30419921875,
        660.0
      ],
      [
        -366.6358947753906,
        -2273.30419921875,
        657.0
      ],
      [
        -366.6358947753906,
        -2273.30419921875,
        657.0
      ],
      [
        -366.6358947753906,
        -2273.30419921875,
        649.0
      ],
      [
        -259.15283203125,
        -2314.728759765625,
        638.001220703125
      ],
      [
        -259.15283203125,
        -2319.005126953125,
        638.0
      ],
      [
        -259.15283203125,
        -2328.595703125,
        638.0
      ],
      [
        -259.15283203125,
        -2319.005126953125,
        638.0
      ],
      [
        -259.15283203125,
        -2319.005126953125,
        652.0
      ],
      [
        -259.15283203125,
        -2314.728759765625,
        652.0
      ],
      [
        -259.15283203125,
        -2319.005126953125,
        653.0
      ],
      [
        -259.15283203125,
        -2328.595703125,
        653.0
      ],
      [
        -259.15283203125,
        -2319.005126953125,
        653.0
      ],
      [
        -259.15283203125,
        -2319.005126953125,
        652.0
      ],
      [
        -259.15283203125,
        -2328.595703125,
        652.0
      ],
      [
        -259.15283203125,
        -2328.595703125,
        653.0
      ],
      [
        -262.233154296875,
        -2326.44140625,
        652.0
      ],
      [
        -259.15283203125,
        -2328.595703125,
        638.0
      ],
      [
        -259.15283203125,
        -2314.728759765625,
        652.0
      ],
      [
        -259.15283203125,
        -2314.728759765625,
        638.001220703125
      ],
      [
        -264.05517578125,
        -2273.306396484375,
        709.0
      ],
      [
        -264.05517578125,
        -2273.306396484375,
        712.0
      ],
      [
        -264.05517578125,
        -2273.306396484375,
        644.0
      ],
      [
        -264.05517578125,
        -2273.306396484375,
        637.0
      ],
      [
        -264.05517578125,
        -2273.306396484375,
        660.0
      ],
      [
        -264.05517578125,
        -2273.306396484375,
        709.0
      ],
      [
        -259.15283203125,
        -2282.430908203125,
        645.0
      ],
      [
        -259.15283203125,
        -2282.430908203125,
        660.0
      ],
      [
        -263.9963073730469,
        -2273.306640625,
        660.0
      ],
      [
        -259.15283203125,
        -2282.430908203125,
        660.0
      ],
      [
        -259.15283203125,
        -2273.306640625,
        660.0
      ],
      [
        -259.15283203125,
        -2273.306640625,
        645.0
      ],
      [
        -259.15283203125,
        -2282.430908203125,
        645.0
      ],
      [
        -263.9962158203125,
        -2273.306640625,
        645.0
      ],
      [
        -263.9962158203125,
        -2273.306640625,
        657.0
      ],
      [
        -263.9963073730469,
        -2273.306640625,
        660.0
      ],
      [
        -263.9962158203125,
        -2273.306640625,
        645.0
      ],
      [
        -263.9962158203125,
        -2273.306640625,
        649.0
      ],
      [
        -260.9382629394531,
        -2280.831298828125,
        657.0
      ],
      [
        -263.9962158203125,
        -2273.306640625,
        657.0
      ],
      [
        -264.0550231933594,
        -2273.306640625,
        657.0
      ],
      [
        -260.9382629394531,
        -2280.831298828125,
        649.0
      ],
      [
        -264.0550231933594,
        -2273.306640625,
        649.0
      ],
      [
        -263.9962158203125,
        -2273.306640625,
        649.0
      ],
      [
        -260.9382629394531,
        -2280.831298828125,
        657.0
      ],
      [
        -260.9382629394531,
        -2280.831298828125,
        649.0
      ],
      [
        -259.14990234375,
        -2294.0,
        687.5
      ],
      [
        -259.14990234375,
        -2294.0,
        690.0
      ],
      [
        -259.14990234375,
        -2298.5,
        692.0
      ],
      [
        -259.14990234375,
        -2300.5,
        687.5
      ],
      [
        -269.363037109375,
        -2273.306396484375,
        647.0
      ],
      [
        -264.05517578125,
        -2273.306396484375,
        644.0
      ],
      [
        -269.363037109375,
        -2273.306396484375,
        660.0
      ],
      [
        -264.05517578125,
        -2273.306396484375,
        660.0
      ],
      [
        -269.363037109375,
        -2273.306396484375,
        647.0
      ],
      [
        -269.3631286621094,
        -2273.306396484375,
        649.0
      ],
      [
        -269.3631286621094,
        -2273.306396484375,
        657.0
      ],
      [
        -269.363037109375,
        -2273.306396484375,
        660.0
      ],
      [
        -269.3631286621094,
        -2273.306396484375,
        657.0
      ],
      [
        -269.3631286621094,
        -2273.306396484375,
        649.0
      ],
      [
        -374.0327453613281,
        -2256.361083984375,
        660.0
      ],
      [
        -353.4643249511719,
        -2247.841064453125,
        660.0
      ],
      [
        -361.549560546875,
        -2238.0,
        660.0
      ],
      [
        -368.28631591796875,
        -2238.0,
        660.0
      ],
      [
        -375.40972900390625,
        -2256.931396484375,
        660.0
      ],
      [
        -374.0327453613281,
        -2256.361083984375,
        660.0
      ],
      [
        -375.40972900390625,
        -2256.931396484375,
        660.0
      ],
      [
        -368.28631591796875,
        -2238.0,
        660.0
      ],
      [
        -376.39422607421875,
        -2238.0,
        660.0
      ],
      [
        -376.0252685546875,
        -2257.186279296875,
        660.0
      ],
      [
        -376.0252685546875,
        -2257.186279296875,
        660.0
      ],
      [
        -376.39422607421875,
        -2238.0,
        660.0
      ],
      [
        -376.84716796875,
        -2238.0,
        660.0
      ],
      [
        -376.84716796875,
        -2256.47216796875,
        660.0
      ],
      [
        -376.4715881347656,
        -2257.37109375,
        660.0
      ],
      [
        -376.4715881347656,
        -2257.37109375,
        660.0
      ],
      [
        -376.84716796875,
        -2256.47216796875,
        660.0
      ],
      [
        -376.84716796875,
        -2257.52685546875,
        660.0
      ],
      [
        -361.549560546875,
        -2238.0,
        645.0
      ],
      [
        -368.76507568359375,
        -2238.0,
        645.0
      ],
      [
        -374.0327453613281,
        -2256.361083984375,
        645.0
      ],
      [
        -353.4643249511719,
        -2247.841064453125,
        645.0
      ],
      [
        -374.0327453613281,
        -2256.361083984375,
        645.0
      ],
      [
        -374.0327453613281,
        -2256.361083984375,
        637.0
      ],
      [
        -361.6766052246094,
        -2242.926025390625,
        645.0
      ],
      [
        -361.6766052246094,
        -2242.926025390625,
        637.0
      ],
      [
        -368.76507568359375,
        -2238.0,
        645.0
      ],
      [
        -368.76507568359375,
        -2238.0,
        637.0
      ],
      [
        -353.4643249511719,
        -2247.841064453125,
        660.0
      ],
      [
        -353.4643249511719,
        -2247.841064453125,
        645.0
      ],
      [
        -361.549560546875,
        -2238.0,
        660.0
      ],
      [
        -361.549560546875,
        -2238.0,
        645.0
      ],
      [
        -366.8457946777344,
        -2238.0,
        658.5
      ],
      [
        -361.549560546875,
        -2238.0,
        655.0
      ],
      [
        -366.8457946777344,
        -2238.0,
        660.0
      ],
      [
        -366.8457946777344,
        -2238.0,
        658.5
      ],
      [
        -282.5357971191406,
        -2247.84130859375,
        660.0
      ],
      [
        -261.96685791015625,
        -2256.361328125,
        660.0
      ],
      [
        -261.96685791015625,
        -2256.361328125,
        660.0
      ],
      [
        -260.59014892578125,
        -2256.931640625,
        660.0
      ],
      [
        -267.71368408203125,
        -2238.0,
        660.0
      ],
      [
        -274.450439453125,
        -2238.0,
        660.0
      ],
      [
        -259.9747314453125,
        -2257.1865234375,
        660.0
      ],
      [
        -259.60577392578125,
        -2238.0,
        660.0
      ],
      [
        -267.71368408203125,
        -2238.0,
        660.0
      ],
      [
        -260.59014892578125,
        -2256.931640625,
        660.0
      ],
      [
        -259.5284729003906,
        -2257.371337890625,
        660.0
      ],
      [
        -259.15283203125,
        -2256.47216796875,
        660.0
      ],
      [
        -259.15283203125,
        -2238.0,
        660.0
      ],
      [
        -259.60577392578125,
        -2238.0,
        660.0
      ],
      [
        -259.9747314453125,
        -2257.1865234375,
        660.0
      ],
      [
        -259.15283203125,
        -2257.52685546875,
        660.0
      ],
      [
        -259.15283203125,
        -2256.47216796875,
        660.0
      ],
      [
        -259.5284729003906,
        -2257.371337890625,
        660.0
      ],
      [
        -267.23492431640625,
        -2238.0,
        645.0
      ],
      [
        -274.450439453125,
        -2238.0,
        645.0
      ],
      [
        -282.5357971191406,
        -2247.84130859375,
        645.0
      ],
      [
        -261.96685791015625,
        -2256.361328125,
        645.0
      ],
      [
        -261.96685791015625,
        -2256.361328125,
        637.0
      ],
      [
        -261.96685791015625,
        -2256.361328125,
        645.0
      ],
      [
        -274.32330322265625,
        -2242.92578125,
        645.0
      ],
      [
        -274.32330322265625,
        -2242.92578125,
        637.0
      ],
      [
        -267.23492431640625,
        -2238.0,
        645.0
      ],
      [
        -267.23492431640625,
        -2238.0,
        637.0
      ],
      [
        -282.5357971191406,
        -2247.84130859375,
        645.0
      ],
      [
        -282.5357971191406,
        -2247.84130859375,
        660.0
      ],
      [
        -274.450439453125,
        -2238.0,
        645.0
      ],
      [
        -274.450439453125,
        -2238.0,
        660.0
      ],
      [
        -274.450439453125,
        -2238.0,
        655.0
      ],
      [
        -269.1542053222656,
        -2238.0,
        658.5
      ],
      [
        -269.1542053222656,
        -2238.0,
        658.5
      ],
      [
        -269.1542053222656,
        -2238.0,
        660.0
      ],
      [
        -376.84716796875,
        -2260.359375,
        660.0
      ],
      [
        -376.84716796875,
        -2272.471923828125,
        660.0
      ],
      [
        -376.84716796875,
        -2259.27734375,
        660.0
      ],
      [
        -376.84716796875,
        -2260.359375,
        660.0
      ],
      [
        -376.84716796875,
        -2258.8076171875,
        660.0
      ],
      [
        -376.84716796875,
        -2259.27734375,
        660.0
      ],
      [
        -376.84716796875,
        -2258.466796875,
        660.0
      ],
      [
        -376.84716796875,
        -2258.8076171875,
        660.0
      ],
      [
        -376.84716796875,
        -2258.12060546875,
        660.0
      ],
      [
        -376.84716796875,
        -2258.466796875,
        660.0
      ],
      [
        -376.84716796875,
        -2257.629638671875,
        660.0
      ],
      [
        -376.84716796875,
        -2258.12060546875,
        660.0
      ],
      [
        -376.84716796875,
        -2257.629638671875,
        660.0
      ],
      [
        -376.84716796875,
        -2272.471923828125,
        645.0
      ],
      [
        -376.84716796875,
        -2260.359375,
        645.0
      ],
      [
        -376.84716796875,
        -2260.359375,
        645.0
      ],
      [
        -376.84716796875,
        -2260.359375,
        637.0
      ],
      [
        -354.5302734375,
        -2250.155029296875,
        657.0
      ],
      [
        -354.5302734375,
        -2250.155029296875,
        649.0
      ],
      [
        -354.5302734375,
        -2250.155029296875,
        657.0
      ],
      [
        -354.5302734375,
        -2250.155029296875,
        649.0
      ],
      [
        -259.15283203125,
        -2260.359375,
        660.0
      ],
      [
        -259.15283203125,
        -2272.471923828125,
        660.0
      ],
      [
        -259.15283203125,
        -2260.359375,
        660.0
      ],
      [
        -259.15283203125,
        -2259.27734375,
        660.0
      ],
      [
        -259.15283203125,
        -2259.27734375,
        660.0
      ],
      [
        -259.15283203125,
        -2258.8076171875,
        660.0
      ],
      [
        -259.15283203125,
        -2258.8076171875,
        660.0
      ],
      [
        -259.15283203125,
        -2258.466796875,
        660.0
      ],
      [
        -259.15283203125,
        -2258.466796875,
        660.0
      ],
      [
        -259.15283203125,
        -2258.12060546875,
        660.0
      ],
      [
        -259.15283203125,
        -2258.12060546875,
        660.0
      ],
      [
        -259.15283203125,
        -2257.629638671875,
        660.0
      ],
      [
        -259.15283203125,
        -2257.629638671875,
        660.0
      ],
      [
        -259.15283203125,
        -2260.359375,
        645.0
      ],
      [
        -259.15283203125,
        -2272.471923828125,
        645.0
      ],
      [
        -259.15283203125,
        -2260.359375,
        637.0
      ],
      [
        -259.15283203125,
        -2260.359375,
        645.0
      ],
      [
        -281.46978759765625,
        -2250.155029296875,
        657.0
      ],
      [
        -281.46978759765625,
        -2250.155029296875,
        649.0
      ],
      [
        -281.46978759765625,
        -2250.155029296875,
        649.0
      ],
      [
        -281.46978759765625,
        -2250.155029296875,
        657.0
      ],
      [
        -264.0550231933594,
        -2273.306640625,
        657.0
      ],
      [
        -264.0550231933594,
        -2273.306640625,
        649.0
      ],
      [
        -371.94366455078125,
        -2273.3037109375,
        657.0
      ],
      [
        -371.94366455078125,
        -2273.3037109375,
        649.0
      ],
      [
        -319.5,
        -2238.0,
        692.0
      ],
      [
        -317.0,
        -2238.0,
        692.0
      ],
      [
        -315.0,
        -2238.0,
        687.5
      ],
      [
        -265.2532958984375,
        -2273.306640625,
        657.0
      ],
      [
        -287.443603515625,
        -2251.1162109375,
        657.0
      ],
      [
        -284.665771484375,
        -2246.958984375,
        657.0
      ],
      [
        -265.2532958984375,
        -2273.306640625,
        649.0
      ],
      [
        -287.443603515625,
        -2251.1162109375,
        649.0
      ],
      [
        -284.665771484375,
        -2246.958984375,
        649.0
      ],
      [
        -269.3631286621094,
        -2273.306396484375,
        648.7777709960938
      ],
      [
        -319.5,
        -2238.0,
        670.5
      ],
      [
        -370.7439880371094,
        -2273.3037109375,
        657.0
      ],
      [
        -351.334228515625,
        -2246.958984375,
        657.0
      ],
      [
        -348.556396484375,
        -2251.1162109375,
        657.0
      ],
      [
        -370.7439880371094,
        -2273.3037109375,
        649.0
      ],
      [
        -351.334228515625,
        -2246.958984375,
        649.0
      ],
      [
        -348.556396484375,
        -2251.1162109375,
        649.0
      ],
      [
        -366.6358947753906,
        -2273.30419921875,
        648.77734375
      ],
      [
        -376.84716796875,
        -2268.0,
        660.0
      ],
      [
        -380.328125,
        -2268.0,
        660.0
      ],
      [
        -386.3544006347656,
        -2268.0,
        660.0
      ],
      [
        -380.328125,
        -2268.0,
        660.0
      ],
      [
        -398.9736328125,
        -2268.0,
        660.0
      ],
      [
        -386.3544006347656,
        -2268.0,
        660.0
      ],
      [
        -384.5644226074219,
        -2238.0,
        660.0
      ],
      [
        -384.5644226074219,
        -2238.0,
        660.0
      ],
      [
        -391.450439453125,
        -2238.0,
        660.0
      ],
      [
        -400.99310302734375,
        -2268.0,
        642.8208618164062
      ],
      [
        -400.99310302734375,
        -2268.0,
        637.0
      ],
      [
        -400.99310302734375,
        -2268.0,
        642.8208618164062
      ],
      [
        -399.4113464355469,
        -2268.0,
        644.1360473632812
      ],
      [
        -391.450439453125,
        -2238.0,
        660.0
      ],
      [
        -391.450439453125,
        -2238.0,
        637.0
      ],
      [
        -398.9736328125,
        -2268.0,
        644.5
      ],
      [
        -398.9736328125,
        -2268.0,
        660.0
      ],
      [
        -398.9736328125,
        -2268.0,
        644.5
      ],
      [
        -380.328125,
        -2268.0,
        645.0
      ],
      [
        -380.328125,
        -2268.0,
        637.0
      ],
      [
        -380.328125,
        -2268.0,
        645.0
      ],
      [
        -376.84716796875,
        -2268.0,
        645.0
      ],
      [
        -397.85711669921875,
        -2260.731689453125,
        645.0
      ],
      [
        -386.067138671875,
        -2280.596923828125,
        659.0
      ],
      [
        -394.177734375,
        -2275.177734375,
        659.0
      ],
      [
        -386.067138671875,
        -2280.596923828125,
        659.0
      ],
      [
        -376.84716796875,
        -2282.430908203125,
        659.0
      ],
      [
        -394.177734375,
        -2275.177734375,
        659.0
      ],
      [
        -398.9736328125,
        -2268.0,
        659.0
      ],
      [
        -420.0,
        -2288.0,
        641.0
      ],
      [
        -420.0,
        -2288.0,
        637.0
      ],
      [
        -402.9565734863281,
        -2269.31201171875,
        640.45947265625
      ],
      [
        -402.9565734863281,
        -2269.31201171875,
        640.45947265625
      ],
      [
        -402.9565734863281,
        -2269.31201171875,
        637.0
      ],
      [
        -402.5,
        -2304.0,
        648.0
      ],
      [
        -402.5,
        -2304.0,
        659.0
      ],
      [
        -435.0,
        -2329.5,
        657.0000610351562
      ],
      [
        -433.5,
        -2329.5,
        657.7500610351562
      ],
      [
        -435.0,
        -2335.0,
        657.0000610351562
      ],
      [
        -433.5,
        -2335.0,
        657.7500610351562
      ],
      [
        -435.0,
        -2336.5,
        657.0000610351562
      ],
      [
        -433.5,
        -2336.5,
        657.7500610351562
      ],
      [
        -433.5,
        -2336.5,
        657.7500610351562
      ],
      [
        -433.5,
        -2335.0,
        657.7500610351562
      ],
      [
        -435.0,
        -2331.0,
        657.0000610351562
      ],
      [
        -433.5,
        -2331.0,
        657.7500610351562
      ],
      [
        -433.5,
        -2331.0,
        657.7500610351562
      ],
      [
        -433.5,
        -2329.5,
        657.7500610351562
      ],
      [
        -435.0,
        -2324.0,
        657.0000610351562
      ],
      [
        -433.5,
        -2324.0,
        657.7500610351562
      ],
      [
        -435.0,
        -2325.5,
        657.0000610351562
      ],
      [
        -433.5,
        -2325.5,
        657.7500610351562
      ],
      [
        -433.5,
        -2325.5,
        657.7500610351562
      ],
      [
        -433.5,
        -2324.0,
        657.7500610351562
      ],
      [
        -435.0,
        -2320.5,
        657.0000610351562
      ],
      [
        -433.5,
        -2320.5,
        657.7500610351562
      ],
      [
        -435.0,
        -2319.0,
        657.0000610351562
      ],
      [
        -433.5,
        -2319.0,
        657.7500610351562
      ],
      [
        -433.5,
        -2320.5,
        657.7500610351562
      ],
      [
        -433.5,
        -2319.0,
        657.7500610351562
      ],
      [
        -433.0,
        -2306.0,
        648.0
      ],
      [
        -433.0,
        -2317.0,
        648.0
      ],
      [
        -433.0,
        -2317.0,
        637.0
      ],
      [
        -433.0,
        -2317.0,
        648.0
      ],
      [
        -433.0,
        -2307.619140625,
        656.4872436523438
      ],
      [
        -433.0,
        -2307.619140625,
        649.5127563476562
      ],
      [
        -433.0,
        -2307.619140625,
        649.5127563476562
      ],
      [
        -433.0,
        -2306.0,
        649.5127563476562
      ],
      [
        -433.0,
        -2306.0,
        656.4872436523438
      ],
      [
        -433.0,
        -2307.619140625,
        656.4872436523438
      ],
      [
        -429.69476318359375,
        -2306.989501953125,
        655.8052368164062
      ],
      [
        -433.0,
        -2307.619140625,
        652.4999389648438
      ],
      [
        -429.69476318359375,
        -2306.0,
        655.8052368164062
      ],
      [
        -429.69476318359375,
        -2306.989501953125,
        655.8052368164062
      ],
      [
        -407.4999694824219,
        -2324.5,
        659.0
      ],
      [
        -410.5,
        -2324.5,
        659.0
      ],
      [
        -410.0000305175781,
        -2324.5,
        658.5
      ],
      [
        -408.00006103515625,
        -2324.5,
        658.5
      ],
      [
        -402.5,
        -2324.5,
        658.5
      ],
      [
        -415.5,
        -2324.5,
        658.5
      ],
      [
        -329.699951171875,
        -2356.494140625,
        660.5
      ],
      [
        -306.30224609375,
        -2356.494140625,
        660.5
      ],
      [
        -303.64044189453125,
        -2355.699951171875,
        660.5
      ],
      [
        -306.30224609375,
        -2356.494140625,
        660.5
      ],
      [
        -332.36090087890625,
        -2355.699951171875,
        660.5
      ],
      [
        -329.699951171875,
        -2356.494140625,
        660.5
      ],
      [
        -335.6806335449219,
        -2357.2001953125,
        664.5
      ],
      [
        -335.97308349609375,
        -2356.494140625,
        660.5
      ],
      [
        -300.02691650390625,
        -2356.494140625,
        660.5
      ],
      [
        -300.3193664550781,
        -2357.2001953125,
        664.5
      ],
      [
        -329.699951171875,
        -2356.449951171875,
        641.0
      ],
      [
        -306.3023681640625,
        -2356.449951171875,
        641.0
      ],
      [
        -306.3023681640625,
        -2356.449951171875,
        641.0
      ],
      [
        -304.2542419433594,
        -2355.699951171875,
        641.0
      ],
      [
        -329.699951171875,
        -2356.449951171875,
        641.0
      ],
      [
        -331.74786376953125,
        -2355.699951171875,
        641.0
      ],
      [
        -337.9910888671875,
        -2356.4501953125,
        641.0
      ],
      [
        -337.8677062988281,
        -2356.4794921875,
        640.6664428710938
      ],
      [
        -337.8677062988281,
        -2356.4794921875,
        640.6664428710938
      ],
      [
        -336.5116882324219,
        -2356.802978515625,
        637.0
      ],
      [
        -298.0089111328125,
        -2356.4501953125,
        641.0
      ],
      [
        -298.1322937011719,
        -2356.4794921875,
        640.6664428710938
      ],
      [
        -298.1322937011719,
        -2356.4794921875,
        640.6664428710938
      ],
      [
        -299.4883117675781,
        -2356.802978515625,
        637.0
      ],
      [
        -311.218017578125,
        -2222.778076171875,
        651.30615234375
      ],
      [
        -314.3505554199219,
        -2219.086181640625,
        653.0
      ],
      [
        -312.0603332519531,
        -2223.052734375,
        653.0
      ],
      [
        -314.3505554199219,
        -2219.086181640625,
        653.0
      ],
      [
        -310.4394836425781,
        -2225.860107421875,
        653.0
      ],
      [
        -312.0603332519531,
        -2223.052734375,
        653.0
      ],
      [
        -311.218017578125,
        -2222.778076171875,
        651.30615234375
      ],
      [
        -310.4394836425781,
        -2225.860107421875,
        653.0
      ],
      [
        -327.0,
        -2237.0,
        647.4650268554688
      ],
      [
        -324.3509826660156,
        -2237.0,
        652.0
      ],
      [
        -325.4989318847656,
        -2234.0,
        653.0
      ],
      [
        -325.6121826171875,
        -2234.0,
        652.8060913085938
      ],
      [
        -325.6121826171875,
        -2234.0,
        652.8060913085938
      ],
      [
        -326.0,
        -2234.0,
        652.1422119140625
      ],
      [
        -326.0,
        -2233.132080078125,
        653.0
      ],
      [
        -326.0,
        -2234.0,
        652.1422119140625
      ],
      [
        -325.4989318847656,
        -2234.0,
        653.0
      ],
      [
        -326.0,
        -2233.132080078125,
        653.0
      ],
      [
        -327.0,
        -2238.0,
        646.4769287109375
      ],
      [
        -327.0,
        -2237.0,
        647.4650268554688
      ],
      [
        -324.3509521484375,
        -2237.0,
        652.0
      ],
      [
        -323.773681640625,
        -2238.0,
        652.0
      ],
      [
        -311.218017578125,
        -2222.778076171875,
        642.6163940429688
      ],
      [
        -314.686279296875,
        -2218.6904296875,
        639.562744140625
      ],
      [
        -311.218017578125,
        -2222.778076171875,
        642.6163940429688
      ],
      [
        -310.0,
        -2227.60009765625,
        638.3014526367188
      ],
      [
        -314.686279296875,
        -2218.6904296875,
        639.562744140625
      ],
      [
        -315.6559753417969,
        -2218.3701171875,
        637.4000244140625
      ],
      [
        -310.0,
        -2228.166748046875,
        637.4000244140625
      ],
      [
        -310.0,
        -2227.60009765625,
        638.3014526367188
      ],
      [
        -326.0,
        -2232.133544921875,
        637.4000244140625
      ],
      [
        -326.0,
        -2234.0,
        640.666259765625
      ],
      [
        -310.0,
        -2234.0,
        641.0
      ],
      [
        -310.0,
        -2227.60009765625,
        641.0
      ],
      [
        -326.0,
        -2227.60009765625,
        641.0
      ],
      [
        -328.39990234375,
        -2222.39990234375,
        641.0
      ],
      [
        -326.0,
        -2227.60009765625,
        641.0
      ],
      [
        -326.0,
        -2234.0,
        641.0
      ],
      [
        -314.686279296875,
        -2218.6904296875,
        641.0
      ],
      [
        -319.199951171875,
        -2217.199951171875,
        641.0
      ],
      [
        -319.199951171875,
        -2217.199951171875,
        641.0
      ],
      [
        -328.39990234375,
        -2222.39990234375,
        641.0
      ],
      [
        -310.0,
        -2227.60009765625,
        641.0
      ],
      [
        -310.7617492675781,
        -2224.58447265625,
        641.0
      ],
      [
        -313.05389404296875,
        -2220.6142578125,
        641.0
      ],
      [
        -314.686279296875,
        -2218.6904296875,
        641.0
      ],
      [
        -324.1583251953125,
        -2217.77197265625,
        651.0
      ],
      [
        -325.60498046875,
        -2218.606689453125,
        651.0
      ],
      [
        -259.15283203125,
        -2232.569091796875,
        660.0
      ],
      [
        -259.15283203125,
        -2232.569091796875,
        637.0
      ],
      [
        -259.15283203125,
        -2232.569091796875,
        660.0
      ],
      [
        -269.1542053222656,
        -2238.0,
        659.17626953125
      ],
      [
        -259.15283203125,
        -2235.569091796875,
        660.0
      ],
      [
        -259.15283203125,
        -2235.569091796875,
        658.6612548828125
      ],
      [
        -259.15283203125,
        -2232.569091796875,
        655.0
      ],
      [
        -259.15283203125,
        -2235.569091796875,
        658.5
      ],
      [
        -259.15283203125,
        -2235.569091796875,
        658.5
      ],
      [
        -373.2688293457031,
        -2236.142822265625,
        660.0
      ],
      [
        -366.8457946777344,
        -2238.0,
        659.1760864257812
      ],
      [
        -241.822265625,
        -2275.177734375,
        638.0
      ],
      [
        -239.537109375,
        -2276.70458984375,
        638.0
      ],
      [
        -239.537109375,
        -2273.651123046875,
        643.4481201171875
      ],
      [
        -281.0,
        -2410.0,
        632.5
      ],
      [
        -285.0,
        -2411.5,
        632.5
      ],
      [
        -351.0,
        -2411.5,
        632.5
      ],
      [
        -355.0,
        -2410.0,
        632.5
      ],
      [
        -285.0,
        -2388.5,
        641.0
      ],
      [
        -285.0,
        -2411.5,
        641.0
      ],
      [
        -351.0,
        -2411.5,
        641.0
      ],
      [
        -351.0,
        -2388.5,
        641.0
      ],
      [
        -336.85791015625,
        -2382.64208984375,
        641.0
      ],
      [
        -328.5704040527344,
        -2411.5,
        641.0
      ],
      [
        -329.1787414550781,
        -2408.56884765625,
        641.0
      ],
      [
        -329.1787414550781,
        -2408.56884765625,
        641.0
      ],
      [
        -329.1805419921875,
        -2408.56103515625,
        641.0
      ],
      [
        -329.1805419921875,
        -2408.56103515625,
        641.0
      ],
      [
        -332.44293212890625,
        -2409.91259765625,
        641.0
      ],
      [
        -344.81939697265625,
        -2408.56103515625,
        641.0
      ],
      [
        -341.55706787109375,
        -2409.91259765625,
        641.0
      ],
      [
        -341.23968505859375,
        -2410.0439453125,
        640.7704467773438
      ],
      [
        -340.5085754394531,
        -2410.295166015625,
        640.26123046875
      ],
      [
        -338.8875427246094,
        -2407.242919921875,
        641.0
      ],
      [
        -340.48785400390625,
        -2408.312255859375,
        641.0
      ],
      [
        -333.51214599609375,
        -2408.312255859375,
        641.0
      ],
      [
        -335.1124572753906,
        -2407.242919921875,
        641.0
      ],
      [
        -332.44293212890625,
        -2409.91259765625,
        641.0
      ],
      [
        -333.51214599609375,
        -2408.312255859375,
        641.0
      ],
      [
        -335.1124572753906,
        -2407.242919921875,
        641.0
      ],
      [
        -337.0,
        -2406.867431640625,
        641.0
      ],
      [
        -337.0,
        -2406.867431640625,
        641.0
      ],
      [
        -338.8875427246094,
        -2407.242919921875,
        641.0
      ],
      [
        -340.48785400390625,
        -2408.312255859375,
        641.0
      ],
      [
        -341.55706787109375,
        -2409.91259765625,
        641.0
      ],
      [
        -299.14208984375,
        -2382.64208984375,
        641.0
      ],
      [
        -307.4295959472656,
        -2411.5,
        641.0
      ],
      [
        -306.8211975097656,
        -2408.56884765625,
        641.0
      ],
      [
        -306.81939697265625,
        -2408.56103515625,
        641.0
      ],
      [
        -306.8211975097656,
        -2408.56884765625,
        641.0
      ],
      [
        -291.1805419921875,
        -2408.56103515625,
        641.0
      ],
      [
        -294.44293212890625,
        -2409.91259765625,
        641.0
      ],
      [
        -306.81939697265625,
        -2408.56103515625,
        641.0
      ],
      [
        -303.55706787109375,
        -2409.91259765625,
        641.0
      ],
      [
        -294.7628173828125,
        -2410.045166015625,
        640.7686157226562
      ],
      [
        -295.4914245605469,
        -2410.295166015625,
        640.26123046875
      ],
      [
        -300.8875427246094,
        -2407.242919921875,
        641.0
      ],
      [
        -302.48785400390625,
        -2408.312255859375,
        641.0
      ],
      [
        -295.51214599609375,
        -2408.312255859375,
        641.0
      ],
      [
        -297.1124572753906,
        -2407.242919921875,
        641.0
      ],
      [
        -302.48785400390625,
        -2408.312255859375,
        641.0
      ],
      [
        -303.55706787109375,
        -2409.91259765625,
        641.0
      ],
      [
        -297.1124572753906,
        -2407.242919921875,
        641.0
      ],
      [
        -299.0,
        -2406.867431640625,
        641.0
      ],
      [
        -299.0,
        -2406.867431640625,
        641.0
      ],
      [
        -300.8875427246094,
        -2407.242919921875,
        641.0
      ],
      [
        -294.44293212890625,
        -2409.91259765625,
        641.0
      ],
      [
        -295.51214599609375,
        -2408.312255859375,
        641.0
      ],
      [
        -285.0,
        -2389.5,
        672.0
      ],
      [
        -351.0,
        -2389.5,
        672.0
      ],
      [
        -303.69171142578125,
        -2371.658447265625,
        660.5
      ],
      [
        -332.30828857421875,
        -2371.658447265625,
        660.5
      ],
      [
        -351.0,
        -2389.5,
        672.0
      ],
      [
        -351.0,
        -2388.5,
        660.5
      ],
      [
        -351.0,
        -2389.5,
        660.5
      ],
      [
        -285.0,
        -2388.5,
        660.5
      ],
      [
        -285.0,
        -2389.5,
        672.0
      ],
      [
        -285.0,
        -2389.5,
        660.5
      ],
      [
        -285.0,
        -2411.5,
        660.5
      ],
      [
        -351.0,
        -2411.5,
        660.5
      ],
      [
        -323.2857971191406,
        -2399.95703125,
        660.5
      ],
      [
        -323.2857971191406,
        -2411.5,
        660.5
      ],
      [
        -312.7142028808594,
        -2411.5,
        660.5
      ],
      [
        -312.7142028808594,
        -2399.95703125,
        660.5
      ],
      [
        -323.2857971191406,
        -2399.95703125,
        660.5
      ],
      [
        -312.7142028808594,
        -2399.95703125,
        660.5
      ],
      [
        -287.91802978515625,
        -2407.209716796875,
        660.5
      ],
      [
        -287.04302978515625,
        -2411.5,
        660.5
      ],
      [
        -310.95697021484375,
        -2411.5,
        660.5
      ],
      [
        -310.08197021484375,
        -2407.209716796875,
        660.5
      ],
      [
        -291.928955078125,
        -2404.72900390625,
        660.5
      ],
      [
        -289.76123046875,
        -2407.97314453125,
        660.5
      ],
      [
        -308.23876953125,
        -2407.97314453125,
        660.5
      ],
      [
        -306.071044921875,
        -2404.72900390625,
        660.5
      ],
      [
        -299.0,
        -2401.800048828125,
        660.5
      ],
      [
        -295.173095703125,
        -2402.561279296875,
        660.5
      ],
      [
        -302.826904296875,
        -2402.561279296875,
        660.5
      ],
      [
        -299.0,
        -2401.800048828125,
        660.5
      ],
      [
        -295.173095703125,
        -2402.561279296875,
        660.5
      ],
      [
        -291.928955078125,
        -2404.72900390625,
        660.5
      ],
      [
        -306.071044921875,
        -2404.72900390625,
        660.5
      ],
      [
        -302.826904296875,
        -2402.561279296875,
        660.5
      ],
      [
        -310.08197021484375,
        -2407.209716796875,
        660.5
      ],
      [
        -308.23876953125,
        -2407.97314453125,
        660.5
      ],
      [
        -287.91802978515625,
        -2407.209716796875,
        660.5
      ],
      [
        -289.76123046875,
        -2407.97314453125,
        660.5
      ],
      [
        -325.91802978515625,
        -2407.209716796875,
        660.5
      ],
      [
        -325.04302978515625,
        -2411.5,
        660.5
      ],
      [
        -348.95697021484375,
        -2411.5,
        660.5
      ],
      [
        -348.08197021484375,
        -2407.209716796875,
        660.5
      ],
      [
        -329.928955078125,
        -2404.72900390625,
        660.5
      ],
      [
        -327.76123046875,
        -2407.97314453125,
        660.5
      ],
      [
        -346.23876953125,
        -2407.97314453125,
        660.5
      ],
      [
        -344.071044921875,
        -2404.72900390625,
        660.5
      ],
      [
        -337.0,
        -2401.800048828125,
        660.5
      ],
      [
        -333.173095703125,
        -2402.561279296875,
        660.5
      ],
      [
        -340.826904296875,
        -2402.561279296875,
        660.5
      ],
      [
        -337.0,
        -2401.800048828125,
        660.5
      ],
      [
        -333.173095703125,
        -2402.561279296875,
        660.5
      ],
      [
        -329.928955078125,
        -2404.72900390625,
        660.5
      ],
      [
        -344.071044921875,
        -2404.72900390625,
        660.5
      ],
      [
        -340.826904296875,
        -2402.561279296875,
        660.5
      ],
      [
        -348.08197021484375,
        -2407.209716796875,
        660.5
      ],
      [
        -346.23876953125,
        -2407.97314453125,
        660.5
      ],
      [
        -325.91802978515625,
        -2407.209716796875,
        660.5
      ],
      [
        -327.76123046875,
        -2407.97314453125,
        660.5
      ],
      [
        -285.0,
        -2389.5,
        660.5
      ],
      [
        -285.0,
        -2389.5,
        641.0
      ],
      [
        -273.2718200683594,
        -2383.64208984375,
        651.5
      ],
      [
        -351.0,
        -2389.5,
        660.5
      ],
      [
        -351.0,
        -2389.5,
        641.0
      ],
      [
        -362.7281494140625,
        -2383.64208984375,
        651.5
      ],
      [
        -325.9545593261719,
        -2411.5,
        644.904052734375
      ],
      [
        -325.95684814453125,
        -2411.488525390625,
        644.9042358398438
      ],
      [
        -325.95684814453125,
        -2411.488525390625,
        644.9042358398438
      ],
      [
        -310.04296875,
        -2411.48828125,
        644.904052734375
      ],
      [
        -310.0452880859375,
        -2411.5,
        644.90380859375
      ],
      [
        -310.04296875,
        -2411.48828125,
        644.904052734375
      ],
      [
        -318.5,
        -2320.260009765625,
        746.0
      ],
      [
        -318.5,
        -2320.260009765625,
        712.0
      ],
      [
        -321.5,
        -2297.0,
        745.8181762695312
      ],
      [
        -318.5,
        -2297.0,
        745.8181762695312
      ],
      [
        -318.5,
        -2294.0,
        745.8181762695312
      ],
      [
        -320.62127685546875,
        -2294.878662109375,
        745.8181762695312
      ],
      [
        -325.7430419921875,
        -2297.0,
        745.8182373046875
      ],
      [
        -318.5,
        -2283.143310546875,
        745.8182373046875
      ],
      [
        -331.8150634765625,
        -2297.0,
        745.8182373046875
      ],
      [
        -331.8150634765625,
        -2297.0,
        717.3182373046875
      ],
      [
        -331.8150634765625,
        -2297.0,
        727.3182373046875
      ],
      [
        -331.8150634765625,
        -2297.0,
        715.3182373046875
      ],
      [
        -331.8150634765625,
        -2297.0,
        712.0
      ],
      [
        -331.8150634765625,
        -2297.0,
        729.3182373046875
      ],
      [
        -331.8150634765625,
        -2297.0,
        739.3182373046875
      ],
      [
        -318.5,
        -2283.143310546875,
        729.3182373046875
      ],
      [
        -318.5,
        -2283.143310546875,
        739.3182373046875
      ],
      [
        -318.5,
        -2283.143310546875,
        715.3182373046875
      ],
      [
        -318.5,
        -2283.143310546875,
        712.0
      ],
      [
        -318.5,
        -2283.143310546875,
        717.3182373046875
      ],
      [
        -318.5,
        -2283.143310546875,
        727.3182373046875
      ],
      [
        -329.9674072265625,
        -2297.0,
        727.3182373046875
      ],
      [
        -331.8150634765625,
        -2297.0,
        727.3182373046875
      ],
      [
        -318.5,
        -2284.990966796875,
        727.3182373046875
      ],
      [
        -318.5,
        -2283.143310546875,
        727.3182373046875
      ],
      [
        -329.9674072265625,
        -2297.0,
        739.3182373046875
      ],
      [
        -331.8150634765625,
        -2297.0,
        739.3182373046875
      ],
      [
        -318.5,
        -2284.990966796875,
        739.3182373046875
      ],
      [
        -318.5,
        -2283.143310546875,
        739.3182373046875
      ],
      [
        -329.9674072265625,
        -2297.0,
        739.3182373046875
      ],
      [
        -329.9674072265625,
        -2297.0,
        741.3182373046875
      ],
      [
        -318.5,
        -2284.990966796875,
        739.3182373046875
      ],
      [
        -318.5,
        -2284.990966796875,
        741.3182373046875
      ],
      [
        -329.9674072265625,
        -2297.0,
        727.3182373046875
      ],
      [
        -329.9674072265625,
        -2297.0,
        729.3182373046875
      ],
      [
        -318.5,
        -2284.990966796875,
        727.3182373046875
      ],
      [
        -318.5,
        -2284.990966796875,
        729.3182373046875
      ],
      [
        -329.9674072265625,
        -2297.0,
        715.3182373046875
      ],
      [
        -331.8150634765625,
        -2297.0,
        715.3182373046875
      ],
      [
        -318.5,
        -2284.990966796875,
        715.3182373046875
      ],
      [
        -318.5,
        -2283.143310546875,
        715.3182373046875
      ],
      [
        -329.9674072265625,
        -2297.0,
        715.3182373046875
      ],
      [
        -329.9674072265625,
        -2297.0,
        717.3182373046875
      ],
      [
        -318.5,
        -2284.990966796875,
        715.3182373046875
      ],
      [
        -318.5,
        -2284.990966796875,
        717.3182373046875
      ],
      [
        -332.74102783203125,
        -2273.304931640625,
        750.0
      ],
      [
        -341.6529541015625,
        -2282.21728515625,
        750.0
      ],
      [
        -318.5,
        -2299.999755859375,
        745.8181762695312
      ],
      [
        -321.4999694824219,
        -2297.0,
        745.8181762695312
      ],
      [
        -320.6213684082031,
        -2299.12109375,
        745.8181762695312
      ],
      [
        -318.5,
        -2304.24267578125,
        745.8181762695312
      ],
      [
        -318.5,
        -2310.421630859375,
        745.8181762695312
      ],
      [
        -318.5,
        -2310.421630859375,
        729.3181762695312
      ],
      [
        -318.5,
        -2310.421630859375,
        739.3181762695312
      ],
      [
        -318.5,
        -2310.421630859375,
        717.3181762695312
      ],
      [
        -318.5,
        -2310.421630859375,
        727.3181762695312
      ],
      [
        -318.5,
        -2310.421630859375,
        715.3181762695312
      ],
      [
        -318.5,
        -2310.421630859375,
        712.0
      ],
      [
        -318.5,
        -2308.573974609375,
        727.3181762695312
      ],
      [
        -318.5,
        -2310.421630859375,
        727.3181762695312
      ],
      [
        -318.5,
        -2308.573974609375,
        739.3181762695312
      ],
      [
        -318.5,
        -2310.421630859375,
        739.3181762695312
      ],
      [
        -318.5,
        -2308.573974609375,
        739.3181762695312
      ],
      [
        -318.5,
        -2308.573974609375,
        741.3181762695312
      ],
      [
        -318.5,
        -2308.573974609375,
        727.3181762695312
      ],
      [
        -318.5,
        -2308.573974609375,
        729.3181762695312
      ],
      [
        -318.5,
        -2308.573974609375,
        715.3181762695312
      ],
      [
        -318.5,
        -2310.421630859375,
        715.3181762695312
      ],
      [
        -318.5,
        -2308.573974609375,
        715.3181762695312
      ],
      [
        -318.5,
        -2308.573974609375,
        717.3181762695312
      ],
      [
        -341.6536865234375,
        -2311.36572265625,
        750.0
      ],
      [
        -332.7588806152344,
        -2320.260009765625,
        750.0
      ],
      [
        -318.5,
        -2370.3154296875,
        750.0
      ],
      [
        -318.5,
        -2375.3154296875,
        730.0
      ],
      [
        -318.5,
        -2375.3154296875,
        730.0
      ],
      [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      [
        -341.65509033203125,
        -2366.56689453125,
        750.0
      ],
      [
        -341.65521240234375,
        -2371.97900390625,
        730.0
      ],
      [
        -341.65521240234375,
        -2371.97900390625,
        730.0
      ],
      [
        -341.65521240234375,
        -2371.97900390625,
        712.0
      ],
      [
        -325.60009765625,
        -2373.972412109375,
        735.3721313476562
      ],
      [
        -323.39990234375,
        -2373.972412109375,
        735.3721313476562
      ],
      [
        -323.39990234375,
        -2367.269775390625,
        750.0
      ],
      [
        -325.60009765625,
        -2367.269775390625,
        750.0
      ],
      [
        -341.6547546386719,
        -2352.9111328125,
        712.0
      ],
      [
        -341.6547546386719,
        -2352.9111328125,
        716.0
      ],
      [
        -318.5,
        -2357.699951171875,
        716.0
      ],
      [
        -318.5,
        -2355.699951171875,
        716.0
      ],
      [
        -341.6547546386719,
        -2352.9111328125,
        716.0
      ],
      [
        -341.6546936035156,
        -2350.746337890625,
        716.0
      ],
      [
        -318.5,
        -2357.699951171875,
        712.0
      ],
      [
        -318.5,
        -2357.699951171875,
        716.0
      ],
      [
        -341.6546936035156,
        -2350.746337890625,
        716.0
      ],
      [
        -341.6546936035156,
        -2350.746337890625,
        712.0
      ],
      [
        -318.5,
        -2355.699951171875,
        716.0
      ],
      [
        -318.5,
        -2355.699951171875,
        712.0
      ],
      [
        -327.8636169433594,
        -2323.7158203125,
        750.0
      ],
      [
        -318.5,
        -2323.7158203125,
        750.0
      ],
      [
        -318.5,
        -2320.260009765625,
        746.0
      ],
      [
        -330.3212585449219,
        -2322.697509765625,
        750.0
      ],
      [
        -332.20172119140625,
        -2320.817138671875,
        750.0
      ],
      [
        -332.20172119140625,
        -2320.817138671875,
        750.0
      ],
      [
        -330.3212585449219,
        -2322.697509765625,
        750.0
      ],
      [
        -327.8636169433594,
        -2323.7158203125,
        750.0
      ],
      [
        -323.39990234375,
        -2366.76416015625,
        750.0
      ],
      [
        -325.60009765625,
        -2366.76416015625,
        750.0
      ],
      [
        -323.39990234375,
        -2366.76416015625,
        750.0
      ],
      [
        -325.60009765625,
        -2366.76416015625,
        750.0
      ],
      [
        -318.5,
        -2294.0,
        745.8181762695312
      ],
      [
        -318.5,
        -2297.0,
        745.8181762695312
      ],
      [
        -315.5000305175781,
        -2297.0,
        745.8181762695312
      ],
      [
        -316.3786926269531,
        -2294.878662109375,
        745.8181762695312
      ],
      [
        -318.5,
        -2289.75732421875,
        745.8182373046875
      ],
      [
        -304.53662109375,
        -2297.0,
        745.8182373046875
      ],
      [
        -304.53662109375,
        -2297.0,
        717.3182373046875
      ],
      [
        -304.53662109375,
        -2297.0,
        727.3182373046875
      ],
      [
        -304.53662109375,
        -2297.0,
        715.3182373046875
      ],
      [
        -304.53662109375,
        -2297.0,
        712.0
      ],
      [
        -304.53662109375,
        -2297.0,
        729.3182373046875
      ],
      [
        -304.53662109375,
        -2297.0,
        739.3182373046875
      ],
      [
        -306.38427734375,
        -2297.0,
        727.3182373046875
      ],
      [
        -304.53662109375,
        -2297.0,
        727.3182373046875
      ],
      [
        -306.38427734375,
        -2297.0,
        739.3182373046875
      ],
      [
        -304.53662109375,
        -2297.0,
        739.3182373046875
      ],
      [
        -306.38427734375,
        -2297.0,
        739.3182373046875
      ],
      [
        -306.38427734375,
        -2297.0,
        741.3182373046875
      ],
      [
        -306.38427734375,
        -2297.0,
        727.3182373046875
      ],
      [
        -306.38427734375,
        -2297.0,
        729.3182373046875
      ],
      [
        -306.38427734375,
        -2297.0,
        715.3182373046875
      ],
      [
        -304.53662109375,
        -2297.0,
        715.3182373046875
      ],
      [
        -306.38427734375,
        -2297.0,
        715.3182373046875
      ],
      [
        -306.38427734375,
        -2297.0,
        717.3182373046875
      ],
      [
        -294.69732666015625,
        -2282.169677734375,
        750.0
      ],
      [
        -303.5616760253906,
        -2273.3056640625,
        750.0
      ],
      [
        -315.5000305175781,
        -2297.0,
        745.8181762695312
      ],
      [
        -318.5,
        -2300.0,
        745.8181762695312
      ],
      [
        -316.37872314453125,
        -2299.121337890625,
        745.8181762695312
      ],
      [
        -318.5,
        -2304.24267578125,
        745.8181762695312
      ],
      [
        -303.5440368652344,
        -2320.260009765625,
        750.0
      ],
      [
        -294.6980895996094,
        -2311.414306640625,
        750.0
      ],
      [
        -294.699462890625,
        -2366.7138671875,
        750.0
      ],
      [
        -294.6998291015625,
        -2372.126220703125,
        730.0
      ],
      [
        -294.6998291015625,
        -2372.126220703125,
        730.0
      ],
      [
        -294.7000427246094,
        -2372.126220703125,
        712.0
      ],
      [
        -310.39990234375,
        -2373.972412109375,
        735.3721313476562
      ],
      [
        -312.60009765625,
        -2373.972412109375,
        735.3721313476562
      ],
      [
        -310.39990234375,
        -2367.269775390625,
        750.0
      ],
      [
        -312.60009765625,
        -2367.269775390625,
        750.0
      ],
      [
        -294.6995849609375,
        -2353.057861328125,
        712.0
      ],
      [
        -294.69952392578125,
        -2353.057861328125,
        716.0
      ],
      [
        -294.69952392578125,
        -2353.057861328125,
        716.0
      ],
      [
        -294.699462890625,
        -2350.89306640625,
        716.0
      ],
      [
        -294.699462890625,
        -2350.89306640625,
        716.0
      ],
      [
        -294.69952392578125,
        -2350.89306640625,
        712.0
      ],
      [
        -308.4392395019531,
        -2323.7158203125,
        750.0
      ],
      [
        -305.9815979003906,
        -2322.697509765625,
        750.0
      ],
      [
        -308.4392395019531,
        -2323.7158203125,
        750.0
      ],
      [
        -305.9815979003906,
        -2322.697509765625,
        750.0
      ],
      [
        -310.39990234375,
        -2366.76416015625,
        750.0
      ],
      [
        -312.60009765625,
        -2366.76416015625,
        750.0
      ],
      [
        -310.39990234375,
        -2366.76416015625,
        750.0
      ],
      [
        -312.60009765625,
        -2366.76416015625,
        750.0
      ],
      [
        -376.84716796875,
        -2313.778564453125,
        716.0
      ],
      [
        -376.84716796875,
        -2279.915771484375,
        716.0
      ],
      [
        -374.1084289550781,
        -2273.3037109375,
        716.0
      ],
      [
        -371.9436950683594,
        -2273.303955078125,
        716.0
      ],
      [
        -376.84716796875,
        -2313.778564453125,
        712.0
      ],
      [
        -376.84716796875,
        -2313.778564453125,
        716.0
      ],
      [
        -347.6374816894531,
        -2350.43212890625,
        712.0
      ],
      [
        -347.6374816894531,
        -2350.43212890625,
        716.0
      ],
      [
        -371.9436950683594,
        -2273.303955078125,
        716.0
      ],
      [
        -371.9436950683594,
        -2273.303955078125,
        712.0
      ],
      [
        -376.84716796875,
        -2279.915771484375,
        712.0
      ],
      [
        -374.1084289550781,
        -2273.3037109375,
        712.0
      ],
      [
        -374.1084289550781,
        -2273.3037109375,
        716.0
      ],
      [
        -376.84716796875,
        -2279.915771484375,
        716.0
      ],
      [
        -345.07513427734375,
        -2287.07861328125,
        750.0
      ],
      [
        -345.0755310058594,
        -2306.504638671875,
        750.0
      ],
      [
        -344.0578918457031,
        -2308.961669921875,
        750.0
      ],
      [
        -344.0574645996094,
        -2284.621826171875,
        750.0
      ],
      [
        -345.0755310058594,
        -2306.504638671875,
        750.0
      ],
      [
        -344.0578918457031,
        -2308.961669921875,
        750.0
      ],
      [
        -344.0574645996094,
        -2284.621826171875,
        750.0
      ],
      [
        -345.07513427734375,
        -2287.07861328125,
        750.0
      ],
      [
        -376.84716796875,
        -2348.96337890625,
        730.0
      ],
      [
        -376.84716796875,
        -2348.96337890625,
        712.0
      ],
      [
        -368.8941650390625,
        -2356.916259765625,
        729.9866943359375
      ],
      [
        -368.8941650390625,
        -2356.916259765625,
        712.0
      ],
      [
        -368.8941650390625,
        -2356.916259765625,
        730.431640625
      ],
      [
        -368.8941650390625,
        -2356.916259765625,
        729.9866943359375
      ],
      [
        -367.3384094238281,
        -2358.47216796875,
        712.0
      ],
      [
        -367.3384094238281,
        -2358.47216796875,
        729.9866943359375
      ],
      [
        -367.3384094238281,
        -2358.47216796875,
        729.9866943359375
      ],
      [
        -367.3384094238281,
        -2358.47216796875,
        730.43212890625
      ],
      [
        -376.53070068359375,
        -2349.27978515625,
        712.0
      ],
      [
        -376.53070068359375,
        -2349.27978515625,
        729.9866943359375
      ],
      [
        -376.53070068359375,
        -2349.27978515625,
        729.9866943359375
      ],
      [
        -376.53070068359375,
        -2349.27978515625,
        730.4326171875
      ],
      [
        -376.84716796875,
        -2341.89208984375,
        750.0
      ],
      [
        -376.84716796875,
        -2348.96337890625,
        730.0
      ],
      [
        -365.3587341308594,
        -2353.380859375,
        750.0
      ],
      [
        -365.3663330078125,
        -2353.388427734375,
        749.95703125
      ],
      [
        -365.3663330078125,
        -2353.388427734375,
        749.95703125
      ],
      [
        -363.8105773925781,
        -2354.9443359375,
        749.9570922851562
      ],
      [
        -363.802978515625,
        -2354.936767578125,
        750.0
      ],
      [
        -363.8105773925781,
        -2354.9443359375,
        749.9570922851562
      ],
      [
        -373.0028076171875,
        -2345.751708984375,
        749.9569702148438
      ],
      [
        -372.9952087402344,
        -2345.744140625,
        750.0
      ],
      [
        -373.0028076171875,
        -2345.751708984375,
        749.9569702148438
      ],
      [
        -374.551025390625,
        -2344.1884765625,
        750.0
      ],
      [
        -374.5586242675781,
        -2344.196044921875,
        749.9569702148438
      ],
      [
        -374.55853271484375,
        -2344.196044921875,
        749.9569091796875
      ],
      [
        -376.84716796875,
        -2346.484619140625,
        737.44287109375
      ],
      [
        -376.84716796875,
        -2346.484619140625,
        737.0110473632812
      ],
      [
        -362.9237976074219,
        -2350.946044921875,
        750.0
      ],
      [
        -361.3681335449219,
        -2352.501953125,
        750.0
      ],
      [
        -361.3681335449219,
        -2352.501953125,
        750.0
      ],
      [
        -362.9237976074219,
        -2350.946044921875,
        750.0
      ],
      [
        -370.5605163574219,
        -2343.3095703125,
        750.0
      ],
      [
        -372.1161804199219,
        -2341.753662109375,
        750.0
      ],
      [
        -376.84716796875,
        -2346.484619140625,
        729.7709350585938
      ],
      [
        -376.84716796875,
        -2346.484619140625,
        712.0
      ],
      [
        -376.84716796875,
        -2346.484619140625,
        729.7709350585938
      ],
      [
        -370.5605163574219,
        -2343.3095703125,
        750.0
      ],
      [
        -372.1161804199219,
        -2341.753662109375,
        750.0
      ],
      [
        -244.5365753173828,
        -2291.60009765625,
        749.9978637695312
      ],
      [
        -244.53712463378906,
        -2291.60009765625,
        750.0
      ],
      [
        -244.5365753173828,
        -2291.60009765625,
        749.9978637695312
      ],
      [
        -244.5365753173828,
        -2289.39990234375,
        749.9978637695312
      ],
      [
        -244.53712463378906,
        -2289.39990234375,
        750.0
      ],
      [
        -244.5365753173828,
        -2289.39990234375,
        749.9978637695312
      ],
      [
        -244.5365753173828,
        -2304.60009765625,
        749.9978637695312
      ],
      [
        -244.53712463378906,
        -2304.60009765625,
        750.0
      ],
      [
        -244.5365753173828,
        -2304.60009765625,
        749.9978637695312
      ],
      [
        -244.5365753173828,
        -2302.39990234375,
        749.9978637695312
      ],
      [
        -244.53712463378906,
        -2302.39990234375,
        750.0
      ],
      [
        -244.5365753173828,
        -2302.39990234375,
        749.9978637695312
      ],
      [
        -261.89031982421875,
        -2273.306640625,
        716.0
      ],
      [
        -264.05517578125,
        -2273.306396484375,
        716.0
      ],
      [
        -288.36224365234375,
        -2350.431884765625,
        712.0
      ],
      [
        -288.3622131347656,
        -2350.431884765625,
        716.0
      ],
      [
        -259.15283203125,
        -2279.91552734375,
        712.0
      ],
      [
        -259.15283203125,
        -2279.91552734375,
        716.0
      ],
      [
        -264.05517578125,
        -2273.306396484375,
        716.0
      ],
      [
        -264.05517578125,
        -2273.306396484375,
        712.0
      ],
      [
        -261.89031982421875,
        -2273.306640625,
        712.0
      ],
      [
        -261.89031982421875,
        -2273.306640625,
        716.0
      ],
      [
        -291.2275390625,
        -2306.504638671875,
        750.0
      ],
      [
        -291.2275390625,
        -2287.078369140625,
        750.0
      ],
      [
        -292.24517822265625,
        -2308.96142578125,
        750.0
      ],
      [
        -292.24517822265625,
        -2284.62158203125,
        750.0
      ],
      [
        -292.24517822265625,
        -2308.96142578125,
        750.0
      ],
      [
        -291.2275390625,
        -2306.504638671875,
        750.0
      ],
      [
        -291.2275390625,
        -2287.078369140625,
        750.0
      ],
      [
        -292.24517822265625,
        -2284.62158203125,
        750.0
      ],
      [
        -272.5019836425781,
        -2350.134765625,
        750.0
      ],
      [
        -274.0576477050781,
        -2351.6904296875,
        750.0
      ],
      [
        -272.5019836425781,
        -2350.134765625,
        750.0
      ],
      [
        -274.0576477050781,
        -2351.6904296875,
        750.0
      ],
      [
        -263.3096008300781,
        -2340.9423828125,
        750.0
      ],
      [
        -264.8652648925781,
        -2342.498046875,
        750.0
      ],
      [
        -263.3096008300781,
        -2340.9423828125,
        750.0
      ],
      [
        -264.8652648925781,
        -2342.498046875,
        750.0
      ],
      [
        -248.2350311279297,
        -2273.30712890625,
        750.0
      ],
      [
        -242.82305908203125,
        -2273.30712890625,
        730.0
      ],
      [
        -248.08302307128906,
        -2291.60009765625,
        750.0
      ],
      [
        -248.08302307128906,
        -2289.39990234375,
        750.0
      ],
      [
        -248.08302307128906,
        -2289.39990234375,
        750.0
      ],
      [
        -248.08302307128906,
        -2291.60009765625,
        750.0
      ],
      [
        -242.82305908203125,
        -2273.30712890625,
        730.0
      ],
      [
        -242.82305908203125,
        -2273.30712890625,
        712.0
      ],
      [
        -248.08302307128906,
        -2302.39990234375,
        750.0
      ],
      [
        -248.08302307128906,
        -2304.60009765625,
        750.0
      ],
      [
        -248.08302307128906,
        -2302.39990234375,
        750.0
      ],
      [
        -248.08302307128906,
        -2304.60009765625,
        750.0
      ],
      [
        -371.5837097167969,
        -2267.20849609375,
        712.0
      ],
      [
        -371.5837097167969,
        -2267.20849609375,
        716.0
      ],
      [
        -264.4162292480469,
        -2267.20849609375,
        712.0
      ],
      [
        -264.4162292480469,
        -2267.20849609375,
        716.0
      ],
      [
        -308.4385986328125,
        -2269.867919921875,
        750.0
      ],
      [
        -327.86468505859375,
        -2269.86767578125,
        750.0
      ],
      [
        -305.9817810058594,
        -2270.8857421875,
        750.0
      ],
      [
        -330.3215026855469,
        -2270.88525390625,
        750.0
      ],
      [
        -305.9817810058594,
        -2270.8857421875,
        750.0
      ],
      [
        -308.4385986328125,
        -2269.867919921875,
        750.0
      ],
      [
        -327.86468505859375,
        -2269.86767578125,
        750.0
      ],
      [
        -330.3215026855469,
        -2270.88525390625,
        750.0
      ],
      [
        -264.0500793457031,
        -2252.072265625,
        750.0
      ],
      [
        -262.4944152832031,
        -2253.628173828125,
        750.0
      ],
      [
        -264.0500793457031,
        -2252.072265625,
        750.0
      ],
      [
        -262.4944152832031,
        -2253.628173828125,
        750.0
      ],
      [
        -273.2424621582031,
        -2242.8798828125,
        750.0
      ],
      [
        -271.6867980957031,
        -2244.435791015625,
        750.0
      ],
      [
        -273.2424621582031,
        -2242.8798828125,
        750.0
      ],
      [
        -271.6867980957031,
        -2244.435791015625,
        750.0
      ],
      [
        -376.84716796875,
        -2244.731201171875,
        730.0
      ],
      [
        -376.84716796875,
        -2244.731201171875,
        712.0
      ],
      [
        -368.1839599609375,
        -2236.06787109375,
        729.9920043945312
      ],
      [
        -368.1839599609375,
        -2236.06787109375,
        712.0
      ],
      [
        -368.1839599609375,
        -2236.06787109375,
        730.26025390625
      ],
      [
        -368.1839599609375,
        -2236.06787109375,
        729.9920043945312
      ],
      [
        -369.7396240234375,
        -2237.62353515625,
        712.0
      ],
      [
        -369.7396240234375,
        -2237.62353515625,
        729.9920043945312
      ],
      [
        -369.7396240234375,
        -2237.62353515625,
        729.9920043945312
      ],
      [
        -369.7396240234375,
        -2237.62353515625,
        730.26025390625
      ],
      [
        -376.84716796875,
        -2251.80224609375,
        750.0
      ],
      [
        -376.84716796875,
        -2244.731201171875,
        730.0
      ],
      [
        -366.2088317871094,
        -2241.15478515625,
        749.9740600585938
      ],
      [
        -366.2042541503906,
        -2241.1591796875,
        750.0
      ],
      [
        -366.2088317871094,
        -2241.15478515625,
        749.9740600585938
      ],
      [
        -364.6529846191406,
        -2239.5986328125,
        749.97412109375
      ],
      [
        -364.6484375,
        -2239.603271484375,
        750.0
      ],
      [
        -364.6529846191406,
        -2239.5986328125,
        749.97412109375
      ],
      [
        -373.8453063964844,
        -2248.791259765625,
        749.9740600585938
      ],
      [
        -373.8407287597656,
        -2248.795654296875,
        750.0
      ],
      [
        -373.8453063964844,
        -2248.791259765625,
        749.9740600585938
      ],
      [
        -376.84716796875,
        -2245.78955078125,
        733.2537231445312
      ],
      [
        -376.84716796875,
        -2245.78955078125,
        732.9930419921875
      ],
      [
        -375.4012145996094,
        -2250.34716796875,
        749.9740600585938
      ],
      [
        -375.3966369628906,
        -2250.3515625,
        750.0
      ],
      [
        -376.84716796875,
        -2248.901123046875,
        742.054443359375
      ],
      [
        -375.4012145996094,
        -2250.34716796875,
        749.9740600585938
      ],
      [
        -376.84716796875,
        -2248.901123046875,
        741.793701171875
      ],
      [
        -325.60009765625,
        -2226.935546875,
        750.0
      ],
      [
        -312.60009765625,
        -2226.935546875,
        750.0
      ],
      [
        -310.39990234375,
        -2226.935546875,
        750.0
      ],
      [
        -312.60009765625,
        -2226.935546875,
        750.0
      ],
      [
        -310.39990234375,
        -2226.935546875,
        750.0
      ],
      [
        -323.39990234375,
        -2226.935546875,
        750.0
      ],
      [
        -325.60009765625,
        -2226.935546875,
        750.0
      ],
      [
        -323.39990234375,
        -2226.935546875,
        750.0
      ],
      [
        -363.7389831542969,
        -2243.624267578125,
        750.0
      ],
      [
        -362.1833190917969,
        -2242.068603515625,
        750.0
      ],
      [
        -363.7389831542969,
        -2243.624267578125,
        750.0
      ],
      [
        -362.1833190917969,
        -2242.068603515625,
        750.0
      ],
      [
        -371.3757019042969,
        -2251.260986328125,
        750.0
      ],
      [
        -376.84716796875,
        -2245.78955078125,
        729.8998413085938
      ],
      [
        -376.84716796875,
        -2245.78955078125,
        712.0
      ],
      [
        -376.84716796875,
        -2245.78955078125,
        729.8998413085938
      ],
      [
        -376.84716796875,
        -2248.85009765625,
        729.6334228515625
      ],
      [
        -376.84716796875,
        -2248.90087890625,
        729.7777099609375
      ],
      [
        -373.2889404296875,
        -2252.458984375,
        750.0
      ],
      [
        -376.84716796875,
        -2248.90087890625,
        729.7777099609375
      ],
      [
        -376.84716796875,
        -2248.90087890625,
        729.50732421875
      ],
      [
        -376.84716796875,
        -2248.85009765625,
        729.6334228515625
      ],
      [
        -376.84716796875,
        -2248.90087890625,
        712.0
      ],
      [
        -376.84716796875,
        -2248.90087890625,
        729.50732421875
      ],
      [
        -372.9313659667969,
        -2252.816650390625,
        750.0
      ],
      [
        -371.3757019042969,
        -2251.260986328125,
        750.0
      ],
      [
        -372.9313659667969,
        -2252.816650390625,
        750.0
      ],
      [
        -391.462890625,
        -2306.0,
        750.0
      ],
      [
        -396.462890625,
        -2306.0,
        730.0
      ],
      [
        -378.0887756347656,
        -2347.726318359375,
        729.9871215820312
      ],
      [
        -378.162841796875,
        -2347.80029296875,
        729.5681762695312
      ],
      [
        -378.0887756347656,
        -2347.726318359375,
        729.9871215820312
      ],
      [
        -376.84716796875,
        -2346.484619140625,
        737.0110473632812
      ],
      [
        -378.0864562988281,
        -2347.723876953125,
        712.0
      ],
      [
        -396.462890625,
        -2306.0,
        712.0
      ],
      [
        -396.462890625,
        -2306.0,
        730.0
      ],
      [
        -378.84716796875,
        -2306.0,
        716.0
      ],
      [
        -376.84716796875,
        -2306.0,
        716.0
      ],
      [
        -378.84716796875,
        -2306.0,
        712.0
      ],
      [
        -378.84716796875,
        -2306.0,
        716.0
      ],
      [
        -391.462890625,
        -2288.0,
        750.0
      ],
      [
        -396.462890625,
        -2288.0,
        730.0
      ],
      [
        -396.462890625,
        -2288.0,
        723.0
      ],
      [
        -396.462890625,
        -2288.0,
        717.0
      ],
      [
        -396.462890625,
        -2288.0,
        730.0
      ],
      [
        -396.462890625,
        -2288.0,
        712.0
      ],
      [
        -378.97802734375,
        -2246.77001953125,
        729.7393188476562
      ],
      [
        -378.9333190917969,
        -2246.814697265625,
        729.9921875
      ],
      [
        -378.9333190917969,
        -2246.814697265625,
        729.9921875
      ],
      [
        -376.84716796875,
        -2248.901123046875,
        741.793701171875
      ],
      [
        -377.3776550292969,
        -2245.259033203125,
        729.9921875
      ],
      [
        -377.42236328125,
        -2245.21435546875,
        729.7393188476562
      ],
      [
        -377.3776550292969,
        -2245.259033203125,
        729.9921875
      ],
      [
        -376.84716796875,
        -2245.78955078125,
        732.9930419921875
      ],
      [
        -377.3763427734375,
        -2245.26025390625,
        712.0
      ],
      [
        -378.9320068359375,
        -2246.81591796875,
        712.0
      ],
      [
        -378.84716796875,
        -2288.0,
        716.0
      ],
      [
        -376.84716796875,
        -2288.0,
        716.0
      ],
      [
        -378.84716796875,
        -2288.0,
        712.0
      ],
      [
        -378.84716796875,
        -2288.0,
        716.0
      ],
      [
        -387.91162109375,
        -2302.39990234375,
        750.0
      ],
      [
        -393.3941345214844,
        -2302.39990234375,
        730.0
      ],
      [
        -387.91162109375,
        -2304.60009765625,
        750.0
      ],
      [
        -393.3941345214844,
        -2304.60009765625,
        730.0
      ],
      [
        -393.3941345214844,
        -2304.60009765625,
        730.0
      ],
      [
        -393.3941345214844,
        -2302.39990234375,
        730.0
      ],
      [
        -387.91162109375,
        -2304.60009765625,
        750.0
      ],
      [
        -387.91162109375,
        -2302.39990234375,
        750.0
      ],
      [
        -387.91162109375,
        -2289.39990234375,
        750.0
      ],
      [
        -393.3941345214844,
        -2289.39990234375,
        730.0
      ],
      [
        -387.91162109375,
        -2291.60009765625,
        750.0
      ],
      [
        -393.3941345214844,
        -2291.60009765625,
        730.0
      ],
      [
        -393.3941345214844,
        -2291.60009765625,
        730.0
      ],
      [
        -393.3941345214844,
        -2289.39990234375,
        730.0
      ],
      [
        -387.91162109375,
        -2291.60009765625,
        750.0
      ],
      [
        -387.91162109375,
        -2289.39990234375,
        750.0
      ],
      [
        -396.462890625,
        -2306.0,
        727.0000610351562
      ],
      [
        -396.462890625,
        -2304.0,
        730.0
      ],
      [
        -393.3334045410156,
        -2304.60009765625,
        729.0999755859375
      ],
      [
        -396.462890625,
        -2304.60009765625,
        729.0999145507812
      ],
      [
        -393.3334045410156,
        -2304.60009765625,
        729.0999755859375
      ],
      [
        -393.4853515625,
        -2304.244384765625,
        729.6334228515625
      ],
      [
        -393.3941345214844,
        -2304.0,
        730.0
      ],
      [
        -393.4853515625,
        -2304.244384765625,
        729.6334228515625
      ],
      [
        -396.462890625,
        -2290.0,
        730.0
      ],
      [
        -396.462890625,
        -2288.0,
        727.0000610351562
      ],
      [
        -393.3333435058594,
        -2289.39990234375,
        729.0997924804688
      ],
      [
        -396.462890625,
        -2289.39990234375,
        729.0997314453125
      ],
      [
        -393.4853515625,
        -2289.755615234375,
        729.6334228515625
      ],
      [
        -393.3333435058594,
        -2289.39990234375,
        729.0997924804688
      ],
      [
        -393.3941345214844,
        -2290.0,
        730.0
      ],
      [
        -393.4853515625,
        -2289.755615234375,
        729.6334228515625
      ],
      [
        -396.462890625,
        -2304.0,
        712.0
      ],
      [
        -396.462890625,
        -2306.0,
        714.5000610351562
      ],
      [
        -388.676513671875,
        -2304.60009765625,
        712.75
      ],
      [
        -396.462890625,
        -2304.60009765625,
        712.75
      ],
      [
        -388.676513671875,
        -2304.60009765625,
        712.75
      ],
      [
        -388.462890625,
        -2304.0,
        712.0
      ],
      [
        -378.84716796875,
        -2304.60009765625,
        712.0
      ],
      [
        -378.84716796875,
        -2304.0,
        712.0
      ],
      [
        -378.84716796875,
        -2304.60009765625,
        712.7501220703125
      ],
      [
        -378.84716796875,
        -2306.0,
        714.5000610351562
      ],
      [
        -396.462890625,
        -2288.0,
        714.4996948242188
      ],
      [
        -396.462890625,
        -2289.999755859375,
        712.0
      ],
      [
        -388.676513671875,
        -2289.39990234375,
        712.75
      ],
      [
        -396.462890625,
        -2289.39990234375,
        712.75
      ],
      [
        -388.676513671875,
        -2289.39990234375,
        712.75
      ],
      [
        -388.462890625,
        -2290.0,
        712.0
      ],
      [
        -378.84716796875,
        -2289.999755859375,
        712.0
      ],
      [
        -378.84716796875,
        -2289.39990234375,
        712.0
      ],
      [
        -378.84716796875,
        -2289.39990234375,
        712.7498168945312
      ],
      [
        -378.84716796875,
        -2288.0,
        714.4996337890625
      ],
      [
        -277.9519348144531,
        -2269.08544921875,
        774.4052734375
      ],
      [
        -277.61895751953125,
        -2268.75244140625,
        774.9501342773438
      ],
      [
        -323.39990234375,
        -2248.452880859375,
        774.9201049804688
      ],
      [
        -323.39990234375,
        -2248.389892578125,
        774.9934692382812
      ],
      [
        -366.4573669433594,
        -2291.60009765625,
        774.9934692382812
      ],
      [
        -366.3931884765625,
        -2291.60009765625,
        774.91845703125
      ],
      [
        -366.3933410644531,
        -2289.39990234375,
        774.9186401367188
      ],
      [
        -366.45733642578125,
        -2289.39990234375,
        774.9934692382812
      ],
      [
        -325.60009765625,
        -2248.389892578125,
        774.9934692382812
      ],
      [
        -325.60009765625,
        -2248.452880859375,
        774.9201049804688
      ],
      [
        -366.45758056640625,
        -2304.60009765625,
        774.9932861328125
      ],
      [
        -366.39190673828125,
        -2304.60009765625,
        774.91650390625
      ],
      [
        -366.3922119140625,
        -2302.39990234375,
        774.9169311523438
      ],
      [
        -366.4575500488281,
        -2302.39990234375,
        774.9933471679688
      ],
      [
        -288.3668518066406,
        -2258.00439453125,
        774.9500122070312
      ],
      [
        -288.7006530761719,
        -2258.338134765625,
        774.40380859375
      ],
      [
        -287.1449890136719,
        -2259.893798828125,
        774.40380859375
      ],
      [
        -286.8111877441406,
        -2259.56005859375,
        774.9500122070312
      ],
      [
        -279.17462158203125,
        -2267.19677734375,
        774.9501342773438
      ],
      [
        -279.5075988769531,
        -2267.52978515625,
        774.4052734375
      ],
      [
        -310.39990234375,
        -2248.452880859375,
        774.9201049804688
      ],
      [
        -310.39990234375,
        -2248.389892578125,
        774.9934692382812
      ],
      [
        -312.60009765625,
        -2248.389892578125,
        774.9934692382812
      ],
      [
        -312.60009765625,
        -2248.452880859375,
        774.9201049804688
      ],
      [
        -280.2184753417969,
        -2327.144775390625,
        774.6267700195312
      ],
      [
        -280.0090026855469,
        -2327.354248046875,
        774.96826171875
      ],
      [
        -269.54083251953125,
        -2302.39990234375,
        774.9957885742188
      ],
      [
        -269.5799560546875,
        -2302.39990234375,
        774.95068359375
      ],
      [
        -278.453369140625,
        -2325.798583984375,
        774.96826171875
      ],
      [
        -278.66265869140625,
        -2325.58935546875,
        774.6270751953125
      ],
      [
        -269.5799560546875,
        -2304.60009765625,
        774.95068359375
      ],
      [
        -269.54083251953125,
        -2304.60009765625,
        774.9957885742188
      ],
      [
        -269.5799560546875,
        -2291.60009765625,
        774.95068359375
      ],
      [
        -269.54083251953125,
        -2291.60009765625,
        774.9957885742188
      ],
      [
        -269.54083251953125,
        -2289.39990234375,
        774.9957885742188
      ],
      [
        -269.5799560546875,
        -2289.39990234375,
        774.95068359375
      ],
      [
        -310.39990234375,
        -2345.309814453125,
        774.9935302734375
      ],
      [
        -310.39990234375,
        -2345.24853515625,
        774.922607421875
      ],
      [
        -323.39990234375,
        -2345.309814453125,
        774.9935302734375
      ],
      [
        -323.39990234375,
        -2345.24853515625,
        774.922607421875
      ],
      [
        -325.60009765625,
        -2345.24853515625,
        774.922607421875
      ],
      [
        -325.60009765625,
        -2345.309814453125,
        774.9935302734375
      ],
      [
        -312.60009765625,
        -2345.24853515625,
        774.922607421875
      ],
      [
        -312.60009765625,
        -2345.309814453125,
        774.9935302734375
      ],
      [
        -289.4108581542969,
        -2336.337158203125,
        774.6267700195312
      ],
      [
        -289.2013854980469,
        -2336.546630859375,
        774.96826171875
      ],
      [
        -287.645751953125,
        -2334.990966796875,
        774.96826171875
      ],
      [
        -287.85504150390625,
        -2334.78173828125,
        774.6270751953125
      ],
      [
        -323.39990234375,
        -2240.265625,
        769.5828857421875
      ],
      [
        -323.39990234375,
        -2242.656982421875,
        767.6068115234375
      ],
      [
        -325.60009765625,
        -2243.879150390625,
        768.4148559570312
      ],
      [
        -323.39990234375,
        -2242.656982421875,
        767.6068115234375
      ],
      [
        -325.60009765625,
        -2241.48388671875,
        770.3942260742188
      ],
      [
        -325.60009765625,
        -2243.879150390625,
        768.4148559570312
      ],
      [
        -312.60009765625,
        -2240.3017578125,
        769.6069946289062
      ],
      [
        -312.60009765625,
        -2242.70654296875,
        767.6395263671875
      ],
      [
        -312.60009765625,
        -2242.70654296875,
        767.6395263671875
      ],
      [
        -310.39990234375,
        -2243.923583984375,
        768.4441528320312
      ],
      [
        -310.39990234375,
        -2241.5146484375,
        770.4147338867188
      ],
      [
        -310.39990234375,
        -2243.923583984375,
        768.4441528320312
      ],
      [
        -278.028564453125,
        -2247.666015625,
        765.2129516601562
      ],
      [
        -279.7173156738281,
        -2249.354736328125,
        763.2664794921875
      ],
      [
        -279.7173156738281,
        -2249.354736328125,
        763.2664794921875
      ],
      [
        -279.0205383300781,
        -2251.76953125,
        764.069580078125
      ],
      [
        -275.60009765625,
        -2263.622314453125,
        768.0119018554688
      ],
      [
        -274.9033508300781,
        -2266.036865234375,
        768.8150024414062
      ],
      [
        -277.3288879394531,
        -2250.077880859375,
        766.0193481445312
      ],
      [
        -279.0205383300781,
        -2251.76953125,
        764.069580078125
      ],
      [
        -273.8948669433594,
        -2261.9169921875,
        769.9774169921875
      ],
      [
        -275.60009765625,
        -2263.622314453125,
        768.0119018554688
      ],
      [
        -273.1952209472656,
        -2264.328857421875,
        770.7837524414062
      ],
      [
        -274.9033508300781,
        -2266.036865234375,
        768.8150024414062
      ],
      [
        -310.39990234375,
        -2233.180908203125,
        764.6949462890625
      ],
      [
        -310.39990234375,
        -2235.46044921875,
        762.81103515625
      ],
      [
        -310.5257873535156,
        -2235.505126953125,
        762.878173828125
      ],
      [
        -312.60009765625,
        -2236.657470703125,
        763.6400146484375
      ],
      [
        -312.60009765625,
        -2234.285400390625,
        765.6001586914062
      ],
      [
        -312.60009765625,
        -2236.657470703125,
        763.6400146484375
      ],
      [
        -310.5257873535156,
        -2235.505126953125,
        762.878173828125
      ],
      [
        -310.39990234375,
        -2235.46044921875,
        762.81103515625
      ],
      [
        -254.44439697265625,
        -2289.39990234375,
        764.8689575195312
      ],
      [
        -255.6233367919922,
        -2289.39990234375,
        763.9078979492188
      ],
      [
        -255.6233367919922,
        -2289.39990234375,
        763.9078979492188
      ],
      [
        -256.78173828125,
        -2289.39990234375,
        762.9635620117188
      ],
      [
        -256.78173828125,
        -2289.39990234375,
        762.9635620117188
      ],
      [
        -257.99652099609375,
        -2291.60009765625,
        763.7667236328125
      ],
      [
        -263.95965576171875,
        -2302.39990234375,
        767.7094116210938
      ],
      [
        -265.1745910644531,
        -2304.60009765625,
        768.5126342773438
      ],
      [
        -255.60604858398438,
        -2291.60009765625,
        765.7154541015625
      ],
      [
        -257.99652099609375,
        -2291.60009765625,
        763.7667236328125
      ],
      [
        -261.5497741699219,
        -2302.39990234375,
        769.6738891601562
      ],
      [
        -263.95965576171875,
        -2302.39990234375,
        767.7094116210938
      ],
      [
        -262.7607116699219,
        -2304.60009765625,
        770.4803466796875
      ],
      [
        -265.1745910644531,
        -2304.60009765625,
        768.5126342773438
      ],
      [
        -267.76580810546875,
        -2336.48583984375,
        764.7802734375
      ],
      [
        -269.18792724609375,
        -2335.06396484375,
        763.1345825195312
      ],
      [
        -269.3914489746094,
        -2334.860595703125,
        762.8990478515625
      ],
      [
        -269.18792724609375,
        -2335.06396484375,
        763.1345825195312
      ],
      [
        -269.3914489746094,
        -2334.860595703125,
        762.8990478515625
      ],
      [
        -271.8075866699219,
        -2335.5556640625,
        763.70361328125
      ],
      [
        -283.66851806640625,
        -2338.96826171875,
        767.6533813476562
      ],
      [
        -286.084716796875,
        -2339.663330078125,
        768.4579467773438
      ],
      [
        -271.8075866699219,
        -2335.5556640625,
        763.70361328125
      ],
      [
        -270.1214599609375,
        -2337.241943359375,
        765.6557006835938
      ],
      [
        -283.66851806640625,
        -2338.96826171875,
        767.6533813476562
      ],
      [
        -281.9682922363281,
        -2340.668212890625,
        769.62109375
      ],
      [
        -286.084716796875,
        -2339.663330078125,
        768.4579467773438
      ],
      [
        -284.3819580078125,
        -2341.3662109375,
        770.4290771484375
      ],
      [
        -310.39990234375,
        -2358.21826171875,
        762.8425903320312
      ],
      [
        -310.39990234375,
        -2360.500732421875,
        764.721923828125
      ],
      [
        -312.60009765625,
        -2357.011474609375,
        763.660400390625
      ],
      [
        -310.466796875,
        -2358.194580078125,
        762.878173828125
      ],
      [
        -323.39990234375,
        -2351.021484375,
        767.6207275390625
      ],
      [
        -325.60009765625,
        -2349.80126953125,
        768.427490234375
      ],
      [
        -312.60009765625,
        -2357.011474609375,
        763.660400390625
      ],
      [
        -312.60009765625,
        -2359.388427734375,
        765.6173706054688
      ],
      [
        -323.39990234375,
        -2351.021484375,
        767.6207275390625
      ],
      [
        -323.39990234375,
        -2353.41796875,
        769.5936279296875
      ],
      [
        -325.60009765625,
        -2349.80126953125,
        768.427490234375
      ],
      [
        -325.60009765625,
        -2352.20166015625,
        770.4036865234375
      ],
      [
        -310.39990234375,
        -2358.21826171875,
        762.8425903320312
      ],
      [
        -310.466796875,
        -2358.194580078125,
        762.878173828125
      ],
      [
        -372.27508544921875,
        -2291.60009765625,
        767.5505981445312
      ],
      [
        -374.6662292480469,
        -2291.60009765625,
        769.5264892578125
      ],
      [
        -372.27508544921875,
        -2291.60009765625,
        767.5505981445312
      ],
      [
        -371.0527648925781,
        -2289.39990234375,
        768.3587646484375
      ],
      [
        -371.0527648925781,
        -2289.39990234375,
        768.3587646484375
      ],
      [
        -373.4478454589844,
        -2289.39990234375,
        770.337890625
      ],
      [
        -372.0869140625,
        -2302.39990234375,
        767.675048828125
      ],
      [
        -374.4833984375,
        -2302.39990234375,
        769.648193359375
      ],
      [
        -370.8665771484375,
        -2304.60009765625,
        768.4818725585938
      ],
      [
        -372.0869140625,
        -2302.39990234375,
        767.675048828125
      ],
      [
        -370.8665771484375,
        -2304.60009765625,
        768.4818725585938
      ],
      [
        -373.2669982910156,
        -2304.60009765625,
        770.4583129882812
      ],
      [
        -358.3182067871094,
        -2346.34033203125,
        764.9351806640625
      ],
      [
        -365.35870361328125,
        -2353.380859375,
        750.0
      ],
      [
        -358.2266845703125,
        -2346.2490234375,
        765.1293334960938
      ],
      [
        -358.3182067871094,
        -2346.34033203125,
        764.9351806640625
      ],
      [
        -363.8028869628906,
        -2354.936767578125,
        750.0
      ],
      [
        -356.7624206542969,
        -2347.896240234375,
        764.9353637695312
      ],
      [
        -356.7623596191406,
        -2347.896240234375,
        764.935302734375
      ],
      [
        -356.67095947265625,
        -2347.8046875,
        765.129150390625
      ],
      [
        -372.99517822265625,
        -2345.744140625,
        750.0
      ],
      [
        -365.9547424316406,
        -2338.703857421875,
        764.935302734375
      ],
      [
        -365.9547424316406,
        -2338.703857421875,
        764.935302734375
      ],
      [
        -365.86334228515625,
        -2338.6123046875,
        765.129150390625
      ],
      [
        -367.5105285644531,
        -2337.14794921875,
        764.9351196289062
      ],
      [
        -374.5508728027344,
        -2344.188232421875,
        750.0
      ],
      [
        -367.41888427734375,
        -2337.056396484375,
        765.1295166015625
      ],
      [
        -367.5105285644531,
        -2337.14794921875,
        764.9351196289062
      ],
      [
        -365.92431640625,
        -2338.67333984375,
        764.9998168945312
      ],
      [
        -355.3629150390625,
        -2328.11181640625,
        774.9572143554688
      ],
      [
        -356.9188232421875,
        -2326.555908203125,
        774.9572143554688
      ],
      [
        -367.4798583984375,
        -2337.1171875,
        765.0001831054688
      ],
      [
        -347.7261962890625,
        -2335.748291015625,
        774.9572143554688
      ],
      [
        -358.2876281738281,
        -2346.309814453125,
        765.0000610351562
      ],
      [
        -356.7318115234375,
        -2347.86572265625,
        765.0001220703125
      ],
      [
        -346.1705322265625,
        -2337.30419921875,
        774.9572143554688
      ],
      [
        -379.4409484863281,
        -2304.60009765625,
        762.7295532226562
      ],
      [
        -381.7206726074219,
        -2304.60009765625,
        764.6133422851562
      ],
      [
        -378.27459716796875,
        -2302.39990234375,
        763.5839233398438
      ],
      [
        -379.342041015625,
        -2304.3212890625,
        762.878173828125
      ],
      [
        -378.27459716796875,
        -2302.39990234375,
        763.5839233398438
      ],
      [
        -380.6463623046875,
        -2302.39990234375,
        765.5437622070312
      ],
      [
        -379.4409484863281,
        -2304.60009765625,
        762.7295532226562
      ],
      [
        -379.342041015625,
        -2304.3212890625,
        762.878173828125
      ],
      [
        -366.78802490234375,
        -2255.848388671875,
        764.9608764648438
      ],
      [
        -373.8408203125,
        -2248.795654296875,
        750.0
      ],
      [
        -366.73284912109375,
        -2255.903564453125,
        765.0780029296875
      ],
      [
        -366.7880554199219,
        -2255.848388671875,
        764.9608764648438
      ],
      [
        -368.34393310546875,
        -2257.404296875,
        764.9608764648438
      ],
      [
        -375.396728515625,
        -2250.3515625,
        750.0
      ],
      [
        -368.34393310546875,
        -2257.404296875,
        764.9608764648438
      ],
      [
        -368.28863525390625,
        -2257.459716796875,
        765.078125
      ],
      [
        -357.59564208984375,
        -2246.656005859375,
        764.9608764648438
      ],
      [
        -364.6484375,
        -2239.603271484375,
        750.0
      ],
      [
        -357.54046630859375,
        -2246.711181640625,
        765.0780029296875
      ],
      [
        -357.5956726074219,
        -2246.656005859375,
        764.9608764648438
      ],
      [
        -359.15155029296875,
        -2248.2119140625,
        764.9608764648438
      ],
      [
        -366.204345703125,
        -2241.1591796875,
        750.0
      ],
      [
        -359.15155029296875,
        -2248.2119140625,
        764.9608764648438
      ],
      [
        -359.09625244140625,
        -2248.267333984375,
        765.078125
      ],
      [
        -356.1874694824219,
        -2266.44921875,
        774.9771118164062
      ],
      [
        -366.76959228515625,
        -2255.866943359375,
        765.0
      ],
      [
        -368.3254089355469,
        -2257.4228515625,
        765.0001831054688
      ],
      [
        -357.7431335449219,
        -2268.0048828125,
        774.9771118164062
      ],
      [
        -346.9950866699219,
        -2257.2568359375,
        774.9771118164062
      ],
      [
        -357.5771789550781,
        -2246.674560546875,
        765.0001220703125
      ],
      [
        -359.133056640625,
        -2248.23046875,
        765.0001220703125
      ],
      [
        -348.5507507324219,
        -2258.8125,
        774.9771118164062
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -239.537109375,
      "bbox_min": [
        -511.7373046875,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -86.1708984375,
        -1971.594482421875,
        775.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2268.0,
      "bbox_min": [
        -239.537109375,
        -2389.5,
        626.0
      ],
      "bbox_max": [
        -86.1708984375,
        -2188.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807842373847961,
        -0.19509564340114594,
        0.0
      ],
      "plane_d": -670.4223022460938,
      "bbox_min": [
        -239.537109375,
        -2268.0,
        627.9925537109375
      ],
      "bbox_max": [
        -234.5,
        -2243.242431640625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314761519432068,
        -0.5555604696273804,
        0.0
      ],
      "plane_d": -1445.4261474609375,
      "bbox_min": [
        -239.537109375,
        -2268.0,
        627.9925537109375
      ],
      "bbox_max": [
        -234.5,
        -2243.242431640625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807842373847961,
        0.19509564340114594,
        0.0
      ],
      "plane_d": 210.43450927734375,
      "bbox_min": [
        -239.537109375,
        -2268.0,
        627.9925537109375
      ],
      "bbox_max": [
        -234.5,
        -2243.242431640625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555562376976013,
        -0.8314789533615112,
        0.0
      ],
      "plane_d": -2016.353759765625,
      "bbox_min": [
        -236.58865356445312,
        -2268.0,
        627.9925537109375
      ],
      "bbox_max": [
        -235.00689697265625,
        -2267.067138671875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5879369974136353,
        0.3928370177745819,
        -0.7071132659912109
      ],
      "plane_d": 1207.332275390625,
      "bbox_min": [
        -236.58865356445312,
        -2268.0,
        627.9925537109375
      ],
      "bbox_max": [
        -235.00689697265625,
        -2267.067138671875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.427785187959671,
        -0.28582966327667236,
        0.8574970960617065
      ],
      "plane_d": -1086.23095703125,
      "bbox_min": [
        -236.58865356445312,
        -2268.0,
        627.9925537109375
      ],
      "bbox_max": [
        -235.00689697265625,
        -2267.067138671875,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314761519432068,
        0.5555604696273804,
        0.0
      ],
      "plane_d": 1062.9293212890625,
      "bbox_min": [
        -239.537109375,
        -2268.0,
        628.7816162109375
      ],
      "bbox_max": [
        -234.5,
        -2243.242431640625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5879369974136353,
        0.3928370177745819,
        -0.7071132659912109
      ],
      "plane_d": 1207.332275390625,
      "bbox_min": [
        -237.02639770507812,
        -2268.0,
        628.7816162109375
      ],
      "bbox_max": [
        -236.403076171875,
        -2267.067138671875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.427785187959671,
        -0.28582966327667236,
        0.8574970960617065
      ],
      "plane_d": -1086.23095703125,
      "bbox_min": [
        -237.02639770507812,
        -2268.0,
        628.7816162109375
      ],
      "bbox_max": [
        -236.403076171875,
        -2267.067138671875,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -239.537109375,
        -2268.0,
        629.0
      ],
      "bbox_max": [
        -234.5,
        -2243.242431640625,
        660.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -629.0,
      "bbox_min": [
        -239.537109375,
        -2268.0,
        629.0
      ],
      "bbox_max": [
        -234.5,
        -2243.242431640625,
        645.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -239.1748046875,
        -2267.067138671875,
        640.0
      ],
      "bbox_max": [
        -234.5,
        -2247.932861328125,
        645.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38264408707618713,
        -0.9238958358764648,
        -0.0
      ],
      "plane_d": -2184.9921875,
      "bbox_min": [
        -239.1748046875,
        -2267.067138671875,
        640.0
      ],
      "bbox_max": [
        -234.5,
        -2247.932861328125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7507426738739014,
        -0.14933623373508453,
        -0.64349365234375
      ],
      "plane_d": -101.33976745605469,
      "bbox_min": [
        -239.1748046875,
        -2267.067138671875,
        640.0
      ],
      "bbox_max": [
        -234.5,
        -2247.932861328125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807825088500977,
        -0.1951041966676712,
        0.0
      ],
      "plane_d": -673.383544921875,
      "bbox_min": [
        -239.1748046875,
        -2260.731689453125,
        640.0
      ],
      "bbox_max": [
        -236.403076171875,
        -2247.932861328125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38264405727386475,
        0.9238958358764648,
        0.0
      ],
      "plane_d": 1986.3975830078125,
      "bbox_min": [
        -239.1748046875,
        -2249.080810546875,
        640.0
      ],
      "bbox_max": [
        -236.403076171875,
        -2247.932861328125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807825088500977,
        0.1951041966676712,
        0.0
      ],
      "plane_d": 207.51187133789062,
      "bbox_min": [
        -238.14285278320312,
        -2260.731689453125,
        643.5
      ],
      "bbox_max": [
        -237.5,
        -2257.5,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -199.0,
      "bbox_min": [
        -239.537109375,
        -2389.5,
        626.0
      ],
      "bbox_max": [
        -86.1708984375,
        -2268.0,
        734.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -199.0,
        -2389.5,
        638.0
      ],
      "bbox_max": [
        -86.1708984375,
        -2284.55322265625,
        717.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.19508717954158783,
        0.9807859063148499,
        0.0
      ],
      "plane_d": 2256.4638671875,
      "bbox_min": [
        -199.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -86.1708984375,
        -2284.55322265625,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555739998817444,
        0.8314670920372009,
        0.0
      ],
      "plane_d": 1863.5758056640625,
      "bbox_min": [
        -199.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -86.1708984375,
        -2284.55322265625,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314670920372009,
        0.5555739998817444,
        0.0
      ],
      "plane_d": 1198.1217041015625,
      "bbox_min": [
        -199.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -86.1708984375,
        -2284.55322265625,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4550155997276306,
        0.6809723377227783,
        -0.5737922191619873
      ],
      "plane_d": 1896.0794677734375,
      "bbox_min": [
        -199.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -86.1708984375,
        -2284.55322265625,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4550141394138336,
        0.6809731721878052,
        0.5737923979759216
      ],
      "plane_d": 1158.1846923828125,
      "bbox_min": [
        -199.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -86.1708984375,
        -2284.55322265625,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6809776425361633,
        0.4550192058086395,
        -0.5737830400466919
      ],
      "plane_d": 1351.0736083984375,
      "bbox_min": [
        -199.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -86.1708984375,
        -2284.55322265625,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6809787154197693,
        0.4550178647041321,
        0.5737828612327576
      ],
      "plane_d": 613.1856079101562,
      "bbox_min": [
        -199.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -86.1708984375,
        -2284.55322265625,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        -199.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -104.08837890625,
        -2299.07275390625,
        649.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 649.0,
      "bbox_min": [
        -199.0,
        -2331.5,
        648.0
      ],
      "bbox_max": [
        -197.0,
        -2314.0,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -197.0,
      "bbox_min": [
        -199.0,
        -2331.5,
        648.0
      ],
      "bbox_max": [
        -197.0,
        -2314.0,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.6246950626373291,
        0.0
      ],
      "plane_d": 1301.0836181640625,
      "bbox_min": [
        -199.0,
        -2331.5,
        648.0
      ],
      "bbox_max": [
        -197.0,
        -2314.0,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -166.0,
      "bbox_min": [
        -177.0,
        -2333.5,
        644.7635498046875
      ],
      "bbox_max": [
        -166.0,
        -2331.188232421875,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -177.0,
      "bbox_min": [
        -177.0,
        -2333.5,
        647.826416015625
      ],
      "bbox_max": [
        -177.0,
        -2333.3759765625,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.15977948904037476,
        0.8032792210578918,
        0.5737708806991577
      ],
      "plane_d": 1480.005615234375,
      "bbox_min": [
        -199.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -126.489990234375,
        -2312.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -166.0,
      "bbox_min": [
        -177.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -166.0,
        -2331.18798828125,
        641.2367553710938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -177.0,
      "bbox_min": [
        -177.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -177.0,
        -2333.3759765625,
        638.173583984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": 2271.82763671875,
      "bbox_min": [
        -199.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -155.0,
        -2312.0,
        648.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -177.0,
      "bbox_min": [
        -199.0,
        -2333.5,
        641.7000732421875
      ],
      "bbox_max": [
        -166.0,
        -2329.0,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -166.0,
      "bbox_min": [
        -166.0,
        -2333.5,
        641.7000732421875
      ],
      "bbox_max": [
        -166.0,
        -2329.0,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.6246950626373291,
        0.0
      ],
      "plane_d": 1301.0836181640625,
      "bbox_min": [
        -199.0,
        -2331.5,
        644.5
      ],
      "bbox_max": [
        -197.0,
        -2329.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2331.5,
      "bbox_min": [
        -199.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -155.0,
        -2312.0,
        648.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -177.0,
      "bbox_min": [
        -177.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -166.0,
        -2331.5,
        644.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -166.0,
      "bbox_min": [
        -166.0,
        -2333.5,
        638.4368286132812
      ],
      "bbox_max": [
        -166.0,
        -2331.5,
        644.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": 1524.355224609375,
      "bbox_min": [
        -199.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -155.0,
        -2312.0,
        648.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7808687686920166,
        0.6246950626373291,
        0.0
      ],
      "plane_d": 1301.0836181640625,
      "bbox_min": [
        -199.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -166.0,
        -2329.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -177.0,
      "bbox_min": [
        -177.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -166.0,
        -2329.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -166.0,
      "bbox_min": [
        -166.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -166.0,
        -2329.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": -1508.3712158203125,
      "bbox_min": [
        -199.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -155.0,
        -2312.0,
        648.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -177.0,
      "bbox_min": [
        -199.0,
        -2316.5,
        641.7000732421875
      ],
      "bbox_max": [
        -166.0,
        -2312.0,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -166.0,
      "bbox_min": [
        -166.0,
        -2316.5,
        641.7000732421875
      ],
      "bbox_max": [
        -166.0,
        -2312.0,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        -0.6246950626373291,
        -0.0
      ],
      "plane_d": -1600.937255859375,
      "bbox_min": [
        -199.0,
        -2316.5,
        644.5
      ],
      "bbox_max": [
        -197.0,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2314.0,
      "bbox_min": [
        -199.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -155.0,
        -2312.0,
        644.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -166.0,
      "bbox_min": [
        -166.0,
        -2314.0,
        638.0
      ],
      "bbox_max": [
        -166.0,
        -2312.0,
        644.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": -2255.843505859375,
      "bbox_min": [
        -199.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -155.0,
        -2314.0,
        641.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        -0.6246950030326843,
        -1.892355072641294e-08
      ],
      "plane_d": -1600.9371337890625,
      "bbox_min": [
        -199.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -166.0,
        -2314.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -166.0,
      "bbox_min": [
        -166.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -166.0,
        -2314.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -216.0,
      "bbox_min": [
        -239.537109375,
        -2389.5,
        626.0
      ],
      "bbox_max": [
        -199.0,
        -2268.0,
        734.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -216.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -199.0,
        -2314.0,
        649.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 649.0,
      "bbox_min": [
        -216.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -199.0,
        -2314.0,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        -216.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -199.0,
        -2314.0,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2314.0,
      "bbox_min": [
        -207.0,
        -2314.0,
        648.0
      ],
      "bbox_max": [
        -199.0,
        -2314.0,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2314.0,
      "bbox_min": [
        -216.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -199.0,
        -2314.0,
        648.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2331.5,
      "bbox_min": [
        -216.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -207.0,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": 1524.355224609375,
      "bbox_min": [
        -216.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -207.0,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": 2271.82763671875,
      "bbox_min": [
        -216.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -207.0,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": -2255.843505859375,
      "bbox_min": [
        -216.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -207.0,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": -1508.3712158203125,
      "bbox_min": [
        -216.0,
        -2316.5,
        644.5
      ],
      "bbox_max": [
        -207.0,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -239.537109375,
        -2331.5,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2268.0,
        730.021484375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        -239.537109375,
        -2331.5,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2268.0,
        730.021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -239.537109375,
        -2304.60009765625,
        648.0
      ],
      "bbox_max": [
        -237.02639770507812,
        -2268.0,
        730.021484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -239.537109375,
        -2289.39990234375,
        648.0
      ],
      "bbox_max": [
        -237.02639770507812,
        -2268.0,
        730.021484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314761519432068,
        0.5555604696273804,
        0.0
      ],
      "plane_d": 1062.9293212890625,
      "bbox_min": [
        -239.537109375,
        -2271.757568359375,
        648.0
      ],
      "bbox_max": [
        -237.02639770507812,
        -2268.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -239.537109375,
        -2271.757568359375,
        660.0
      ],
      "bbox_max": [
        -237.02639770507812,
        -2268.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -239.537109375,
        -2302.39990234375,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2302.39990234375,
        730.021484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": -2255.843505859375,
      "bbox_min": [
        -239.537109375,
        -2331.5,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2268.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555562376976013,
        -0.8314789533615112,
        0.0
      ],
      "plane_d": -2016.353759765625,
      "bbox_min": [
        -239.537109375,
        -2295.0,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2268.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555562973022461,
        0.8314789533615112,
        0.0
      ],
      "plane_d": 2026.1082763671875,
      "bbox_min": [
        -239.537109375,
        -2295.0,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2268.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2295.0,
      "bbox_min": [
        -220.89990234375,
        -2295.0,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2295.0,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5879369974136353,
        0.3928370177745819,
        -0.7071132659912109
      ],
      "plane_d": 1207.332275390625,
      "bbox_min": [
        -239.537109375,
        -2277.95556640625,
        626.0
      ],
      "bbox_max": [
        -232.24560546875,
        -2268.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314761519432068,
        0.5555604696273804,
        0.0
      ],
      "plane_d": 1062.9293212890625,
      "bbox_min": [
        -239.537109375,
        -2271.757568359375,
        644.5
      ],
      "bbox_max": [
        -237.02639770507812,
        -2268.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.427785187959671,
        -0.28582966327667236,
        0.8574970960617065
      ],
      "plane_d": -1086.23095703125,
      "bbox_min": [
        -239.537109375,
        -2277.95556640625,
        626.0
      ],
      "bbox_max": [
        -232.24560546875,
        -2268.0,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -629.0,
      "bbox_min": [
        -239.537109375,
        -2271.757568359375,
        629.0
      ],
      "bbox_max": [
        -237.02639770507812,
        -2268.0,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": 2271.82763671875,
      "bbox_min": [
        -239.537109375,
        -2331.5,
        641.5
      ],
      "bbox_max": [
        -216.0,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": -1508.3712158203125,
      "bbox_min": [
        -239.537109375,
        -2331.5,
        641.5
      ],
      "bbox_max": [
        -216.0,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2331.5,
      "bbox_min": [
        -239.537109375,
        -2331.5,
        641.5
      ],
      "bbox_max": [
        -216.0,
        -2314.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2314.0,
      "bbox_min": [
        -239.537109375,
        -2314.0,
        641.5
      ],
      "bbox_max": [
        -216.0,
        -2314.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518882870674133
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -511.7373046875,
        -2133.71044921875,
        639.28125
      ],
      "bbox_max": [
        -309.987548828125,
        -1971.594482421875,
        716.4224243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4736105501651764,
        -0.6577551960945129,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -511.7373046875,
        -2133.71044921875,
        639.28125
      ],
      "bbox_max": [
        -309.987548828125,
        -1971.594482421875,
        716.4224243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30801334977149963,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -511.7373046875,
        -2133.71044921875,
        639.28125
      ],
      "bbox_max": [
        -309.987548828125,
        -1971.594482421875,
        710.3526000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -511.7373046875,
        -2133.71044921875,
        639.28125
      ],
      "bbox_max": [
        -309.987548828125,
        -2014.4228515625,
        645.7384643554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.04707995802164078,
        -0.02905004657804966,
        0.9984686374664307
      ],
      "plane_d": -717.8628540039062,
      "bbox_min": [
        -416.1728515625,
        -2077.14501953125,
        639.28125
      ],
      "bbox_max": [
        -309.987548828125,
        -2014.4228515625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.9980202913284302
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -416.1728515625,
        -2077.14501953125,
        639.28125
      ],
      "bbox_max": [
        -393.90704345703125,
        -2064.272216796875,
        640.161865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000061392784119,
        -0.8660218715667725,
        0.0
      ],
      "plane_d": -1640.235595703125,
      "bbox_min": [
        -504.10089111328125,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -239.537109375,
        -2023.8939208984375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -504.10089111328125,
        -2139.602783203125,
        639.28125
      ],
      "bbox_max": [
        -313.8933410644531,
        -2023.8939208984375,
        655.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.04707995802164078,
        -0.02905004657804966,
        0.9984686374664307
      ],
      "plane_d": -717.8628540039062,
      "bbox_min": [
        -406.1270751953125,
        -2120.05419921875,
        639.28125
      ],
      "bbox_max": [
        -313.8933410644531,
        -2023.8939208984375,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.9980202913284302
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -406.1270751953125,
        -2109.384765625,
        639.28125
      ],
      "bbox_max": [
        -338.8740234375,
        -2070.08984375,
        642.3384399414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        -393.1123962402344,
        -2120.05419921875,
        639.9999389648438
      ],
      "bbox_max": [
        -375.095947265625,
        -2107.53271484375,
        655.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -393.1123962402344,
        -2120.05419921875,
        639.9999389648438
      ],
      "bbox_max": [
        -375.095947265625,
        -2107.53271484375,
        655.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254071712493896,
        -0.17237460613250732
      ],
      "plane_d": -1249.1888427734375,
      "bbox_min": [
        -378.520751953125,
        -2111.9541015625,
        639.9999389648438
      ],
      "bbox_max": [
        -375.095947265625,
        -2107.53271484375,
        655.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2427.0,
      "bbox_min": [
        -329.699951171875,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        620.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 618.0,
      "bbox_min": [
        -329.699951171875,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        620.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2355.699951171875,
      "bbox_min": [
        -329.699951171875,
        -2427.0,
        618.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        620.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -308.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        618.0
      ],
      "bbox_max": [
        -308.0,
        -2415.0,
        620.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        618.0
      ],
      "bbox_max": [
        -308.0,
        -2424.0,
        620.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2424.0,
      "bbox_min": [
        -310.0,
        -2424.0,
        618.0
      ],
      "bbox_max": [
        -308.0,
        -2424.0,
        620.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        618.0
      ],
      "bbox_max": [
        -325.0,
        -2424.0,
        620.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2424.0,
      "bbox_min": [
        -327.0,
        -2424.0,
        618.0
      ],
      "bbox_max": [
        -325.0,
        -2424.0,
        620.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.24253562092781067,
        0.0
      ],
      "plane_d": -251.48521423339844,
      "bbox_min": [
        -329.699951171875,
        -2355.699951171875,
        618.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        620.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.24253562092781067,
        -0.0
      ],
      "plane_d": -868.495849609375,
      "bbox_min": [
        -325.699951171875,
        -2355.699951171875,
        618.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        620.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2339.699951171875,
      "bbox_min": [
        -325.699951171875,
        -2339.699951171875,
        618.0
      ],
      "bbox_max": [
        -310.300048828125,
        -2339.699951171875,
        620.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -608.0,
      "bbox_min": [
        -329.699951171875,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        618.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -308.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -308.0,
        -2415.0,
        608.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -308.0,
        -2424.0,
        608.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2424.0,
      "bbox_min": [
        -310.0,
        -2424.0,
        603.0
      ],
      "bbox_max": [
        -308.0,
        -2424.0,
        608.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -325.0,
        -2424.0,
        608.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2424.0,
      "bbox_min": [
        -327.0,
        -2424.0,
        603.0
      ],
      "bbox_max": [
        -325.0,
        -2424.0,
        608.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 329.699951171875,
      "bbox_min": [
        -329.699951171875,
        -2427.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        618.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -306.300048828125,
      "bbox_min": [
        -329.699951171875,
        -2427.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        618.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.5299989581108093,
        0.847998321056366
      ],
      "plane_d": -1764.1014404296875,
      "bbox_min": [
        -329.699951171875,
        -2427.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2411.5,
      "bbox_min": [
        -329.699951171875,
        -2427.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        618.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -308.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        608.0
      ],
      "bbox_max": [
        -308.0,
        -2411.5,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        608.0
      ],
      "bbox_max": [
        -308.0,
        -2411.5,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2424.0,
      "bbox_min": [
        -310.0,
        -2424.0,
        608.0
      ],
      "bbox_max": [
        -308.0,
        -2424.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        608.0
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2424.0,
      "bbox_min": [
        -327.0,
        -2424.0,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2424.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 616.9500122070312,
      "bbox_min": [
        -323.5,
        -2413.0,
        608.4500122070312
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        616.9500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -608.4500122070312,
      "bbox_min": [
        -323.5,
        -2413.0,
        608.4500122070312
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        616.9500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.5,
      "bbox_min": [
        -323.5,
        -2413.0,
        608.4500122070312
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        616.9500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -311.5,
      "bbox_min": [
        -311.5,
        -2413.0,
        608.4500122070312
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        616.9500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.24253562092781067,
        0.0
      ],
      "plane_d": -251.48521423339844,
      "bbox_min": [
        -329.699951171875,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.24253562092781067,
        0.0
      ],
      "plane_d": -868.495849609375,
      "bbox_min": [
        -329.699951171875,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2380.0,
      "bbox_min": [
        -329.699951171875,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2360.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2390.0,
      "bbox_min": [
        -329.699951171875,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2380.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2400.0,
      "bbox_min": [
        -329.699951171875,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2390.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -200.81832885742188,
      "bbox_min": [
        -327.0,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2400.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2400.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2400.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 665.387451171875,
      "bbox_min": [
        -327.0,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2400.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2401.0,
        616.0
      ],
      "bbox_max": [
        -325.0,
        -2400.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -650.5382080078125,
      "bbox_min": [
        -311.0,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2400.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -311.0,
        -2400.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -309.0,
      "bbox_min": [
        -311.0,
        -2401.0,
        611.0
      ],
      "bbox_max": [
        -309.0,
        -2400.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 215.66757202148438,
      "bbox_min": [
        -311.0,
        -2401.0,
        614.0
      ],
      "bbox_max": [
        -309.0,
        -2400.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2401.0,
        616.0
      ],
      "bbox_max": [
        -311.0,
        -2400.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -200.81832885742188,
      "bbox_min": [
        -327.0,
        -2391.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2390.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2391.0,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2390.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2391.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2390.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 665.387451171875,
      "bbox_min": [
        -327.0,
        -2391.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2390.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2391.0,
        616.0
      ],
      "bbox_max": [
        -325.0,
        -2390.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -650.5382080078125,
      "bbox_min": [
        -311.0,
        -2391.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2390.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2391.0,
        608.0
      ],
      "bbox_max": [
        -311.0,
        -2390.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -309.0,
      "bbox_min": [
        -311.0,
        -2391.0,
        611.0
      ],
      "bbox_max": [
        -309.0,
        -2390.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 215.66757202148438,
      "bbox_min": [
        -311.0,
        -2391.0,
        614.0
      ],
      "bbox_max": [
        -309.0,
        -2390.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2391.0,
        616.0
      ],
      "bbox_max": [
        -311.0,
        -2390.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2381.0,
      "bbox_min": [
        -329.699951171875,
        -2381.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2380.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -200.81832885742188,
      "bbox_min": [
        -327.0,
        -2381.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2380.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2381.0,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2380.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -650.5382080078125,
      "bbox_min": [
        -327.0,
        -2381.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2380.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2381.0,
        608.0
      ],
      "bbox_max": [
        -311.0,
        -2380.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2381.0,
        611.0
      ],
      "bbox_max": [
        -309.0,
        -2380.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 665.387451171875,
      "bbox_min": [
        -327.0,
        -2381.0,
        611.0
      ],
      "bbox_max": [
        -309.0,
        -2380.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2381.0,
        616.0
      ],
      "bbox_max": [
        -325.0,
        -2380.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -309.0,
      "bbox_min": [
        -311.0,
        -2381.0,
        611.0
      ],
      "bbox_max": [
        -309.0,
        -2380.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 215.66757202148438,
      "bbox_min": [
        -311.0,
        -2381.0,
        614.0
      ],
      "bbox_max": [
        -309.0,
        -2380.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2381.0,
        616.0
      ],
      "bbox_max": [
        -311.0,
        -2380.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2370.0,
      "bbox_min": [
        -329.699951171875,
        -2371.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2360.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2371.0,
      "bbox_min": [
        -329.699951171875,
        -2371.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2370.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -200.81832885742188,
      "bbox_min": [
        -327.0,
        -2371.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2370.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2371.0,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2370.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -650.5382080078125,
      "bbox_min": [
        -327.0,
        -2371.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2370.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2371.0,
        608.0
      ],
      "bbox_max": [
        -311.0,
        -2370.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -309.0,
      "bbox_min": [
        -327.0,
        -2371.0,
        611.0
      ],
      "bbox_max": [
        -309.0,
        -2370.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2371.0,
        611.0
      ],
      "bbox_max": [
        -309.0,
        -2370.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 665.387451171875,
      "bbox_min": [
        -327.0,
        -2371.0,
        614.0
      ],
      "bbox_max": [
        -309.0,
        -2370.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2371.0,
        616.0
      ],
      "bbox_max": [
        -325.0,
        -2370.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 215.66757202148438,
      "bbox_min": [
        -311.0,
        -2371.0,
        614.0
      ],
      "bbox_max": [
        -309.0,
        -2370.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2371.0,
        616.0
      ],
      "bbox_max": [
        -311.0,
        -2370.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2360.0,
      "bbox_min": [
        -329.699951171875,
        -2361.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2360.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2361.0,
      "bbox_min": [
        -329.699951171875,
        -2361.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2360.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -200.81832885742188,
      "bbox_min": [
        -327.0,
        -2361.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2360.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2361.0,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2360.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2361.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2360.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -650.5382080078125,
      "bbox_min": [
        -327.0,
        -2361.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2360.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2361.0,
        608.0
      ],
      "bbox_max": [
        -311.0,
        -2360.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -309.0,
      "bbox_min": [
        -327.0,
        -2361.0,
        611.0
      ],
      "bbox_max": [
        -309.0,
        -2360.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 215.66757202148438,
      "bbox_min": [
        -327.0,
        -2361.0,
        614.0
      ],
      "bbox_max": [
        -309.0,
        -2360.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2361.0,
        616.0
      ],
      "bbox_max": [
        -311.0,
        -2360.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 665.387451171875,
      "bbox_min": [
        -327.0,
        -2361.0,
        614.0
      ],
      "bbox_max": [
        -325.0,
        -2360.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2361.0,
        616.0
      ],
      "bbox_max": [
        -325.0,
        -2360.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2411.5,
      "bbox_min": [
        -450.5,
        -2427.0,
        619.9999389648438
      ],
      "bbox_max": [
        -239.537109375,
        -2105.55419921875,
        750.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2427.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        620.0
      ],
      "bbox_max": [
        -308.0,
        -2411.5,
        638.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        620.0
      ],
      "bbox_max": [
        -308.0,
        -2411.5,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -308.0,
      "bbox_min": [
        -310.0,
        -2425.0,
        620.0
      ],
      "bbox_max": [
        -308.0,
        -2415.0,
        638.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2424.0,
      "bbox_min": [
        -310.0,
        -2424.0,
        620.0
      ],
      "bbox_max": [
        -308.0,
        -2424.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        620.0
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2425.0,
        620.0
      ],
      "bbox_max": [
        -325.0,
        -2415.0,
        638.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2424.0,
      "bbox_min": [
        -327.0,
        -2424.0,
        620.0
      ],
      "bbox_max": [
        -325.0,
        -2424.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.9500122070312,
      "bbox_min": [
        -323.5,
        -2413.0,
        626.9500122070312
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        635.9500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -311.5,
      "bbox_min": [
        -323.5,
        -2413.0,
        626.9500122070312
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        635.9500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.5,
      "bbox_min": [
        -323.5,
        -2413.0,
        626.9500122070312
      ],
      "bbox_max": [
        -323.5,
        -2411.5,
        635.9500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 435.0,
      "bbox_min": [
        -450.5,
        -2411.5,
        619.9999389648438
      ],
      "bbox_max": [
        -239.537109375,
        -2105.55419921875,
        750.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -437.0,
      "bbox_min": [
        -450.5,
        -2389.5,
        642.0
      ],
      "bbox_max": [
        -435.0,
        -2287.60009765625,
        730.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -712.0,
      "bbox_min": [
        -437.0,
        -2302.60009765625,
        648.0
      ],
      "bbox_max": [
        -435.0,
        -2291.0,
        720.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -648.0,
      "bbox_min": [
        -437.0,
        -2302.60009765625,
        648.0
      ],
      "bbox_max": [
        -435.0,
        -2291.0,
        656.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 656.4000244140625,
      "bbox_min": [
        -437.0,
        -2302.60009765625,
        648.0
      ],
      "bbox_max": [
        -435.0,
        -2291.0,
        656.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2291.0,
      "bbox_min": [
        -437.0,
        -2302.60009765625,
        648.0
      ],
      "bbox_max": [
        -435.0,
        -2291.0,
        656.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.60009765625,
      "bbox_min": [
        -437.0,
        -2302.60009765625,
        648.0
      ],
      "bbox_max": [
        -435.0,
        -2291.0,
        656.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8076642155647278,
        -0.5896427035331726
      ],
      "plane_d": -1464.55712890625,
      "bbox_min": [
        -437.0,
        -2302.60009765625,
        648.0
      ],
      "bbox_max": [
        -435.0,
        -2291.0,
        656.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8076642155647278,
        -0.5896427035331726
      ],
      "plane_d": 2245.529296875,
      "bbox_min": [
        -437.0,
        -2302.60009765625,
        648.0
      ],
      "bbox_max": [
        -435.0,
        -2291.0,
        656.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7808486819267273,
        0.6247201561927795
      ],
      "plane_d": -2194.899169921875,
      "bbox_min": [
        -437.0,
        -2302.60009765625,
        648.0
      ],
      "bbox_max": [
        -435.0,
        -2291.0,
        649.8507690429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7808486819267273,
        0.6247201561927795
      ],
      "plane_d": 1392.00732421875,
      "bbox_min": [
        -437.0,
        -2302.60009765625,
        648.0
      ],
      "bbox_max": [
        -435.0,
        -2301.119384765625,
        649.8507690429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 720.4000244140625,
      "bbox_min": [
        -437.0,
        -2302.60009765625,
        712.0
      ],
      "bbox_max": [
        -435.0,
        -2291.0,
        720.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2291.0,
      "bbox_min": [
        -437.0,
        -2302.60009765625,
        712.0
      ],
      "bbox_max": [
        -435.0,
        -2291.0,
        720.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.60009765625,
      "bbox_min": [
        -437.0,
        -2302.60009765625,
        712.0
      ],
      "bbox_max": [
        -435.0,
        -2291.0,
        720.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8076642155647278,
        -0.5896427035331726
      ],
      "plane_d": -1426.8199462890625,
      "bbox_min": [
        -437.0,
        -2302.60009765625,
        712.0
      ],
      "bbox_max": [
        -435.0,
        -2291.0,
        720.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8076642155647278,
        -0.5896427035331726
      ],
      "plane_d": 2283.266357421875,
      "bbox_min": [
        -437.0,
        -2302.60009765625,
        712.0
      ],
      "bbox_max": [
        -435.0,
        -2291.0,
        720.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7808486819267273,
        0.6247201561927795
      ],
      "plane_d": -2234.88134765625,
      "bbox_min": [
        -437.0,
        -2302.60009765625,
        712.0
      ],
      "bbox_max": [
        -435.0,
        -2291.0,
        713.8507690429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7808486819267273,
        0.6247201561927795
      ],
      "plane_d": 1352.0252685546875,
      "bbox_min": [
        -437.0,
        -2302.60009765625,
        712.0
      ],
      "bbox_max": [
        -435.0,
        -2301.119384765625,
        713.8507690429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2291.0,
      "bbox_min": [
        -450.5,
        -2306.0,
        644.0
      ],
      "bbox_max": [
        -437.0,
        -2287.60009765625,
        730.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 447.0,
      "bbox_min": [
        -450.5,
        -2291.0,
        644.0
      ],
      "bbox_max": [
        -437.0,
        -2287.60009765625,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2287.60009765625,
      "bbox_min": [
        -450.5,
        -2291.0,
        644.0
      ],
      "bbox_max": [
        -447.0,
        -2287.60009765625,
        730.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 450.5,
      "bbox_min": [
        -450.5,
        -2291.0,
        644.0
      ],
      "bbox_max": [
        -447.0,
        -2287.60009765625,
        730.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -644.0,
      "bbox_min": [
        -450.5,
        -2291.0,
        644.0
      ],
      "bbox_max": [
        -447.0,
        -2287.60009765625,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2287.60009765625,
      "bbox_min": [
        -440.5,
        -2291.0,
        644.0
      ],
      "bbox_max": [
        -437.0,
        -2287.60009765625,
        730.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -644.0,
      "bbox_min": [
        -440.5,
        -2291.0,
        644.0
      ],
      "bbox_max": [
        -437.0,
        -2287.60009765625,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -440.5,
        -2291.0,
        730.0
      ],
      "bbox_max": [
        -437.0,
        -2287.60009765625,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2287.60009765625,
      "bbox_min": [
        -447.0,
        -2291.0,
        644.0
      ],
      "bbox_max": [
        -440.5,
        -2287.60009765625,
        730.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -644.0,
      "bbox_min": [
        -447.0,
        -2291.0,
        644.0
      ],
      "bbox_max": [
        -440.5,
        -2287.60009765625,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -447.0,
        -2291.0,
        730.0
      ],
      "bbox_max": [
        -440.5,
        -2287.60009765625,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 447.0,
      "bbox_min": [
        -450.5,
        -2306.0,
        644.0
      ],
      "bbox_max": [
        -437.0,
        -2291.0,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.60009765625,
      "bbox_min": [
        -450.5,
        -2306.0,
        644.0
      ],
      "bbox_max": [
        -447.0,
        -2291.0,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2306.0,
      "bbox_min": [
        -450.5,
        -2306.0,
        644.0
      ],
      "bbox_max": [
        -447.0,
        -2302.60009765625,
        730.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 450.5,
      "bbox_min": [
        -450.5,
        -2306.0,
        644.0
      ],
      "bbox_max": [
        -447.0,
        -2302.60009765625,
        730.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -644.0,
      "bbox_min": [
        -450.5,
        -2306.0,
        644.0
      ],
      "bbox_max": [
        -447.0,
        -2302.60009765625,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -450.5,
        -2306.0,
        730.0
      ],
      "bbox_max": [
        -447.0,
        -2302.60009765625,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 450.5,
      "bbox_min": [
        -450.5,
        -2302.60009765625,
        644.0
      ],
      "bbox_max": [
        -447.0,
        -2291.0,
        730.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -644.0,
      "bbox_min": [
        -450.5,
        -2302.60009765625,
        644.0
      ],
      "bbox_max": [
        -447.0,
        -2291.0,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -450.5,
        -2302.60009765625,
        730.0
      ],
      "bbox_max": [
        -447.0,
        -2291.0,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.60009765625,
      "bbox_min": [
        -447.0,
        -2306.0,
        644.0
      ],
      "bbox_max": [
        -437.0,
        -2291.0,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -440.5,
      "bbox_min": [
        -447.0,
        -2306.0,
        644.0
      ],
      "bbox_max": [
        -437.0,
        -2302.60009765625,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2306.0,
      "bbox_min": [
        -440.5,
        -2306.0,
        644.0
      ],
      "bbox_max": [
        -437.0,
        -2302.60009765625,
        730.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -644.0,
      "bbox_min": [
        -440.5,
        -2306.0,
        644.0
      ],
      "bbox_max": [
        -437.0,
        -2302.60009765625,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -440.5,
        -2306.0,
        730.0
      ],
      "bbox_max": [
        -437.0,
        -2302.60009765625,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2306.0,
      "bbox_min": [
        -447.0,
        -2306.0,
        644.0
      ],
      "bbox_max": [
        -440.5,
        -2302.60009765625,
        730.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -644.0,
      "bbox_min": [
        -447.0,
        -2306.0,
        644.0
      ],
      "bbox_max": [
        -440.5,
        -2302.60009765625,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -447.0,
        -2306.0,
        730.0
      ],
      "bbox_max": [
        -440.5,
        -2302.60009765625,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -644.0,
      "bbox_min": [
        -447.0,
        -2302.60009765625,
        644.0
      ],
      "bbox_max": [
        -437.0,
        -2291.0,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -447.0,
        -2302.60009765625,
        730.0
      ],
      "bbox_max": [
        -437.0,
        -2291.0,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -712.0,
      "bbox_min": [
        -435.0,
        -2411.5,
        619.9999389648438
      ],
      "bbox_max": [
        -239.537109375,
        -2105.55419921875,
        750.0
      ],
      "face_count": 17
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -401.07666015625,
        -2206.083740234375,
        630.7999877929688
      ],
      "bbox_max": [
        -325.3114318847656,
        -2105.55419921875,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.3023406609136146e-05,
        -2.2557347620022483e-05,
        1.0
      ],
      "plane_d": -640.042724609375,
      "bbox_min": [
        -401.07666015625,
        -2146.992919921875,
        630.7999877929688
      ],
      "bbox_max": [
        -362.217041015625,
        -2105.55419921875,
        641.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.1305050551891327,
        -0.9914476275444031,
        0.0
      ],
      "plane_d": -2055.033203125,
      "bbox_min": [
        -401.07666015625,
        -2128.482421875,
        630.7999877929688
      ],
      "bbox_max": [
        -366.435791015625,
        -2105.55419921875,
        639.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7933823466300964,
        -0.6087236404418945,
        0.0
      ],
      "plane_d": -990.9769287109375,
      "bbox_min": [
        -370.162841796875,
        -2110.411865234375,
        630.7999877929688
      ],
      "bbox_max": [
        -366.435791015625,
        -2105.55419921875,
        639.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.608748733997345,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1926.1617431640625,
      "bbox_min": [
        -395.006103515625,
        -2128.482421875,
        630.7999877929688
      ],
      "bbox_max": [
        -390.1484375,
        -2124.755126953125,
        639.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660219311714172,
        0.5000061392784119,
        0.0
      ],
      "plane_d": 1397.33154296875,
      "bbox_min": [
        -379.841552734375,
        -2146.2607421875,
        640.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2128.060546875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660219311714172,
        -0.5000061392784119,
        -0.0
      ],
      "plane_d": -1383.3314208984375,
      "bbox_min": [
        -379.841552734375,
        -2139.2607421875,
        640.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2128.060546875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49997738003730774,
        -0.86603844165802,
        0.0
      ],
      "plane_d": -1658.581787109375,
      "bbox_min": [
        -379.841552734375,
        -2136.734619140625,
        640.0
      ],
      "bbox_max": [
        -367.717041015625,
        -2128.060546875,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.86605304479599,
        0.49995216727256775,
        0.0
      ],
      "plane_d": 1393.328125,
      "bbox_min": [
        -378.614013671875,
        -2133.052490234375,
        640.0
      ],
      "bbox_max": [
        -372.26806640625,
        -2128.060546875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.86605304479599,
        -0.49995216727256775,
        -0.0
      ],
      "plane_d": -1387.3282470703125,
      "bbox_min": [
        -373.41796875,
        -2130.052490234375,
        640.0
      ],
      "bbox_max": [
        -372.26806640625,
        -2128.060546875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25884971022605896,
        -0.9659175872802734,
        -0.0
      ],
      "plane_d": -2152.33154296875,
      "bbox_min": [
        -379.841552734375,
        -2136.734619140625,
        640.0
      ],
      "bbox_max": [
        -367.717041015625,
        -2129.00244140625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659176468849182,
        -0.2588496804237366,
        0.0
      ],
      "plane_d": -186.19741821289062,
      "bbox_min": [
        -379.841552734375,
        -2136.734619140625,
        640.0
      ],
      "bbox_max": [
        -379.109375,
        -2134.00244140625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7727664709091187,
        0.44615715742111206,
        -0.45141535997390747
      ],
      "plane_d": 1543.02392578125,
      "bbox_min": [
        -379.841552734375,
        -2206.083740234375,
        641.0
      ],
      "bbox_max": [
        -325.3114318847656,
        -2128.060546875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8327006101608276,
        0.4807601869106293,
        0.27473509311676025
      ],
      "plane_d": 1169.4652099609375,
      "bbox_min": [
        -379.841552734375,
        -2206.083740234375,
        641.0
      ],
      "bbox_max": [
        -325.3114318847656,
        -2128.060546875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7709356546401978,
        -0.44509944319725037,
        -0.4555707275867462
      ],
      "plane_d": -932.5703735351562,
      "bbox_min": [
        -379.841552734375,
        -2199.33349609375,
        641.0
      ],
      "bbox_max": [
        -325.3114318847656,
        -2128.060546875,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4924207925796509,
        -0.8528348207473755,
        -0.17376579344272614
      ],
      "plane_d": -1573.84912109375,
      "bbox_min": [
        -344.200927734375,
        -2179.897705078125,
        642.2142944335938
      ],
      "bbox_max": [
        -327.710693359375,
        -2169.56787109375,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1983572542667389,
        -0.11451967060565948,
        0.9734165072441101
      ],
      "plane_d": -940.360595703125,
      "bbox_min": [
        -338.16650390625,
        -2179.897705078125,
        642.2142944335938
      ],
      "bbox_max": [
        -327.710693359375,
        -2169.56787109375,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000067353248596,
        -0.8660215139389038,
        0.0
      ],
      "plane_d": -1712.534912109375,
      "bbox_min": [
        -338.16650390625,
        -2172.718017578125,
        642.21435546875
      ],
      "bbox_max": [
        -332.710693359375,
        -2169.56787109375,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1983572542667389,
        -0.11451967060565948,
        0.9734165072441101
      ],
      "plane_d": -940.360595703125,
      "bbox_min": [
        -340.07177734375,
        -2182.478271484375,
        641.0
      ],
      "bbox_max": [
        -330.6023254394531,
        -2171.2373046875,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000067353248596,
        -0.8660215139389038,
        0.0
      ],
      "plane_d": -1712.534912109375,
      "bbox_min": [
        -340.07177734375,
        -2173.81787109375,
        641.0
      ],
      "bbox_max": [
        -335.6023864746094,
        -2171.2373046875,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999828040599823,
        -0.8660353422164917,
        -2.6044453989015892e-06
      ],
      "plane_d": -1674.571533203125,
      "bbox_min": [
        -379.841552734375,
        -2191.826416015625,
        641.0
      ],
      "bbox_max": [
        -335.32568359375,
        -2128.060546875,
        665.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.8660219311714172,
        0.5000061392784119,
        0.0
      ],
      "plane_d": 1397.33154296875,
      "bbox_min": [
        -379.841552734375,
        -2146.992919921875,
        641.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2128.060546875,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660219311714172,
        -0.5000061392784119,
        -0.0
      ],
      "plane_d": -1383.3314208984375,
      "bbox_min": [
        -379.841552734375,
        -2146.992919921875,
        641.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2128.060546875,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6018846035003662,
        0.3474956154823303,
        -0.7190144658088684
      ],
      "plane_d": 1439.971923828125,
      "bbox_min": [
        -379.841552734375,
        -2146.992919921875,
        641.0
      ],
      "bbox_max": [
        -364.26806640625,
        -2128.060546875,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49997738003730774,
        -0.86603844165802,
        0.0
      ],
      "plane_d": -1658.581787109375,
      "bbox_min": [
        -379.841552734375,
        -2146.908935546875,
        641.0
      ],
      "bbox_max": [
        -364.26806640625,
        -2128.060546875,
        653.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.86605304479599,
        0.49995216727256775,
        0.0
      ],
      "plane_d": 1393.328125,
      "bbox_min": [
        -378.614013671875,
        -2133.052490234375,
        641.0
      ],
      "bbox_max": [
        -372.26806640625,
        -2128.060546875,
        649.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.86605304479599,
        -0.49995216727256775,
        -0.0
      ],
      "plane_d": -1387.3282470703125,
      "bbox_min": [
        -378.614013671875,
        -2133.052490234375,
        641.0
      ],
      "bbox_max": [
        -372.26806640625,
        -2128.060546875,
        649.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 649.9999389648438,
      "bbox_min": [
        -378.614013671875,
        -2133.052490234375,
        649.9999389648438
      ],
      "bbox_max": [
        -372.26806640625,
        -2128.060546875,
        649.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25884971022605896,
        -0.9659175872802734,
        -0.0
      ],
      "plane_d": -2152.33154296875,
      "bbox_min": [
        -379.841552734375,
        -2146.908935546875,
        641.0
      ],
      "bbox_max": [
        -364.26806640625,
        -2129.00244140625,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659176468849182,
        -0.2588496804237366,
        0.0
      ],
      "plane_d": -186.19741821289062,
      "bbox_min": [
        -379.841552734375,
        -2146.908935546875,
        641.0
      ],
      "bbox_max": [
        -364.26806640625,
        -2134.00244140625,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8608181476593018,
        0.4970272481441498,
        -0.10934361815452576
      ],
      "plane_d": 1455.202880859375,
      "bbox_min": [
        -369.964111328125,
        -2146.908935546875,
        641.0
      ],
      "bbox_max": [
        -364.26806640625,
        -2143.04296875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8617133498191833,
        -0.49754413962364197,
        -0.09949871897697449
      ],
      "plane_d": -1316.8052978515625,
      "bbox_min": [
        -369.011474609375,
        -2146.35888671875,
        641.0
      ],
      "bbox_max": [
        -364.26806640625,
        -2143.04296875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -369.011474609375,
        -2146.35888671875,
        651.0
      ],
      "bbox_max": [
        -365.134033203125,
        -2143.54296875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999884068965912,
        -0.8660321235656738,
        -4.7862531573628075e-06
      ],
      "plane_d": -1702.5611572265625,
      "bbox_min": [
        -370.263671875,
        -2191.826416015625,
        654.0
      ],
      "bbox_max": [
        -335.32568359375,
        -2147.406494140625,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4999884068965912,
        -0.8660321235656738,
        -4.7862531573628075e-06
      ],
      "plane_d": -1682.5611572265625,
      "bbox_min": [
        -370.263671875,
        -2173.639892578125,
        654.0
      ],
      "bbox_max": [
        -345.82568359375,
        -2147.406494140625,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -370.263671875,
        -2156.319580078125,
        654.0
      ],
      "bbox_max": [
        -355.82568359375,
        -2147.406494140625,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        -370.263671875,
        -2156.319580078125,
        654.0
      ],
      "bbox_max": [
        -355.82568359375,
        -2147.406494140625,
        656.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7588072419166565,
        -0.4381272494792938,
        -0.4819295108318329
      ],
      "plane_d": -900.006591796875,
      "bbox_min": [
        -366.310546875,
        -2154.037109375,
        654.0
      ],
      "bbox_max": [
        -359.748291015625,
        -2149.671142578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745586633682251,
        0.44722193479537964,
        -0.44727107882499695
      ],
      "plane_d": 1539.189697265625,
      "bbox_min": [
        -366.310546875,
        -2154.037109375,
        654.0
      ],
      "bbox_max": [
        -364.9443359375,
        -2152.671142578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -360.263671875,
        -2173.639892578125,
        654.0
      ],
      "bbox_max": [
        -345.82568359375,
        -2164.72705078125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        -360.263671875,
        -2173.639892578125,
        654.0
      ],
      "bbox_max": [
        -345.82568359375,
        -2164.72705078125,
        656.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7588072419166565,
        -0.4381272494792938,
        -0.4819295108318329
      ],
      "plane_d": -900.0071411132812,
      "bbox_min": [
        -356.310546875,
        -2171.357666015625,
        654.0
      ],
      "bbox_max": [
        -349.748291015625,
        -2166.99169921875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745586633682251,
        0.44722193479537964,
        -0.44727107882499695
      ],
      "plane_d": 1539.190185546875,
      "bbox_min": [
        -356.310546875,
        -2171.357666015625,
        654.0
      ],
      "bbox_max": [
        -354.9443359375,
        -2169.99169921875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999884068965912,
        -0.8660321235656738,
        -4.7862531573628075e-06
      ],
      "plane_d": -1723.5611572265625,
      "bbox_min": [
        -349.763671875,
        -2191.826416015625,
        654.0
      ],
      "bbox_max": [
        -335.32568359375,
        -2182.91357421875,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -349.763671875,
        -2191.826416015625,
        654.0
      ],
      "bbox_max": [
        -335.32568359375,
        -2182.91357421875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        -349.763671875,
        -2191.826416015625,
        654.0
      ],
      "bbox_max": [
        -335.32568359375,
        -2182.91357421875,
        656.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7588072419166565,
        -0.4381272494792938,
        -0.4819295108318329
      ],
      "plane_d": -900.0076904296875,
      "bbox_min": [
        -345.810546875,
        -2189.544189453125,
        654.0
      ],
      "bbox_max": [
        -339.248291015625,
        -2185.17822265625,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745586633682251,
        0.44722193479537964,
        -0.44727107882499695
      ],
      "plane_d": 1539.1907958984375,
      "bbox_min": [
        -345.810546875,
        -2189.544189453125,
        654.0
      ],
      "bbox_max": [
        -344.4443359375,
        -2188.17822265625,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2368.5,
      "bbox_min": [
        -435.0,
        -2411.5,
        619.9999389648438
      ],
      "bbox_max": [
        -239.537109375,
        -2194.983642578125,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -435.0,
        -2368.5,
        619.9999389648438
      ],
      "bbox_max": [
        -239.537109375,
        -2194.983642578125,
        712.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2268.0,
      "bbox_min": [
        -420.0,
        -2368.5,
        619.9999389648438
      ],
      "bbox_max": [
        -239.537109375,
        -2232.5,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -327.0,
      "bbox_min": [
        -401.5,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -239.537109375,
        -2232.5,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 309.0,
      "bbox_min": [
        -309.0,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -239.537109375,
        -2232.5,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 95.18456268310547,
      "bbox_min": [
        -309.0,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -239.537109375,
        -2232.5,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1790.1290283203125,
      "bbox_min": [
        -309.0,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -239.537109375,
        -2232.5,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -629.0,
      "bbox_min": [
        -277.177734375,
        -2268.0,
        629.0
      ],
      "bbox_max": [
        -239.537109375,
        -2232.5,
        637.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.9100080132484436,
        0.41459059715270996,
        -0.0
      ],
      "plane_d": 1172.9549560546875,
      "bbox_min": [
        -274.35546875,
        -2268.0,
        629.0
      ],
      "bbox_max": [
        -255.67189025878906,
        -2242.92578125,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509564340114594,
        -0.9807842373847961,
        -0.0
      ],
      "plane_d": -2240.22802734375,
      "bbox_min": [
        -274.32330322265625,
        -2245.0,
        629.0
      ],
      "bbox_max": [
        -239.537109375,
        -2232.5,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555604696273804,
        -0.8314761519432068,
        0.0
      ],
      "plane_d": -1996.7056884765625,
      "bbox_min": [
        -274.32330322265625,
        -2245.0,
        629.0
      ],
      "bbox_max": [
        -239.537109375,
        -2234.403076171875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5706624388694763,
        -0.8211847543716431,
        0.0
      ],
      "plane_d": -1685.310546875,
      "bbox_min": [
        -274.32330322265625,
        -2245.0,
        629.0
      ],
      "bbox_max": [
        -239.537109375,
        -2237.72900390625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -265.0,
      "bbox_min": [
        -265.0,
        -2245.0,
        629.0
      ],
      "bbox_max": [
        -239.537109375,
        -2239.822265625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314761519432068,
        -0.5555604696273804,
        0.0
      ],
      "plane_d": -1445.4261474609375,
      "bbox_min": [
        -241.822265625,
        -2243.242431640625,
        629.0
      ],
      "bbox_max": [
        -239.537109375,
        -2239.822265625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826833665370941,
        -0.9238795638084412,
        -0.0
      ],
      "plane_d": -2184.8564453125,
      "bbox_min": [
        -309.0,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -266.2532043457031,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2258.0,
      "bbox_min": [
        -309.0,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -266.2532043457031,
        -2238.0,
        637.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.48564356565475464,
        -0.0,
        0.8741569519042969
      ],
      "plane_d": -406.7741394042969,
      "bbox_min": [
        -308.9999694824219,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -266.2532043457031,
        -2258.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48564356565475464,
        -0.0,
        -0.8741569519042969
      ],
      "plane_d": 406.3370666503906,
      "bbox_min": [
        -308.9999694824219,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -290.0999450683594,
        -2258.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 626.5,
      "bbox_min": [
        -291.47369384765625,
        -2268.0,
        626.5
      ],
      "bbox_max": [
        -290.0999450683594,
        -2266.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472167193889618,
        0.0,
        0.894425630569458
      ],
      "plane_d": -690.9449462890625,
      "bbox_min": [
        -291.47369384765625,
        -2268.0,
        626.7631225585938
      ],
      "bbox_max": [
        -291.0,
        -2266.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2266.0,
      "bbox_min": [
        -305.0,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -291.0,
        -2266.0,
        626.7631225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472169578075409,
        0.0,
        -0.8944255113601685
      ],
      "plane_d": 690.4977416992188,
      "bbox_min": [
        -304.0,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -291.0,
        -2266.0,
        626.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        -0.3826833665370941,
        -0.0
      ],
      "plane_d": -1113.9117431640625,
      "bbox_min": [
        -291.0,
        -2268.0,
        620.0
      ],
      "bbox_max": [
        -266.2532043457031,
        -2258.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -627.0,
      "bbox_min": [
        -291.0,
        -2268.0,
        626.5
      ],
      "bbox_max": [
        -286.5,
        -2258.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 626.5,
      "bbox_min": [
        -290.0999450683594,
        -2268.0,
        626.5
      ],
      "bbox_max": [
        -286.5,
        -2258.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 286.5,
      "bbox_min": [
        -286.5,
        -2268.0,
        626.5
      ],
      "bbox_max": [
        -286.5,
        -2258.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -309.0,
        -2238.0,
        620.0
      ],
      "bbox_max": [
        -306.294677734375,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": -508.17803955078125,
      "bbox_min": [
        -401.5,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2232.5,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1340.4090576171875,
      "bbox_min": [
        -401.5,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2232.5,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -629.0,
      "bbox_min": [
        -401.5,
        -2268.0,
        627.9925537109375
      ],
      "bbox_max": [
        -358.822265625,
        -2232.5,
        637.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.427785187959671,
        -0.28582966327667236,
        0.8574970960617065
      ],
      "plane_d": -1358.3023681640625,
      "bbox_min": [
        -400.99310302734375,
        -2268.0,
        627.9925537109375
      ],
      "bbox_max": [
        -398.9736328125,
        -2267.067138671875,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555562973022461,
        -0.8314789533615112,
        0.0
      ],
      "plane_d": -1663.02001953125,
      "bbox_min": [
        -400.99310302734375,
        -2268.0,
        627.9925537109375
      ],
      "bbox_max": [
        -399.596923828125,
        -2267.067138671875,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7360445261001587,
        0.6769331097602844,
        0.0
      ],
      "plane_d": 1252.1007080078125,
      "bbox_min": [
        -401.5,
        -2268.0,
        629.0
      ],
      "bbox_max": [
        -358.822265625,
        -2232.5,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9100080132484436,
        0.41459059715270996,
        0.0
      ],
      "plane_d": 594.1898803710938,
      "bbox_min": [
        -380.3280944824219,
        -2268.0,
        629.0
      ],
      "bbox_max": [
        -361.64453125,
        -2242.926025390625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555562973022461,
        -0.8314789533615112,
        0.0
      ],
      "plane_d": -1663.02001953125,
      "bbox_min": [
        -400.99310302734375,
        -2268.0,
        629.0
      ],
      "bbox_max": [
        -399.596923828125,
        -2267.067138671875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807842373847961,
        -0.19509564340114594,
        0.0
      ],
      "plane_d": -46.6435432434082,
      "bbox_min": [
        -401.5,
        -2257.5,
        629.0
      ],
      "bbox_max": [
        -361.6766052246094,
        -2234.403076171875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314761519432068,
        -0.5555604696273804,
        0.0
      ],
      "plane_d": -916.6072998046875,
      "bbox_min": [
        -399.596923828125,
        -2247.932861328125,
        629.0
      ],
      "bbox_max": [
        -361.6766052246094,
        -2234.403076171875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555604696273804,
        -0.8314761519432068,
        0.0
      ],
      "plane_d": -1643.3692626953125,
      "bbox_min": [
        -394.177734375,
        -2242.926025390625,
        629.0
      ],
      "bbox_max": [
        -361.6766052246094,
        -2234.403076171875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706624388694763,
        -0.8211847543716431,
        -0.0
      ],
      "plane_d": -2048.251953125,
      "bbox_min": [
        -369.155029296875,
        -2242.926025390625,
        629.0
      ],
      "bbox_max": [
        -361.6766052246094,
        -2237.72900390625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826833665370941,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": -1941.4697265625,
      "bbox_min": [
        -369.7467956542969,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2258.0,
      "bbox_min": [
        -369.7467956542969,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2238.0,
        637.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.48564356565475464,
        0.0,
        0.8741569519042969
      ],
      "plane_d": -715.6434326171875,
      "bbox_min": [
        -369.7467956542969,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0000305175781,
        -2258.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48564356565475464,
        0.0,
        -0.8741569519042969
      ],
      "plane_d": 715.2063598632812,
      "bbox_min": [
        -345.90008544921875,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0000305175781,
        -2258.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 626.5,
      "bbox_min": [
        -345.90008544921875,
        -2268.0,
        626.5
      ],
      "bbox_max": [
        -344.5263366699219,
        -2266.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472167193889618,
        0.0,
        0.894425630569458
      ],
      "plane_d": -406.5151062011719,
      "bbox_min": [
        -345.0,
        -2268.0,
        626.76318359375
      ],
      "bbox_max": [
        -344.5263366699219,
        -2266.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2266.0,
      "bbox_min": [
        -345.0,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -331.0,
        -2266.0,
        626.76318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472169578075409,
        0.0,
        -0.8944255113601685
      ],
      "plane_d": 406.0677185058594,
      "bbox_min": [
        -345.0,
        -2268.0,
        619.9999389648438
      ],
      "bbox_max": [
        -332.0,
        -2266.0,
        626.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -526.3244018554688,
      "bbox_min": [
        -369.7467956542969,
        -2268.0,
        620.0
      ],
      "bbox_max": [
        -345.0,
        -2258.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -627.0,
      "bbox_min": [
        -349.5,
        -2268.0,
        626.5
      ],
      "bbox_max": [
        -345.0,
        -2258.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 626.5,
      "bbox_min": [
        -349.5,
        -2268.0,
        626.5
      ],
      "bbox_max": [
        -345.90008544921875,
        -2258.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -349.5,
      "bbox_min": [
        -349.5,
        -2268.0,
        626.5
      ],
      "bbox_max": [
        -349.5,
        -2258.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -329.705322265625,
        -2238.0,
        620.0
      ],
      "bbox_max": [
        -327.0,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268962502479553,
        0.923876941204071,
        0.0
      ],
      "plane_d": 1991.308837890625,
      "bbox_min": [
        -420.0,
        -2368.5,
        619.9999389648438
      ],
      "bbox_max": [
        -239.537109375,
        -2268.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826913833618164,
        -0.9238762259483337,
        -0.0
      ],
      "plane_d": -2252.6982421875,
      "bbox_min": [
        -371.0,
        -2368.5,
        620.0
      ],
      "bbox_max": [
        -239.537109375,
        -2268.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268962502479553,
        0.923876941204071,
        -0.0
      ],
      "plane_d": 2234.699462890625,
      "bbox_min": [
        -309.0,
        -2311.052490234375,
        620.0
      ],
      "bbox_max": [
        -239.537109375,
        -2268.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3630545735359192,
        0.8764691948890686,
        0.3162168562412262
      ],
      "plane_d": 1922.0771484375,
      "bbox_min": [
        -309.0,
        -2311.052490234375,
        620.0
      ],
      "bbox_max": [
        -239.537109375,
        -2268.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -259.15283203125,
      "bbox_min": [
        -309.0,
        -2311.052490234375,
        620.0
      ],
      "bbox_max": [
        -239.537109375,
        -2268.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9100080132484436,
        0.41459059715270996,
        -0.0
      ],
      "plane_d": 1172.9549560546875,
      "bbox_min": [
        -255.67189025878906,
        -2280.596923828125,
        627.35107421875
      ],
      "bbox_max": [
        -239.537109375,
        -2268.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555562973022461,
        0.8314789533615112,
        0.0
      ],
      "plane_d": 2026.1082763671875,
      "bbox_min": [
        -241.822265625,
        -2276.70458984375,
        627.35107421875
      ],
      "bbox_max": [
        -239.537109375,
        -2273.651123046875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.427785187959671,
        -0.28582966327667236,
        0.8574970960617065
      ],
      "plane_d": -1086.23095703125,
      "bbox_min": [
        -241.822265625,
        -2276.70458984375,
        627.35107421875
      ],
      "bbox_max": [
        -239.537109375,
        -2273.651123046875,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -629.0,
      "bbox_min": [
        -249.64556884765625,
        -2275.177734375,
        628.368896484375
      ],
      "bbox_max": [
        -239.537109375,
        -2268.0,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.427785187959671,
        -0.28582966327667236,
        0.8574970960617065
      ],
      "plane_d": -1086.23095703125,
      "bbox_min": [
        -241.822265625,
        -2275.177734375,
        628.368896484375
      ],
      "bbox_max": [
        -239.537109375,
        -2271.757568359375,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        -0.3826833665370941,
        -0.0
      ],
      "plane_d": -1113.9117431640625,
      "bbox_min": [
        -309.0,
        -2311.052490234375,
        620.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2268.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9239127039909363,
        0.38260337710380554,
        0.0
      ],
      "plane_d": 643.8252563476562,
      "bbox_min": [
        -309.0,
        -2311.052490234375,
        620.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2282.54931640625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314775824546814,
        0.5555582642555237,
        -0.0
      ],
      "plane_d": 1527.4034423828125,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        620.0
      ],
      "bbox_max": [
        -303.9912109375,
        -2282.54931640625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 309.0,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        620.0
      ],
      "bbox_max": [
        -303.9912109375,
        -2282.54931640625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7888118624687195,
        0.5270435214042664,
        0.3162292242050171
      ],
      "plane_d": 1251.0513916015625,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        620.0
      ],
      "bbox_max": [
        -303.9912109375,
        -2282.54931640625,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 95.18456268310547,
      "bbox_min": [
        -309.0,
        -2286.84716796875,
        620.0
      ],
      "bbox_max": [
        -307.0,
        -2282.54931640625,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826913833618164,
        -0.9238762259483337,
        0.0
      ],
      "plane_d": -2009.306640625,
      "bbox_min": [
        -371.0,
        -2368.5,
        620.0
      ],
      "bbox_max": [
        -265.0,
        -2308.989013671875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3630545437335968,
        -0.8764698505401611,
        0.31621500849723816
      ],
      "plane_d": -2335.057373046875,
      "bbox_min": [
        -371.0,
        -2368.5,
        620.0
      ],
      "bbox_max": [
        -265.0,
        -2308.989013671875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3630538284778595,
        -0.8764702081680298,
        0.31621500849723816
      ],
      "plane_d": -2104.15576171875,
      "bbox_min": [
        -371.0,
        -2368.5,
        620.0
      ],
      "bbox_max": [
        -265.0,
        -2308.989013671875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3828069269657135,
        0.9238283634185791,
        -0.0
      ],
      "plane_d": 2302.473876953125,
      "bbox_min": [
        -371.0,
        -2368.5,
        620.0
      ],
      "bbox_max": [
        -265.0,
        -2308.989013671875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -632.5,
      "bbox_min": [
        -371.0,
        -2368.5,
        632.5
      ],
      "bbox_max": [
        -303.5242004394531,
        -2348.46630859375,
        637.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3826870322227478,
        -0.923878014087677,
        0.0
      ],
      "plane_d": -2035.4044189453125,
      "bbox_min": [
        -371.0,
        -2368.5,
        632.5
      ],
      "bbox_max": [
        -303.5242004394531,
        -2348.46630859375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -563.635498046875,
      "bbox_min": [
        -371.0,
        -2368.5,
        632.5
      ],
      "bbox_max": [
        -303.5242004394531,
        -2348.46630859375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1212.1978759765625,
      "bbox_min": [
        -365.14208984375,
        -2368.5,
        632.5
      ],
      "bbox_max": [
        -303.5242004394531,
        -2348.46630859375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3806573450565338,
        -0.9189779758453369,
        0.10285679250955582
      ],
      "plane_d": -2357.14453125,
      "bbox_min": [
        -365.14208984375,
        -2368.5,
        635.0
      ],
      "bbox_max": [
        -331.0,
        -2348.46630859375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3657400906085968,
        0.8829648494720459,
        0.2942911386489868
      ],
      "plane_d": 2015.142822265625,
      "bbox_min": [
        -365.14208984375,
        -2368.5,
        635.0
      ],
      "bbox_max": [
        -331.0,
        -2348.46630859375,
        637.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3657400906085968,
        0.8829648494720459,
        0.2942911386489868
      ],
      "plane_d": 1758.393310546875,
      "bbox_min": [
        -365.14208984375,
        -2368.5,
        635.0
      ],
      "bbox_max": [
        -331.0,
        -2348.5,
        637.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8829648494720459,
        0.3657400906085968,
        0.2942911386489868
      ],
      "plane_d": 971.6419067382812,
      "bbox_min": [
        -337.3292541503906,
        -2368.5,
        635.0
      ],
      "bbox_max": [
        -331.0,
        -2354.35791015625,
        637.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3765573501586914,
        -0.9214465022087097,
        0.09560827910900116
      ],
      "plane_d": -2356.89990234375,
      "bbox_min": [
        -351.0,
        -2349.4931640625,
        635.0
      ],
      "bbox_max": [
        -348.06207275390625,
        -2348.46630859375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07863236218690872,
        -0.996903657913208,
        0.0
      ],
      "plane_d": -2313.628173828125,
      "bbox_min": [
        -351.0,
        -2348.5,
        635.0
      ],
      "bbox_max": [
        -350.5743408203125,
        -2348.46630859375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9961298704147339,
        0.08789381384849548
      ],
      "plane_d": -2403.670166015625,
      "bbox_min": [
        -336.969970703125,
        -2368.5,
        632.5
      ],
      "bbox_max": [
        -303.5242004394531,
        -2354.087646484375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3690228760242462,
        -0.9294202923774719,
        0.0
      ],
      "plane_d": -2312.496337890625,
      "bbox_min": [
        -336.969970703125,
        -2357.199951171875,
        632.5
      ],
      "bbox_max": [
        -329.699951171875,
        -2354.087646484375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3806573450565338,
        -0.9189779758453369,
        0.10285679250955582
      ],
      "plane_d": -2357.14453125,
      "bbox_min": [
        -336.969970703125,
        -2354.54296875,
        635.0
      ],
      "bbox_max": [
        -335.87060546875,
        -2354.087646484375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 624.6114501953125,
      "bbox_min": [
        -305.0,
        -2368.5,
        632.5
      ],
      "bbox_max": [
        -303.5242004394531,
        -2366.310791015625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8829615712165833,
        0.3657243251800537,
        0.2943204939365387
      ],
      "plane_d": 410.0212707519531,
      "bbox_min": [
        -305.0,
        -2368.5,
        635.0
      ],
      "bbox_max": [
        -303.5242004394531,
        -2366.310791015625,
        637.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        -0.923878014087677,
        0.0
      ],
      "plane_d": -2278.793212890625,
      "bbox_min": [
        -318.00030517578125,
        -2368.5,
        632.5
      ],
      "bbox_max": [
        -265.0,
        -2348.46630859375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -1151.221923828125,
      "bbox_min": [
        -318.00030517578125,
        -2368.5,
        632.5
      ],
      "bbox_max": [
        -265.0,
        -2348.46630859375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -632.5,
      "bbox_min": [
        -318.00030517578125,
        -2366.54638671875,
        632.5
      ],
      "bbox_max": [
        -270.85791015625,
        -2348.46630859375,
        637.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3690228760242462,
        -0.9294202923774719,
        0.0
      ],
      "plane_d": -2077.7978515625,
      "bbox_min": [
        -309.92059326171875,
        -2357.199951171875,
        632.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34268662333488464,
        -0.9358057379722595,
        0.0826646089553833
      ],
      "plane_d": -2153.20166015625,
      "bbox_min": [
        -309.92059326171875,
        -2357.199951171875,
        632.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9961298704147339,
        0.08789381384849548
      ],
      "plane_d": -2403.670166015625,
      "bbox_min": [
        -309.92059326171875,
        -2357.199951171875,
        632.5
      ],
      "bbox_max": [
        -306.300048828125,
        -2356.802978515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 624.6114501953125,
      "bbox_min": [
        -299.2821044921875,
        -2354.696044921875,
        632.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3657400906085968,
        0.8829648494720459,
        0.2942911386489868
      ],
      "plane_d": 1782.5321044921875,
      "bbox_min": [
        -304.0931701660156,
        -2366.54638671875,
        632.5
      ],
      "bbox_max": [
        -270.85791015625,
        -2348.46630859375,
        637.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3657400906085968,
        0.8829648494720459,
        0.2942911386489868
      ],
      "plane_d": 1991.0040283203125,
      "bbox_min": [
        -304.0931701660156,
        -2366.54638671875,
        632.5
      ],
      "bbox_max": [
        -270.85791015625,
        -2348.5,
        637.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 624.6114501953125,
      "bbox_min": [
        -304.0931701660156,
        -2366.54638671875,
        632.5
      ],
      "bbox_max": [
        -298.6707458496094,
        -2354.35791015625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8829648494720459,
        0.3657400906085968,
        0.2942911386489868
      ],
      "plane_d": 410.0762634277344,
      "bbox_min": [
        -304.0931701660156,
        -2366.54638671875,
        635.0
      ],
      "bbox_max": [
        -298.6707458496094,
        -2354.35791015625,
        637.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.37654542922973633,
        -0.9214403629302979,
        0.09571424126625061
      ],
      "plane_d": -2117.4658203125,
      "bbox_min": [
        -287.9385681152344,
        -2349.4931640625,
        635.0
      ],
      "bbox_max": [
        -285.0,
        -2348.46630859375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07918098568916321,
        -0.9968602657318115,
        -0.0
      ],
      "plane_d": -2363.69287109375,
      "bbox_min": [
        -285.4256591796875,
        -2348.5,
        635.0
      ],
      "bbox_max": [
        -285.0,
        -2348.46630859375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2355.699951171875,
      "bbox_min": [
        -368.92333984375,
        -2360.548095703125,
        620.0
      ],
      "bbox_max": [
        -267.07666015625,
        -2308.989013671875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9961298704147339,
        0.08789381384849548
      ],
      "plane_d": -2403.670166015625,
      "bbox_min": [
        -327.0379638671875,
        -2360.548095703125,
        632.5
      ],
      "bbox_max": [
        -308.962646484375,
        -2356.802978515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -632.5,
      "bbox_min": [
        -326.0800476074219,
        -2360.548095703125,
        632.5
      ],
      "bbox_max": [
        -309.92059326171875,
        -2357.199951171875,
        632.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2308.989013671875,
      "bbox_min": [
        -368.92333984375,
        -2330.181640625,
        620.0
      ],
      "bbox_max": [
        -267.07666015625,
        -2308.989013671875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238892197608948,
        0.38266000151634216,
        0.0
      ],
      "plane_d": 1231.5552978515625,
      "bbox_min": [
        -368.92333984375,
        -2330.181640625,
        620.0
      ],
      "bbox_max": [
        -267.07666015625,
        -2308.989013671875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923894464969635,
        0.38264742493629456,
        0.0
      ],
      "plane_d": 643.930908203125,
      "bbox_min": [
        -323.794677734375,
        -2330.181396484375,
        620.0
      ],
      "bbox_max": [
        -267.07666015625,
        -2308.989013671875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2388.4580078125,
      "bbox_min": [
        -323.794677734375,
        -2310.989013671875,
        620.0
      ],
      "bbox_max": [
        -312.205322265625,
        -2308.989013671875,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3630546033382416,
        0.8764746785163879,
        0.31620171666145325
      ],
      "plane_d": 1691.196533203125,
      "bbox_min": [
        -420.0,
        -2311.052490234375,
        619.9999389648438
      ],
      "bbox_max": [
        -286.5,
        -2268.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 95.18456268310547,
      "bbox_min": [
        -309.0,
        -2283.377685546875,
        620.0
      ],
      "bbox_max": [
        -307.0,
        -2280.384521484375,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.0428289897390641e-05,
        0.0
      ],
      "plane_d": 376.8710021972656,
      "bbox_min": [
        -420.0,
        -2311.052490234375,
        619.9999389648438
      ],
      "bbox_max": [
        -286.5,
        -2268.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -420.0,
        -2293.0,
        626.0
      ],
      "bbox_max": [
        -380.3280944824219,
        -2268.0,
        637.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 420.0,
      "bbox_min": [
        -420.0,
        -2293.0,
        626.0
      ],
      "bbox_max": [
        -380.3280944824219,
        -2268.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9100080132484436,
        0.41459059715270996,
        0.0
      ],
      "plane_d": 594.1898803710938,
      "bbox_min": [
        -403.75439453125,
        -2280.596923828125,
        626.0
      ],
      "bbox_max": [
        -380.3280944824219,
        -2268.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.427785187959671,
        -0.28582966327667236,
        0.8574970960617065
      ],
      "plane_d": -1358.3023681640625,
      "bbox_min": [
        -403.75439453125,
        -2277.95556640625,
        626.0
      ],
      "bbox_max": [
        -394.177734375,
        -2268.0,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555562973022461,
        -0.8314789533615112,
        0.0
      ],
      "plane_d": -1663.02001953125,
      "bbox_min": [
        -403.75439453125,
        -2269.844970703125,
        626.0
      ],
      "bbox_max": [
        -400.99310302734375,
        -2268.0,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555562973022461,
        -0.8314789533615112,
        0.0
      ],
      "plane_d": -1663.02001953125,
      "bbox_min": [
        -403.75439453125,
        -2269.844970703125,
        629.0
      ],
      "bbox_max": [
        -402.9565734863281,
        -2269.31201171875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555562973022461,
        -0.8314789533615112,
        0.0
      ],
      "plane_d": -1663.02001953125,
      "bbox_min": [
        -402.9565734863281,
        -2269.31201171875,
        629.0
      ],
      "bbox_max": [
        -400.99310302734375,
        -2268.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -526.3244018554688,
      "bbox_min": [
        -376.84716796875,
        -2311.052490234375,
        619.9999389648438
      ],
      "bbox_max": [
        -286.5,
        -2268.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -327.0,
      "bbox_min": [
        -376.846923828125,
        -2311.052490234375,
        619.9999389648438
      ],
      "bbox_max": [
        -286.5,
        -2268.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 309.0,
      "bbox_min": [
        -309.0,
        -2283.377685546875,
        619.9999389648438
      ],
      "bbox_max": [
        -286.5,
        -2268.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472167193889618,
        0.0,
        0.894425630569458
      ],
      "plane_d": -690.9449462890625,
      "bbox_min": [
        -309.0,
        -2283.377685546875,
        619.9999389648438
      ],
      "bbox_max": [
        -286.5,
        -2268.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2274.0,
      "bbox_min": [
        -305.0,
        -2274.0,
        619.9999389648438
      ],
      "bbox_max": [
        -286.5,
        -2268.0,
        627.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4472169578075409,
        0.0,
        -0.8944255113601685
      ],
      "plane_d": 690.4977416992188,
      "bbox_min": [
        -304.0,
        -2274.0,
        619.9999389648438
      ],
      "bbox_max": [
        -286.5,
        -2268.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 626.5,
      "bbox_min": [
        -291.0,
        -2274.0,
        626.5
      ],
      "bbox_max": [
        -286.5,
        -2268.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -627.0,
      "bbox_min": [
        -290.0,
        -2274.0,
        626.5
      ],
      "bbox_max": [
        -286.5,
        -2268.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 286.5,
      "bbox_min": [
        -286.5,
        -2274.0,
        626.5
      ],
      "bbox_max": [
        -286.5,
        -2268.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 95.18456268310547,
      "bbox_min": [
        -309.0,
        -2283.377685546875,
        620.0
      ],
      "bbox_max": [
        -307.0,
        -2268.0,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": -508.17803955078125,
      "bbox_min": [
        -376.846923828125,
        -2311.052490234375,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2268.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2274.0,
      "bbox_min": [
        -376.846923828125,
        -2311.052490234375,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2268.0,
        637.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4472167193889618,
        0.0,
        0.894425630569458
      ],
      "plane_d": -406.5151062011719,
      "bbox_min": [
        -349.5,
        -2274.0,
        619.9999389648438
      ],
      "bbox_max": [
        -331.0,
        -2268.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472169578075409,
        0.0,
        -0.8944255113601685
      ],
      "plane_d": 406.0677185058594,
      "bbox_min": [
        -349.5,
        -2274.0,
        619.9999389648438
      ],
      "bbox_max": [
        -332.0,
        -2268.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 626.5,
      "bbox_min": [
        -349.5,
        -2274.0,
        626.5
      ],
      "bbox_max": [
        -345.0,
        -2268.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -627.0,
      "bbox_min": [
        -349.5,
        -2274.0,
        626.5
      ],
      "bbox_max": [
        -346.00006103515625,
        -2268.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -349.5,
      "bbox_min": [
        -349.5,
        -2274.0,
        626.5
      ],
      "bbox_max": [
        -349.5,
        -2268.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238892197608948,
        0.38266000151634216,
        0.0
      ],
      "plane_d": 1231.5557861328125,
      "bbox_min": [
        -376.846923828125,
        -2311.052490234375,
        620.0
      ],
      "bbox_max": [
        -327.0,
        -2286.240478515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314775824546814,
        0.5555582642555237,
        0.0
      ],
      "plane_d": 998.5836791992188,
      "bbox_min": [
        -332.0087890625,
        -2292.359130859375,
        620.0
      ],
      "bbox_max": [
        -327.0,
        -2286.240478515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7888135313987732,
        0.5270446538925171,
        0.3162231743335724
      ],
      "plane_d": 749.372802734375,
      "bbox_min": [
        -332.0087890625,
        -2292.359130859375,
        620.0
      ],
      "bbox_max": [
        -327.0,
        -2286.240478515625,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 259.15283203125,
      "bbox_min": [
        -435.0,
        -2368.5,
        637.0
      ],
      "bbox_max": [
        -239.537109375,
        -2194.983642578125,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2238.0,
      "bbox_min": [
        -435.0,
        -2368.5,
        637.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2194.983642578125,
        712.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2355.699951171875,
      "bbox_min": [
        -435.0,
        -2368.5,
        637.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2339.0,
      "bbox_min": [
        -435.0,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -3.082740931859007e-06
      ],
      "plane_d": 1907.825439453125,
      "bbox_min": [
        -365.697998046875,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -270.302001953125,
        -2339.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3826870322227478,
        -0.923878014087677,
        0.0
      ],
      "plane_d": -2035.4044189453125,
      "bbox_min": [
        -365.697998046875,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -342.3699035644531,
        -2348.395263671875,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -563.635498046875,
      "bbox_min": [
        -365.697998046875,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -342.3699035644531,
        -2348.395263671875,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -365.697998046875,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -342.3699035644531,
        -2348.395263671875,
        660.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -364.6707458496094,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -342.3700256347656,
        -2348.395263671875,
        660.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3657243251800537,
        0.8829615712165833,
        0.2943204939365387
      ],
      "plane_d": 1758.37255859375,
      "bbox_min": [
        -364.6707458496094,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -345.1446533203125,
        -2348.399169921875,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3765573501586914,
        -0.9214465022087097,
        0.09560827910900116
      ],
      "plane_d": -2356.89990234375,
      "bbox_min": [
        -349.93731689453125,
        -2349.137451171875,
        637.0
      ],
      "bbox_max": [
        -348.9324035644531,
        -2348.726806640625,
        638.4221801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3765573501586914,
        -0.9214465022087097,
        0.09560827910900116
      ],
      "plane_d": -2356.89990234375,
      "bbox_min": [
        -349.7230529785156,
        -2348.435302734375,
        641.0
      ],
      "bbox_max": [
        -349.6343994140625,
        -2348.395263671875,
        641.2283325195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1458.1033935546875,
      "bbox_min": [
        -351.334228515625,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -270.302001953125,
        -2339.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        -0.923878014087677,
        0.0
      ],
      "plane_d": -2278.793212890625,
      "bbox_min": [
        -293.6302795410156,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -270.302001953125,
        -2348.394775390625,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -1151.221923828125,
      "bbox_min": [
        -293.6302795410156,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -270.302001953125,
        -2348.394775390625,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -293.6302795410156,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -270.302001953125,
        -2348.394775390625,
        660.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -293.6302185058594,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -271.3292541503906,
        -2348.394775390625,
        660.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3657243251800537,
        0.8829615712165833,
        0.2943204939365387
      ],
      "plane_d": 1990.97314453125,
      "bbox_min": [
        -290.8558044433594,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -271.3292541503906,
        -2348.398681640625,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.37654542922973633,
        -0.9214403629302979,
        0.09571424126625061
      ],
      "plane_d": -2117.4658203125,
      "bbox_min": [
        -287.0677490234375,
        -2349.13720703125,
        637.0
      ],
      "bbox_max": [
        -286.0624694824219,
        -2348.7265625,
        638.4217529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37654542922973633,
        -0.9214403629302979,
        0.09571424126625061
      ],
      "plane_d": -2117.4658203125,
      "bbox_min": [
        -286.3650817871094,
        -2348.4345703125,
        641.0
      ],
      "bbox_max": [
        -286.2769470214844,
        -2348.394775390625,
        641.226806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3828069269657135,
        0.9238283634185791,
        -0.0
      ],
      "plane_d": 2302.473876953125,
      "bbox_min": [
        -351.334228515625,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2339.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3806573450565338,
        -0.9189779758453369,
        0.10285679250955582
      ],
      "plane_d": -2357.14453125,
      "bbox_min": [
        -349.6744689941406,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -329.699951171875,
        -2348.16796875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34271809458732605,
        -0.9358025193214417,
        0.08257081359624863
      ],
      "plane_d": -2371.09375,
      "bbox_min": [
        -335.87060546875,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -329.699951171875,
        -2354.54296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3765573501586914,
        -0.9214465022087097,
        0.09560827910900116
      ],
      "plane_d": -2356.89990234375,
      "bbox_min": [
        -349.6744689941406,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -329.699951171875,
        -2348.16796875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -347.9140625,
        -2355.699951171875,
        649.5
      ],
      "bbox_max": [
        -329.699951171875,
        -2348.16796875,
        650.49609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238263368606567,
        -0.3828117847442627,
        0.0
      ],
      "plane_d": -577.5281372070312,
      "bbox_min": [
        -347.9140625,
        -2348.256591796875,
        649.5
      ],
      "bbox_max": [
        -347.8773193359375,
        -2348.16796875,
        650.49609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -349.6744689941406,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -329.699951171875,
        -2348.16796875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36527690291404724,
        -0.8818466663360596,
        -0.2981933653354645
      ],
      "plane_d": -2002.2723388671875,
      "bbox_min": [
        -349.67431640625,
        -2355.699951171875,
        656.0
      ],
      "bbox_max": [
        -329.699951171875,
        -2348.256591796875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3690228760242462,
        -0.9294202923774719,
        0.0
      ],
      "plane_d": -2312.496337890625,
      "bbox_min": [
        -336.85791015625,
        -2355.699951171875,
        656.0
      ],
      "bbox_max": [
        -329.699951171875,
        -2354.35791015625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2819654643535614,
        -0.9448255300521851,
        -0.16673390567302704
      ],
      "plane_d": -2209.31201171875,
      "bbox_min": [
        -336.85791015625,
        -2355.699951171875,
        656.0
      ],
      "bbox_max": [
        -329.699951171875,
        -2354.35791015625,
        662.3888549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1212.1978759765625,
      "bbox_min": [
        -336.85791015625,
        -2355.699951171875,
        660.5
      ],
      "bbox_max": [
        -333.47784423828125,
        -2354.35791015625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 664.5,
      "bbox_min": [
        -336.85791015625,
        -2355.699951171875,
        664.5
      ],
      "bbox_max": [
        -333.47784423828125,
        -2354.35791015625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -349.67431640625,
        -2355.699951171875,
        656.0
      ],
      "bbox_max": [
        -336.302001953125,
        -2348.256591796875,
        663.7877197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1212.1978759765625,
      "bbox_min": [
        -336.85791015625,
        -2355.699951171875,
        660.5
      ],
      "bbox_max": [
        -336.302001953125,
        -2354.35791015625,
        663.7877197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07863236218690872,
        -0.996903657913208,
        0.0
      ],
      "plane_d": -2313.628173828125,
      "bbox_min": [
        -349.67431640625,
        -2348.3955078125,
        656.0
      ],
      "bbox_max": [
        -347.9140625,
        -2348.256591796875,
        658.5668334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -349.6743469238281,
        -2355.699951171875,
        656.0
      ],
      "bbox_max": [
        -336.302001953125,
        -2348.256591796875,
        663.66943359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1212.1978759765625,
      "bbox_min": [
        -336.85791015625,
        -2355.699951171875,
        660.5
      ],
      "bbox_max": [
        -336.302001953125,
        -2354.35791015625,
        663.66943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07863236218690872,
        -0.996903657913208,
        0.0
      ],
      "plane_d": -2313.628173828125,
      "bbox_min": [
        -349.6743469238281,
        -2348.3955078125,
        656.0
      ],
      "bbox_max": [
        -347.9140625,
        -2348.256591796875,
        658.4395141601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07863236218690872,
        -0.996903657913208,
        0.0
      ],
      "plane_d": -2313.628173828125,
      "bbox_min": [
        -349.6744689941406,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -336.9686279296875,
        -2348.16796875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238263368606567,
        -0.3828117847442627,
        0.0
      ],
      "plane_d": -577.5281372070312,
      "bbox_min": [
        -347.9140625,
        -2348.256591796875,
        649.5
      ],
      "bbox_max": [
        -347.8773193359375,
        -2348.16796875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -345.1446533203125,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -336.9686279296875,
        -2352.92529296875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8829648494720459,
        0.3657400906085968,
        0.2942911386489868
      ],
      "plane_d": 971.6419067382812,
      "bbox_min": [
        -338.199951171875,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -336.9686279296875,
        -2354.829345703125,
        640.6943969726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3828069269657135,
        0.9238283634185791,
        0.0
      ],
      "plane_d": 2059.008544921875,
      "bbox_min": [
        -351.334228515625,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2339.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3806525468826294,
        -0.9189664125442505,
        0.10297729074954987
      ],
      "plane_d": -2115.09716796875,
      "bbox_min": [
        -306.3046875,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -286.32513427734375,
        -2348.16748046875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34268662333488464,
        -0.9358057379722595,
        0.0826646089553833
      ],
      "plane_d": -2153.20166015625,
      "bbox_min": [
        -306.3046875,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -300.1300354003906,
        -2354.54296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37654542922973633,
        -0.9214403629302979,
        0.09571424126625061
      ],
      "plane_d": -2117.4658203125,
      "bbox_min": [
        -306.3046875,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -286.32513427734375,
        -2348.16748046875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -306.3046875,
        -2355.699951171875,
        649.5
      ],
      "bbox_max": [
        -288.0859375,
        -2348.16748046875,
        650.4846801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238263368606567,
        -0.3828117847442627,
        0.0
      ],
      "plane_d": -1165.0810546875,
      "bbox_min": [
        -288.1221923828125,
        -2348.2548828125,
        649.5
      ],
      "bbox_max": [
        -288.0859375,
        -2348.16748046875,
        650.4846801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -306.3046875,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -286.32513427734375,
        -2348.16748046875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3652403652667999,
        -0.8817585110664368,
        -0.2984985113143921
      ],
      "plane_d": -1769.55810546875,
      "bbox_min": [
        -306.3046875,
        -2355.699951171875,
        656.0
      ],
      "bbox_max": [
        -286.32513427734375,
        -2348.2548828125,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3690228760242462,
        -0.9294202923774719,
        0.0
      ],
      "plane_d": -2077.7978515625,
      "bbox_min": [
        -306.3046875,
        -2355.699951171875,
        656.0
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28187909722328186,
        -0.9448241591453552,
        -0.16688749194145203
      ],
      "plane_d": -2029.9031982421875,
      "bbox_min": [
        -306.3046875,
        -2355.699951171875,
        656.0
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        662.3888549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 624.6114501953125,
      "bbox_min": [
        -302.52215576171875,
        -2355.699951171875,
        660.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 664.5,
      "bbox_min": [
        -302.52215576171875,
        -2355.699951171875,
        664.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -299.697998046875,
        -2355.699951171875,
        656.0
      ],
      "bbox_max": [
        -286.32513427734375,
        -2348.2548828125,
        663.7841186523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 624.6114501953125,
      "bbox_min": [
        -299.697998046875,
        -2355.699951171875,
        660.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        663.7841186523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07918098568916321,
        -0.9968602657318115,
        -0.0
      ],
      "plane_d": -2363.69287109375,
      "bbox_min": [
        -288.0859375,
        -2348.394775390625,
        656.0
      ],
      "bbox_max": [
        -286.32513427734375,
        -2348.2548828125,
        658.567626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -299.697998046875,
        -2355.699951171875,
        656.0
      ],
      "bbox_max": [
        -286.32513427734375,
        -2348.2548828125,
        663.66552734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 624.6114501953125,
      "bbox_min": [
        -299.697998046875,
        -2355.699951171875,
        660.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        663.66552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07918098568916321,
        -0.9968602657318115,
        -0.0
      ],
      "plane_d": -2363.69287109375,
      "bbox_min": [
        -288.0859375,
        -2348.394775390625,
        656.0
      ],
      "bbox_max": [
        -286.32513427734375,
        -2348.2548828125,
        658.4400634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07918098568916321,
        -0.9968602657318115,
        -0.0
      ],
      "plane_d": -2363.69287109375,
      "bbox_min": [
        -299.0313720703125,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -286.32513427734375,
        -2348.16748046875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238263368606567,
        -0.3828117847442627,
        0.0
      ],
      "plane_d": -1165.0810546875,
      "bbox_min": [
        -288.1221923828125,
        -2348.2548828125,
        649.5
      ],
      "bbox_max": [
        -288.0859375,
        -2348.16748046875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -299.0313720703125,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -290.8558044433594,
        -2352.925537109375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8829648494720459,
        0.3657400906085968,
        0.2942911386489868
      ],
      "plane_d": 410.0762634277344,
      "bbox_min": [
        -299.0313720703125,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -297.800048828125,
        -2354.829345703125,
        640.6943969726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.0,
      "bbox_min": [
        -351.334228515625,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2339.0,
        692.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -351.334228515625,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        659.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8310803771018982,
        0.5561522841453552,
        -0.0
      ],
      "plane_d": 1541.722412109375,
      "bbox_min": [
        -287.44775390625,
        -2346.7353515625,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2350.796142578125,
      "bbox_min": [
        -318.2650451660156,
        -2350.796142578125,
        646.5
      ],
      "bbox_max": [
        -307.280517578125,
        -2350.796142578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38281548023223877,
        0.9238248467445374,
        -0.0
      ],
      "plane_d": 2297.564453125,
      "bbox_min": [
        -351.334228515625,
        -2350.796142578125,
        643.0
      ],
      "bbox_max": [
        -318.0042724609375,
        -2342.578125,
        649.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.831441342830658,
        0.5556125640869141,
        0.0
      ],
      "plane_d": 1011.7618408203125,
      "bbox_min": [
        -351.334228515625,
        -2346.7353515625,
        643.0
      ],
      "bbox_max": [
        -348.55615234375,
        -2342.578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2350.796142578125,
      "bbox_min": [
        -328.72412109375,
        -2350.796142578125,
        646.5
      ],
      "bbox_max": [
        -318.0042724609375,
        -2350.796142578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5809391736984253,
        -0.8139470219612122
      ],
      "plane_d": 1891.8863525390625,
      "bbox_min": [
        -329.699951171875,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2350.796142578125,
        649.4287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2350.796142578125,
      "bbox_min": [
        -328.72412109375,
        -2350.796142578125,
        646.5
      ],
      "bbox_max": [
        -307.280517578125,
        -2350.796142578125,
        649.4287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -319.11553955078125,
        -2355.699951171875,
        649.5
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        659.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8310803771018982,
        0.5561522841453552,
        -0.0
      ],
      "plane_d": 1541.722412109375,
      "bbox_min": [
        -287.44775390625,
        -2346.7353515625,
        656.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8310803771018982,
        0.5561522841453552,
        -0.0
      ],
      "plane_d": 1541.722412109375,
      "bbox_min": [
        -290.0,
        -2348.16748046875,
        649.5
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238263368606567,
        -0.3828117847442627,
        0.0
      ],
      "plane_d": -1165.0810546875,
      "bbox_min": [
        -290.0,
        -2348.16748046875,
        649.5
      ],
      "bbox_max": [
        -288.1221923828125,
        -2343.6357421875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2350.796142578125,
      "bbox_min": [
        -351.334228515625,
        -2355.699951171875,
        649.5
      ],
      "bbox_max": [
        -307.280517578125,
        -2342.578125,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -341.53460693359375,
        -2355.699951171875,
        656.0
      ],
      "bbox_max": [
        -307.280517578125,
        -2350.796142578125,
        656.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -351.334228515625,
        -2350.796142578125,
        649.5
      ],
      "bbox_max": [
        -328.72412109375,
        -2342.578125,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.831441342830658,
        0.5556125640869141,
        0.0
      ],
      "plane_d": 1011.7618408203125,
      "bbox_min": [
        -351.334228515625,
        -2346.7353515625,
        656.0
      ],
      "bbox_max": [
        -348.55615234375,
        -2342.578125,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.831441342830658,
        0.5556125640869141,
        0.0
      ],
      "plane_d": 1011.7618408203125,
      "bbox_min": [
        -351.334228515625,
        -2348.16796875,
        649.5
      ],
      "bbox_max": [
        -346.0,
        -2342.578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238263368606567,
        -0.3828117847442627,
        0.0
      ],
      "plane_d": -577.5281372070312,
      "bbox_min": [
        -347.8773193359375,
        -2348.16796875,
        649.5
      ],
      "bbox_max": [
        -346.0,
        -2343.637451171875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8797038793563843,
        0.47552189230918884,
        -0.0
      ],
      "plane_d": 1397.2935791015625,
      "bbox_min": [
        -321.5,
        -2355.699951171875,
        670.5
      ],
      "bbox_max": [
        -315.0,
        -2339.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8797038793563843,
        0.47552192211151123,
        0.0
      ],
      "plane_d": 837.3621826171875,
      "bbox_min": [
        -321.5,
        -2355.699951171875,
        670.5
      ],
      "bbox_max": [
        -315.0,
        -2347.374755859375,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9771250486373901,
        -0.2126655876636505
      ],
      "plane_d": 2444.40576171875,
      "bbox_min": [
        -321.5,
        -2355.699951171875,
        670.5
      ],
      "bbox_max": [
        -315.0,
        -2349.6875,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47552192211151123,
        0.8797038793563843
      ],
      "plane_d": 511.431884765625,
      "bbox_min": [
        -321.5,
        -2355.699951171875,
        690.0
      ],
      "bbox_max": [
        -315.0,
        -2351.4560546875,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -319.5,
        -2352.0,
        690.0
      ],
      "bbox_max": [
        -317.0,
        -2351.4560546875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -319.2059631347656,
        -2351.4560546875,
        690.0
      ],
      "bbox_max": [
        -317.2940368652344,
        -2349.6875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -319.5,
        -2352.0,
        690.0
      ],
      "bbox_max": [
        -318.2499694824219,
        -2347.374755859375,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        -319.5,
        -2352.0,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2339.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -319.5,
        -2352.0,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2339.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -319.5,
        -2352.0,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2339.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -319.5,
      "bbox_min": [
        -319.5,
        -2347.374755859375,
        687.5
      ],
      "bbox_max": [
        -319.5,
        -2339.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -376.84716796875,
      "bbox_min": [
        -435.0,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        2.5105127861024812e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2273.313232421875,
      "bbox_min": [
        -376.84716796875,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.5105127861024812e-05,
        -1.1625744264165405e-05
      ],
      "plane_d": 294.6487731933594,
      "bbox_min": [
        -376.84716796875,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2273.3037109375,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.5105127861024812e-05,
        0.0
      ],
      "plane_d": -341.5956726074219,
      "bbox_min": [
        -376.84716796875,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -294.697998046875,
        -2273.3037109375,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2320.260009765625,
      "bbox_min": [
        -341.653564453125,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -318.5,
        -2273.304931640625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -663.0,
      "bbox_min": [
        -341.6533508300781,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -318.5,
        -2273.304931640625,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -331.6534423828125,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -318.5,
        -2283.304931640625,
        663.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8314775824546814,
        0.5555582642555237,
        0.0
      ],
      "plane_d": 998.5836791992188,
      "bbox_min": [
        -330.682861328125,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -327.0,
        -2286.84716796875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882246017456,
        -0.3826768100261688,
        0.0
      ],
      "plane_d": -1182.7447509765625,
      "bbox_min": [
        -330.682861328125,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -328.7605895996094,
        -2292.359130859375,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.69339919090271,
        0.6933562755584717,
        -0.1960984170436859
      ],
      "plane_d": 1488.6630859375,
      "bbox_min": [
        -331.6534423828125,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2283.304931640625,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 655.0,
      "bbox_min": [
        -331.6534423828125,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2283.304931640625,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805718064308167,
        2.144169957318809e-05,
        -0.1961604505777359
      ],
      "plane_d": -195.10638427734375,
      "bbox_min": [
        -331.6534423828125,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2283.304931640625,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.144122845493257e-05,
        0.9805718064308167,
        -0.1961604654788971
      ],
      "plane_d": 2369.005859375,
      "bbox_min": [
        -330.6533203125,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2283.304931640625,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 231.46905517578125,
      "bbox_min": [
        -330.6533203125,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2284.30517578125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2080.52392578125,
      "bbox_min": [
        -323.34423828125,
        -2287.30517578125,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2284.30517578125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -664.0,
      "bbox_min": [
        -341.6533508300781,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2273.304931640625,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071147561073303,
        0.7070987820625305,
        0.0
      ],
      "plane_d": 1380.587890625,
      "bbox_min": [
        -336.6533203125,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2278.30517578125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -336.6533203125,
      "bbox_min": [
        -336.6533203125,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2278.30517578125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999927878379822,
        -0.4999774992465973,
        0.7071278095245361
      ],
      "plane_d": -1449.1494140625,
      "bbox_min": [
        -331.8057861328125,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2278.30517578125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2278.30517578125,
      "bbox_min": [
        -325.82958984375,
        -2278.30517578125,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2278.30517578125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2278.30517578125,
      "bbox_min": [
        -318.97412109375,
        -2278.30517578125,
        663.6647338867188
      ],
      "bbox_max": [
        -318.5,
        -2278.30517578125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707112193107605,
        1.54620865941979e-05,
        -0.7071013450622559
      ],
      "plane_d": 256.2476501464844,
      "bbox_min": [
        -341.6533203125,
        -2297.0,
        688.6470336914062
      ],
      "bbox_max": [
        -318.5,
        -2273.304931640625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5461750081158243e-05,
        0.707112193107605,
        -0.7071013450622559
      ],
      "plane_d": 2105.2861328125,
      "bbox_min": [
        -331.8150634765625,
        -2297.0,
        689.0333251953125
      ],
      "bbox_max": [
        -318.5,
        -2273.304931640625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071284055709839,
        -0.7070851922035217,
        0.0
      ],
      "plane_d": -1385.390625,
      "bbox_min": [
        -331.8150634765625,
        -2297.0,
        692.2789916992188
      ],
      "bbox_max": [
        -318.5,
        -2283.143310546875,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -2.16076059587067e-05,
        0.0
      ],
      "plane_d": 331.76544189453125,
      "bbox_min": [
        -331.8150634765625,
        -2297.0,
        692.2789916992188
      ],
      "bbox_max": [
        -318.5,
        -2283.143310546875,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -2.1607138478429988e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2283.150390625,
      "bbox_min": [
        -331.8150634765625,
        -2297.0,
        692.2789916992188
      ],
      "bbox_max": [
        -318.5,
        -2283.143310546875,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        0.3826742172241211,
        0.0
      ],
      "plane_d": 581.9741821289062,
      "bbox_min": [
        -321.5,
        -2297.0,
        702.0
      ],
      "bbox_max": [
        -318.5,
        -2294.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.86285799741745,
        0.3573974072933197,
        -0.3574116826057434
      ],
      "plane_d": 795.5082397460938,
      "bbox_min": [
        -321.5,
        -2297.0,
        702.0
      ],
      "bbox_max": [
        -318.5,
        -2294.0,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35739922523498535,
        0.8628624081611633,
        -0.35739922523498535
      ],
      "plane_d": 2117.541259765625,
      "bbox_min": [
        -320.621337890625,
        -2297.0,
        702.0
      ],
      "bbox_max": [
        -318.5,
        -2294.0,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15655864775180817,
        0.3779553174972534,
        -0.9124906659126282
      ],
      "plane_d": 1458.867919921875,
      "bbox_min": [
        -320.621337890625,
        -2297.0,
        702.0
      ],
      "bbox_max": [
        -318.5,
        -2294.878662109375,
        702.878662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37795528769493103,
        0.15655864775180817,
        -0.9124906659126282
      ],
      "plane_d": 879.804931640625,
      "bbox_min": [
        -320.621337890625,
        -2297.0,
        702.0
      ],
      "bbox_max": [
        -318.5,
        -2295.5,
        702.878662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.248028057598276e-06,
        2.5882093268592143e-06,
        -1.0
      ],
      "plane_d": 703.326171875,
      "bbox_min": [
        -331.8150634765625,
        -2297.0,
        692.2789916992188
      ],
      "bbox_max": [
        -318.5,
        -2283.143310546875,
        705.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071317434310913,
        -0.7070817947387695,
        0.0
      ],
      "plane_d": -1387.2294921875,
      "bbox_min": [
        -329.9674072265625,
        -2297.0,
        703.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2284.990966796875,
        705.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.49937511398457e-05,
        0.0
      ],
      "plane_d": 329.9100036621094,
      "bbox_min": [
        -329.9674072265625,
        -2297.0,
        703.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2284.990966796875,
        705.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.4993127226480283e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2284.9990234375,
      "bbox_min": [
        -323.06005859375,
        -2284.990966796875,
        703.3182373046875
      ],
      "bbox_max": [
        -318.5,
        -2284.990966796875,
        705.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070654034614563,
        -0.7070155739784241,
        0.013692148961126804
      ],
      "plane_d": -1396.6131591796875,
      "bbox_min": [
        -331.81494140625,
        -2297.0,
        692.2789916992188
      ],
      "bbox_max": [
        -318.5,
        -2283.143310546875,
        696.8034057617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.517616331577301,
        -0.5175898671150208,
        0.6813032627105713
      ],
      "plane_d": -1488.8489990234375,
      "bbox_min": [
        -331.81494140625,
        -2291.898681640625,
        694.8181762695312
      ],
      "bbox_max": [
        -321.2511291503906,
        -2283.143310546875,
        696.8034057617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -323.758544921875,
        -2285.0703125,
        689.0333251953125
      ],
      "bbox_max": [
        -318.5,
        -2283.304931640625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -323.0456848144531,
        -2285.0703125,
        689.0333251953125
      ],
      "bbox_max": [
        -318.5,
        -2285.025634765625,
        692.2793579101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.1866526367375627e-05,
        0.0
      ],
      "plane_d": -331.60321044921875,
      "bbox_min": [
        -331.796142578125,
        -2297.0,
        688.6470336914062
      ],
      "bbox_max": [
        -329.88287353515625,
        -2291.2001953125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999061822891235,
        -2.4905815735110082e-05,
        0.013697962276637554
      ],
      "plane_d": 320.3616638183594,
      "bbox_min": [
        -329.9326171875,
        -2297.0,
        688.6470336914062
      ],
      "bbox_max": [
        -329.88287353515625,
        -2291.9130859375,
        692.2791137695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -331.796142578125,
        -2297.0,
        690.0
      ],
      "bbox_max": [
        -331.650146484375,
        -2296.85400390625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071163058280945,
        0.7070972323417664,
        0.0
      ],
      "plane_d": 1383.583740234375,
      "bbox_min": [
        -333.6533203125,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2273.30517578125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.867096398200374e-05,
        0.9805803894996643,
        0.19611762464046478
      ],
      "plane_d": 2104.82568359375,
      "bbox_min": [
        -333.6533203125,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2275.218017578125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6933853030204773,
        0.6933665871620178,
        0.19611123204231262
      ],
      "plane_d": 1224.537841796875,
      "bbox_min": [
        -333.6533203125,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2281.304931640625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071171402931213,
        -0.7070955634117126,
        0.001076003652997315
      ],
      "plane_d": -1386.1417236328125,
      "bbox_min": [
        -331.8162841796875,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2281.304931640625,
        692.2792358398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.9040728147956543e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2281.31103515625,
      "bbox_min": [
        -324.5869140625,
        -2281.304931640625,
        664.0
      ],
      "bbox_max": [
        -321.9739990234375,
        -2281.304931640625,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999994039535522,
        -2.1604791982099414e-05,
        0.0010726567124947906
      ],
      "plane_d": 331.0437316894531,
      "bbox_min": [
        -331.8162841796875,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2281.304931640625,
        692.2792358398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1605259462376125e-05,
        -0.9999994039535522,
        0.0010726567124947906
      ],
      "plane_d": -2283.870361328125,
      "bbox_min": [
        -331.8162841796875,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2281.304931640625,
        692.2792358398438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.9040728147956543e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2281.31103515625,
      "bbox_min": [
        -321.98919677734375,
        -2281.304931640625,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2281.304931640625,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6933979392051697,
        -0.693348228931427,
        -0.19613134860992432
      ],
      "plane_d": -1226.3212890625,
      "bbox_min": [
        -331.8162841796875,
        -2297.0,
        673.786865234375
      ],
      "bbox_max": [
        -318.5,
        -2283.14208984375,
        692.2792358398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070654034614563,
        -0.7070155739784241,
        0.013692148961126804
      ],
      "plane_d": -1396.6131591796875,
      "bbox_min": [
        -329.9324951171875,
        -2294.03125,
        683.786865234375
      ],
      "bbox_max": [
        -320.9277038574219,
        -2285.025634765625,
        692.2792358398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -329.9324951171875,
        -2294.03125,
        683.786865234375
      ],
      "bbox_max": [
        -320.9277038574219,
        -2285.025634765625,
        692.2792358398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999061822891235,
        -2.4905815735110082e-05,
        0.013697962276637554
      ],
      "plane_d": 320.3616638183594,
      "bbox_min": [
        -329.9324951171875,
        -2294.03125,
        683.786865234375
      ],
      "bbox_max": [
        -329.816162109375,
        -2291.9130859375,
        692.2789916992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805810451507568,
        -2.4826093067531474e-05,
        -0.19611415266990662
      ],
      "plane_d": 457.4548645019531,
      "bbox_min": [
        -331.8162841796875,
        -2297.0,
        673.786865234375
      ],
      "bbox_max": [
        -318.5,
        -2283.14208984375,
        690.766845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.482546551618725e-05,
        -0.9805810451507568,
        -0.19611415266990662
      ],
      "plane_d": -2106.6748046875,
      "bbox_min": [
        -323.825927734375,
        -2285.14208984375,
        673.786865234375
      ],
      "bbox_max": [
        -318.5,
        -2283.14208984375,
        690.766845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -322.99755859375,
        -2285.14208984375,
        683.786865234375
      ],
      "bbox_max": [
        -318.5,
        -2285.04638671875,
        690.766845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707128643989563,
        0.7070848941802979,
        0.0
      ],
      "plane_d": 1385.551513671875,
      "bbox_min": [
        -325.75848388671875,
        -2285.304931640625,
        684.0
      ],
      "bbox_max": [
        -323.758544921875,
        -2283.304931640625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -319.5,
        -2283.3046875,
        687.5
      ],
      "bbox_max": [
        -318.5,
        -2275.218017578125,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -319.5,
      "bbox_min": [
        -319.5,
        -2283.3046875,
        687.5
      ],
      "bbox_max": [
        -319.5,
        -2276.218017578125,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -319.5,
      "bbox_min": [
        -319.5,
        -2276.218017578125,
        687.5
      ],
      "bbox_max": [
        -318.5,
        -2273.30517578125,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -319.5,
        -2276.218017578125,
        687.5
      ],
      "bbox_max": [
        -318.5,
        -2273.30517578125,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -319.5,
        -2276.218017578125,
        690.0
      ],
      "bbox_max": [
        -318.5,
        -2273.30517578125,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.1866526367375627e-05,
        0.0
      ],
      "plane_d": -331.60321044921875,
      "bbox_min": [
        -341.6533508300781,
        -2297.0,
        684.0
      ],
      "bbox_max": [
        -329.6532897949219,
        -2289.199951171875,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2296.0,
      "bbox_min": [
        -341.6533508300781,
        -2297.0,
        687.5
      ],
      "bbox_max": [
        -331.650146484375,
        -2296.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -341.6533508300781,
        -2297.0,
        687.5
      ],
      "bbox_max": [
        -331.650146484375,
        -2296.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -341.6533508300781,
        -2297.0,
        690.0
      ],
      "bbox_max": [
        -331.650146484375,
        -2296.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070879340171814,
        -0.7071256041526794,
        0.0
      ],
      "plane_d": -1872.5697021484375,
      "bbox_min": [
        -341.653564453125,
        -2320.260009765625,
        637.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -663.0,
      "bbox_min": [
        -341.653564453125,
        -2320.260009765625,
        637.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -331.653564453125,
        -2310.260009765625,
        637.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        663.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2308.989013671875,
      "bbox_min": [
        -323.794677734375,
        -2308.989013671875,
        637.0
      ],
      "bbox_max": [
        -318.5,
        -2308.989013671875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6933562755584717,
        -0.69339919090271,
        -0.1960984170436859
      ],
      "plane_d": -1696.3990478515625,
      "bbox_min": [
        -331.653564453125,
        -2310.260009765625,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 655.0,
      "bbox_min": [
        -331.653564453125,
        -2310.260009765625,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805718064308167,
        2.144169957318809e-05,
        -0.1961604505777359
      ],
      "plane_d": -195.10638427734375,
      "bbox_min": [
        -331.653564453125,
        -2310.260009765625,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.144189966202248e-05,
        -0.9805810451507568,
        -0.1961144208908081
      ],
      "plane_d": -2135.38037109375,
      "bbox_min": [
        -330.6533203125,
        -2310.260009765625,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 231.46905517578125,
      "bbox_min": [
        -330.6533203125,
        -2309.260009765625,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.670008168730419e-05,
        -0.7070814967155457,
        -0.70713210105896
      ],
      "plane_d": -1167.5474853515625,
      "bbox_min": [
        -323.34423828125,
        -2309.260009765625,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2306.260009765625,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999842643737793,
        -0.5000151991844177,
        -0.7071071863174438
      ],
      "plane_d": -826.3067626953125,
      "bbox_min": [
        -341.653564453125,
        -2320.260009765625,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707112193107605,
        1.54620865941979e-05,
        -0.7071013450622559
      ],
      "plane_d": 256.2476501464844,
      "bbox_min": [
        -341.653564453125,
        -2320.260009765625,
        688.9570922851562
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.5461899238289334e-05,
        -0.7071036100387573,
        -0.7071099877357483
      ],
      "plane_d": -1142.8638916015625,
      "bbox_min": [
        -331.815185546875,
        -2320.260009765625,
        689.0336303710938
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070851922035217,
        0.7071284055709839,
        -0.0
      ],
      "plane_d": 1862.73681640625,
      "bbox_min": [
        -331.815185546875,
        -2310.421630859375,
        692.2789306640625
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -2.16076059587067e-05,
        0.0
      ],
      "plane_d": 331.76544189453125,
      "bbox_min": [
        -331.815185546875,
        -2310.421630859375,
        692.2789306640625
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        2.16076059587067e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2310.4287109375,
      "bbox_min": [
        -331.815185546875,
        -2310.421630859375,
        692.2789306640625
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826742172241211,
        -0.9238833785057068,
        -0.0
      ],
      "plane_d": -2246.8134765625,
      "bbox_min": [
        -321.5,
        -2300.0,
        702.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8628624081611633,
        -0.35739922523498535,
        -0.35739922523498535
      ],
      "plane_d": -846.3898315429688,
      "bbox_min": [
        -321.5,
        -2300.0,
        702.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3573974072933197,
        -0.86285799741745,
        -0.3574116826057434
      ],
      "plane_d": -1846.42919921875,
      "bbox_min": [
        -320.621337890625,
        -2300.0,
        702.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3779553174972534,
        -0.15655864775180817,
        -0.9124906659126282
      ],
      "plane_d": 160.574462890625,
      "bbox_min": [
        -320.621337890625,
        -2299.121337890625,
        702.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        702.878662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15655864775180817,
        -0.37795528769493103,
        -0.9124906659126282
      ],
      "plane_d": -277.4587707519531,
      "bbox_min": [
        -320.0,
        -2299.121337890625,
        702.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        702.878662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.5882093268592143e-06,
        6.248028057598276e-06,
        -1.0
      ],
      "plane_d": 703.331787109375,
      "bbox_min": [
        -331.815185546875,
        -2310.421630859375,
        692.2789306640625
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        705.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7070817947387695,
        0.7071317434310913,
        -0.0
      ],
      "plane_d": 1860.8956298828125,
      "bbox_min": [
        -329.967529296875,
        -2308.573974609375,
        703.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        705.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.49937511398457e-05,
        0.0
      ],
      "plane_d": 329.9100036621094,
      "bbox_min": [
        -329.967529296875,
        -2308.573974609375,
        703.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        705.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.49937511398457e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2308.58203125,
      "bbox_min": [
        -323.059814453125,
        -2308.573974609375,
        703.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2308.573974609375,
        705.3181762695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070155739784241,
        0.7070654034614563,
        0.013692148961126804
      ],
      "plane_d": 1851.20751953125,
      "bbox_min": [
        -329.967529296875,
        -2308.573974609375,
        692.2789306640625
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        694.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999061822891235,
        -2.4905815735110082e-05,
        0.013697962276637554
      ],
      "plane_d": 320.3616638183594,
      "bbox_min": [
        -329.967529296875,
        -2308.573974609375,
        692.2789306640625
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        694.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.1866526367375627e-05,
        0.0
      ],
      "plane_d": -331.60321044921875,
      "bbox_min": [
        -331.653564453125,
        -2302.365234375,
        688.9570922851562
      ],
      "bbox_max": [
        -329.8871154785156,
        -2297.0,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999061822891235,
        -2.4905815735110082e-05,
        0.013697962276637554
      ],
      "plane_d": 320.3616638183594,
      "bbox_min": [
        -329.9327392578125,
        -2301.65234375,
        688.9570922851562
      ],
      "bbox_max": [
        -329.8871154785156,
        -2297.0,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1867.5323486328125,
      "bbox_min": [
        -341.65338134765625,
        -2320.260009765625,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -664.0,
      "bbox_min": [
        -341.65338134765625,
        -2320.260009765625,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        694.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -336.6533203125,
      "bbox_min": [
        -336.6533203125,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999714195728302,
        0.5000020265579224,
        0.7071256041526794
      ],
      "plane_d": 847.5809936523438,
      "bbox_min": [
        -331.805908203125,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2315.26025390625,
      "bbox_min": [
        -325.829345703125,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2315.26025390625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2315.26025390625,
      "bbox_min": [
        -318.9735412597656,
        -2315.26025390625,
        663.6651611328125
      ],
      "bbox_max": [
        -318.5,
        -2315.26025390625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070877552032471,
        -0.7071258425712585,
        0.0
      ],
      "plane_d": -1864.5701904296875,
      "bbox_min": [
        -333.653564453125,
        -2320.260009765625,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9805760979652405,
        0.1961391568183899
      ],
      "plane_d": -2399.544921875,
      "bbox_min": [
        -333.653564453125,
        -2318.3466796875,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.693355143070221,
        -0.6933924555778503,
        0.19612644612789154
      ],
      "plane_d": -1960.546875,
      "bbox_min": [
        -333.653564453125,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999994039535522,
        -2.1604791982099414e-05,
        0.0010726567124947906
      ],
      "plane_d": 331.0437316894531,
      "bbox_min": [
        -331.81640625,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070847749710083,
        0.7071279883384705,
        0.001076010405085981
      ],
      "plane_d": 1862.0120849609375,
      "bbox_min": [
        -331.81640625,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2312.26025390625,
      "bbox_min": [
        -324.586669921875,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -321.97357177734375,
        -2312.26025390625,
        674.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9805810451507568,
        -2.4826093067531474e-05,
        -0.19611415266990662
      ],
      "plane_d": 457.4548645019531,
      "bbox_min": [
        -331.81640625,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070155739784241,
        0.7070654034614563,
        0.013692148961126804
      ],
      "plane_d": 1851.20751953125,
      "bbox_min": [
        -329.9327392578125,
        -2303.467041015625,
        683.786865234375
      ],
      "bbox_max": [
        -328.1180419921875,
        -2297.0,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999061822891235,
        -2.4905815735110082e-05,
        0.013697962276637554
      ],
      "plane_d": 320.3616638183594,
      "bbox_min": [
        -329.9327392578125,
        -2301.65234375,
        683.786865234375
      ],
      "bbox_max": [
        -329.8162841796875,
        -2297.0,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070155739784241,
        0.7070654034614563,
        0.013692148961126804
      ],
      "plane_d": 1851.20751953125,
      "bbox_min": [
        -329.81640625,
        -2312.26025390625,
        673.7864990234375
      ],
      "bbox_max": [
        -320.9271545410156,
        -2301.604248046875,
        692.2791137695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2312.26025390625,
      "bbox_min": [
        -321.9887390136719,
        -2312.26025390625,
        673.7864990234375
      ],
      "bbox_max": [
        -321.9280090332031,
        -2312.26025390625,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.499140646250453e-05,
        0.9999061822891235,
        0.013698036782443523
      ],
      "plane_d": 2298.847900390625,
      "bbox_min": [
        -323.0454406738281,
        -2308.539306640625,
        683.786865234375
      ],
      "bbox_max": [
        -320.9271545410156,
        -2308.4228515625,
        692.279052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2312.26025390625,
      "bbox_min": [
        -323.82568359375,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2308.4228515625,
        690.7666015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 320.986572265625,
      "bbox_min": [
        -323.8212890625,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2310.41259765625,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01679205149412155,
        0.9998589754104614,
        -6.251823503333753e-10
      ],
      "plane_d": 2315.5244140625,
      "bbox_min": [
        -323.8212890625,
        -2310.460205078125,
        664.0
      ],
      "bbox_max": [
        -320.986572265625,
        -2310.41259765625,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 672.0,
      "bbox_min": [
        -320.986572265625,
        -2312.26025390625,
        672.0
      ],
      "bbox_max": [
        -318.5,
        -2310.460205078125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.4826093067531474e-05,
        0.9805810451507568,
        -0.19611415266990662
      ],
      "plane_d": 2397.7041015625,
      "bbox_min": [
        -323.82568359375,
        -2310.494384765625,
        672.0
      ],
      "bbox_max": [
        -318.5,
        -2308.4228515625,
        683.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9997844099998474,
        -0.02076338790357113
      ],
      "plane_d": 2323.9150390625,
      "bbox_min": [
        -323.82568359375,
        -2310.494384765625,
        672.0
      ],
      "bbox_max": [
        -318.5,
        -2310.423095703125,
        673.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 672.0,
      "bbox_min": [
        -320.986572265625,
        -2310.494384765625,
        672.0
      ],
      "bbox_max": [
        -318.5,
        -2310.460205078125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070848941802979,
        -0.707128643989563,
        0.0
      ],
      "plane_d": -1862.57568359375,
      "bbox_min": [
        -331.653564453125,
        -2310.260009765625,
        684.0
      ],
      "bbox_max": [
        -323.75830078125,
        -2302.365234375,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1866526367375627e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2310.26708984375,
      "bbox_min": [
        -325.75872802734375,
        -2318.3466796875,
        684.0
      ],
      "bbox_max": [
        -318.5,
        -2308.259765625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070848941802979,
        -0.707128643989563,
        0.0
      ],
      "plane_d": -1862.57568359375,
      "bbox_min": [
        -325.75872802734375,
        -2310.260009765625,
        684.0
      ],
      "bbox_max": [
        -323.75830078125,
        -2308.259765625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -319.5,
        -2318.3466796875,
        687.5
      ],
      "bbox_max": [
        -318.5,
        -2310.260009765625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -319.5,
      "bbox_min": [
        -319.5,
        -2317.3466796875,
        687.5
      ],
      "bbox_max": [
        -319.5,
        -2310.260009765625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -319.5,
      "bbox_min": [
        -319.5,
        -2320.260009765625,
        687.5
      ],
      "bbox_max": [
        -318.5,
        -2317.3466796875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -319.5,
        -2320.260009765625,
        687.5
      ],
      "bbox_max": [
        -318.5,
        -2317.3466796875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -319.5,
        -2320.260009765625,
        690.0
      ],
      "bbox_max": [
        -318.5,
        -2317.3466796875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.1866526367375627e-05,
        0.0
      ],
      "plane_d": -331.60321044921875,
      "bbox_min": [
        -341.65338134765625,
        -2304.365234375,
        684.0
      ],
      "bbox_max": [
        -329.6535339355469,
        -2297.0,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2298.5,
      "bbox_min": [
        -341.65338134765625,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -331.650146484375,
        -2297.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -341.65338134765625,
        -2298.5,
        690.0
      ],
      "bbox_max": [
        -331.650146484375,
        -2297.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -319.5,
        -2339.0,
        690.0
      ],
      "bbox_max": [
        -318.5,
        -2320.260009765625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2320.260009765625,
      "bbox_min": [
        -318.5,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -294.697998046875,
        -2273.30517578125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -663.0,
      "bbox_min": [
        -318.5,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -294.697998046875,
        -2273.30517578125,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -318.5,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.304931640625,
        663.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8314775824546814,
        0.5555582642555237,
        -0.0
      ],
      "plane_d": 1527.4034423828125,
      "bbox_min": [
        -309.0,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -305.317138671875,
        -2286.84716796875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923882246017456,
        -0.3826768100261688,
        0.0
      ],
      "plane_d": -595.1555786132812,
      "bbox_min": [
        -307.2394104003906,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -305.317138671875,
        -2292.359130859375,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 655.0,
      "bbox_min": [
        -318.5,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.304931640625,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49997347593307495,
        0.49999019503593445,
        -0.7071324586868286
      ],
      "plane_d": 1763.9188232421875,
      "bbox_min": [
        -318.5,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.304931640625,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.144122845493257e-05,
        0.9805718064308167,
        -0.1961604654788971
      ],
      "plane_d": 2369.005859375,
      "bbox_min": [
        -318.5,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.304931640625,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806875228882,
        0.0,
        -0.1961161345243454
      ],
      "plane_d": 428.80621337890625,
      "bbox_min": [
        -318.5,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2284.30517578125,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2080.52392578125,
      "bbox_min": [
        -318.5,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -305.6982421875,
        -2284.30517578125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070814967155457,
        -1.670047640800476e-05,
        -0.70713210105896
      ],
      "plane_d": 681.408203125,
      "bbox_min": [
        -308.698486328125,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -305.6982421875,
        -2291.6142578125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -664.0,
      "bbox_min": [
        -318.5,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -294.697998046875,
        -2273.30517578125,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7070987820625305,
        0.7071147561073303,
        0.0
      ],
      "plane_d": 1830.5931396484375,
      "bbox_min": [
        -318.5,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2278.30517578125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2278.30517578125,
      "bbox_min": [
        -318.5,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2278.30517578125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999714195728302,
        -0.5000020265579224,
        0.7071256041526794
      ],
      "plane_d": -1767.36865234375,
      "bbox_min": [
        -318.5,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2283.152587890625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 299.6982421875,
      "bbox_min": [
        -299.6982421875,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2289.12890625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 299.6982421875,
      "bbox_min": [
        -299.6982421875,
        -2297.0,
        663.28173828125
      ],
      "bbox_max": [
        -299.6982421875,
        -2295.984130859375,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5461750081158243e-05,
        0.707112193107605,
        -0.7071013450622559
      ],
      "plane_d": 2105.2861328125,
      "bbox_min": [
        -318.5,
        -2297.0,
        688.57080078125
      ],
      "bbox_max": [
        -294.697998046875,
        -2273.30517578125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071154117584229,
        0.0,
        -0.707098126411438
      ],
      "plane_d": 706.1829223632812,
      "bbox_min": [
        -318.5,
        -2297.0,
        688.646728515625
      ],
      "bbox_max": [
        -294.697998046875,
        -2283.143310546875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070959806442261,
        -0.7071175575256348,
        0.0
      ],
      "plane_d": -1835.43701171875,
      "bbox_min": [
        -318.5,
        -2297.0,
        692.2791137695312
      ],
      "bbox_max": [
        -304.53662109375,
        -2283.143310546875,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -2.1607138478429988e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2283.150390625,
      "bbox_min": [
        -318.5,
        -2297.0,
        692.2791137695312
      ],
      "bbox_max": [
        -304.53662109375,
        -2283.143310546875,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -304.53662109375,
      "bbox_min": [
        -318.5,
        -2297.0,
        692.2791137695312
      ],
      "bbox_max": [
        -304.53662109375,
        -2283.143310546875,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826742172241211,
        0.9238833785057068,
        0.0
      ],
      "plane_d": 2241.270263671875,
      "bbox_min": [
        -318.5,
        -2297.0,
        702.0
      ],
      "bbox_max": [
        -315.5,
        -2294.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8628624081611633,
        0.35739922523498535,
        -0.35739922523498535
      ],
      "plane_d": 1345.1455078125,
      "bbox_min": [
        -318.5,
        -2297.0,
        702.0
      ],
      "bbox_max": [
        -315.5,
        -2294.0,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3573974072933197,
        0.86285799741745,
        -0.3574116826057434
      ],
      "plane_d": 2345.20263671875,
      "bbox_min": [
        -318.5,
        -2297.0,
        702.0
      ],
      "bbox_max": [
        -316.378662109375,
        -2294.0,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3779553174972534,
        0.15655864775180817,
        -0.9124906659126282
      ],
      "plane_d": 1120.5623779296875,
      "bbox_min": [
        -318.5,
        -2297.0,
        702.0
      ],
      "bbox_max": [
        -316.378662109375,
        -2294.878662109375,
        702.878662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15655864775180817,
        0.37795528769493103,
        -0.9124906659126282
      ],
      "plane_d": 1558.595703125,
      "bbox_min": [
        -318.5,
        -2297.0,
        702.0
      ],
      "bbox_max": [
        -317.0,
        -2294.878662109375,
        702.878662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.588235929579241e-06,
        -6.248092176974751e-06,
        -1.0
      ],
      "plane_d": 703.3046875,
      "bbox_min": [
        -318.5,
        -2297.0,
        692.2791137695312
      ],
      "bbox_max": [
        -304.53662109375,
        -2283.143310546875,
        705.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7070943117141724,
        -0.7071192860603333,
        0.0
      ],
      "plane_d": -1837.2882080078125,
      "bbox_min": [
        -318.5,
        -2297.0,
        703.3181762695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2284.990966796875,
        705.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.4993127226480283e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2284.9990234375,
      "bbox_min": [
        -318.5,
        -2297.0,
        703.3181762695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2284.990966796875,
        705.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -306.38427734375,
      "bbox_min": [
        -306.38427734375,
        -2297.0,
        703.3182373046875
      ],
      "bbox_max": [
        -306.38427734375,
        -2291.8984375,
        705.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070280909538269,
        -0.7070529460906982,
        0.013692048378288746
      ],
      "plane_d": -1846.6292724609375,
      "bbox_min": [
        -318.5,
        -2297.0,
        692.2791137695312
      ],
      "bbox_max": [
        -304.53662109375,
        -2283.143310546875,
        696.8034057617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5175962448120117,
        -0.5176068544387817,
        0.6813055276870728
      ],
      "plane_d": -1818.2691650390625,
      "bbox_min": [
        -315.1010437011719,
        -2291.8984375,
        694.8181762695312
      ],
      "bbox_max": [
        -304.53662109375,
        -2283.1435546875,
        696.8034057617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -318.5,
        -2297.0,
        692.2791137695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2283.143310546875,
        696.8034057617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2136239092797041e-05,
        -0.7320027351379395,
        0.6813016533851624
      ],
      "plane_d": -2146.00439453125,
      "bbox_min": [
        -318.5,
        -2284.9912109375,
        694.8181762695312
      ],
      "bbox_max": [
        -313.291748046875,
        -2283.143310546875,
        696.8034057617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999061822891235,
        0.0,
        0.013698102906346321
      ],
      "plane_d": -315.87322998046875,
      "bbox_min": [
        -306.4190673828125,
        -2297.0,
        692.2791137695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2291.8984375,
        694.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999061822891235,
        0.0,
        0.013698102906346321
      ],
      "plane_d": -315.87322998046875,
      "bbox_min": [
        -306.46881103515625,
        -2297.0,
        688.646728515625
      ],
      "bbox_max": [
        -306.4190673828125,
        -2291.912841796875,
        692.2791137695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -304.68994140625,
        -2297.0,
        690.0
      ],
      "bbox_max": [
        -304.554931640625,
        -2296.864990234375,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -318.5,
        -2285.07666015625,
        688.57080078125
      ],
      "bbox_max": [
        -312.59326171875,
        -2283.055419921875,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -318.5,
        -2285.07666015625,
        688.57080078125
      ],
      "bbox_max": [
        -313.3061218261719,
        -2285.02587890625,
        692.279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -318.5,
        -2283.3046875,
        690.0
      ],
      "bbox_max": [
        -318.250732421875,
        -2283.055419921875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070877552032471,
        0.7071258425712585,
        -0.0
      ],
      "plane_d": 1833.614990234375,
      "bbox_min": [
        -318.5,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -294.6983947753906,
        -2281.30517578125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805803894996643,
        -1.867096398200374e-05,
        0.19611762464046478
      ],
      "plane_d": 164.5936737060547,
      "bbox_min": [
        -318.5,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -296.0691833496094,
        -2281.30517578125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693355143070221,
        0.6933924555778503,
        0.19612644612789154
      ],
      "plane_d": 1665.8143310546875,
      "bbox_min": [
        -318.5,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -302.697998046875,
        -2281.30517578125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070847749710083,
        -0.7071279883384705,
        0.001076010405085981
      ],
      "plane_d": -1836.18115234375,
      "bbox_min": [
        -318.5,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -302.697998046875,
        -2283.14208984375,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -1.9040728147956543e-05,
        0.0
      ],
      "plane_d": 302.6543884277344,
      "bbox_min": [
        -302.69805908203125,
        -2292.984619140625,
        664.0
      ],
      "bbox_max": [
        -302.697998046875,
        -2290.37158203125,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1605259462376125e-05,
        -0.9999994039535522,
        0.0010726567124947906
      ],
      "plane_d": -2283.870361328125,
      "bbox_min": [
        -318.5,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -302.69805908203125,
        -2283.14208984375,
        692.2791748046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999994039535522,
        2.1605259462376125e-05,
        0.0010726567124947906
      ],
      "plane_d": -305.2082214355469,
      "bbox_min": [
        -318.5,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -302.69805908203125,
        -2283.14208984375,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -1.9040728147956543e-05,
        0.0
      ],
      "plane_d": 302.6543884277344,
      "bbox_min": [
        -302.6981201171875,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -302.69805908203125,
        -2292.969482421875,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6933631300926208,
        -0.693388044834137,
        -0.1961136758327484
      ],
      "plane_d": -1667.65869140625,
      "bbox_min": [
        -318.5,
        -2297.0,
        673.786865234375
      ],
      "bbox_max": [
        -304.53515625,
        -2283.14208984375,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070280909538269,
        -0.7070529460906982,
        0.013692048378288746
      ],
      "plane_d": -1846.6292724609375,
      "bbox_min": [
        -315.4241943359375,
        -2294.03076171875,
        683.786865234375
      ],
      "bbox_max": [
        -306.4190673828125,
        -2285.02587890625,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -315.4241943359375,
        -2294.03076171875,
        683.786865234375
      ],
      "bbox_max": [
        -306.4190673828125,
        -2285.02587890625,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999061822891235,
        0.0,
        0.013698102906346321
      ],
      "plane_d": -315.87322998046875,
      "bbox_min": [
        -306.535400390625,
        -2294.03076171875,
        683.786865234375
      ],
      "bbox_max": [
        -306.4190673828125,
        -2291.912841796875,
        692.2791137695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.482546551618725e-05,
        -0.9805810451507568,
        -0.19611415266990662
      ],
      "plane_d": -2106.6748046875,
      "bbox_min": [
        -318.5,
        -2297.0,
        673.786865234375
      ],
      "bbox_max": [
        -304.53515625,
        -2283.14208984375,
        690.7669067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805760979652405,
        -0.0,
        -0.1961391568183899
      ],
      "plane_d": -166.4639129638672,
      "bbox_min": [
        -306.535400390625,
        -2297.0,
        673.786865234375
      ],
      "bbox_max": [
        -304.53515625,
        -2291.132568359375,
        690.766845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999061822891235,
        0.0,
        0.013698102906346321
      ],
      "plane_d": -315.87322998046875,
      "bbox_min": [
        -306.535400390625,
        -2297.0,
        683.786865234375
      ],
      "bbox_max": [
        -306.4397888183594,
        -2291.9609375,
        690.766845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070958614349365,
        0.7071177363395691,
        -0.0
      ],
      "plane_d": 1835.5989990234375,
      "bbox_min": [
        -306.697998046875,
        -2291.199951171875,
        684.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2289.2001953125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -304.68994140625,
        -2297.0,
        687.5
      ],
      "bbox_max": [
        -296.0691833496094,
        -2296.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2296.0,
      "bbox_min": [
        -304.68994140625,
        -2296.0,
        687.5
      ],
      "bbox_max": [
        -297.06927490234375,
        -2296.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2296.0,
      "bbox_min": [
        -297.06939697265625,
        -2297.0,
        687.5
      ],
      "bbox_max": [
        -294.6983947753906,
        -2296.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -297.06939697265625,
        -2297.0,
        687.5
      ],
      "bbox_max": [
        -294.6983947753906,
        -2296.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -297.06927490234375,
        -2297.0,
        687.5
      ],
      "bbox_max": [
        -294.69842529296875,
        -2296.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -318.5,
        -2285.30517578125,
        684.0
      ],
      "bbox_max": [
        -310.5931091308594,
        -2273.30517578125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        -318.5,
        -2283.3046875,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2273.30517578125,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -318.5,
        -2283.3046875,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2273.30517578125,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -318.5,
        -2283.3046875,
        690.0
      ],
      "bbox_max": [
        -317.0,
        -2273.30517578125,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071130871772766,
        -0.707100510597229,
        0.0
      ],
      "plane_d": -1422.54736328125,
      "bbox_min": [
        -318.5,
        -2320.260009765625,
        637.0
      ],
      "bbox_max": [
        -294.6982421875,
        -2297.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -663.0,
      "bbox_min": [
        -318.5,
        -2320.260009765625,
        637.0
      ],
      "bbox_max": [
        -294.6982421875,
        -2297.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -318.5,
        -2310.26025390625,
        637.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2297.0,
        663.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2308.989013671875,
      "bbox_min": [
        -318.5,
        -2308.989013671875,
        637.0
      ],
      "bbox_max": [
        -312.205322265625,
        -2308.989013671875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6933689117431641,
        -0.6933689117431641,
        -0.19616110622882843
      ],
      "plane_d": -1255.0654296875,
      "bbox_min": [
        -318.5,
        -2310.26025390625,
        655.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2297.0,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 655.0,
      "bbox_min": [
        -318.5,
        -2310.26025390625,
        655.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2297.0,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.144189966202248e-05,
        -0.9805810451507568,
        -0.1961144208908081
      ],
      "plane_d": -2135.38037109375,
      "bbox_min": [
        -318.5,
        -2310.26025390625,
        655.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2297.0,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806875228882,
        0.0,
        -0.1961161345243454
      ],
      "plane_d": 428.80621337890625,
      "bbox_min": [
        -318.5,
        -2309.26025390625,
        655.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2297.0,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.670008168730419e-05,
        -0.7070814967155457,
        -0.70713210105896
      ],
      "plane_d": -1167.5474853515625,
      "bbox_min": [
        -318.5,
        -2309.26025390625,
        655.0
      ],
      "bbox_max": [
        -305.6983642578125,
        -2297.0,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070814967155457,
        -1.670047640800476e-05,
        -0.70713210105896
      ],
      "plane_d": 681.408203125,
      "bbox_min": [
        -308.698486328125,
        -2301.950927734375,
        655.0
      ],
      "bbox_max": [
        -305.6983642578125,
        -2297.0,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -664.0,
      "bbox_min": [
        -318.5,
        -2320.260009765625,
        663.0
      ],
      "bbox_max": [
        -294.6982421875,
        -2297.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1417.5638427734375,
      "bbox_min": [
        -318.5,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2297.0,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2315.26025390625,
      "bbox_min": [
        -318.5,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2297.0,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999927878379822,
        0.4999774992465973,
        0.7071278095245361
      ],
      "plane_d": 529.3587036132812,
      "bbox_min": [
        -318.5,
        -2310.41259765625,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2297.0,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 299.6982421875,
      "bbox_min": [
        -299.6982421875,
        -2304.436279296875,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2297.0,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 299.6982421875,
      "bbox_min": [
        -299.6982421875,
        -2297.580322265625,
        663.5897216796875
      ],
      "bbox_max": [
        -299.6982421875,
        -2297.0,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.5461899238289334e-05,
        -0.7071036100387573,
        -0.7071099877357483
      ],
      "plane_d": -1142.8638916015625,
      "bbox_min": [
        -318.5,
        -2320.260009765625,
        688.5704345703125
      ],
      "bbox_max": [
        -294.6982421875,
        -2297.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071154117584229,
        0.0,
        -0.707098126411438
      ],
      "plane_d": 706.1829223632812,
      "bbox_min": [
        -318.5,
        -2310.421875,
        688.957275390625
      ],
      "bbox_max": [
        -294.6982421875,
        -2297.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1412.7254638671875,
      "bbox_min": [
        -318.5,
        -2310.421875,
        692.2789916992188
      ],
      "bbox_max": [
        -304.53662109375,
        -2297.0,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        2.16076059587067e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2310.4287109375,
      "bbox_min": [
        -318.5,
        -2310.421875,
        692.2789916992188
      ],
      "bbox_max": [
        -304.53662109375,
        -2297.0,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -304.53662109375,
      "bbox_min": [
        -318.5,
        -2310.421875,
        692.2789916992188
      ],
      "bbox_max": [
        -304.53662109375,
        -2297.0,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826742172241211,
        -0.9238833785057068,
        0.0
      ],
      "plane_d": -2003.050048828125,
      "bbox_min": [
        -318.5,
        -2300.0,
        702.0
      ],
      "bbox_max": [
        -315.5,
        -2297.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.86285799741745,
        -0.3573974072933197,
        -0.3574116826057434
      ],
      "plane_d": -296.73492431640625,
      "bbox_min": [
        -318.5,
        -2300.0,
        702.0
      ],
      "bbox_max": [
        -315.5,
        -2297.0,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35739922523498535,
        -0.8628624081611633,
        -0.35739922523498535
      ],
      "plane_d": -1618.785400390625,
      "bbox_min": [
        -318.5,
        -2300.0,
        702.0
      ],
      "bbox_max": [
        -316.378662109375,
        -2297.0,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15655864775180817,
        -0.3779553174972534,
        -0.9124906659126282
      ],
      "plane_d": -177.73098754882812,
      "bbox_min": [
        -318.5,
        -2299.121337890625,
        702.0
      ],
      "bbox_max": [
        -316.378662109375,
        -2297.0,
        702.878662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37795528769493103,
        -0.15655864775180817,
        -0.9124906659126282
      ],
      "plane_d": 401.3320007324219,
      "bbox_min": [
        -318.5,
        -2298.5,
        702.0
      ],
      "bbox_max": [
        -316.378662109375,
        -2297.0,
        702.878662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.247936653380748e-06,
        2.5881715828290908e-06,
        -1.0
      ],
      "plane_d": 703.3261108398438,
      "bbox_min": [
        -318.5,
        -2310.421875,
        692.2789916992188
      ],
      "bbox_max": [
        -304.53662109375,
        -2297.0,
        705.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1410.877685546875,
      "bbox_min": [
        -318.5,
        -2308.57421875,
        703.3181762695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2297.0,
        705.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.49937511398457e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2308.58203125,
      "bbox_min": [
        -318.5,
        -2308.57421875,
        703.3181762695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2297.0,
        705.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -306.38427734375,
      "bbox_min": [
        -306.38427734375,
        -2301.666748046875,
        703.3182373046875
      ],
      "bbox_max": [
        -306.38427734375,
        -2297.0,
        705.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707040548324585,
        0.7070404291152954,
        0.013691874220967293
      ],
      "plane_d": 1401.23193359375,
      "bbox_min": [
        -318.5,
        -2308.57421875,
        692.2789916992188
      ],
      "bbox_max": [
        -306.38427734375,
        -2297.0,
        694.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.499140646250453e-05,
        0.9999061822891235,
        0.013698036782443523
      ],
      "plane_d": 2298.847900390625,
      "bbox_min": [
        -318.5,
        -2308.57421875,
        692.2789916992188
      ],
      "bbox_max": [
        -306.38427734375,
        -2297.0,
        694.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999061822891235,
        0.0,
        0.013698102906346321
      ],
      "plane_d": -315.87322998046875,
      "bbox_min": [
        -306.4645690917969,
        -2301.65234375,
        688.957275390625
      ],
      "bbox_max": [
        -306.4190673828125,
        -2297.0,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1866526367375627e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2310.26708984375,
      "bbox_min": [
        -318.5,
        -2310.510009765625,
        688.5704345703125
      ],
      "bbox_max": [
        -312.59326171875,
        -2308.48828125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.499140646250453e-05,
        0.9999061822891235,
        0.013698036782443523
      ],
      "plane_d": 2298.847900390625,
      "bbox_min": [
        -318.5,
        -2308.53955078125,
        688.5704345703125
      ],
      "bbox_max": [
        -313.3061218261719,
        -2308.48828125,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -318.5,
        -2310.510009765625,
        690.0
      ],
      "bbox_max": [
        -318.24993896484375,
        -2310.260009765625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2312.26025390625,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -296.5048522949219,
        -2297.0,
        694.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9805803894996643,
        -1.867096398200374e-05,
        0.19611762464046478
      ],
      "plane_d": 164.5936737060547,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -296.5048522949219,
        -2297.0,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693382978439331,
        -0.6933642625808716,
        0.1961275041103363
      ],
      "plane_d": -1519.2562255859375,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -302.6981201171875,
        -2297.0,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071171402931213,
        0.7070955634117126,
        0.001076003652997315
      ],
      "plane_d": 1411.97265625,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -302.6981201171875,
        -2297.0,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -1.9040728147956543e-05,
        0.0
      ],
      "plane_d": 302.6543884277344,
      "bbox_min": [
        -302.6982421875,
        -2303.193603515625,
        664.0
      ],
      "bbox_max": [
        -302.69818115234375,
        -2300.580322265625,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999994039535522,
        2.1605259462376125e-05,
        0.0010726567124947906
      ],
      "plane_d": -305.2082214355469,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -302.6981201171875,
        -2297.0,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -1.9040728147956543e-05,
        0.0
      ],
      "plane_d": 302.6543884277344,
      "bbox_min": [
        -302.69818115234375,
        -2300.595458984375,
        664.0
      ],
      "bbox_max": [
        -302.6981201171875,
        -2297.0,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6933757662773132,
        0.6933757662773132,
        -0.19611229002475739
      ],
      "plane_d": 1517.431396484375,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -304.5352783203125,
        -2297.0,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707040548324585,
        0.7070404291152954,
        0.013691874220967293
      ],
      "plane_d": 1401.23193359375,
      "bbox_min": [
        -315.4239501953125,
        -2308.53955078125,
        683.786865234375
      ],
      "bbox_max": [
        -306.4190673828125,
        -2299.534423828125,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999061822891235,
        0.0,
        0.013698102906346321
      ],
      "plane_d": -315.87322998046875,
      "bbox_min": [
        -315.4239501953125,
        -2308.53955078125,
        683.786865234375
      ],
      "bbox_max": [
        -306.4190673828125,
        -2299.534423828125,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.499140646250453e-05,
        0.9999061822891235,
        0.013698036782443523
      ],
      "plane_d": 2298.847900390625,
      "bbox_min": [
        -315.4239501953125,
        -2308.53955078125,
        683.786865234375
      ],
      "bbox_max": [
        -313.3061218261719,
        -2308.423095703125,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805760979652405,
        -0.0,
        -0.1961391568183899
      ],
      "plane_d": -166.4639129638672,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -304.5352783203125,
        -2297.0,
        690.7669677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999061822891235,
        0.0,
        0.013698102906346321
      ],
      "plane_d": -315.87322998046875,
      "bbox_min": [
        -306.535400390625,
        -2301.604248046875,
        683.786865234375
      ],
      "bbox_max": [
        -306.4397888183594,
        -2297.0,
        690.7669677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016004294157028198,
        0.9998713135719299,
        0.001079715322703123
      ],
      "plane_d": 2304.396484375,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -312.525634765625,
        -2308.4228515625,
        683.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.964599609375,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -312.530029296875,
        -2310.41259765625,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01955101452767849,
        0.9998088479042053,
        0.0
      ],
      "plane_d": 2303.860595703125,
      "bbox_min": [
        -314.964599609375,
        -2310.460205078125,
        664.0
      ],
      "bbox_max": [
        -312.530029296875,
        -2310.41259765625,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 672.0,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        672.0
      ],
      "bbox_max": [
        -314.964599609375,
        -2310.460205078125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.4826093067531474e-05,
        0.9805810451507568,
        -0.19611415266990662
      ],
      "plane_d": 2397.7041015625,
      "bbox_min": [
        -318.5,
        -2310.516845703125,
        672.0
      ],
      "bbox_max": [
        -312.525634765625,
        -2308.4228515625,
        683.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9997844099998474,
        -0.02076338790357113
      ],
      "plane_d": 2323.9150390625,
      "bbox_min": [
        -318.5,
        -2310.516845703125,
        672.0
      ],
      "bbox_max": [
        -312.525634765625,
        -2310.423095703125,
        673.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 672.0,
      "bbox_min": [
        -318.5,
        -2310.516845703125,
        672.0
      ],
      "bbox_max": [
        -314.964599609375,
        -2310.460205078125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1412.5638427734375,
      "bbox_min": [
        -312.59326171875,
        -2310.26025390625,
        684.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2302.365234375,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 304.6982421875,
      "bbox_min": [
        -306.69830322265625,
        -2304.365234375,
        684.0
      ],
      "bbox_max": [
        -296.5048522949219,
        -2297.0,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1412.5638427734375,
      "bbox_min": [
        -306.69830322265625,
        -2304.365234375,
        684.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2302.365234375,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -304.68994140625,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -296.5048828125,
        -2297.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2298.5,
      "bbox_min": [
        -304.68994140625,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -298.0047302246094,
        -2298.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2298.5,
      "bbox_min": [
        -298.0047607421875,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -294.69842529296875,
        -2297.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -298.0047302246094,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -294.69842529296875,
        -2297.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -298.0047302246094,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -294.6984558105469,
        -2297.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1866526367375627e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2310.26708984375,
      "bbox_min": [
        -318.5,
        -2320.260009765625,
        684.0
      ],
      "bbox_max": [
        -310.5927429199219,
        -2308.259765625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        -318.5,
        -2320.260009765625,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2310.260009765625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -318.5,
        -2320.260009765625,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2310.260009765625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -318.5,
        -2320.260009765625,
        690.0
      ],
      "bbox_max": [
        -317.0,
        -2310.260009765625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        -318.5,
        -2339.0,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2320.260009765625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -318.5,
        -2339.0,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2320.260009765625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -318.5,
        -2339.0,
        690.0
      ],
      "bbox_max": [
        -317.0,
        -2320.260009765625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        0.3826833665370941,
        -9.773058309292537e-07
      ],
      "plane_d": 1231.606689453125,
      "bbox_min": [
        -376.84716796875,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -341.6533203125,
        -2273.3037109375,
        712.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9238680601119995,
        -0.38271114230155945,
        -0.0
      ],
      "plane_d": -1235.666259765625,
      "bbox_min": [
        -376.84716796875,
        -2335.287353515625,
        637.0
      ],
      "bbox_max": [
        -368.92333984375,
        -2311.052490234375,
        654.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -376.84716796875,
        -2328.06494140625,
        638.002197265625
      ],
      "bbox_max": [
        -368.92333984375,
        -2311.052490234375,
        652.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -376.84716796875,
        -2328.06494140625,
        638.002197265625
      ],
      "bbox_max": [
        -368.92333984375,
        -2311.052490234375,
        652.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238551259040833,
        0.382742315530777,
        0.0
      ],
      "plane_d": 1232.733154296875,
      "bbox_min": [
        -376.84716796875,
        -2328.06494140625,
        638.002197265625
      ],
      "bbox_max": [
        -368.92333984375,
        -2311.052490234375,
        652.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38267284631729126,
        0.9238839149475098,
        0.0
      ],
      "plane_d": 2006.3314208984375,
      "bbox_min": [
        -376.84716796875,
        -2326.44140625,
        638.002197265625
      ],
      "bbox_max": [
        -370.995361328125,
        -2314.206787109375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38271352648735046,
        -0.9238670468330383,
        0.0
      ],
      "plane_d": -1994.2769775390625,
      "bbox_min": [
        -376.84716796875,
        -2314.728759765625,
        638.002197265625
      ],
      "bbox_max": [
        -375.58740234375,
        -2314.206787109375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3828117847442627,
        -0.9238263368606567,
        0.0
      ],
      "plane_d": -1991.14599609375,
      "bbox_min": [
        -376.735595703125,
        -2328.06494140625,
        638.002197265625
      ],
      "bbox_max": [
        -368.92333984375,
        -2311.052490234375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38260337710380554,
        0.9239127039909363,
        0.0
      ],
      "plane_d": 2009.4239501953125,
      "bbox_min": [
        -369.84716796875,
        -2328.06494140625,
        638.002197265625
      ],
      "bbox_max": [
        -368.92333984375,
        -2327.682373046875,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38177749514579773,
        0.9242542386054993,
        0.0
      ],
      "plane_d": 2014.5274658203125,
      "bbox_min": [
        -376.84716796875,
        -2335.287353515625,
        637.0
      ],
      "bbox_max": [
        -371.087890625,
        -2319.005126953125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.5,
      "bbox_min": [
        -376.84716796875,
        -2335.287353515625,
        652.0
      ],
      "bbox_max": [
        -371.087890625,
        -2319.005126953125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29812341928482056,
        0.7217341065406799,
        -0.6246777772903442
      ],
      "plane_d": 1980.3995361328125,
      "bbox_min": [
        -376.84716796875,
        -2335.287353515625,
        652.0
      ],
      "bbox_max": [
        -371.087890625,
        -2331.060791015625,
        654.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -3.082740931859007e-06
      ],
      "plane_d": 1907.825439453125,
      "bbox_min": [
        -376.84716796875,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -341.6533203125,
        -2273.3037109375,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -526.3244018554688,
      "bbox_min": [
        -376.84716796875,
        -2300.5,
        637.0
      ],
      "bbox_max": [
        -341.6533203125,
        -2273.3037109375,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.19509564340114594,
        0.9807842373847961,
        0.0
      ],
      "plane_d": 2312.093505859375,
      "bbox_min": [
        -376.84716796875,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -371.94366455078125,
        -2273.3037109375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -376.84716796875,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -371.94366455078125,
        -2273.3037109375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -376.84716796875,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -371.94366455078125,
        -2273.3037109375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9219129085540771,
        0.38739722967147827,
        0.0
      ],
      "plane_d": 537.717529296875,
      "bbox_min": [
        -376.5,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -371.94366455078125,
        -2273.3037109375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -375.150390625,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -371.94366455078125,
        -2273.3037109375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -375.150390625,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -371.94366455078125,
        -2273.3037109375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38266947865486145,
        0.9238852858543396,
        -0.0
      ],
      "plane_d": 2250.751220703125,
      "bbox_min": [
        -375.150390625,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -375.0616760253906,
        -2280.794677734375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7841436862945557,
        0.6205793023109436,
        0.0
      ],
      "plane_d": 1121.2421875,
      "bbox_min": [
        -376.5,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -375.150390625,
        -2280.794677734375,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2296.0,
      "bbox_min": [
        -376.84716796875,
        -2300.5,
        644.0
      ],
      "bbox_max": [
        -341.6533203125,
        -2273.3037109375,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -376.840087890625,
        -2300.5,
        670.5
      ],
      "bbox_max": [
        -341.6533203125,
        -2296.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -376.840087890625,
        -2300.5,
        687.5
      ],
      "bbox_max": [
        -341.6533203125,
        -2296.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2298.5,
      "bbox_min": [
        -376.840087890625,
        -2300.5,
        687.5
      ],
      "bbox_max": [
        -341.65338134765625,
        -2298.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47552189230918884,
        -0.8797038793563843,
        0.0
      ],
      "plane_d": -1844.5631103515625,
      "bbox_min": [
        -376.840087890625,
        -2300.5,
        687.5
      ],
      "bbox_max": [
        -373.14013671875,
        -2298.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47552192211151123,
        -0.0,
        0.8797038793563843
      ],
      "plane_d": -429.5593566894531,
      "bbox_min": [
        -376.840087890625,
        -2300.5,
        690.0
      ],
      "bbox_max": [
        -373.14013671875,
        -2296.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47552192211151123,
        0.8797038793563843,
        0.0
      ],
      "plane_d": 2197.236328125,
      "bbox_min": [
        -376.84716796875,
        -2296.0,
        644.0
      ],
      "bbox_max": [
        -366.6358947753906,
        -2273.3037109375,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9771250486373901,
        0.0,
        -0.2126655876636505
      ],
      "plane_d": 510.8121643066406,
      "bbox_min": [
        -376.840087890625,
        -2296.0,
        670.5
      ],
      "bbox_max": [
        -373.14013671875,
        -2294.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4821348190307617,
        -0.19970673322677612,
        -0.8530318140983582
      ],
      "plane_d": 274.6854248046875,
      "bbox_min": [
        -376.84716796875,
        -2286.1171875,
        644.0
      ],
      "bbox_max": [
        -366.6358947753906,
        -2273.3037109375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -660.0,
      "bbox_min": [
        -376.84716796875,
        -2286.1171875,
        647.0
      ],
      "bbox_max": [
        -366.6358947753906,
        -2273.3037109375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238790273666382,
        -0.38268470764160156,
        0.0
      ],
      "plane_d": -531.2314453125,
      "bbox_min": [
        -375.0616760253906,
        -2286.1171875,
        647.0
      ],
      "bbox_max": [
        -366.6358947753906,
        -2273.3037109375,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -375.0616760253906,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -366.6358947753906,
        -2273.3037109375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -375.0616760253906,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -366.6358947753906,
        -2273.3037109375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38266947865486145,
        0.9238852858543396,
        -0.0
      ],
      "plane_d": 2250.751220703125,
      "bbox_min": [
        -375.0616760253906,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -370.531005859375,
        -2280.831298828125,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        0.3826833665370941,
        0.0
      ],
      "plane_d": 644.0186157226562,
      "bbox_min": [
        -294.698486328125,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2273.306396484375,
        712.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -267.07666015625,
        -2328.595703125,
        638.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2311.052490234375,
        653.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -267.07666015625,
        -2328.595703125,
        638.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2311.052490234375,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        -262.233154296875,
        -2328.595703125,
        652.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2319.005126953125,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238755106925964,
        -0.38269320130348206,
        0.0
      ],
      "plane_d": -648.0425415039062,
      "bbox_min": [
        -262.233154296875,
        -2328.595703125,
        652.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2319.005126953125,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5731114149093628,
        0.8194774389266968,
        -0.0
      ],
      "plane_d": 2056.755126953125,
      "bbox_min": [
        -262.233154296875,
        -2328.595703125,
        652.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2326.44140625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238551259040833,
        0.382742315530777,
        0.0
      ],
      "plane_d": 645.1622924804688,
      "bbox_min": [
        -267.07666015625,
        -2328.06494140625,
        638.0
      ],
      "bbox_max": [
        -262.233154296875,
        -2325.29345703125,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267284631729126,
        0.9238839149475098,
        -0.0
      ],
      "plane_d": 2249.711181640625,
      "bbox_min": [
        -265.004638671875,
        -2326.44140625,
        638.0
      ],
      "bbox_max": [
        -262.233154296875,
        -2325.29345703125,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38260337710380554,
        0.9239127039909363,
        0.0
      ],
      "plane_d": 2252.759765625,
      "bbox_min": [
        -267.07666015625,
        -2328.06494140625,
        638.002197265625
      ],
      "bbox_max": [
        -266.15283203125,
        -2327.682373046875,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238551259040833,
        0.382742315530777,
        0.0
      ],
      "plane_d": 645.161376953125,
      "bbox_min": [
        -260.41259765625,
        -2314.728759765625,
        638.001220703125
      ],
      "bbox_max": [
        -259.15283203125,
        -2311.052490234375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38271352648735046,
        -0.9238670468330383,
        -0.0
      ],
      "plane_d": -2237.682861328125,
      "bbox_min": [
        -260.41259765625,
        -2314.728759765625,
        638.001220703125
      ],
      "bbox_max": [
        -259.15283203125,
        -2314.206787109375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3828117847442627,
        -0.9238263368606567,
        -0.0
      ],
      "plane_d": -2234.6142578125,
      "bbox_min": [
        -260.188232421875,
        -2311.435302734375,
        638.002197265625
      ],
      "bbox_max": [
        -259.264404296875,
        -2311.052490234375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1458.1033935546875,
      "bbox_min": [
        -294.698486328125,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2273.306396484375,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -1113.9117431640625,
      "bbox_min": [
        -294.698486328125,
        -2300.5,
        637.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2273.306396484375,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.19509564340114594,
        0.9807842373847961,
        0.0
      ],
      "plane_d": 2188.0126953125,
      "bbox_min": [
        -264.0550231933594,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2273.306640625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -264.0550231933594,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2273.306640625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -264.0550231933594,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2273.306640625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9219129085540771,
        0.38739722967147827,
        -0.0
      ],
      "plane_d": 1124.05419921875,
      "bbox_min": [
        -264.0550231933594,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -259.5,
        -2273.306640625,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -264.0550231933594,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -260.849609375,
        -2273.306640625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -264.0550231933594,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -260.849609375,
        -2273.306640625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38266947865486145,
        0.9238852858543396,
        0.0
      ],
      "plane_d": 2007.3734130859375,
      "bbox_min": [
        -260.9382629394531,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -260.849609375,
        -2280.794677734375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7841436862945557,
        0.6205793023109436,
        0.0
      ],
      "plane_d": 1619.95751953125,
      "bbox_min": [
        -260.849609375,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -259.5,
        -2280.794677734375,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -294.698486328125,
        -2300.5,
        644.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2273.306396484375,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2298.5,
      "bbox_min": [
        -294.698486328125,
        -2300.5,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2294.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -294.6984558105469,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2294.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2296.0,
      "bbox_min": [
        -294.69842529296875,
        -2296.0,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2294.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47552189230918884,
        0.8797038793563843,
        0.0
      ],
      "plane_d": 1894.8092041015625,
      "bbox_min": [
        -262.849853515625,
        -2296.0,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2294.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47552192211151123,
        0.0,
        0.8797038793563843
      ],
      "plane_d": -731.986572265625,
      "bbox_min": [
        -262.849853515625,
        -2298.5,
        690.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2294.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9771250486373901,
        0.0,
        -0.2126655876636505
      ],
      "plane_d": -110.62958526611328,
      "bbox_min": [
        -269.3631286621094,
        -2300.5,
        644.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2273.306396484375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47552192211151123,
        -0.8797038793563843,
        -0.0
      ],
      "plane_d": -2146.990234375,
      "bbox_min": [
        -262.849853515625,
        -2300.5,
        670.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2294.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4821368455886841,
        -0.19970838725566864,
        -0.853030264377594
      ],
      "plane_d": -31.957632064819336,
      "bbox_min": [
        -269.3631286621094,
        -2286.1171875,
        644.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2273.306396484375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -660.0,
      "bbox_min": [
        -269.3631286621094,
        -2286.1171875,
        647.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2273.306396484375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        -0.3826741576194763,
        8.165456529241055e-05
      ],
      "plane_d": -1118.849365234375,
      "bbox_min": [
        -269.3631286621094,
        -2286.1171875,
        647.0
      ],
      "bbox_max": [
        -260.9382629394531,
        -2273.306396484375,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -269.3631286621094,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -260.9382629394531,
        -2273.306396484375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -269.3631286621094,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -260.9382629394531,
        -2273.306396484375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38266947865486145,
        0.9238852858543396,
        0.0
      ],
      "plane_d": 2007.3734130859375,
      "bbox_min": [
        -265.468994140625,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -260.9382629394531,
        -2280.831298828125,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826833665370941,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": -1941.4697265625,
      "bbox_min": [
        -376.84716796875,
        -2273.306640625,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -376.84716796875,
        -2257.52685546875,
        637.0
      ],
      "bbox_max": [
        -353.4643249511719,
        -2238.0,
        660.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.5706624388694763,
        -0.8211847543716431,
        -0.0
      ],
      "plane_d": -2048.251953125,
      "bbox_min": [
        -361.6766052246094,
        -2242.9482421875,
        637.0
      ],
      "bbox_max": [
        -361.64453125,
        -2242.926025390625,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555604696273804,
        -0.8314761519432068,
        -0.0
      ],
      "plane_d": -2061.706298828125,
      "bbox_min": [
        -366.8457946777344,
        -2241.943603515625,
        645.0
      ],
      "bbox_max": [
        -358.822265625,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4252527952194214,
        -0.6364531517028809,
        -0.6434962749481201
      ],
      "plane_d": -1156.64208984375,
      "bbox_min": [
        -366.8457946777344,
        -2241.943603515625,
        655.0
      ],
      "bbox_max": [
        -358.822265625,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555597543716431,
        -0.831476628780365,
        -0.0
      ],
      "plane_d": -2064.6494140625,
      "bbox_min": [
        -366.8457946777344,
        -2241.943603515625,
        655.0
      ],
      "bbox_max": [
        -358.822265625,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1330.06787109375,
      "bbox_min": [
        -360.943603515625,
        -2241.943603515625,
        655.0
      ],
      "bbox_max": [
        -358.822265625,
        -2239.822265625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826833665370941,
        -0.9238795638084412,
        -0.0
      ],
      "plane_d": -2184.8564453125,
      "bbox_min": [
        -376.84716796875,
        -2273.306640625,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -282.5357971191406,
        -2257.52685546875,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        660.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.5706624388694763,
        -0.8211847543716431,
        0.0
      ],
      "plane_d": -1685.310546875,
      "bbox_min": [
        -274.35546875,
        -2242.9482421875,
        637.0
      ],
      "bbox_max": [
        -274.32330322265625,
        -2242.92578125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555604696273804,
        -0.8314761519432068,
        0.0
      ],
      "plane_d": -1708.3697509765625,
      "bbox_min": [
        -277.177734375,
        -2241.943603515625,
        645.0
      ],
      "bbox_max": [
        -269.1542053222656,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4252528250217438,
        -0.6364519596099854,
        -0.6434974074363708
      ],
      "plane_d": -886.1778564453125,
      "bbox_min": [
        -277.177734375,
        -2241.943603515625,
        655.0
      ],
      "bbox_max": [
        -269.1542053222656,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555597543716431,
        -0.831476628780365,
        0.0
      ],
      "plane_d": -1711.3134765625,
      "bbox_min": [
        -277.177734375,
        -2241.943603515625,
        655.0
      ],
      "bbox_max": [
        -269.1542053222656,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1779.7877197265625,
      "bbox_min": [
        -277.177734375,
        -2241.943603515625,
        655.0
      ],
      "bbox_max": [
        -275.056396484375,
        -2239.822265625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1340.4090576171875,
      "bbox_min": [
        -376.84716796875,
        -2273.306640625,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -376.84716796875,
        -2272.471923828125,
        637.0
      ],
      "bbox_max": [
        -353.403076171875,
        -2247.841064453125,
        660.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -376.84716796875,
        -2272.471923828125,
        637.0
      ],
      "bbox_max": [
        -353.403076171875,
        -2247.841064453125,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7360445261001587,
        0.6769331097602844,
        0.0
      ],
      "plane_d": 1252.1007080078125,
      "bbox_min": [
        -376.84716796875,
        -2260.359375,
        637.0
      ],
      "bbox_max": [
        -374.0327453613281,
        -2256.361083984375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9100080132484436,
        0.41459059715270996,
        0.0
      ],
      "plane_d": 594.1898803710938,
      "bbox_min": [
        -376.84716796875,
        -2260.359375,
        637.0
      ],
      "bbox_max": [
        -376.0,
        -2258.5,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.710696816444397,
        0.7034984827041626,
        0.0
      ],
      "plane_d": 1330.9207763671875,
      "bbox_min": [
        -367.888427734375,
        -2263.512939453125,
        645.0
      ],
      "bbox_max": [
        -353.403076171875,
        -2247.841064453125,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -367.888427734375,
        -2263.512939453125,
        649.0
      ],
      "bbox_max": [
        -354.5302734375,
        -2250.0869140625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -367.888427734375,
        -2263.512939453125,
        649.0
      ],
      "bbox_max": [
        -354.5302734375,
        -2250.0869140625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1841.7906494140625,
      "bbox_min": [
        -354.598388671875,
        -2250.155029296875,
        649.0
      ],
      "bbox_max": [
        -354.5302734375,
        -2250.0869140625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314761519432068,
        -0.5555604696273804,
        -0.0
      ],
      "plane_d": -1542.7088623046875,
      "bbox_min": [
        -354.598388671875,
        -2250.0869140625,
        645.0
      ],
      "bbox_max": [
        -353.403076171875,
        -2247.841064453125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8743956089019775,
        0.4852137267589569,
        0.0
      ],
      "plane_d": 781.7138061523438,
      "bbox_min": [
        -354.598388671875,
        -2250.0869140625,
        645.0
      ],
      "bbox_max": [
        -353.403076171875,
        -2247.932861328125,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1790.1290283203125,
      "bbox_min": [
        -376.84716796875,
        -2273.306640625,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -282.596923828125,
        -2272.471923828125,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2247.84130859375,
        660.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -282.596923828125,
        -2272.471923828125,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2247.84130859375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7360445261001587,
        0.6769331097602844,
        -0.0
      ],
      "plane_d": 1720.2249755859375,
      "bbox_min": [
        -261.96685791015625,
        -2260.359375,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2256.361328125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9100080132484436,
        0.41459059715270996,
        -0.0
      ],
      "plane_d": 1172.9549560546875,
      "bbox_min": [
        -260.0,
        -2260.359375,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2258.5,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.710696816444397,
        0.7034984827041626,
        0.0
      ],
      "plane_d": 1782.9239501953125,
      "bbox_min": [
        -282.596923828125,
        -2263.512939453125,
        645.0
      ],
      "bbox_max": [
        -268.111572265625,
        -2247.84130859375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -281.46978759765625,
        -2263.512939453125,
        649.0
      ],
      "bbox_max": [
        -268.111572265625,
        -2250.0869140625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -281.46978759765625,
        -2263.512939453125,
        649.0
      ],
      "bbox_max": [
        -268.111572265625,
        -2250.0869140625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1392.0706787109375,
      "bbox_min": [
        -281.46978759765625,
        -2250.155029296875,
        649.0
      ],
      "bbox_max": [
        -281.401611328125,
        -2250.0869140625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314761519432068,
        -0.5555604696273804,
        0.0
      ],
      "plane_d": -1013.8900146484375,
      "bbox_min": [
        -282.596923828125,
        -2250.0869140625,
        645.0
      ],
      "bbox_max": [
        -281.401611328125,
        -2247.84130859375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8743956089019775,
        0.4852137267589569,
        -0.0
      ],
      "plane_d": 1337.829345703125,
      "bbox_min": [
        -282.596923828125,
        -2250.0869140625,
        645.0
      ],
      "bbox_max": [
        -281.401611328125,
        -2247.932861328125,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -1113.9117431640625,
      "bbox_min": [
        -376.84716796875,
        -2273.306640625,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -268.11181640625,
        -2273.306640625,
        645.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2263.512939453125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -268.11181640625,
        -2273.306640625,
        645.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2263.512939453125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9219129085540771,
        0.38739722967147827,
        -0.0
      ],
      "plane_d": 1124.05419921875,
      "bbox_min": [
        -268.11181640625,
        -2273.306640625,
        645.0
      ],
      "bbox_max": [
        -263.9962158203125,
        -2263.512939453125,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -268.111572265625,
        -2273.306640625,
        649.0
      ],
      "bbox_max": [
        -263.9962158203125,
        -2263.512939453125,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -268.111572265625,
        -2273.306640625,
        649.0
      ],
      "bbox_max": [
        -263.9962158203125,
        -2263.512939453125,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -526.3244018554688,
      "bbox_min": [
        -376.84716796875,
        -2273.306640625,
        637.0
      ],
      "bbox_max": [
        -264.0550231933594,
        -2238.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -376.84716796875,
        -2273.3037109375,
        645.0
      ],
      "bbox_max": [
        -367.88818359375,
        -2263.512939453125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -376.84716796875,
        -2273.3037109375,
        645.0
      ],
      "bbox_max": [
        -367.88818359375,
        -2263.512939453125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9219129085540771,
        0.38739722967147827,
        0.0
      ],
      "plane_d": 537.717529296875,
      "bbox_min": [
        -372.0026550292969,
        -2273.3037109375,
        645.0
      ],
      "bbox_max": [
        -367.88818359375,
        -2263.512939453125,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -372.0026550292969,
        -2273.3037109375,
        649.0
      ],
      "bbox_max": [
        -367.888427734375,
        -2263.512939453125,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -372.0026550292969,
        -2273.3037109375,
        649.0
      ],
      "bbox_max": [
        -367.888427734375,
        -2263.512939453125,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -319.5,
      "bbox_min": [
        -371.9436950683594,
        -2273.306640625,
        644.0
      ],
      "bbox_max": [
        -264.0550231933594,
        -2238.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -319.5,
        -2273.306640625,
        644.0
      ],
      "bbox_max": [
        -264.0550231933594,
        -2238.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        -319.5,
        -2273.30517578125,
        687.5
      ],
      "bbox_max": [
        -315.0,
        -2238.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -319.5,
        -2273.30517578125,
        690.0
      ],
      "bbox_max": [
        -317.0,
        -2238.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.47552192211151123,
        0.8797038793563843
      ],
      "plane_d": -1672.97314453125,
      "bbox_min": [
        -319.5,
        -2241.699951171875,
        690.0
      ],
      "bbox_max": [
        -317.0,
        -2238.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8797038793563843,
        -0.47552192211151123,
        0.0
      ],
      "plane_d": -787.111328125,
      "bbox_min": [
        -317.0,
        -2241.699951171875,
        687.5
      ],
      "bbox_max": [
        -315.0,
        -2238.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3690088987350464,
        -0.3690088987350464,
        -0.8530327677726746
      ],
      "plane_d": -384.8389587402344,
      "bbox_min": [
        -287.443603515625,
        -2273.306640625,
        644.0
      ],
      "bbox_max": [
        -264.0550231933594,
        -2246.958984375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1795.0328369140625,
      "bbox_min": [
        -287.443603515625,
        -2273.306640625,
        644.0
      ],
      "bbox_max": [
        -264.0550231933594,
        -2246.958984375,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -287.443603515625,
        -2273.306640625,
        644.0
      ],
      "bbox_max": [
        -264.0550231933594,
        -2246.958984375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314638733863831,
        0.5555787682533264,
        0.0
      ],
      "plane_d": 1011.6734008789062,
      "bbox_min": [
        -287.443603515625,
        -2251.1162109375,
        657.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2246.958984375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -287.443603515625,
        -2273.306640625,
        644.0
      ],
      "bbox_max": [
        -264.0550231933594,
        -2246.958984375,
        657.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314638733863831,
        0.5555787682533264,
        0.0
      ],
      "plane_d": 1011.6734008789062,
      "bbox_min": [
        -287.443603515625,
        -2251.1162109375,
        644.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2246.958984375,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314638733863831,
        0.5555787682533264,
        0.0
      ],
      "plane_d": 1011.6734008789062,
      "bbox_min": [
        -287.443603515625,
        -2253.62255859375,
        649.0
      ],
      "bbox_max": [
        -281.46978759765625,
        -2246.958984375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1392.0706787109375,
      "bbox_min": [
        -284.937255859375,
        -2253.62255859375,
        649.0
      ],
      "bbox_max": [
        -281.46978759765625,
        -2250.155029296875,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -272.26904296875,
        -2273.306640625,
        647.0
      ],
      "bbox_max": [
        -265.2532958984375,
        -2266.290771484375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        -0.3826741576194763,
        8.165456529241055e-05
      ],
      "plane_d": -1118.849365234375,
      "bbox_min": [
        -272.26904296875,
        -2273.306396484375,
        657.0
      ],
      "bbox_max": [
        -269.363037109375,
        -2266.290771484375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -272.26904296875,
        -2273.306640625,
        647.0
      ],
      "bbox_max": [
        -265.2532958984375,
        -2266.290771484375,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238790273666382,
        -0.38268470764160156,
        -0.00010143048712052405
      ],
      "plane_d": -1118.7528076171875,
      "bbox_min": [
        -272.26904296875,
        -2273.306396484375,
        647.0
      ],
      "bbox_max": [
        -269.3631286621094,
        -2266.290771484375,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4821368455886841,
        -0.19970838725566864,
        -0.853030264377594
      ],
      "plane_d": -31.957632064819336,
      "bbox_min": [
        -272.26904296875,
        -2273.306396484375,
        644.0
      ],
      "bbox_max": [
        -264.05517578125,
        -2263.512939453125,
        648.7777709960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238790273666382,
        -0.38268470764160156,
        -0.00010143048712052405
      ],
      "plane_d": -1118.7528076171875,
      "bbox_min": [
        -272.26904296875,
        -2273.306396484375,
        647.0
      ],
      "bbox_max": [
        -269.363037109375,
        -2266.290771484375,
        648.7777709960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9771250486373901,
        -0.2126655876636505
      ],
      "plane_d": -2044.213623046875,
      "bbox_min": [
        -319.5,
        -2241.699951171875,
        670.5
      ],
      "bbox_max": [
        -315.0,
        -2238.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8797038793563843,
        -0.47552192211151123,
        0.0
      ],
      "plane_d": -787.111328125,
      "bbox_min": [
        -317.0,
        -2241.699951171875,
        670.5
      ],
      "bbox_max": [
        -315.0,
        -2238.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -660.0,
      "bbox_min": [
        -371.9436950683594,
        -2273.30419921875,
        644.0
      ],
      "bbox_max": [
        -319.5,
        -2238.0,
        692.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3690088987350464,
        -0.3690088987350464,
        -0.8530327677726746
      ],
      "plane_d": -150.14930725097656,
      "bbox_min": [
        -371.9436950683594,
        -2273.30419921875,
        644.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1345.3128662109375,
      "bbox_min": [
        -371.94366455078125,
        -2273.30419921875,
        644.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -371.94366455078125,
        -2273.3037109375,
        644.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8314638733863831,
        0.5555788278579712,
        0.0
      ],
      "plane_d": 1540.4844970703125,
      "bbox_min": [
        -351.334228515625,
        -2251.1162109375,
        657.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -371.94366455078125,
        -2273.3037109375,
        644.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        657.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8314638733863831,
        0.5555788278579712,
        0.0
      ],
      "plane_d": 1540.4844970703125,
      "bbox_min": [
        -351.334228515625,
        -2251.1162109375,
        644.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314638733863831,
        0.5555788278579712,
        0.0
      ],
      "plane_d": 1540.4844970703125,
      "bbox_min": [
        -354.5302734375,
        -2253.62255859375,
        649.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1841.7906494140625,
      "bbox_min": [
        -354.5302734375,
        -2253.62255859375,
        649.0
      ],
      "bbox_max": [
        -351.062744140625,
        -2250.155029296875,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -370.7439880371094,
        -2273.30419921875,
        647.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2266.290771484375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238790273666382,
        -0.38268470764160156,
        0.0
      ],
      "plane_d": -531.2314453125,
      "bbox_min": [
        -366.635986328125,
        -2273.30419921875,
        657.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2266.290771484375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -370.7439880371094,
        -2273.30419921875,
        647.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2266.290771484375,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        -0.3826741576194763,
        0.0
      ],
      "plane_d": -531.2059326171875,
      "bbox_min": [
        -366.6358947753906,
        -2273.30419921875,
        647.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2266.290771484375,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4821348190307617,
        -0.19970673322677612,
        -0.8530318140983582
      ],
      "plane_d": 274.6854248046875,
      "bbox_min": [
        -371.9436950683594,
        -2273.30419921875,
        644.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2263.512939453125,
        648.77734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        -0.3826741576194763,
        0.0
      ],
      "plane_d": -531.2059326171875,
      "bbox_min": [
        -366.635986328125,
        -2273.30419921875,
        647.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2266.290771484375,
        648.77734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8797038793563843,
        -0.47552189230918884,
        0.0
      ],
      "plane_d": -1347.0428466796875,
      "bbox_min": [
        -321.5,
        -2241.699951171875,
        670.5
      ],
      "bbox_max": [
        -319.5,
        -2238.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9771250486373901,
        -0.2126655876636505
      ],
      "plane_d": -2044.213623046875,
      "bbox_min": [
        -321.5,
        -2241.699951171875,
        670.5
      ],
      "bbox_max": [
        -319.5,
        -2238.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -401.5,
        -2268.0,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2238.0,
        660.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.9807842373847961,
        0.19509564340114594,
        0.0
      ],
      "plane_d": 834.2132568359375,
      "bbox_min": [
        -401.5,
        -2268.0,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555562973022461,
        -0.8314789533615112,
        0.0
      ],
      "plane_d": -1663.02001953125,
      "bbox_min": [
        -400.99310302734375,
        -2268.0,
        637.0
      ],
      "bbox_max": [
        -399.4113464355469,
        -2267.067138671875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5879369974136353,
        0.3928370177745819,
        -0.7071132659912109
      ],
      "plane_d": 1581.26025390625,
      "bbox_min": [
        -400.99310302734375,
        -2268.0,
        642.8208618164062
      ],
      "bbox_max": [
        -399.4113464355469,
        -2267.067138671875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555604696273804,
        -0.8314761519432068,
        0.0
      ],
      "plane_d": -1643.3692626953125,
      "bbox_min": [
        -401.5,
        -2268.0,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5879369974136353,
        0.3928370177745819,
        -0.7071132659912109
      ],
      "plane_d": 1581.26025390625,
      "bbox_min": [
        -399.596923828125,
        -2268.0,
        644.1360473632812
      ],
      "bbox_max": [
        -398.9736328125,
        -2267.067138671875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9100080132484436,
        0.41459059715270996,
        0.0
      ],
      "plane_d": 594.1898803710938,
      "bbox_min": [
        -401.5,
        -2268.0,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2247.932861328125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -380.328125,
        -2268.0,
        645.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2260.359375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38264405727386475,
        -0.9238958358764648,
        0.0
      ],
      "plane_d": -1941.6304931640625,
      "bbox_min": [
        -401.5,
        -2267.067138671875,
        640.0
      ],
      "bbox_max": [
        -396.8251953125,
        -2247.932861328125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7507328987121582,
        -0.14934109151363373,
        -0.6435039639472961
      ],
      "plane_d": 376.1243591308594,
      "bbox_min": [
        -401.5,
        -2267.067138671875,
        640.0
      ],
      "bbox_max": [
        -396.8251953125,
        -2247.932861328125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807825088500977,
        -0.1951041966676712,
        0.0
      ],
      "plane_d": -49.60589599609375,
      "bbox_min": [
        -399.596923828125,
        -2260.731689453125,
        640.0
      ],
      "bbox_max": [
        -396.8251953125,
        -2247.932861328125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38264408707618713,
        0.9238958358764648,
        0.0
      ],
      "plane_d": 2229.75927734375,
      "bbox_min": [
        -399.596923828125,
        -2249.080810546875,
        640.0
      ],
      "bbox_max": [
        -396.8251953125,
        -2247.932861328125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807825088500977,
        0.1951041966676712,
        0.0
      ],
      "plane_d": 831.28955078125,
      "bbox_min": [
        -398.5,
        -2260.731689453125,
        643.5
      ],
      "bbox_max": [
        -397.85711669921875,
        -2257.5,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807825088500977,
        0.1951041966676712,
        0.0
      ],
      "plane_d": 831.28955078125,
      "bbox_min": [
        -398.5,
        -2265.919189453125,
        643.5
      ],
      "bbox_max": [
        -396.8251953125,
        -2257.5,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 659.0,
      "bbox_min": [
        -435.0,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2268.0,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -398.9736328125,
        -2282.430908203125,
        659.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2268.0,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.19509564340114594,
        0.9807842373847961,
        0.0
      ],
      "plane_d": 2312.093505859375,
      "bbox_min": [
        -398.9736328125,
        -2282.430908203125,
        659.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2268.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555604696273804,
        0.8314761519432068,
        0.0
      ],
      "plane_d": 2110.74560546875,
      "bbox_min": [
        -420.0,
        -2288.0,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2268.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5879369974136353,
        0.3928370177745819,
        -0.7071132659912109
      ],
      "plane_d": 1581.26025390625,
      "bbox_min": [
        -403.75439453125,
        -2277.95556640625,
        637.0
      ],
      "bbox_max": [
        -394.177734375,
        -2269.31201171875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5879369974136353,
        0.3928370177745819,
        -0.7071132659912109
      ],
      "plane_d": 1581.26025390625,
      "bbox_min": [
        -402.9565734863281,
        -2275.177734375,
        637.0
      ],
      "bbox_max": [
        -394.177734375,
        -2268.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555562973022461,
        -0.8314789533615112,
        0.0
      ],
      "plane_d": -1663.02001953125,
      "bbox_min": [
        -402.9565734863281,
        -2269.31201171875,
        637.0
      ],
      "bbox_max": [
        -400.99310302734375,
        -2268.0,
        642.8208618164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9100080132484436,
        0.41459059715270996,
        0.0
      ],
      "plane_d": 594.1898803710938,
      "bbox_min": [
        -386.067138671875,
        -2282.430908203125,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2268.0,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -386.067138671875,
        -2282.430908203125,
        645.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2268.0,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2306.0,
      "bbox_min": [
        -435.0,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2288.0,
        659.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -648.0,
      "bbox_min": [
        -435.0,
        -2306.0,
        637.0
      ],
      "bbox_max": [
        -402.5,
        -2288.0,
        659.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 420.0,
      "bbox_min": [
        -420.0,
        -2293.0,
        637.0
      ],
      "bbox_max": [
        -420.0,
        -2288.0,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2304.0,
      "bbox_min": [
        -435.0,
        -2306.0,
        648.0
      ],
      "bbox_max": [
        -402.5,
        -2288.0,
        659.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -402.5,
      "bbox_min": [
        -428.0,
        -2306.0,
        648.0
      ],
      "bbox_max": [
        -402.5,
        -2304.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.5999755859375,
      "bbox_min": [
        -428.0,
        -2306.0,
        648.0
      ],
      "bbox_max": [
        -409.60009765625,
        -2304.0,
        657.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 428.0,
      "bbox_min": [
        -428.0,
        -2306.0,
        648.0
      ],
      "bbox_max": [
        -409.60009765625,
        -2304.0,
        657.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -409.60009765625,
      "bbox_min": [
        -428.0,
        -2306.0,
        648.0
      ],
      "bbox_max": [
        -409.60009765625,
        -2304.0,
        657.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": -303.4210205078125,
      "bbox_min": [
        -428.0,
        -2306.0,
        648.0
      ],
      "bbox_max": [
        -409.60009765625,
        -2304.0,
        657.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5677459239959717,
        0.0,
        0.8232038617134094
      ],
      "plane_d": -767.6312866210938,
      "bbox_min": [
        -428.0,
        -2306.0,
        648.0
      ],
      "bbox_max": [
        -409.60009765625,
        -2304.0,
        657.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47058263421058655,
        0.0,
        -0.8823559284210205
      ],
      "plane_d": 780.23486328125,
      "bbox_min": [
        -428.0,
        -2306.0,
        656.0
      ],
      "bbox_max": [
        -409.60009765625,
        -2304.0,
        657.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49615931510925293,
        0.0,
        -0.868231475353241
      ],
      "plane_d": 366.33294677734375,
      "bbox_min": [
        -412.39990234375,
        -2306.0,
        656.0
      ],
      "bbox_max": [
        -409.60009765625,
        -2304.0,
        657.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -402.5,
      "bbox_min": [
        -435.0,
        -2304.0,
        648.0
      ],
      "bbox_max": [
        -402.5,
        -2288.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 415.5,
      "bbox_min": [
        -435.0,
        -2304.0,
        648.0
      ],
      "bbox_max": [
        -402.5,
        -2288.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.0,
      "bbox_min": [
        -435.0,
        -2304.0,
        648.0
      ],
      "bbox_max": [
        -415.5,
        -2288.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 658.0,
      "bbox_min": [
        -422.0,
        -2304.0,
        658.0
      ],
      "bbox_max": [
        -415.5,
        -2288.0,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2290.0,
      "bbox_min": [
        -435.0,
        -2290.0,
        648.0
      ],
      "bbox_max": [
        -433.0,
        -2288.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 433.0,
      "bbox_min": [
        -433.0,
        -2290.0,
        648.0
      ],
      "bbox_max": [
        -433.0,
        -2288.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -404.5,
      "bbox_min": [
        -404.5,
        -2290.0,
        648.0
      ],
      "bbox_max": [
        -402.5,
        -2288.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2290.0,
      "bbox_min": [
        -404.5,
        -2290.0,
        648.0
      ],
      "bbox_max": [
        -402.5,
        -2290.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 433.0,
      "bbox_min": [
        -435.0,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2306.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": 782.1765747070312,
      "bbox_min": [
        -435.0,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -433.0,
        -2306.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2329.5,
      "bbox_min": [
        -435.0,
        -2336.5,
        657.0000610351562
      ],
      "bbox_max": [
        -433.5,
        -2319.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2335.0,
      "bbox_min": [
        -435.0,
        -2336.5,
        657.0000610351562
      ],
      "bbox_max": [
        -433.5,
        -2329.5,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2336.5,
      "bbox_min": [
        -435.0,
        -2336.5,
        657.0000610351562
      ],
      "bbox_max": [
        -433.5,
        -2335.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 433.5,
      "bbox_min": [
        -433.5,
        -2336.5,
        657.7500610351562
      ],
      "bbox_max": [
        -433.5,
        -2335.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2331.0,
      "bbox_min": [
        -435.0,
        -2331.0,
        657.0000610351562
      ],
      "bbox_max": [
        -433.5,
        -2329.5,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 433.5,
      "bbox_min": [
        -433.5,
        -2331.0,
        657.7500610351562
      ],
      "bbox_max": [
        -433.5,
        -2329.5,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2324.0,
      "bbox_min": [
        -435.0,
        -2325.5,
        657.0000610351562
      ],
      "bbox_max": [
        -433.5,
        -2319.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2325.5,
      "bbox_min": [
        -435.0,
        -2325.5,
        657.0000610351562
      ],
      "bbox_max": [
        -433.5,
        -2324.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 433.5,
      "bbox_min": [
        -433.5,
        -2325.5,
        657.7500610351562
      ],
      "bbox_max": [
        -433.5,
        -2324.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2320.5,
      "bbox_min": [
        -435.0,
        -2320.5,
        657.0000610351562
      ],
      "bbox_max": [
        -433.5,
        -2319.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2319.0,
      "bbox_min": [
        -435.0,
        -2320.5,
        657.0000610351562
      ],
      "bbox_max": [
        -433.5,
        -2319.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 433.5,
      "bbox_min": [
        -433.5,
        -2320.5,
        657.7500610351562
      ],
      "bbox_max": [
        -433.5,
        -2319.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2324.0,
      "bbox_min": [
        -435.0,
        -2336.5,
        637.0
      ],
      "bbox_max": [
        -433.0,
        -2306.0,
        657.7500610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 433.5,
      "bbox_min": [
        -435.0,
        -2336.5,
        637.0
      ],
      "bbox_max": [
        -433.5,
        -2324.0,
        657.7500610351562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2331.0,
      "bbox_min": [
        -435.0,
        -2336.5,
        637.0
      ],
      "bbox_max": [
        -433.5,
        -2325.5,
        657.7500610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2329.5,
      "bbox_min": [
        -435.0,
        -2329.5,
        637.0
      ],
      "bbox_max": [
        -433.5,
        -2325.5,
        657.7500610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2325.5,
      "bbox_min": [
        -435.0,
        -2325.5,
        637.0
      ],
      "bbox_max": [
        -433.5,
        -2325.5,
        657.7500610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2335.0,
      "bbox_min": [
        -435.0,
        -2336.5,
        637.0
      ],
      "bbox_max": [
        -433.5,
        -2335.0,
        657.7500610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2336.5,
      "bbox_min": [
        -435.0,
        -2336.5,
        637.0
      ],
      "bbox_max": [
        -433.5,
        -2336.5,
        657.7500610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2319.0,
      "bbox_min": [
        -435.0,
        -2320.5,
        637.0
      ],
      "bbox_max": [
        -433.0,
        -2306.0,
        657.7500610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 433.5,
      "bbox_min": [
        -435.0,
        -2320.5,
        637.0
      ],
      "bbox_max": [
        -433.5,
        -2319.0,
        657.7500610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2320.5,
      "bbox_min": [
        -435.0,
        -2320.5,
        637.0
      ],
      "bbox_max": [
        -433.5,
        -2320.5,
        657.7500610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -648.0,
      "bbox_min": [
        -435.0,
        -2317.0,
        637.0
      ],
      "bbox_max": [
        -433.0,
        -2306.0,
        656.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2317.0,
      "bbox_min": [
        -435.0,
        -2317.0,
        637.0
      ],
      "bbox_max": [
        -433.0,
        -2317.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18710336089134216,
        -0.9823402166366577,
        0.0
      ],
      "plane_d": -2185.851318359375,
      "bbox_min": [
        -435.0,
        -2308.0,
        649.1000366210938
      ],
      "bbox_max": [
        -433.0,
        -2306.0,
        656.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20208822190761566,
        0.0,
        -0.9793673157691956
      ],
      "plane_d": 723.61572265625,
      "bbox_min": [
        -435.0,
        -2308.0,
        649.1000366210938
      ],
      "bbox_max": [
        -433.0,
        -2306.0,
        656.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20208820700645447,
        0.0,
        0.9793673157691956
      ],
      "plane_d": -555.43798828125,
      "bbox_min": [
        -435.0,
        -2308.0,
        656.4872436523438
      ],
      "bbox_max": [
        -433.0,
        -2306.0,
        656.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 767.5643920898438,
      "bbox_min": [
        -433.0,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2306.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 658.5,
      "bbox_min": [
        -433.0,
        -2337.0,
        652.4999389648438
      ],
      "bbox_max": [
        -426.5,
        -2306.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 162.281005859375,
      "bbox_min": [
        -429.5,
        -2337.0,
        658.5
      ],
      "bbox_max": [
        -426.5,
        -2308.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2337.0,
      "bbox_min": [
        -429.5,
        -2337.0,
        658.5
      ],
      "bbox_max": [
        -426.5,
        -2308.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2308.0,
      "bbox_min": [
        -429.5,
        -2308.0,
        658.5
      ],
      "bbox_max": [
        -426.5,
        -2308.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18710336089134216,
        -0.9823402166366577,
        0.0
      ],
      "plane_d": -2185.851318359375,
      "bbox_min": [
        -433.0,
        -2307.619140625,
        652.4999389648438
      ],
      "bbox_max": [
        -429.69476318359375,
        -2306.0,
        656.4872436523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20208820700645447,
        0.0,
        0.9793673157691956
      ],
      "plane_d": -555.43798828125,
      "bbox_min": [
        -433.0,
        -2307.619140625,
        655.8052368164062
      ],
      "bbox_max": [
        -429.69476318359375,
        -2306.0,
        656.4872436523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -402.5,
      "bbox_min": [
        -433.0,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2306.0,
        659.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 654.5,
      "bbox_min": [
        -402.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2310.735595703125,
        654.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 400.5,
      "bbox_min": [
        -402.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2310.735595703125,
        654.5
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 646.5,
      "bbox_min": [
        -402.5,
        -2333.5,
        637.0
      ],
      "bbox_max": [
        -400.5,
        -2318.5,
        646.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2333.5,
      "bbox_min": [
        -402.5,
        -2333.5,
        637.0
      ],
      "bbox_max": [
        -400.5,
        -2318.5,
        646.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2318.5,
      "bbox_min": [
        -402.5,
        -2333.5,
        637.0
      ],
      "bbox_max": [
        -400.5,
        -2318.5,
        646.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 472.033935546875,
      "bbox_min": [
        -402.5,
        -2333.5,
        637.0
      ],
      "bbox_max": [
        -400.5,
        -2318.5,
        646.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": 1620.03125,
      "bbox_min": [
        -402.5,
        -2333.5,
        637.0
      ],
      "bbox_max": [
        -400.5,
        -2318.5,
        646.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.49613893032073975,
        0.8682431578636169
      ],
      "plane_d": -1705.10546875,
      "bbox_min": [
        -402.5,
        -2322.0,
        637.0
      ],
      "bbox_max": [
        -400.5,
        -2318.5,
        646.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.49613893032073975,
        -0.8682431578636169
      ],
      "plane_d": -590.7153930664062,
      "bbox_min": [
        -402.5,
        -2322.0,
        644.5
      ],
      "bbox_max": [
        -400.5,
        -2318.5,
        646.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269031047821045,
        -0.9238767027854919,
        0.0
      ],
      "plane_d": -1989.30810546875,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2310.735595703125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.000679489690810442,
        -0.9999997615814209,
        0.0
      ],
      "plane_d": -2313.071533203125,
      "bbox_min": [
        -400.5,
        -2314.800048828125,
        637.0
      ],
      "bbox_max": [
        -389.511474609375,
        -2312.800048828125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1575925201177597,
        -0.987504243850708,
        0.0
      ],
      "plane_d": -2224.256103515625,
      "bbox_min": [
        -400.5,
        -2314.800048828125,
        637.0
      ],
      "bbox_max": [
        -389.511474609375,
        -2312.800048828125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968662858009338,
        -0.07910475134849548,
        -0.0
      ],
      "plane_d": -572.8864135742188,
      "bbox_min": [
        -400.5,
        -2314.800048828125,
        637.0
      ],
      "bbox_max": [
        -391.0,
        -2312.800048828125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.781836211681366,
        -0.6234838366508484
      ],
      "plane_d": -1401.724365234375,
      "bbox_min": [
        -400.5,
        -2314.800048828125,
        652.0
      ],
      "bbox_max": [
        -391.0,
        -2312.800048828125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0005305923405103385,
        -0.7808687090873718,
        -0.6246950030326843
      ],
      "plane_d": -1398.904541015625,
      "bbox_min": [
        -400.5,
        -2314.800048828125,
        652.0
      ],
      "bbox_max": [
        -391.158203125,
        -2312.800048828125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.189622163772583,
        0.9818571209907532,
        0.0
      ],
      "plane_d": 2222.25244140625,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2310.735595703125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0009321773541159928,
        0.9999995827674866,
        0.0
      ],
      "plane_d": 2338.42578125,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2310.735595703125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238680601119995,
        -0.38271114230155945,
        0.0
      ],
      "plane_d": -1235.666015625,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2310.735595703125,
        654.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.38271352648735046,
        -0.9238670468330383,
        0.0
      ],
      "plane_d": -1994.2769775390625,
      "bbox_min": [
        -378.359130859375,
        -2319.005126953125,
        638.002197265625
      ],
      "bbox_max": [
        -376.84716796875,
        -2314.728759765625,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -378.359130859375,
        -2319.005126953125,
        638.002197265625
      ],
      "bbox_max": [
        -376.84716796875,
        -2314.728759765625,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -378.359130859375,
        -2319.005126953125,
        652.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2314.728759765625,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38177749514579773,
        0.9242542386054993,
        0.0
      ],
      "plane_d": 2014.5274658203125,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2333.12939453125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14836359024047852,
        0.7682216167449951,
        -0.6227549910545349
      ],
      "plane_d": 2144.76416015625,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        652.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2333.12939453125,
        654.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0007291665533557534,
        0.7822183966636658,
        -0.6230039000511169
      ],
      "plane_d": 2235.35888671875,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        652.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2333.12939453125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7808688282966614,
        -0.6246950626373291
      ],
      "plane_d": 2233.59716796875,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        652.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2333.12939453125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2994239926338196,
        0.7228582501411438,
        -0.6227529048919678
      ],
      "plane_d": 1981.2764892578125,
      "bbox_min": [
        -381.092041015625,
        -2336.80322265625,
        652.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2333.12939453125,
        654.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 658.0,
      "bbox_min": [
        -433.0,
        -2337.0,
        637.0
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        659.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -422.0,
      "bbox_min": [
        -422.0,
        -2337.0,
        658.0
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2327.5,
      "bbox_min": [
        -422.0,
        -2337.0,
        658.0
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 415.5,
      "bbox_min": [
        -415.5,
        -2324.5,
        658.0
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 658.5,
      "bbox_min": [
        -415.5,
        -2324.5,
        658.0
      ],
      "bbox_max": [
        -402.5,
        -2308.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 175.71603393554688,
      "bbox_min": [
        -415.5,
        -2324.5,
        658.5
      ],
      "bbox_max": [
        -402.5,
        -2308.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 754.12939453125,
      "bbox_min": [
        -410.5,
        -2324.5,
        658.5
      ],
      "bbox_max": [
        -402.5,
        -2308.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2323.0,
      "bbox_min": [
        -410.5,
        -2324.5,
        658.5
      ],
      "bbox_max": [
        -407.4999694824219,
        -2308.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2308.0,
      "bbox_min": [
        -410.5,
        -2308.0,
        658.5
      ],
      "bbox_max": [
        -407.5,
        -2308.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2324.5,
      "bbox_min": [
        -410.5,
        -2324.5,
        658.5
      ],
      "bbox_max": [
        -407.4999694824219,
        -2324.5,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2324.5,
      "bbox_min": [
        -408.00006103515625,
        -2324.5,
        658.5
      ],
      "bbox_max": [
        -402.5,
        -2324.5,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2324.5,
      "bbox_min": [
        -415.5,
        -2324.5,
        658.5
      ],
      "bbox_max": [
        -410.0000305175781,
        -2324.5,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2324.5,
      "bbox_min": [
        -415.5,
        -2324.5,
        658.0
      ],
      "bbox_max": [
        -402.5,
        -2324.5,
        658.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 658.5,
      "bbox_min": [
        -410.5,
        -2337.0,
        658.5
      ],
      "bbox_max": [
        -407.5,
        -2329.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 175.71603393554688,
      "bbox_min": [
        -410.5,
        -2337.0,
        658.5
      ],
      "bbox_max": [
        -407.5,
        -2329.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 754.12939453125,
      "bbox_min": [
        -410.5,
        -2337.0,
        658.5
      ],
      "bbox_max": [
        -407.5,
        -2329.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2329.0,
      "bbox_min": [
        -410.5,
        -2337.0,
        658.5
      ],
      "bbox_max": [
        -407.5,
        -2329.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2337.0,
      "bbox_min": [
        -410.5,
        -2337.0,
        658.5
      ],
      "bbox_max": [
        -407.5,
        -2337.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 425.0,
      "bbox_min": [
        -433.0,
        -2317.0,
        637.0
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        656.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -648.0,
      "bbox_min": [
        -433.0,
        -2317.0,
        637.0
      ],
      "bbox_max": [
        -425.0,
        -2306.0,
        655.8052368164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2317.0,
      "bbox_min": [
        -433.0,
        -2317.0,
        637.0
      ],
      "bbox_max": [
        -425.0,
        -2317.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18710336089134216,
        -0.9823402166366577,
        0.0
      ],
      "plane_d": -2185.851318359375,
      "bbox_min": [
        -433.0,
        -2307.619140625,
        649.5127563476562
      ],
      "bbox_max": [
        -428.699951171875,
        -2306.0,
        655.8052368164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20208822190761566,
        0.0,
        -0.9793673157691956
      ],
      "plane_d": 723.61572265625,
      "bbox_min": [
        -433.0,
        -2307.619140625,
        649.5127563476562
      ],
      "bbox_max": [
        -428.699951171875,
        -2306.0,
        655.8052368164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20208820700645447,
        0.0,
        0.9793673157691956
      ],
      "plane_d": -555.43798828125,
      "bbox_min": [
        -429.69476318359375,
        -2306.989501953125,
        655.5999755859375
      ],
      "bbox_max": [
        -428.699951171875,
        -2306.0,
        655.8052368164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -412.5,
      "bbox_min": [
        -425.0,
        -2317.0,
        637.0
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        656.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -648.0,
      "bbox_min": [
        -412.5,
        -2317.0,
        637.0
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        656.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2317.0,
      "bbox_min": [
        -412.5,
        -2317.0,
        637.0
      ],
      "bbox_max": [
        -402.5,
        -2317.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18710336089134216,
        -0.9823402166366577,
        0.0
      ],
      "plane_d": -2342.55029296875,
      "bbox_min": [
        -408.800048828125,
        -2308.0,
        649.1000366210938
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        656.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20208820700645447,
        -0.0,
        -0.9793673157691956
      ],
      "plane_d": 554.3668823242188,
      "bbox_min": [
        -408.800048828125,
        -2308.0,
        649.1000366210938
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        656.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20208822190761566,
        0.0,
        0.9793673157691956
      ],
      "plane_d": -724.6868896484375,
      "bbox_min": [
        -408.800048828125,
        -2308.0,
        650.4000244140625
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        656.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -408.800048828125,
      "bbox_min": [
        -408.800048828125,
        -2306.800048828125,
        650.4000244140625
      ],
      "bbox_max": [
        -408.800048828125,
        -2306.0,
        655.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -644.0,
      "bbox_min": [
        -425.0,
        -2317.0,
        637.5
      ],
      "bbox_max": [
        -412.5,
        -2306.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -425.0,
        -2317.0,
        637.5
      ],
      "bbox_max": [
        -412.5,
        -2310.0,
        644.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.0,
      "bbox_min": [
        -425.0,
        -2317.0,
        637.5
      ],
      "bbox_max": [
        -412.5,
        -2314.0,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -425.0,
        -2317.0,
        637.5
      ],
      "bbox_max": [
        -412.5,
        -2316.0,
        639.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2317.0,
      "bbox_min": [
        -425.0,
        -2317.0,
        637.5
      ],
      "bbox_max": [
        -412.5,
        -2317.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2316.0,
      "bbox_min": [
        -425.0,
        -2316.0,
        638.5
      ],
      "bbox_max": [
        -412.5,
        -2316.0,
        639.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        -425.0,
        -2315.0,
        639.5
      ],
      "bbox_max": [
        -412.5,
        -2314.0,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2315.0,
      "bbox_min": [
        -425.0,
        -2315.0,
        639.5
      ],
      "bbox_max": [
        -412.5,
        -2315.0,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2314.0,
      "bbox_min": [
        -425.0,
        -2314.0,
        640.5
      ],
      "bbox_max": [
        -412.5,
        -2314.0,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -643.0,
      "bbox_min": [
        -425.0,
        -2313.0,
        641.5
      ],
      "bbox_max": [
        -412.5,
        -2310.0,
        644.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -642.0,
      "bbox_min": [
        -425.0,
        -2313.0,
        641.5
      ],
      "bbox_max": [
        -412.5,
        -2312.0,
        643.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2313.0,
      "bbox_min": [
        -425.0,
        -2313.0,
        641.5
      ],
      "bbox_max": [
        -412.5,
        -2313.0,
        642.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2312.0,
      "bbox_min": [
        -425.0,
        -2312.0,
        642.5
      ],
      "bbox_max": [
        -412.5,
        -2312.0,
        643.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 643.5,
      "bbox_min": [
        -425.0,
        -2311.0,
        643.5
      ],
      "bbox_max": [
        -412.5,
        -2310.0,
        644.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2311.0,
      "bbox_min": [
        -425.0,
        -2311.0,
        643.5
      ],
      "bbox_max": [
        -412.5,
        -2311.0,
        644.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.0,
      "bbox_min": [
        -425.0,
        -2310.0,
        644.5
      ],
      "bbox_max": [
        -412.5,
        -2306.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -425.0,
        -2310.0,
        644.5
      ],
      "bbox_max": [
        -412.5,
        -2308.0,
        646.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 644.5,
      "bbox_min": [
        -425.0,
        -2310.0,
        644.5
      ],
      "bbox_max": [
        -412.5,
        -2309.0,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2310.0,
      "bbox_min": [
        -425.0,
        -2310.0,
        644.5
      ],
      "bbox_max": [
        -412.5,
        -2310.0,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 645.5,
      "bbox_min": [
        -425.0,
        -2309.0,
        645.5
      ],
      "bbox_max": [
        -412.5,
        -2308.0,
        646.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2309.0,
      "bbox_min": [
        -425.0,
        -2309.0,
        645.5
      ],
      "bbox_max": [
        -412.5,
        -2309.0,
        646.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 647.5,
      "bbox_min": [
        -425.0,
        -2308.0,
        646.5
      ],
      "bbox_max": [
        -412.5,
        -2306.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -648.0,
      "bbox_min": [
        -425.0,
        -2307.0,
        647.5
      ],
      "bbox_max": [
        -412.5,
        -2306.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2307.0,
      "bbox_min": [
        -425.0,
        -2307.0,
        647.5
      ],
      "bbox_max": [
        -412.5,
        -2307.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 646.5,
      "bbox_min": [
        -425.0,
        -2308.0,
        646.5
      ],
      "bbox_max": [
        -412.5,
        -2307.0,
        647.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -647.0,
      "bbox_min": [
        -425.0,
        -2308.0,
        646.5
      ],
      "bbox_max": [
        -412.5,
        -2307.0,
        647.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2308.0,
      "bbox_min": [
        -425.0,
        -2308.0,
        646.5
      ],
      "bbox_max": [
        -412.5,
        -2308.0,
        647.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -1151.221923828125,
      "bbox_min": [
        -371.0,
        -2368.5,
        637.0
      ],
      "bbox_max": [
        -265.0,
        -2355.699951171875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -563.635498046875,
      "bbox_min": [
        -371.0,
        -2368.5,
        637.0
      ],
      "bbox_max": [
        -265.0,
        -2355.699951171875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 664.5,
      "bbox_min": [
        -371.0,
        -2368.5,
        637.0
      ],
      "bbox_max": [
        -265.0,
        -2355.699951171875,
        664.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -371.0,
        -2368.5,
        637.0
      ],
      "bbox_max": [
        -265.0,
        -2355.699951171875,
        664.5
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        -0.9847835302352905,
        -0.17378532886505127
      ],
      "plane_d": -2205.851318359375,
      "bbox_min": [
        -336.302001953125,
        -2368.5,
        660.5
      ],
      "bbox_max": [
        -299.697998046875,
        -2355.699951171875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28187909722328186,
        -0.9448241591453552,
        -0.16688749194145203
      ],
      "plane_d": -2029.9031982421875,
      "bbox_min": [
        -336.302001953125,
        -2357.2001953125,
        660.5
      ],
      "bbox_max": [
        -299.697998046875,
        -2355.699951171875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3690228760242462,
        -0.9294202923774719,
        0.0
      ],
      "plane_d": -2077.7978515625,
      "bbox_min": [
        -306.300048828125,
        -2357.199951171875,
        662.3888549804688
      ],
      "bbox_max": [
        -302.52215576171875,
        -2355.699951171875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1212.1978759765625,
      "bbox_min": [
        -336.302001953125,
        -2357.2001953125,
        660.5
      ],
      "bbox_max": [
        -335.6806335449219,
        -2355.699951171875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 624.6114501953125,
      "bbox_min": [
        -300.3193664550781,
        -2357.2001953125,
        660.5
      ],
      "bbox_max": [
        -299.697998046875,
        -2355.699951171875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1212.1978759765625,
      "bbox_min": [
        -335.97308349609375,
        -2368.5,
        660.5
      ],
      "bbox_max": [
        -300.02691650390625,
        -2356.494140625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 624.6114501953125,
      "bbox_min": [
        -305.0,
        -2368.5,
        660.5
      ],
      "bbox_max": [
        -300.02691650390625,
        -2356.494140625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9847835302352905,
        -0.17378532886505127
      ],
      "plane_d": -2205.851318359375,
      "bbox_min": [
        -369.0,
        -2368.5,
        637.0
      ],
      "bbox_max": [
        -267.0,
        -2355.699951171875,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28187909722328186,
        -0.9448241591453552,
        -0.16688749194145203
      ],
      "plane_d": -2029.9031982421875,
      "bbox_min": [
        -332.36090087890625,
        -2356.494140625,
        656.0
      ],
      "bbox_max": [
        -303.64044189453125,
        -2355.699951171875,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2819654643535614,
        -0.9448255300521851,
        -0.16673390567302704
      ],
      "plane_d": -2209.31201171875,
      "bbox_min": [
        -332.36090087890625,
        -2356.494140625,
        656.0
      ],
      "bbox_max": [
        -329.699951171875,
        -2355.699951171875,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -369.0,
        -2368.5,
        637.0
      ],
      "bbox_max": [
        -267.0,
        -2355.699951171875,
        649.5
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        -0.9961298704147339,
        0.08789381384849548
      ],
      "plane_d": -2403.670166015625,
      "bbox_min": [
        -363.800048828125,
        -2368.5,
        637.0
      ],
      "bbox_max": [
        -272.199951171875,
        -2355.699951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34268662333488464,
        -0.9358057379722595,
        0.0826646089553833
      ],
      "plane_d": -2153.20166015625,
      "bbox_min": [
        -363.800048828125,
        -2356.802978515625,
        637.0
      ],
      "bbox_max": [
        -272.199951171875,
        -2355.699951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34271809458732605,
        -0.9358025193214417,
        0.08257081359624863
      ],
      "plane_d": -2371.09375,
      "bbox_min": [
        -363.800048828125,
        -2356.802978515625,
        637.0
      ],
      "bbox_max": [
        -329.699951171875,
        -2355.699951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8829648494720459,
        0.3657400906085968,
        0.2942911386489868
      ],
      "plane_d": 971.6419067382812,
      "bbox_min": [
        -363.800048828125,
        -2356.802978515625,
        637.0
      ],
      "bbox_max": [
        -336.5116882324219,
        -2355.699951171875,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3657400906085968,
        0.8829648494720459,
        0.2942911386489868
      ],
      "plane_d": 2015.142822265625,
      "bbox_min": [
        -363.800048828125,
        -2355.77197265625,
        640.6943969726562
      ],
      "bbox_max": [
        -338.199951171875,
        -2355.699951171875,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3657400906085968,
        0.8829648494720459,
        0.2942911386489868
      ],
      "plane_d": 1758.393310546875,
      "bbox_min": [
        -363.800048828125,
        -2355.77197265625,
        640.6943969726562
      ],
      "bbox_max": [
        -363.55413818359375,
        -2355.699951171875,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8829648494720459,
        0.3657400906085968,
        0.2942911386489868
      ],
      "plane_d": 410.0762634277344,
      "bbox_min": [
        -299.4883117675781,
        -2356.802978515625,
        637.0
      ],
      "bbox_max": [
        -272.199951171875,
        -2355.699951171875,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3657400906085968,
        0.8829648494720459,
        0.2942911386489868
      ],
      "plane_d": 1782.5321044921875,
      "bbox_min": [
        -297.800048828125,
        -2355.77197265625,
        640.6943969726562
      ],
      "bbox_max": [
        -272.199951171875,
        -2355.699951171875,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3657400906085968,
        0.8829648494720459,
        0.2942911386489868
      ],
      "plane_d": 1991.0040283203125,
      "bbox_min": [
        -272.44586181640625,
        -2355.77197265625,
        640.6943969726562
      ],
      "bbox_max": [
        -272.199951171875,
        -2355.699951171875,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8829615712165833,
        0.3657243251800537,
        0.2943204939365387
      ],
      "plane_d": 971.5848388671875,
      "bbox_min": [
        -337.9910888671875,
        -2368.5,
        637.0
      ],
      "bbox_max": [
        -298.0089111328125,
        -2356.4501953125,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8829615712165833,
        0.3657243251800537,
        0.2943204939365387
      ],
      "plane_d": 410.0212707519531,
      "bbox_min": [
        -304.3333435058594,
        -2368.5,
        637.0
      ],
      "bbox_max": [
        -298.0089111328125,
        -2356.4501953125,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.34271809458732605,
        -0.9358025193214417,
        0.08257081359624863
      ],
      "plane_d": -2371.09375,
      "bbox_min": [
        -331.74786376953125,
        -2356.449951171875,
        641.0
      ],
      "bbox_max": [
        -329.699951171875,
        -2355.699951171875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509564340114594,
        -0.9807842373847961,
        0.0
      ],
      "plane_d": -2263.05419921875,
      "bbox_min": [
        -391.450439453125,
        -2238.0,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2194.983642578125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509564340114594,
        -0.9807842373847961,
        0.0
      ],
      "plane_d": -2138.973388671875,
      "bbox_min": [
        -344.53717041015625,
        -2238.0,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2194.983642578125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7709355354309082,
        -0.44510096311569214,
        -0.45556941628456116
      ],
      "plane_d": -932.5745239257812,
      "bbox_min": [
        -344.53717041015625,
        -2238.0,
        637.4000244140625
      ],
      "bbox_max": [
        -309.0,
        -2194.983642578125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7625132203102112,
        -0.64697265625,
        0.0
      ],
      "plane_d": -1675.384521484375,
      "bbox_min": [
        -314.3505554199219,
        -2225.860107421875,
        651.30615234375
      ],
      "bbox_max": [
        -310.4394836425781,
        -2219.086181640625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        -314.3505554199219,
        -2225.860107421875,
        651.30615234375
      ],
      "bbox_max": [
        -310.4394836425781,
        -2219.086181640625,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.969547688961029,
        -0.24490270018577576,
        0.0
      ],
      "plane_d": -846.1050415039062,
      "bbox_min": [
        -311.218017578125,
        -2225.860107421875,
        651.30615234375
      ],
      "bbox_max": [
        -310.4394836425781,
        -2222.778076171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7727664709091187,
        0.44615715742111206,
        -0.45141535997390747
      ],
      "plane_d": 1543.02392578125,
      "bbox_min": [
        -344.53717041015625,
        -2238.0,
        637.4000244140625
      ],
      "bbox_max": [
        -309.0,
        -2194.983642578125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2237.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        646.4769287109375
      ],
      "bbox_max": [
        -323.773681640625,
        -2233.132080078125,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2234.0,
      "bbox_min": [
        -326.0,
        -2234.0,
        652.1422119140625
      ],
      "bbox_max": [
        -325.4989318847656,
        -2233.132080078125,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -326.0,
        -2234.0,
        652.1422119140625
      ],
      "bbox_max": [
        -325.4989318847656,
        -2233.132080078125,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        -326.0,
        -2234.0,
        653.0
      ],
      "bbox_max": [
        -325.4989318847656,
        -2233.132080078125,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        646.4769287109375
      ],
      "bbox_max": [
        -323.773681640625,
        -2237.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        652.0
      ],
      "bbox_max": [
        -323.773681640625,
        -2237.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.4000244140625,
      "bbox_min": [
        -344.53717041015625,
        -2238.0,
        637.4000244140625
      ],
      "bbox_max": [
        -309.0,
        -2194.983642578125,
        665.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        -344.53717041015625,
        -2238.0,
        637.4000244140625
      ],
      "bbox_max": [
        -309.0,
        -2194.983642578125,
        665.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.4999884068965912,
        -0.8660321235656738,
        -4.7862531573628075e-06
      ],
      "plane_d": -1743.5611572265625,
      "bbox_min": [
        -339.763671875,
        -2209.14697265625,
        654.0
      ],
      "bbox_max": [
        -325.32568359375,
        -2200.23388671875,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -339.763671875,
        -2209.14697265625,
        654.0
      ],
      "bbox_max": [
        -325.32568359375,
        -2200.23388671875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        -339.763671875,
        -2209.14697265625,
        654.0
      ],
      "bbox_max": [
        -325.32568359375,
        -2200.23388671875,
        656.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.75886070728302,
        -0.43803462386131287,
        -0.4819295108318329
      ],
      "plane_d": -899.8217163085938,
      "bbox_min": [
        -335.810546875,
        -2206.86474609375,
        654.0
      ],
      "bbox_max": [
        -329.248291015625,
        -2202.49853515625,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7746132612228394,
        0.44712740182876587,
        -0.44727107882499695
      ],
      "plane_d": 1539.0009765625,
      "bbox_min": [
        -335.810546875,
        -2206.86474609375,
        654.0
      ],
      "bbox_max": [
        -334.4443359375,
        -2205.49853515625,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8261853456497192,
        -0.4769970178604126,
        0.29981938004493713
      ],
      "plane_d": -1510.0511474609375,
      "bbox_min": [
        -344.53717041015625,
        -2238.0,
        637.4000244140625
      ],
      "bbox_max": [
        -309.0,
        -2194.983642578125,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7625132203102112,
        -0.64697265625,
        0.0
      ],
      "plane_d": -1675.384521484375,
      "bbox_min": [
        -315.6559753417969,
        -2228.166748046875,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2218.3701171875,
        642.6163940429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.969547688961029,
        -0.24490270018577576,
        0.0
      ],
      "plane_d": -846.1050415039062,
      "bbox_min": [
        -315.6559753417969,
        -2228.166748046875,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2218.3701171875,
        642.6163940429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3135608732700348,
        -0.9495680928230286,
        0.0
      ],
      "plane_d": -2205.470947265625,
      "bbox_min": [
        -315.6559753417969,
        -2228.166748046875,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2218.3701171875,
        639.562744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -310.0,
        -2228.166748046875,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2227.60009765625,
        638.3014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2234.0,
      "bbox_min": [
        -344.53717041015625,
        -2238.0,
        637.4000244140625
      ],
      "bbox_max": [
        -309.0,
        -2196.083740234375,
        653.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -327.0,
        -2238.0,
        638.002197265625
      ],
      "bbox_max": [
        -309.0,
        -2234.0,
        652.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        638.002197265625
      ],
      "bbox_max": [
        -309.0,
        -2234.0,
        652.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2237.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        638.002197265625
      ],
      "bbox_max": [
        -309.0,
        -2234.0,
        652.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -312.0,
      "bbox_min": [
        -324.0,
        -2237.0,
        638.002197265625
      ],
      "bbox_max": [
        -312.0,
        -2234.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 324.0,
      "bbox_min": [
        -324.0,
        -2237.0,
        638.002197265625
      ],
      "bbox_max": [
        -324.0,
        -2234.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -309.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        638.002197265625
      ],
      "bbox_max": [
        -309.0,
        -2237.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        638.002197265625
      ],
      "bbox_max": [
        -327.0,
        -2237.0,
        647.4650268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8327006101608276,
        0.4807601869106293,
        0.27473509311676025
      ],
      "plane_d": 1169.4652099609375,
      "bbox_min": [
        -344.53717041015625,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2196.083740234375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -326.0,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -326.0,
        -2232.133544921875,
        640.666259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -342.8050537109375,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2196.083740234375,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4734824299812317,
        -0.8377031087875366,
        0.2721542716026306
      ],
      "plane_d": -1879.69091796875,
      "bbox_min": [
        -328.39990234375,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48331403732299805,
        -0.8377364873886108,
        0.2541753351688385
      ],
      "plane_d": -1865.0765380859375,
      "bbox_min": [
        -328.39990234375,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -328.39990234375,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9079718589782715,
        0.41903114318847656,
        0.0
      ],
      "plane_d": 1229.4326171875,
      "bbox_min": [
        -328.39990234375,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -326.0,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -326.0,
        -2227.60009765625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3135608732700348,
        -0.9495680928230286,
        0.0
      ],
      "plane_d": -2205.470947265625,
      "bbox_min": [
        -328.39990234375,
        -2227.60009765625,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7625132203102112,
        -0.64697265625,
        0.0
      ],
      "plane_d": -1675.384521484375,
      "bbox_min": [
        -314.686279296875,
        -2220.6142578125,
        639.562744140625
      ],
      "bbox_max": [
        -313.05389404296875,
        -2218.6904296875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -326.0,
        -2234.0,
        641.0
      ],
      "bbox_max": [
        -326.0,
        -2227.60009765625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3135608732700348,
        -0.9495680928230286,
        0.0
      ],
      "plane_d": -2205.470947265625,
      "bbox_min": [
        -328.39990234375,
        -2227.60009765625,
        641.0
      ],
      "bbox_max": [
        -310.0,
        -2216.699951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7625132203102112,
        -0.64697265625,
        0.0
      ],
      "plane_d": -1675.384521484375,
      "bbox_min": [
        -328.39990234375,
        -2227.60009765625,
        641.0
      ],
      "bbox_max": [
        -310.0,
        -2216.699951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.969547688961029,
        -0.24490270018577576,
        0.0
      ],
      "plane_d": -846.1050415039062,
      "bbox_min": [
        -328.39990234375,
        -2227.60009765625,
        641.0
      ],
      "bbox_max": [
        -310.0,
        -2216.699951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11463826894760132,
        -0.9934073090553284,
        0.0
      ],
      "plane_d": -2165.989990234375,
      "bbox_min": [
        -328.39990234375,
        -2222.39990234375,
        641.0
      ],
      "bbox_max": [
        -319.199951171875,
        -2216.699951171875,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -324.1583251953125,
        -2217.77197265625,
        651.0
      ],
      "bbox_max": [
        -321.800048828125,
        -2216.699951171875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8050610423088074,
        -0.5931919813156128,
        0.0
      ],
      "plane_d": -1053.9278564453125,
      "bbox_min": [
        -328.39990234375,
        -2222.39990234375,
        641.0
      ],
      "bbox_max": [
        -319.199951171875,
        -2217.199951171875,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -327.5,
        -2220.5,
        651.0
      ],
      "bbox_max": [
        -325.60498046875,
        -2218.606689453125,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -327.0,
        -2220.5,
        651.0
      ],
      "bbox_max": [
        -321.800048828125,
        -2217.5,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4385019838809967,
        -0.7758143544197083,
        -0.4536828398704529
      ],
      "plane_d": -1283.910888671875,
      "bbox_min": [
        -328.39990234375,
        -2222.39990234375,
        651.0
      ],
      "bbox_max": [
        -319.199951171875,
        -2217.199951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509564340114594,
        -0.9807842373847961,
        -0.0
      ],
      "plane_d": -2240.22802734375,
      "bbox_min": [
        -274.450439453125,
        -2238.0,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -274.450439453125,
        -2238.0,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2232.5,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5706624388694763,
        -0.8211847543716431,
        0.0
      ],
      "plane_d": -1685.310546875,
      "bbox_min": [
        -267.23492431640625,
        -2238.0,
        637.0
      ],
      "bbox_max": [
        -266.844970703125,
        -2237.72900390625,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555597543716431,
        -0.831476628780365,
        0.0
      ],
      "plane_d": -1711.3134765625,
      "bbox_min": [
        -269.1542053222656,
        -2238.0,
        658.5
      ],
      "bbox_max": [
        -259.15283203125,
        -2235.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1951041966676712,
        -0.9807825088500977,
        0.0
      ],
      "plane_d": -2243.1689453125,
      "bbox_min": [
        -259.5,
        -2235.569091796875,
        658.5
      ],
      "bbox_max": [
        -259.15283203125,
        -2235.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4252528250217438,
        -0.6364519596099854,
        -0.6434974074363708
      ],
      "plane_d": -886.1778564453125,
      "bbox_min": [
        -274.450439453125,
        -2238.0,
        655.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2232.5,
        659.17626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555597543716431,
        -0.831476628780365,
        0.0
      ],
      "plane_d": -1711.3134765625,
      "bbox_min": [
        -269.1542053222656,
        -2238.0,
        658.5
      ],
      "bbox_max": [
        -267.919189453125,
        -2237.1748046875,
        659.17626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14933465421199799,
        -0.7507347464561462,
        -0.6435033082962036
      ],
      "plane_d": -1293.27294921875,
      "bbox_min": [
        -259.5,
        -2235.569091796875,
        655.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2232.5,
        658.6612548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1951041966676712,
        -0.9807825088500977,
        0.0
      ],
      "plane_d": -2243.1689453125,
      "bbox_min": [
        -259.5,
        -2235.569091796875,
        658.5
      ],
      "bbox_max": [
        -259.15283203125,
        -2235.5,
        658.6612548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509564340114594,
        -0.9807842373847961,
        0.0
      ],
      "plane_d": -2116.147216796875,
      "bbox_min": [
        -391.450439453125,
        -2238.0,
        637.0
      ],
      "bbox_max": [
        -361.549560546875,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555604696273804,
        -0.8314761519432068,
        0.0
      ],
      "plane_d": -1643.3692626953125,
      "bbox_min": [
        -391.450439453125,
        -2238.0,
        637.0
      ],
      "bbox_max": [
        -361.549560546875,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -391.450439453125,
        -2238.0,
        637.0
      ],
      "bbox_max": [
        -361.549560546875,
        -2232.5,
        660.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.149342879652977,
        -0.7507419586181641,
        -0.6434929966926575
      ],
      "plane_d": -1198.31591796875,
      "bbox_min": [
        -386.067138671875,
        -2238.0,
        637.0
      ],
      "bbox_max": [
        -361.549560546875,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1951041966676712,
        -0.9807825088500977,
        0.0
      ],
      "plane_d": -2119.08251953125,
      "bbox_min": [
        -386.067138671875,
        -2237.1748046875,
        655.0
      ],
      "bbox_max": [
        -373.2688293457031,
        -2234.403076171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238958358764648,
        -0.38264405727386475,
        0.0
      ],
      "plane_d": -1211.6668701171875,
      "bbox_min": [
        -386.067138671875,
        -2237.1748046875,
        655.0
      ],
      "bbox_max": [
        -384.919189453125,
        -2234.403076171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1951041966676712,
        -0.9807825088500977,
        -0.0
      ],
      "plane_d": -2265.99609375,
      "bbox_min": [
        -376.5,
        -2236.142822265625,
        658.5
      ],
      "bbox_max": [
        -373.2688293457031,
        -2235.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1951041966676712,
        -0.9807825088500977,
        -0.0
      ],
      "plane_d": -2265.99609375,
      "bbox_min": [
        -376.5,
        -2238.0,
        658.5
      ],
      "bbox_max": [
        -366.8457946777344,
        -2235.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555597543716431,
        -0.831476628780365,
        -0.0
      ],
      "plane_d": -2064.6494140625,
      "bbox_min": [
        -368.080810546875,
        -2238.0,
        658.5
      ],
      "bbox_max": [
        -366.8457946777344,
        -2237.1748046875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706624388694763,
        -0.8211847543716431,
        -0.0
      ],
      "plane_d": -2048.251953125,
      "bbox_min": [
        -369.155029296875,
        -2238.0,
        637.0
      ],
      "bbox_max": [
        -361.549560546875,
        -2234.403076171875,
        659.1760864257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4252527952194214,
        -0.6364531517028809,
        -0.6434962749481201
      ],
      "plane_d": -1156.64208984375,
      "bbox_min": [
        -368.080810546875,
        -2238.0,
        655.0
      ],
      "bbox_max": [
        -361.549560546875,
        -2234.403076171875,
        659.1760864257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555597543716431,
        -0.831476628780365,
        -0.0
      ],
      "plane_d": -2064.6494140625,
      "bbox_min": [
        -368.080810546875,
        -2238.0,
        658.5
      ],
      "bbox_max": [
        -366.8457946777344,
        -2237.1748046875,
        659.1760864257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -259.15283203125,
        -2331.5,
        637.0
      ],
      "bbox_max": [
        -239.537109375,
        -2232.569091796875,
        660.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.5555604696273804,
        -0.8314761519432068,
        0.0
      ],
      "plane_d": -1996.7056884765625,
      "bbox_min": [
        -259.15283203125,
        -2331.5,
        637.0
      ],
      "bbox_max": [
        -239.537109375,
        -2232.569091796875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509564340114594,
        -0.9807842373847961,
        -0.0
      ],
      "plane_d": -2240.22802734375,
      "bbox_min": [
        -259.15283203125,
        -2331.5,
        637.0
      ],
      "bbox_max": [
        -239.537109375,
        -2232.569091796875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -259.15283203125,
        -2331.5,
        637.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.651123046875,
        653.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.5555562973022461,
        0.8314789533615112,
        0.0
      ],
      "plane_d": 2026.1082763671875,
      "bbox_min": [
        -241.822265625,
        -2276.70458984375,
        637.0
      ],
      "bbox_max": [
        -239.537109375,
        -2275.177734375,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -255.0,
      "bbox_min": [
        -259.15283203125,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.651123046875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 649.2000122070312,
      "bbox_min": [
        -255.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.651123046875,
        649.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2313.5,
      "bbox_min": [
        -255.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.651123046875,
        649.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555562973022461,
        0.8314789533615112,
        0.0
      ],
      "plane_d": 2026.1082763671875,
      "bbox_min": [
        -241.822265625,
        -2276.70458984375,
        638.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.651123046875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5879369974136353,
        0.3928370177745819,
        -0.7071132659912109
      ],
      "plane_d": 1207.332275390625,
      "bbox_min": [
        -241.822265625,
        -2276.70458984375,
        641.7517700195312
      ],
      "bbox_max": [
        -239.537109375,
        -2273.651123046875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2331.5,
      "bbox_min": [
        -255.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -239.537109375,
        -2313.5,
        649.2000122070312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -245.0,
      "bbox_min": [
        -245.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -239.537109375,
        -2313.5,
        649.2000122070312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        -245.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -239.537109375,
        -2314.0,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2320.0,
      "bbox_min": [
        -245.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -239.537109375,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": -2255.843505859375,
      "bbox_min": [
        -243.39990234375,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -239.537109375,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": -1508.3712158203125,
      "bbox_min": [
        -243.39990234375,
        -2316.5,
        641.5
      ],
      "bbox_max": [
        -239.537109375,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2314.0,
      "bbox_min": [
        -243.39990234375,
        -2314.0,
        641.5
      ],
      "bbox_max": [
        -239.537109375,
        -2314.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2325.0,
      "bbox_min": [
        -245.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -239.537109375,
        -2325.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": 1524.355224609375,
      "bbox_min": [
        -243.39990234375,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -239.537109375,
        -2329.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": 2271.82763671875,
      "bbox_min": [
        -243.39990234375,
        -2331.5,
        644.5
      ],
      "bbox_max": [
        -239.537109375,
        -2329.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5731114149093628,
        0.8194774389266968,
        -0.0
      ],
      "plane_d": 2056.755126953125,
      "bbox_min": [
        -259.15283203125,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -255.0,
        -2313.5,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        -259.15283203125,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -255.0,
        -2313.5,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38271352648735046,
        -0.9238670468330383,
        -0.0
      ],
      "plane_d": -2237.682861328125,
      "bbox_min": [
        -259.15283203125,
        -2319.005126953125,
        638.0
      ],
      "bbox_max": [
        -255.0,
        -2313.5,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5747867226600647,
        -0.8183032274246216,
        0.0
      ],
      "plane_d": -1746.5738525390625,
      "bbox_min": [
        -257.640869140625,
        -2315.35498046875,
        638.0
      ],
      "bbox_max": [
        -255.0,
        -2313.5,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -259.15283203125,
        -2319.005126953125,
        652.0
      ],
      "bbox_max": [
        -257.640869140625,
        -2314.728759765625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238755106925964,
        -0.38269320130348206,
        0.0
      ],
      "plane_d": -648.0425415039062,
      "bbox_min": [
        -259.15283203125,
        -2319.005126953125,
        652.0
      ],
      "bbox_max": [
        -257.640869140625,
        -2315.35498046875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9100080132484436,
        0.41459059715270996,
        -0.0
      ],
      "plane_d": 1172.9549560546875,
      "bbox_min": [
        -259.15283203125,
        -2282.430908203125,
        637.0
      ],
      "bbox_max": [
        -239.537109375,
        -2232.569091796875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509564340114594,
        0.9807842373847961,
        0.0
      ],
      "plane_d": 2188.0126953125,
      "bbox_min": [
        -259.15283203125,
        -2282.430908203125,
        645.0
      ],
      "bbox_max": [
        -249.932861328125,
        -2280.596923828125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314761519432068,
        -0.5555604696273804,
        0.0
      ],
      "plane_d": -1445.4261474609375,
      "bbox_min": [
        -259.15283203125,
        -2275.177734375,
        637.0
      ],
      "bbox_max": [
        -239.537109375,
        -2232.569091796875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5879369974136353,
        0.3928370177745819,
        -0.7071132659912109
      ],
      "plane_d": 1207.332275390625,
      "bbox_min": [
        -241.822265625,
        -2275.177734375,
        643.4481201171875
      ],
      "bbox_max": [
        -239.537109375,
        -2271.757568359375,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14933465421199799,
        -0.7507347464561462,
        -0.6435033082962036
      ],
      "plane_d": -1293.27294921875,
      "bbox_min": [
        -259.15283203125,
        -2237.1748046875,
        655.0
      ],
      "bbox_max": [
        -249.932861328125,
        -2232.569091796875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1951041966676712,
        -0.9807825088500977,
        0.0
      ],
      "plane_d": -2243.1689453125,
      "bbox_min": [
        -259.15283203125,
        -2237.1748046875,
        655.0
      ],
      "bbox_max": [
        -249.932861328125,
        -2234.403076171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238958358764648,
        -0.38264408707618713,
        0.0
      ],
      "plane_d": -624.0692138671875,
      "bbox_min": [
        -251.080810546875,
        -2237.1748046875,
        655.0
      ],
      "bbox_max": [
        -249.932861328125,
        -2234.403076171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -435.0,
        -2411.5,
        625.5
      ],
      "bbox_max": [
        -239.537109375,
        -2368.5,
        712.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -281.0,
      "bbox_min": [
        -376.0,
        -2411.5,
        625.5
      ],
      "bbox_max": [
        -260.0,
        -2368.5,
        641.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -625.5,
      "bbox_min": [
        -281.0,
        -2408.0,
        625.5
      ],
      "bbox_max": [
        -260.0,
        -2392.0,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": 2353.315673828125,
      "bbox_min": [
        -281.0,
        -2408.0,
        625.5
      ],
      "bbox_max": [
        -260.0,
        -2394.0,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2001.610107421875,
      "bbox_min": [
        -281.0,
        -2408.0,
        625.5
      ],
      "bbox_max": [
        -260.0,
        -2394.0,
        635.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -281.0,
        -2406.0,
        626.0
      ],
      "bbox_max": [
        -279.0,
        -2394.0,
        635.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        -0.5144957304000854
      ],
      "plane_d": 2387.517578125,
      "bbox_min": [
        -281.0,
        -2406.0,
        626.0
      ],
      "bbox_max": [
        -279.0,
        -2403.0,
        635.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9138115644454956,
        0.40613847970962524
      ],
      "plane_d": 1942.560302734375,
      "bbox_min": [
        -281.0,
        -2406.0,
        626.0
      ],
      "bbox_max": [
        -279.0,
        -2404.0,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -376.0,
        -2411.5,
        625.5
      ],
      "bbox_max": [
        -281.0,
        -2368.5,
        641.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -625.5,
      "bbox_min": [
        -376.0,
        -2408.0,
        625.5
      ],
      "bbox_max": [
        -355.0,
        -2392.0,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": 2353.315673828125,
      "bbox_min": [
        -376.0,
        -2408.0,
        625.5
      ],
      "bbox_max": [
        -355.0,
        -2394.0,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2001.610107421875,
      "bbox_min": [
        -376.0,
        -2408.0,
        625.5
      ],
      "bbox_max": [
        -355.0,
        -2394.0,
        635.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -357.0,
        -2406.0,
        626.0
      ],
      "bbox_max": [
        -355.0,
        -2394.0,
        635.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        -0.5144957304000854
      ],
      "plane_d": 2387.517578125,
      "bbox_min": [
        -357.0,
        -2406.0,
        626.0
      ],
      "bbox_max": [
        -355.0,
        -2403.0,
        635.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9138115644454956,
        0.40613847970962524
      ],
      "plane_d": 1942.560302734375,
      "bbox_min": [
        -357.0,
        -2406.0,
        626.0
      ],
      "bbox_max": [
        -355.0,
        -2404.0,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -355.0,
        -2411.5,
        626.0
      ],
      "bbox_max": [
        -281.0,
        -2368.5,
        641.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -632.5,
      "bbox_min": [
        -355.0,
        -2411.5,
        626.0
      ],
      "bbox_max": [
        -281.0,
        -2368.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3511234521865845,
        0.936329185962677,
        0.0
      ],
      "plane_d": 2157.8876953125,
      "bbox_min": [
        -355.0,
        -2411.5,
        626.0
      ],
      "bbox_max": [
        -281.0,
        -2410.0,
        632.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3511234521865845,
        0.936329185962677,
        -0.0
      ],
      "plane_d": 2381.2021484375,
      "bbox_min": [
        -355.0,
        -2411.5,
        626.0
      ],
      "bbox_max": [
        -351.0,
        -2410.0,
        632.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.0,
      "bbox_min": [
        -355.0,
        -2411.5,
        632.5
      ],
      "bbox_max": [
        -281.0,
        -2368.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3511234521865845,
        0.936329185962677,
        0.0
      ],
      "plane_d": 2157.8876953125,
      "bbox_min": [
        -285.0,
        -2411.5,
        632.5
      ],
      "bbox_max": [
        -281.0,
        -2410.0,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 351.0,
      "bbox_min": [
        -355.0,
        -2411.5,
        632.5
      ],
      "bbox_max": [
        -291.1805419921875,
        -2368.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3511234521865845,
        0.936329185962677,
        -0.0
      ],
      "plane_d": 2381.2021484375,
      "bbox_min": [
        -355.0,
        -2411.5,
        632.5
      ],
      "bbox_max": [
        -351.0,
        -2410.0,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8829648494720459,
        -0.3657400906085968,
        0.2942911386489868
      ],
      "plane_d": -1322.4345703125,
      "bbox_min": [
        -344.81939697265625,
        -2411.5,
        632.5
      ],
      "bbox_max": [
        -291.1805419921875,
        -2368.5,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.923878014087677,
        -0.3826870322227478,
        -0.0
      ],
      "plane_d": -1188.177001953125,
      "bbox_min": [
        -305.0,
        -2382.64208984375,
        632.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2368.5,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8829648494720459,
        -0.3657400906085968,
        0.2942911386489868
      ],
      "plane_d": -760.868896484375,
      "bbox_min": [
        -344.81939697265625,
        -2411.5,
        632.5
      ],
      "bbox_max": [
        -291.1805419921875,
        -2368.5,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -600.5906372070312,
      "bbox_min": [
        -336.85791015625,
        -2382.64208984375,
        632.5
      ],
      "bbox_max": [
        -331.0,
        -2368.5,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 1922.976806640625,
      "bbox_min": [
        -344.81939697265625,
        -2411.5,
        635.0
      ],
      "bbox_max": [
        -291.1805419921875,
        -2381.22802734375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.546083927154541,
        0.12711937725543976,
        -0.8280296325683594
      ],
      "plane_d": 1016.7019653320312,
      "bbox_min": [
        -344.81939697265625,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -329.1787414550781,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38270998001098633,
        0.9238685369491577,
        -6.281529203988612e-05
      ],
      "plane_d": 2099.25341796875,
      "bbox_min": [
        -344.81939697265625,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -329.1805419921875,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38271570205688477,
        0.9238661527633667,
        -5.348400372895412e-05
      ],
      "plane_d": 2357.190185546875,
      "bbox_min": [
        -344.81939697265625,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -332.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.324804425239563,
        0.9457812309265137,
        -0.0
      ],
      "plane_d": 2390.21044921875,
      "bbox_min": [
        -341.55706787109375,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -332.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31816256046295166,
        0.9476114511489868,
        0.028374386951327324
      ],
      "plane_d": 2374.240478515625,
      "bbox_min": [
        -341.241943359375,
        -2411.5,
        638.4130859375
      ],
      "bbox_max": [
        -337.0,
        -2410.043212890625,
        640.7704467773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46815547347068787,
        0.31280118227005005,
        -0.8264296054840088
      ],
      "plane_d": 1123.6630859375,
      "bbox_min": [
        -341.23968505859375,
        -2410.335693359375,
        640.26123046875
      ],
      "bbox_max": [
        -340.5085754394531,
        -2410.0439453125,
        640.7704467773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31816256046295166,
        0.9476114511489868,
        0.028374403715133667
      ],
      "plane_d": 2159.798828125,
      "bbox_min": [
        -341.55706787109375,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -332.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.324804425239563,
        0.9457812309265137,
        0.0
      ],
      "plane_d": 2171.292236328125,
      "bbox_min": [
        -337.0,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -332.758056640625,
        -2410.043212890625,
        639.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1726299226284027,
        0.11533552408218384,
        -0.9782109260559082
      ],
      "plane_d": 961.873779296875,
      "bbox_min": [
        -341.55706787109375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -332.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11793964356184006,
        0.17652766406536102,
        -0.9772042632102966
      ],
      "plane_d": 1090.3642578125,
      "bbox_min": [
        -341.55706787109375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -332.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04192692041397095,
        0.2107943445444107,
        -0.9766308665275574
      ],
      "plane_d": 1147.015380859375,
      "bbox_min": [
        -341.55706787109375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -332.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04192691668868065,
        0.2107943445444107,
        -0.9766308665275574
      ],
      "plane_d": 1118.756591796875,
      "bbox_min": [
        -341.55706787109375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -332.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.312797874212265,
        0.46815043687820435,
        -0.8264337182044983
      ],
      "plane_d": 1550.692626953125,
      "bbox_min": [
        -341.55706787109375,
        -2410.335693359375,
        640.26123046875
      ],
      "bbox_max": [
        -332.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31280118227005005,
        0.46815547347068787,
        -0.8264296054840088
      ],
      "plane_d": 1761.5289306640625,
      "bbox_min": [
        -341.55706787109375,
        -2410.335693359375,
        640.26123046875
      ],
      "bbox_max": [
        -332.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46815043687820435,
        0.312797874212265,
        -0.8264337182044983
      ],
      "plane_d": 1439.19287109375,
      "bbox_min": [
        -341.55706787109375,
        -2410.335693359375,
        640.26123046875
      ],
      "bbox_max": [
        -332.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10985693335533142,
        0.5522241592407227,
        -0.8264260292053223
      ],
      "plane_d": 1895.8912353515625,
      "bbox_min": [
        -341.55706787109375,
        -2410.295166015625,
        640.26123046875
      ],
      "bbox_max": [
        -335.1124572753906,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10985572636127472,
        0.5522180795669556,
        -0.8264302611351013
      ],
      "plane_d": 1821.836181640625,
      "bbox_min": [
        -341.55706787109375,
        -2410.295166015625,
        640.26123046875
      ],
      "bbox_max": [
        -337.0,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46815547347068787,
        0.31280118227005005,
        -0.8264296054840088
      ],
      "plane_d": 1123.6630859375,
      "bbox_min": [
        -341.55706787109375,
        -2410.295166015625,
        640.26123046875
      ],
      "bbox_max": [
        -339.7060546875,
        -2408.312255859375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1473.2569580078125,
      "bbox_min": [
        -307.4295959472656,
        -2411.5,
        635.0
      ],
      "bbox_max": [
        -291.1805419921875,
        -2381.22802734375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5460926294326782,
        0.12712153792381287,
        -0.8280234932899475
      ],
      "plane_d": 669.3912353515625,
      "bbox_min": [
        -306.8211975097656,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -291.1805419921875,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38270998001098633,
        0.9238685369491577,
        -6.281529203988612e-05
      ],
      "plane_d": 2113.79638671875,
      "bbox_min": [
        -306.81939697265625,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -291.1805419921875,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38271570205688477,
        0.9238661527633667,
        -5.348400372895412e-05
      ],
      "plane_d": 2342.64697265625,
      "bbox_min": [
        -306.81939697265625,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -294.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.324804425239563,
        0.9457812309265137,
        0.0
      ],
      "plane_d": 2183.635009765625,
      "bbox_min": [
        -303.55706787109375,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -294.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31816256046295166,
        0.9476114511489868,
        0.028374403715133667
      ],
      "plane_d": 2171.888916015625,
      "bbox_min": [
        -299.0,
        -2411.5,
        638.4130859375
      ],
      "bbox_max": [
        -294.758056640625,
        -2410.043212890625,
        640.7686157226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46815043687820435,
        0.312797874212265,
        -0.8264337182044983
      ],
      "plane_d": 1421.403076171875,
      "bbox_min": [
        -295.4914245605469,
        -2410.335693359375,
        640.26123046875
      ],
      "bbox_max": [
        -294.7628173828125,
        -2410.045166015625,
        640.7686157226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31816256046295166,
        0.9476114511489868,
        0.028374386951327324
      ],
      "plane_d": 2362.150146484375,
      "bbox_min": [
        -303.55706787109375,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -294.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.324804425239563,
        0.9457812309265137,
        -0.0
      ],
      "plane_d": 2377.867919921875,
      "bbox_min": [
        -303.241943359375,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -299.0,
        -2410.043212890625,
        639.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1726299226284027,
        0.11533553153276443,
        -0.9782109260559082
      ],
      "plane_d": 852.0811767578125,
      "bbox_min": [
        -303.55706787109375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -294.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11793964356184006,
        0.17652764916419983,
        -0.9772042632102966
      ],
      "plane_d": 1015.3546142578125,
      "bbox_min": [
        -303.55706787109375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -294.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04192692041397095,
        0.2107943445444107,
        -0.9766308665275574
      ],
      "plane_d": 1145.422119140625,
      "bbox_min": [
        -303.55706787109375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -294.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04192691668868065,
        0.2107943445444107,
        -0.9766308665275574
      ],
      "plane_d": 1120.349853515625,
      "bbox_min": [
        -303.55706787109375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -294.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.312797874212265,
        0.46815043687820435,
        -0.8264337182044983
      ],
      "plane_d": 1562.578857421875,
      "bbox_min": [
        -303.55706787109375,
        -2410.335693359375,
        640.26123046875
      ],
      "bbox_max": [
        -294.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31280118227005005,
        0.46815547347068787,
        -0.8264296054840088
      ],
      "plane_d": 1749.6424560546875,
      "bbox_min": [
        -303.55706787109375,
        -2410.335693359375,
        640.26123046875
      ],
      "bbox_max": [
        -294.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46815547347068787,
        0.31280118227005005,
        -0.8264296054840088
      ],
      "plane_d": 1141.4530029296875,
      "bbox_min": [
        -303.55706787109375,
        -2410.335693359375,
        640.26123046875
      ],
      "bbox_max": [
        -294.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10985693335533142,
        0.5522241592407227,
        -0.8264260292053223
      ],
      "plane_d": 1891.7166748046875,
      "bbox_min": [
        -300.8875427246094,
        -2410.295166015625,
        640.26123046875
      ],
      "bbox_max": [
        -294.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10985572636127472,
        0.5522180795669556,
        -0.8264302611351013
      ],
      "plane_d": 1826.0107421875,
      "bbox_min": [
        -300.8875427246094,
        -2410.295166015625,
        640.26123046875
      ],
      "bbox_max": [
        -294.44293212890625,
        -2406.867431640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46815043687820435,
        0.312797874212265,
        -0.8264337182044983
      ],
      "plane_d": 1421.403076171875,
      "bbox_min": [
        -296.2939453125,
        -2410.295166015625,
        640.26123046875
      ],
      "bbox_max": [
        -294.44293212890625,
        -2408.312255859375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -435.0,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -239.537109375,
        -2368.5,
        712.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 672.0,
      "bbox_min": [
        -351.0,
        -2389.5,
        660.5
      ],
      "bbox_max": [
        -285.0,
        -2368.5,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5639112591743469,
        -0.8258353471755981
      ],
      "plane_d": -791.940673828125,
      "bbox_min": [
        -351.0,
        -2389.5,
        660.5
      ],
      "bbox_max": [
        -285.0,
        -2368.5,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.24024011194705963,
        -0.9707134962081909
      ],
      "plane_d": 76.03041076660156,
      "bbox_min": [
        -336.85791015625,
        -2382.64208984375,
        660.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2368.5,
        668.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -1188.177001953125,
      "bbox_min": [
        -336.85791015625,
        -2382.64208984375,
        660.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2368.5,
        668.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 351.0,
      "bbox_min": [
        -351.0,
        -2389.5,
        660.5
      ],
      "bbox_max": [
        -351.0,
        -2388.5,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 672.0,
      "bbox_min": [
        -351.0,
        -2411.5,
        660.5
      ],
      "bbox_max": [
        -285.0,
        -2389.5,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.0,
      "bbox_min": [
        -351.0,
        -2411.5,
        660.5
      ],
      "bbox_max": [
        -285.0,
        -2389.5,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.993532657623291,
        0.0,
        -0.11354658752679825
      ],
      "plane_d": 385.68927001953125,
      "bbox_min": [
        -324.60009765625,
        -2411.5,
        660.5
      ],
      "bbox_max": [
        -287.038330078125,
        -2397.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9684929251670837,
        -0.24904105067253113
      ],
      "plane_d": 2488.8330078125,
      "bbox_min": [
        -324.60009765625,
        -2399.95703125,
        660.5
      ],
      "bbox_max": [
        -311.39990234375,
        -2397.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9798362851142883,
        0.19980166852474213,
        -0.000411680230172351
      ],
      "plane_d": 763.3489379882812,
      "bbox_min": [
        -310.961669921875,
        -2411.5,
        660.5
      ],
      "bbox_max": [
        -287.038330078125,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9798362851142883,
        0.19980166852474213,
        -0.000400588265620172
      ],
      "plane_d": 177.39939880371094,
      "bbox_min": [
        -310.961669921875,
        -2411.5,
        660.5
      ],
      "bbox_max": [
        -287.91357421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314626216888428,
        0.555580735206604,
        0.0
      ],
      "plane_d": 1578.7491455078125,
      "bbox_min": [
        -310.08642578125,
        -2407.97314453125,
        660.5
      ],
      "bbox_max": [
        -287.91357421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314626216888428,
        0.555580735206604,
        0.0
      ],
      "plane_d": 1081.534423828125,
      "bbox_min": [
        -310.08642578125,
        -2407.97314453125,
        660.5
      ],
      "bbox_max": [
        -291.928955078125,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509324431419373,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 2413.981689453125,
      "bbox_min": [
        -306.071044921875,
        -2404.72900390625,
        660.5
      ],
      "bbox_max": [
        -291.928955078125,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509324431419373,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 2297.31591796875,
      "bbox_min": [
        -306.071044921875,
        -2404.72900390625,
        660.5
      ],
      "bbox_max": [
        -291.928955078125,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.555580735206604,
        0.8314626216888428,
        0.0
      ],
      "plane_d": 2161.63232421875,
      "bbox_min": [
        -306.071044921875,
        -2404.72900390625,
        660.5
      ],
      "bbox_max": [
        -291.928955078125,
        -2402.561279296875,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.555580735206604,
        0.8314626216888428,
        0.0
      ],
      "plane_d": 1829.3951416015625,
      "bbox_min": [
        -306.071044921875,
        -2404.72900390625,
        660.5
      ],
      "bbox_max": [
        -302.826904296875,
        -2402.561279296875,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269850611686707,
        0.9238733053207397,
        -8.707995675649727e-07
      ],
      "plane_d": 2342.625244140625,
      "bbox_min": [
        -310.08642578125,
        -2407.97314453125,
        660.5
      ],
      "bbox_max": [
        -308.23876953125,
        -2407.207763671875,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827075958251953,
        0.9238695502281189,
        -8.666777375765378e-07
      ],
      "plane_d": 2113.759765625,
      "bbox_min": [
        -289.76123046875,
        -2407.97314453125,
        660.5
      ],
      "bbox_max": [
        -287.91357421875,
        -2407.207763671875,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9798362851142883,
        0.19980166852474213,
        -0.000411680230172351
      ],
      "plane_d": 800.5827026367188,
      "bbox_min": [
        -348.961669921875,
        -2411.5,
        660.5
      ],
      "bbox_max": [
        -325.038330078125,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9798362851142883,
        0.19980166852474213,
        -0.000400588265620172
      ],
      "plane_d": 140.16561889648438,
      "bbox_min": [
        -348.961669921875,
        -2411.5,
        660.5
      ],
      "bbox_max": [
        -325.91357421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314626216888428,
        0.555580735206604,
        0.0
      ],
      "plane_d": 1610.3447265625,
      "bbox_min": [
        -348.08642578125,
        -2407.97314453125,
        660.5
      ],
      "bbox_max": [
        -325.91357421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314626216888428,
        0.555580735206604,
        0.0
      ],
      "plane_d": 1049.9388427734375,
      "bbox_min": [
        -348.08642578125,
        -2407.97314453125,
        660.5
      ],
      "bbox_max": [
        -329.928955078125,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509324431419373,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 2421.395263671875,
      "bbox_min": [
        -344.071044921875,
        -2404.72900390625,
        660.5
      ],
      "bbox_max": [
        -329.928955078125,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509324431419373,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 2289.90234375,
      "bbox_min": [
        -344.071044921875,
        -2404.72900390625,
        660.5
      ],
      "bbox_max": [
        -329.928955078125,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.555580735206604,
        0.8314626216888428,
        0.0
      ],
      "plane_d": 2182.744384765625,
      "bbox_min": [
        -344.071044921875,
        -2404.72900390625,
        660.5
      ],
      "bbox_max": [
        -329.928955078125,
        -2402.561279296875,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.555580735206604,
        0.8314626216888428,
        0.0
      ],
      "plane_d": 1808.2830810546875,
      "bbox_min": [
        -344.071044921875,
        -2404.72900390625,
        660.5
      ],
      "bbox_max": [
        -340.826904296875,
        -2402.561279296875,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269850611686707,
        0.9238733053207397,
        -8.707995675649727e-07
      ],
      "plane_d": 2357.167724609375,
      "bbox_min": [
        -348.08642578125,
        -2407.97314453125,
        660.5
      ],
      "bbox_max": [
        -346.23876953125,
        -2407.207763671875,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827075958251953,
        0.9238695502281189,
        -8.666777375765378e-07
      ],
      "plane_d": 2099.217041015625,
      "bbox_min": [
        -327.76123046875,
        -2407.97314453125,
        660.5
      ],
      "bbox_max": [
        -325.91357421875,
        -2407.207763671875,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.0,
      "bbox_min": [
        -371.0,
        -2389.5,
        641.0
      ],
      "bbox_max": [
        -265.0,
        -2368.5,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 661.5665893554688,
      "bbox_min": [
        -285.0,
        -2388.5,
        641.0
      ],
      "bbox_max": [
        -265.0,
        -2368.5,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        0.923878014087677,
        0.0
      ],
      "plane_d": 2097.616943359375,
      "bbox_min": [
        -285.0,
        -2388.5,
        641.0
      ],
      "bbox_max": [
        -265.0,
        -2368.5,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        0.3826742172241211,
        0.0
      ],
      "plane_d": 659.68701171875,
      "bbox_min": [
        -285.0,
        -2388.5,
        641.0
      ],
      "bbox_max": [
        -265.0,
        -2368.5,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826742172241211,
        0.9238833785057068,
        0.0
      ],
      "plane_d": 2095.78564453125,
      "bbox_min": [
        -285.0,
        -2388.5,
        641.0
      ],
      "bbox_max": [
        -272.27197265625,
        -2381.22802734375,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.5,
      "bbox_min": [
        -285.0,
        -2388.5,
        651.5
      ],
      "bbox_max": [
        -272.27197265625,
        -2381.22802734375,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        -0.0
      ],
      "plane_d": 1249.1529541015625,
      "bbox_min": [
        -371.0,
        -2388.5,
        641.0
      ],
      "bbox_max": [
        -351.0,
        -2368.5,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        0.3826742172241211,
        0.0
      ],
      "plane_d": 1247.27685546875,
      "bbox_min": [
        -371.0,
        -2388.5,
        641.0
      ],
      "bbox_max": [
        -351.0,
        -2368.5,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826742172241211,
        0.9238833785057068,
        -0.0
      ],
      "plane_d": 2339.166259765625,
      "bbox_min": [
        -363.72802734375,
        -2388.5,
        641.0
      ],
      "bbox_max": [
        -351.0,
        -2381.22802734375,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -651.5,
      "bbox_min": [
        -363.72802734375,
        -2388.5,
        651.5
      ],
      "bbox_max": [
        -351.0,
        -2381.22802734375,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.5,
      "bbox_min": [
        -351.0,
        -2388.5,
        641.0
      ],
      "bbox_max": [
        -285.0,
        -2381.22802734375,
        651.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1473.2569580078125,
      "bbox_min": [
        -299.14208984375,
        -2382.64208984375,
        641.0
      ],
      "bbox_max": [
        -297.72802734375,
        -2381.22802734375,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.993532657623291,
        0.0,
        -0.11354658752679825
      ],
      "plane_d": 385.68927001953125,
      "bbox_min": [
        -348.95697021484375,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -287.04302978515625,
        -2399.95703125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.993532657623291,
        -0.0,
        -0.11354659497737885
      ],
      "plane_d": -246.19747924804688,
      "bbox_min": [
        -348.95697021484375,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -312.7142028808594,
        -2399.95703125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.5,
      "bbox_min": [
        -323.2857971191406,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -312.7142028808594,
        -2399.95703125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9684929251670837,
        -0.24904105067253113
      ],
      "plane_d": 2488.8330078125,
      "bbox_min": [
        -323.2857971191406,
        -2401.5,
        654.5
      ],
      "bbox_max": [
        -312.7142028808594,
        -2399.95703125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.4000244140625,
      "bbox_min": [
        -321.60009765625,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -314.39990234375,
        -2403.60009765625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -321.60009765625,
      "bbox_min": [
        -321.60009765625,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -314.39990234375,
        -2403.60009765625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 314.39990234375,
      "bbox_min": [
        -321.60009765625,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -314.39990234375,
        -2403.60009765625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2403.60009765625,
      "bbox_min": [
        -321.60009765625,
        -2403.60009765625,
        652.4000244140625
      ],
      "bbox_max": [
        -314.39990234375,
        -2403.60009765625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9798362851142883,
        0.19980166852474213,
        -0.000411680230172351
      ],
      "plane_d": 800.5827026367188,
      "bbox_min": [
        -348.95697021484375,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -325.04302978515625,
        -2401.800048828125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9798362851142883,
        0.19980166852474213,
        -0.000400588265620172
      ],
      "plane_d": 140.16561889648438,
      "bbox_min": [
        -348.95697021484375,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -325.047607421875,
        -2401.800048828125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509324431419373,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 2421.395263671875,
      "bbox_min": [
        -348.952392578125,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -325.047607421875,
        -2401.800048828125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509324431419373,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 2289.90234375,
      "bbox_min": [
        -348.952392578125,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -325.047607421875,
        -2401.800048828125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827075958251953,
        0.9238695502281189,
        -8.666777375765378e-07
      ],
      "plane_d": 2099.217041015625,
      "bbox_min": [
        -348.952392578125,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -325.047607421875,
        -2401.800048828125,
        660.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.960491418838501,
        0.195743128657341,
        -0.1978406459093094
      ],
      "plane_d": 912.6994018554688,
      "bbox_min": [
        -329.1805419921875,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -325.047607421875,
        -2407.21142578125,
        649.3076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8203608989715576,
        0.17341561615467072,
        -0.5449174642562866
      ],
      "plane_d": 1037.0115966796875,
      "bbox_min": [
        -329.1805419921875,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -325.9545593261719,
        -2407.557373046875,
        644.9067993164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5541775226593018,
        0.1150112897157669,
        -0.8244147300720215
      ],
      "plane_d": 987.8859252929688,
      "bbox_min": [
        -329.1805419921875,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -328.529541015625,
        -2408.55322265625,
        641.0274658203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8191777467727661,
        0.16721095144748688,
        -0.5486240386962891
      ],
      "plane_d": 1024.0538330078125,
      "bbox_min": [
        -329.16162109375,
        -2411.488525390625,
        641.013671875
      ],
      "bbox_max": [
        -325.95684814453125,
        -2407.557373046875,
        644.9067993164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8191777467727661,
        0.16721095144748688,
        -0.5486240386962891
      ],
      "plane_d": 1024.0538330078125,
      "bbox_min": [
        -326.757568359375,
        -2411.5,
        644.904052734375
      ],
      "bbox_max": [
        -325.9443359375,
        -2407.557373046875,
        644.91943359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38269850611686707,
        0.9238733053207397,
        -8.707995675649727e-07
      ],
      "plane_d": 2357.167724609375,
      "bbox_min": [
        -348.952392578125,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -327.76123046875,
        -2401.800048828125,
        660.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9604582786560059,
        0.19748155772686005,
        -0.19626763463020325
      ],
      "plane_d": 268.5106506347656,
      "bbox_min": [
        -348.952392578125,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -347.242431640625,
        -2407.557373046875,
        649.3076782226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.555580735206604,
        0.8314626216888428,
        0.0
      ],
      "plane_d": 1808.2830810546875,
      "bbox_min": [
        -346.23876953125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -327.76123046875,
        -2401.800048828125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314626216888428,
        0.555580735206604,
        0.0
      ],
      "plane_d": 1049.9388427734375,
      "bbox_min": [
        -346.23876953125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -327.76123046875,
        -2401.800048828125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19148309528827667,
        0.9626355767250061,
        -0.1914861500263214
      ],
      "plane_d": 2371.898681640625,
      "bbox_min": [
        -346.23876953125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -327.76123046875,
        -2401.800048828125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19148465991020203,
        0.9626434445381165,
        -0.19144512712955475
      ],
      "plane_d": 2500.950927734375,
      "bbox_min": [
        -346.23876953125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -327.76123046875,
        -2401.800048828125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8160831928253174,
        0.5453042387962341,
        -0.1914459615945816
      ],
      "plane_d": 1704.902587890625,
      "bbox_min": [
        -346.23876953125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -327.76123046875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5452976226806641,
        0.8160732388496399,
        -0.19150692224502563
      ],
      "plane_d": 2266.728271484375,
      "bbox_min": [
        -346.23876953125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -328.46435546875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5453042387962341,
        0.8160831928253174,
        -0.1914459615945816
      ],
      "plane_d": 1899.1796875,
      "bbox_min": [
        -346.23876953125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -328.46435546875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8160732388496399,
        0.5452976226806641,
        -0.19150692224502563
      ],
      "plane_d": 1154.8895263671875,
      "bbox_min": [
        -346.23876953125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -328.46435546875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16313675045967102,
        0.8203286528587341,
        -0.5481306910514832
      ],
      "plane_d": 2269.825927734375,
      "bbox_min": [
        -345.53564453125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -328.46435546875,
        -2402.561279296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16313259303569794,
        0.8203077912330627,
        -0.5481631755828857
      ],
      "plane_d": 2379.749755859375,
      "bbox_min": [
        -345.53564453125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -328.46435546875,
        -2402.561279296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4647390842437744,
        0.6954092383384705,
        -0.5481091141700745
      ],
      "plane_d": 2180.12548828125,
      "bbox_min": [
        -345.53564453125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -328.46435546875,
        -2403.264404296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6954092383384705,
        0.4647390842437744,
        -0.5481091141700745
      ],
      "plane_d": 1232.8253173828125,
      "bbox_min": [
        -345.53564453125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -328.46435546875,
        -2403.264404296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6953831315040588,
        0.4647216498851776,
        -0.5481569766998291
      ],
      "plane_d": 1701.511474609375,
      "bbox_min": [
        -343.53271484375,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -328.46435546875,
        -2403.264404296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4647216498851776,
        0.6953831315040588,
        -0.5481569766998291
      ],
      "plane_d": 1866.865478515625,
      "bbox_min": [
        -343.53271484375,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -330.46728515625,
        -2403.264404296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46815547347068787,
        0.31280118227005005,
        -0.8264296054840088
      ],
      "plane_d": 1123.6630859375,
      "bbox_min": [
        -343.53271484375,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -330.46728515625,
        -2404.72900390625,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46815043687820435,
        0.312797874212265,
        -0.8264337182044983
      ],
      "plane_d": 1439.19287109375,
      "bbox_min": [
        -342.0,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -330.46728515625,
        -2404.72900390625,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31280118227005005,
        0.46815547347068787,
        -0.8264296054840088
      ],
      "plane_d": 1761.5289306640625,
      "bbox_min": [
        -342.0,
        -2408.312255859375,
        641.0
      ],
      "bbox_max": [
        -332.0,
        -2404.72900390625,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.312797874212265,
        0.46815043687820435,
        -0.8264337182044983
      ],
      "plane_d": 1550.692626953125,
      "bbox_min": [
        -342.0,
        -2408.312255859375,
        641.0
      ],
      "bbox_max": [
        -334.2939453125,
        -2404.72900390625,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10985693335533142,
        0.5522241592407227,
        -0.8264260292053223
      ],
      "plane_d": 1895.8912353515625,
      "bbox_min": [
        -339.7060546875,
        -2407.242919921875,
        641.0
      ],
      "bbox_max": [
        -334.2939453125,
        -2404.72900390625,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10985572636127472,
        0.5522180795669556,
        -0.8264302611351013
      ],
      "plane_d": 1821.836181640625,
      "bbox_min": [
        -339.7060546875,
        -2407.242919921875,
        641.0
      ],
      "bbox_max": [
        -337.0,
        -2404.72900390625,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9798362851142883,
        0.19980166852474213,
        -0.000411680230172351
      ],
      "plane_d": 763.3489379882812,
      "bbox_min": [
        -310.95697021484375,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -287.04302978515625,
        -2401.800048828125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9798362851142883,
        0.19980166852474213,
        -0.000400588265620172
      ],
      "plane_d": 177.39939880371094,
      "bbox_min": [
        -310.95697021484375,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -287.047607421875,
        -2401.800048828125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509324431419373,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 2413.981689453125,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -287.047607421875,
        -2401.800048828125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509324431419373,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 2297.31591796875,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -287.047607421875,
        -2401.800048828125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269850611686707,
        0.9238733053207397,
        -8.707995675649727e-07
      ],
      "plane_d": 2342.625244140625,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -287.047607421875,
        -2401.800048828125,
        660.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.960491955280304,
        0.19574043154716492,
        -0.19784054160118103
      ],
      "plane_d": 301.8201599121094,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -306.81939697265625,
        -2407.21142578125,
        649.3076782226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8203592896461487,
        0.1734265685081482,
        -0.5449163913726807
      ],
      "plane_d": 515.2882690429688,
      "bbox_min": [
        -310.0452880859375,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -306.81939697265625,
        -2407.557373046875,
        644.9067993164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5541764497756958,
        0.11502812802791595,
        -0.8244131207466125
      ],
      "plane_d": 635.4688720703125,
      "bbox_min": [
        -307.470458984375,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -306.81939697265625,
        -2408.55322265625,
        641.0274658203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8191738724708557,
        0.1672101467847824,
        -0.5486300587654114
      ],
      "plane_d": 503.0599670410156,
      "bbox_min": [
        -310.04296875,
        -2411.48828125,
        641.0137329101562
      ],
      "bbox_max": [
        -306.83837890625,
        -2407.557373046875,
        644.9067993164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8191738724708557,
        0.1672101467847824,
        -0.5486300587654114
      ],
      "plane_d": 503.0599670410156,
      "bbox_min": [
        -310.0556640625,
        -2411.5,
        644.90380859375
      ],
      "bbox_max": [
        -309.242431640625,
        -2407.557373046875,
        644.91943359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3827075958251953,
        0.9238695502281189,
        -8.666777375765378e-07
      ],
      "plane_d": 2113.759765625,
      "bbox_min": [
        -308.23876953125,
        -2411.5,
        641.0
      ],
      "bbox_max": [
        -287.047607421875,
        -2401.800048828125,
        660.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9604577422142029,
        0.1974814385175705,
        -0.19627024233341217
      ],
      "plane_d": 879.3633422851562,
      "bbox_min": [
        -288.757568359375,
        -2411.5,
        644.9067993164062
      ],
      "bbox_max": [
        -287.047607421875,
        -2407.557373046875,
        649.3076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314626216888428,
        0.555580735206604,
        0.0
      ],
      "plane_d": 1578.7491455078125,
      "bbox_min": [
        -308.23876953125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -289.76123046875,
        -2401.800048828125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.555580735206604,
        0.8314626216888428,
        0.0
      ],
      "plane_d": 2161.63232421875,
      "bbox_min": [
        -308.23876953125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -289.76123046875,
        -2401.800048828125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19148309528827667,
        0.9626355767250061,
        -0.1914861500263214
      ],
      "plane_d": 2379.175048828125,
      "bbox_min": [
        -308.23876953125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -289.76123046875,
        -2401.800048828125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19148465991020203,
        0.9626434445381165,
        -0.19144512712955475
      ],
      "plane_d": 2493.674560546875,
      "bbox_min": [
        -308.23876953125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -289.76123046875,
        -2401.800048828125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5452976226806641,
        0.8160732388496399,
        -0.19150692224502563
      ],
      "plane_d": 2246.0068359375,
      "bbox_min": [
        -308.23876953125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -289.76123046875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5453042387962341,
        0.8160831928253174,
        -0.1914459615945816
      ],
      "plane_d": 1919.9012451171875,
      "bbox_min": [
        -308.23876953125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -289.76123046875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8160732388496399,
        0.5452976226806641,
        -0.19150692224502563
      ],
      "plane_d": 1185.900390625,
      "bbox_min": [
        -308.23876953125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -289.76123046875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8160831928253174,
        0.5453042387962341,
        -0.1914459615945816
      ],
      "plane_d": 1673.891357421875,
      "bbox_min": [
        -307.53564453125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -289.76123046875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16313675045967102,
        0.8203286528587341,
        -0.5481306910514832
      ],
      "plane_d": 2276.025146484375,
      "bbox_min": [
        -307.53564453125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -290.46435546875,
        -2402.561279296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16313259303569794,
        0.8203077912330627,
        -0.5481631755828857
      ],
      "plane_d": 2373.550537109375,
      "bbox_min": [
        -307.53564453125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -290.46435546875,
        -2402.561279296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6954092383384705,
        0.4647390842437744,
        -0.5481091141700745
      ],
      "plane_d": 1259.2508544921875,
      "bbox_min": [
        -307.53564453125,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -290.46435546875,
        -2403.264404296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4647390842437744,
        0.6954092383384705,
        -0.5481091141700745
      ],
      "plane_d": 2162.46533203125,
      "bbox_min": [
        -305.53271484375,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -290.46435546875,
        -2403.264404296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4647216498851776,
        0.6953831315040588,
        -0.5481569766998291
      ],
      "plane_d": 1884.52490234375,
      "bbox_min": [
        -305.53271484375,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -290.46435546875,
        -2403.264404296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6953831315040588,
        0.4647216498851776,
        -0.5481569766998291
      ],
      "plane_d": 1675.0869140625,
      "bbox_min": [
        -305.53271484375,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -290.46435546875,
        -2404.72900390625,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46815547347068787,
        0.31280118227005005,
        -0.8264296054840088
      ],
      "plane_d": 1141.4530029296875,
      "bbox_min": [
        -305.53271484375,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -292.46728515625,
        -2404.72900390625,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46815043687820435,
        0.312797874212265,
        -0.8264337182044983
      ],
      "plane_d": 1421.403076171875,
      "bbox_min": [
        -304.0,
        -2409.91259765625,
        641.0
      ],
      "bbox_max": [
        -292.46728515625,
        -2404.72900390625,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31280118227005005,
        0.46815547347068787,
        -0.8264296054840088
      ],
      "plane_d": 1749.6424560546875,
      "bbox_min": [
        -304.0,
        -2408.312255859375,
        641.0
      ],
      "bbox_max": [
        -294.0,
        -2404.72900390625,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.312797874212265,
        0.46815043687820435,
        -0.8264337182044983
      ],
      "plane_d": 1562.578857421875,
      "bbox_min": [
        -304.0,
        -2408.312255859375,
        641.0
      ],
      "bbox_max": [
        -296.2939453125,
        -2404.72900390625,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10985693335533142,
        0.5522241592407227,
        -0.8264260292053223
      ],
      "plane_d": 1891.7166748046875,
      "bbox_min": [
        -301.7060546875,
        -2407.242919921875,
        641.0
      ],
      "bbox_max": [
        -296.2939453125,
        -2404.72900390625,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10985572636127472,
        0.5522180795669556,
        -0.8264302611351013
      ],
      "plane_d": 1826.0107421875,
      "bbox_min": [
        -301.7060546875,
        -2407.242919921875,
        641.0
      ],
      "bbox_max": [
        -299.0,
        -2404.72900390625,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -376.84716796875,
      "bbox_min": [
        -435.0,
        -2389.5,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.5105127861024812e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2273.313232421875,
      "bbox_min": [
        -376.84716796875,
        -2389.5,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.5105127861024812e-05,
        -1.1625744264165405e-05
      ],
      "plane_d": 294.6487731933594,
      "bbox_min": [
        -376.84716796875,
        -2389.5,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.3037109375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.5105127861024812e-05,
        0.0
      ],
      "plane_d": -341.5956726074219,
      "bbox_min": [
        -376.84716796875,
        -2389.5,
        712.0
      ],
      "bbox_max": [
        -294.69732666015625,
        -2273.3037109375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2320.260009765625,
      "bbox_min": [
        -341.6556701660156,
        -2389.5,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2273.304931640625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826742172241211,
        0.9238833785057068,
        0.0
      ],
      "plane_d": 1997.5067138671875,
      "bbox_min": [
        -331.8150634765625,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2283.143310546875,
        746.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        0.3826742172241211,
        0.0
      ],
      "plane_d": 581.9741821289062,
      "bbox_min": [
        -325.7430419921875,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2294.0,
        746.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.639186151209287e-06,
        0.0,
        -1.0
      ],
      "plane_d": 745.820556640625,
      "bbox_min": [
        -321.5,
        -2297.0,
        745.8181762695312
      ],
      "bbox_max": [
        -318.5,
        -2294.0,
        745.8181762695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.639186151209287e-06,
        0.0,
        -1.0
      ],
      "plane_d": 745.820556640625,
      "bbox_min": [
        -325.7430419921875,
        -2297.0,
        745.8181762695312
      ],
      "bbox_max": [
        -320.62127685546875,
        -2294.878662109375,
        745.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071284055709839,
        -0.7070851922035217,
        0.0
      ],
      "plane_d": -1385.390625,
      "bbox_min": [
        -331.8150634765625,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2283.143310546875,
        745.8182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        7.639186151209287e-06,
        0.0,
        -1.0
      ],
      "plane_d": 745.820556640625,
      "bbox_min": [
        -331.8150634765625,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2283.143310546875,
        745.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.16076059587067e-05,
        0.0
      ],
      "plane_d": 331.76544189453125,
      "bbox_min": [
        -331.8150634765625,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2283.143310546875,
        741.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -2.1607138478429988e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2283.150390625,
      "bbox_min": [
        -331.8150634765625,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2283.143310546875,
        741.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        6.248028057598276e-06,
        2.5882093268592143e-06,
        -1.0
      ],
      "plane_d": 727.326171875,
      "bbox_min": [
        -331.8150634765625,
        -2297.0,
        715.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2283.143310546875,
        741.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        6.248028057598276e-06,
        2.5882093268592143e-06,
        -1.0
      ],
      "plane_d": 739.326171875,
      "bbox_min": [
        -331.8150634765625,
        -2297.0,
        727.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2283.143310546875,
        741.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071317434310913,
        -0.7070817947387695,
        0.0
      ],
      "plane_d": -1387.2294921875,
      "bbox_min": [
        -329.9674072265625,
        -2297.0,
        739.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2284.990966796875,
        741.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.49937511398457e-05,
        0.0
      ],
      "plane_d": 329.9100036621094,
      "bbox_min": [
        -329.9674072265625,
        -2297.0,
        739.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2284.990966796875,
        741.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.4993127226480283e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2284.9990234375,
      "bbox_min": [
        -323.06005859375,
        -2284.990966796875,
        739.3182373046875
      ],
      "bbox_max": [
        -318.5,
        -2284.990966796875,
        741.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071317434310913,
        -0.7070817947387695,
        0.0
      ],
      "plane_d": -1387.2294921875,
      "bbox_min": [
        -329.9674072265625,
        -2297.0,
        727.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2284.990966796875,
        729.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.49937511398457e-05,
        0.0
      ],
      "plane_d": 329.9100036621094,
      "bbox_min": [
        -329.9674072265625,
        -2297.0,
        727.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2284.990966796875,
        729.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.4993127226480283e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2284.9990234375,
      "bbox_min": [
        -323.06005859375,
        -2284.990966796875,
        727.3182373046875
      ],
      "bbox_max": [
        -318.5,
        -2284.990966796875,
        729.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.248028057598276e-06,
        2.5882093268592143e-06,
        -1.0
      ],
      "plane_d": 715.326171875,
      "bbox_min": [
        -331.8150634765625,
        -2297.0,
        715.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2283.143310546875,
        717.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071317434310913,
        -0.7070817947387695,
        0.0
      ],
      "plane_d": -1387.2294921875,
      "bbox_min": [
        -329.9674072265625,
        -2297.0,
        715.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2284.990966796875,
        717.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.49937511398457e-05,
        0.0
      ],
      "plane_d": 329.9100036621094,
      "bbox_min": [
        -329.9674072265625,
        -2297.0,
        715.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2284.990966796875,
        717.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.4993127226480283e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2284.9990234375,
      "bbox_min": [
        -323.06005859375,
        -2284.990966796875,
        715.3182373046875
      ],
      "bbox_max": [
        -318.5,
        -2284.990966796875,
        717.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5372592806816101,
        0.5372592806816101,
        -0.6501576900482178
      ],
      "plane_d": 1530.2041015625,
      "bbox_min": [
        -341.653076171875,
        -2287.05810546875,
        746.0
      ],
      "bbox_max": [
        -327.900634765625,
        -2273.304931640625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070879340171814,
        -0.7071256041526794,
        0.0
      ],
      "plane_d": -1872.5697021484375,
      "bbox_min": [
        -341.6536865234375,
        -2320.260009765625,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        -0.3826742172241211,
        -0.0
      ],
      "plane_d": -1176.0311279296875,
      "bbox_min": [
        -331.815185546875,
        -2310.421630859375,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        746.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826742172241211,
        -0.9238833785057068,
        -0.0
      ],
      "plane_d": -2246.8134765625,
      "bbox_min": [
        -321.4999694824219,
        -2304.24267578125,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        746.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.639186151209287e-06,
        0.0,
        -1.0
      ],
      "plane_d": 745.820556640625,
      "bbox_min": [
        -321.4999694824219,
        -2299.999755859375,
        745.8181762695312
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        745.8181762695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.639186151209287e-06,
        0.0,
        -1.0
      ],
      "plane_d": 745.820556640625,
      "bbox_min": [
        -320.6213684082031,
        -2304.24267578125,
        745.8181762695312
      ],
      "bbox_max": [
        -318.5,
        -2299.12109375,
        745.8181762695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070851922035217,
        0.7071284055709839,
        -0.0
      ],
      "plane_d": 1862.73681640625,
      "bbox_min": [
        -331.815185546875,
        -2310.421630859375,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        745.8182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        7.639186151209287e-06,
        0.0,
        -1.0
      ],
      "plane_d": 745.820556640625,
      "bbox_min": [
        -331.815185546875,
        -2310.421630859375,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        745.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.16076059587067e-05,
        0.0
      ],
      "plane_d": 331.76544189453125,
      "bbox_min": [
        -331.815185546875,
        -2310.421630859375,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        741.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        2.16076059587067e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2310.4287109375,
      "bbox_min": [
        -331.815185546875,
        -2310.421630859375,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        741.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -2.5882093268592143e-06,
        6.248028057598276e-06,
        -1.0
      ],
      "plane_d": 727.331787109375,
      "bbox_min": [
        -331.815185546875,
        -2310.421630859375,
        715.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        741.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -2.5882093268592143e-06,
        6.248028057598276e-06,
        -1.0
      ],
      "plane_d": 739.331787109375,
      "bbox_min": [
        -331.815185546875,
        -2310.421630859375,
        727.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        741.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7070817947387695,
        0.7071317434310913,
        -0.0
      ],
      "plane_d": 1860.8956298828125,
      "bbox_min": [
        -329.967529296875,
        -2308.573974609375,
        739.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        741.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.49937511398457e-05,
        0.0
      ],
      "plane_d": 329.9100036621094,
      "bbox_min": [
        -329.967529296875,
        -2308.573974609375,
        739.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        741.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.49937511398457e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2308.58203125,
      "bbox_min": [
        -323.059814453125,
        -2308.573974609375,
        739.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2308.573974609375,
        741.3181762695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070817947387695,
        0.7071317434310913,
        -0.0
      ],
      "plane_d": 1860.8956298828125,
      "bbox_min": [
        -329.967529296875,
        -2308.573974609375,
        727.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        729.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.49937511398457e-05,
        0.0
      ],
      "plane_d": 329.9100036621094,
      "bbox_min": [
        -329.967529296875,
        -2308.573974609375,
        727.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        729.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.49937511398457e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2308.58203125,
      "bbox_min": [
        -323.059814453125,
        -2308.573974609375,
        727.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2308.573974609375,
        729.3181762695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.5882093268592143e-06,
        6.248028057598276e-06,
        -1.0
      ],
      "plane_d": 715.331787109375,
      "bbox_min": [
        -331.815185546875,
        -2310.421630859375,
        715.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        717.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7070817947387695,
        0.7071317434310913,
        -0.0
      ],
      "plane_d": 1860.8956298828125,
      "bbox_min": [
        -329.967529296875,
        -2308.573974609375,
        715.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        717.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.49937511398457e-05,
        0.0
      ],
      "plane_d": 329.9100036621094,
      "bbox_min": [
        -329.967529296875,
        -2308.573974609375,
        715.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        717.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.49937511398457e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2308.58203125,
      "bbox_min": [
        -323.059814453125,
        -2308.573974609375,
        715.3181762695312
      ],
      "bbox_max": [
        -318.5,
        -2308.573974609375,
        717.3181762695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5364111065864563,
        -0.5364397168159485,
        -0.6515332460403442
      ],
      "plane_d": -934.5252075195312,
      "bbox_min": [
        -341.6536865234375,
        -2320.260009765625,
        746.0
      ],
      "bbox_max": [
        -327.900390625,
        -2306.507568359375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": 2481.4453125,
      "bbox_min": [
        -341.65521240234375,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2320.260009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2375.3154296875,
      "bbox_min": [
        -341.65521240234375,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2320.260009765625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.37136074900627136,
        0.8962519764900208,
        -0.24253582954406738
      ],
      "plane_d": 2429.8193359375,
      "bbox_min": [
        -341.65521240234375,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2320.260009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3827912509441376,
        0.9238348603248596,
        0.0
      ],
      "plane_d": 2322.099609375,
      "bbox_min": [
        -341.65521240234375,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2320.260009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.961749255657196,
        0.2739313840866089
      ],
      "plane_d": 2081.724609375,
      "bbox_min": [
        -341.6547546386719,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2320.260009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -325.60009765625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2367.3154296875,
        735.3721313476562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -323.39990234375,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2367.3154296875,
        735.3721313476562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -325.60009765625,
        -2373.972412109375,
        729.6334228515625
      ],
      "bbox_max": [
        -325.60009765625,
        -2367.269775390625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3828097879886627,
        -0.9238271713256836,
        0.0
      ],
      "plane_d": -2304.471923828125,
      "bbox_min": [
        -341.6547546386719,
        -2367.57177734375,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2320.260009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -716.0,
      "bbox_min": [
        -341.6547546386719,
        -2357.699951171875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2320.260009765625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2357.699951171875,
      "bbox_min": [
        -341.6546936035156,
        -2357.699951171875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2350.746337890625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3828069269657135,
        0.9238283634185791,
        0.0
      ],
      "plane_d": 2302.473876953125,
      "bbox_min": [
        -341.6546936035156,
        -2355.699951171875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2350.746337890625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2355.699951171875,
      "bbox_min": [
        -329.699951171875,
        -2355.699951171875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2355.699951171875,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7566943764686584,
        -0.65376877784729
      ],
      "plane_d": -1268.0162353515625,
      "bbox_min": [
        -332.7588806152344,
        -2323.7158203125,
        746.0
      ],
      "bbox_max": [
        -318.5,
        -2320.260009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5364111065864563,
        -0.5364397168159485,
        -0.6515332460403442
      ],
      "plane_d": -934.5252075195312,
      "bbox_min": [
        -332.7588806152344,
        -2323.7158203125,
        746.0
      ],
      "bbox_max": [
        -327.8636169433594,
        -2320.260009765625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2996884286403656,
        -0.7232757806777954,
        -0.6221407055854797
      ],
      "plane_d": -1312.3388671875,
      "bbox_min": [
        -330.3212585449219,
        -2323.7158203125,
        746.0
      ],
      "bbox_max": [
        -327.8636169433594,
        -2320.260009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": 2385.87939453125,
      "bbox_min": [
        -325.60009765625,
        -2367.57177734375,
        748.7863159179688
      ],
      "bbox_max": [
        -323.39990234375,
        -2366.76416015625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -325.60009765625,
        -2367.57177734375,
        748.7863159179688
      ],
      "bbox_max": [
        -323.39990234375,
        -2366.76416015625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -325.60009765625,
        -2367.57177734375,
        748.7863159179688
      ],
      "bbox_max": [
        -325.60009765625,
        -2366.76416015625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2320.260009765625,
      "bbox_min": [
        -318.5,
        -2389.5,
        712.0
      ],
      "bbox_max": [
        -294.69732666015625,
        -2273.305419921875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        0.3826742172241211,
        0.0
      ],
      "plane_d": 1170.4879150390625,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -304.53662109375,
        -2283.143310546875,
        746.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826742172241211,
        0.9238833785057068,
        0.0
      ],
      "plane_d": 2241.270263671875,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -315.5000305175781,
        -2289.75732421875,
        746.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.639186151209287e-06,
        0.0,
        -1.0
      ],
      "plane_d": 745.820556640625,
      "bbox_min": [
        -318.5,
        -2297.0,
        745.8181762695312
      ],
      "bbox_max": [
        -315.5000305175781,
        -2294.0,
        745.8181762695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.639186151209287e-06,
        0.0,
        -1.0
      ],
      "plane_d": 745.820556640625,
      "bbox_min": [
        -318.5,
        -2294.878662109375,
        745.8181762695312
      ],
      "bbox_max": [
        -316.3786926269531,
        -2289.75732421875,
        745.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070959806442261,
        -0.7071175575256348,
        0.0
      ],
      "plane_d": -1835.43701171875,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -304.53662109375,
        -2283.143310546875,
        745.8182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        7.639186151209287e-06,
        0.0,
        -1.0
      ],
      "plane_d": 745.820556640625,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -304.53662109375,
        -2283.143310546875,
        745.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1607138478429988e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2283.150390625,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -304.53662109375,
        -2283.143310546875,
        741.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -304.53662109375,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -304.53662109375,
        -2283.143310546875,
        741.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        2.588235929579241e-06,
        -6.248092176974751e-06,
        -1.0
      ],
      "plane_d": 727.3046875,
      "bbox_min": [
        -318.5,
        -2297.0,
        715.3181762695312
      ],
      "bbox_max": [
        -304.53662109375,
        -2283.143310546875,
        741.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        2.588235929579241e-06,
        -6.248092176974751e-06,
        -1.0
      ],
      "plane_d": 739.3046875,
      "bbox_min": [
        -318.5,
        -2297.0,
        727.3181762695312
      ],
      "bbox_max": [
        -304.53662109375,
        -2283.143310546875,
        741.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7070943117141724,
        -0.7071192860603333,
        0.0
      ],
      "plane_d": -1837.2882080078125,
      "bbox_min": [
        -318.5,
        -2297.0,
        739.3181762695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2284.990966796875,
        741.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.4993127226480283e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2284.9990234375,
      "bbox_min": [
        -318.5,
        -2297.0,
        739.3181762695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2284.990966796875,
        741.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -306.38427734375,
      "bbox_min": [
        -306.38427734375,
        -2297.0,
        739.3182373046875
      ],
      "bbox_max": [
        -306.38427734375,
        -2291.8984375,
        741.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070943117141724,
        -0.7071192860603333,
        0.0
      ],
      "plane_d": -1837.2882080078125,
      "bbox_min": [
        -318.5,
        -2297.0,
        727.3181762695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2284.990966796875,
        729.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.4993127226480283e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2284.9990234375,
      "bbox_min": [
        -318.5,
        -2297.0,
        727.3181762695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2284.990966796875,
        729.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -306.38427734375,
      "bbox_min": [
        -306.38427734375,
        -2297.0,
        727.3182373046875
      ],
      "bbox_max": [
        -306.38427734375,
        -2291.8984375,
        729.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.588235929579241e-06,
        -6.248092176974751e-06,
        -1.0
      ],
      "plane_d": 715.3046875,
      "bbox_min": [
        -318.5,
        -2297.0,
        715.3181762695312
      ],
      "bbox_max": [
        -304.53662109375,
        -2283.143310546875,
        717.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7070943117141724,
        -0.7071192860603333,
        0.0
      ],
      "plane_d": -1837.2882080078125,
      "bbox_min": [
        -318.5,
        -2297.0,
        715.3181762695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2284.990966796875,
        717.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.4993127226480283e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2284.9990234375,
      "bbox_min": [
        -318.5,
        -2297.0,
        715.3181762695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2284.990966796875,
        717.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -306.38427734375,
      "bbox_min": [
        -306.38427734375,
        -2297.0,
        715.3182373046875
      ],
      "bbox_max": [
        -306.38427734375,
        -2291.8984375,
        717.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5349872708320618,
        0.5349872708320618,
        -0.6538938879966736
      ],
      "plane_d": 1869.0113525390625,
      "bbox_min": [
        -308.451171875,
        -2287.057861328125,
        746.0
      ],
      "bbox_max": [
        -294.69732666015625,
        -2273.305419921875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071130871772766,
        -0.707100510597229,
        0.0
      ],
      "plane_d": -1422.54736328125,
      "bbox_min": [
        -318.5,
        -2320.260009765625,
        712.0
      ],
      "bbox_max": [
        -294.697998046875,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        -0.3826742172241211,
        0.0
      ],
      "plane_d": -587.5174560546875,
      "bbox_min": [
        -318.5,
        -2310.421875,
        712.0
      ],
      "bbox_max": [
        -304.53662109375,
        -2297.0,
        746.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826742172241211,
        -0.9238833785057068,
        0.0
      ],
      "plane_d": -2003.050048828125,
      "bbox_min": [
        -318.5,
        -2304.24267578125,
        712.0
      ],
      "bbox_max": [
        -315.5000305175781,
        -2297.0,
        746.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.639186151209287e-06,
        0.0,
        -1.0
      ],
      "plane_d": 745.820556640625,
      "bbox_min": [
        -318.5,
        -2300.0,
        745.8181762695312
      ],
      "bbox_max": [
        -315.5000305175781,
        -2297.0,
        745.8181762695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.639186151209287e-06,
        0.0,
        -1.0
      ],
      "plane_d": 745.820556640625,
      "bbox_min": [
        -318.5,
        -2304.24267578125,
        745.8181762695312
      ],
      "bbox_max": [
        -316.37872314453125,
        -2299.121337890625,
        745.8181762695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1412.7254638671875,
      "bbox_min": [
        -318.5,
        -2310.421875,
        712.0
      ],
      "bbox_max": [
        -304.53662109375,
        -2297.0,
        745.8182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        7.639186151209287e-06,
        0.0,
        -1.0
      ],
      "plane_d": 745.820556640625,
      "bbox_min": [
        -318.5,
        -2310.421875,
        712.0
      ],
      "bbox_max": [
        -304.53662109375,
        -2297.0,
        745.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.16076059587067e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2310.4287109375,
      "bbox_min": [
        -318.5,
        -2310.421875,
        712.0
      ],
      "bbox_max": [
        -304.53662109375,
        -2297.0,
        741.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -304.53662109375,
      "bbox_min": [
        -318.5,
        -2310.421875,
        712.0
      ],
      "bbox_max": [
        -304.53662109375,
        -2297.0,
        741.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        6.247936653380748e-06,
        2.5881715828290908e-06,
        -1.0
      ],
      "plane_d": 727.3261108398438,
      "bbox_min": [
        -318.5,
        -2310.421875,
        715.3181762695312
      ],
      "bbox_max": [
        -304.53662109375,
        -2297.0,
        741.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        6.247936653380748e-06,
        2.5881715828290908e-06,
        -1.0
      ],
      "plane_d": 739.3261108398438,
      "bbox_min": [
        -318.5,
        -2310.421875,
        727.3181762695312
      ],
      "bbox_max": [
        -304.53662109375,
        -2297.0,
        741.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1410.877685546875,
      "bbox_min": [
        -318.5,
        -2308.57421875,
        739.3181762695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2297.0,
        741.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.49937511398457e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2308.58203125,
      "bbox_min": [
        -318.5,
        -2308.57421875,
        739.3181762695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2297.0,
        741.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -306.38427734375,
      "bbox_min": [
        -306.38427734375,
        -2301.666748046875,
        739.3182373046875
      ],
      "bbox_max": [
        -306.38427734375,
        -2297.0,
        741.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1410.877685546875,
      "bbox_min": [
        -318.5,
        -2308.57421875,
        727.3181762695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2297.0,
        729.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.49937511398457e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2308.58203125,
      "bbox_min": [
        -318.5,
        -2308.57421875,
        727.3181762695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2297.0,
        729.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -306.38427734375,
      "bbox_min": [
        -306.38427734375,
        -2301.666748046875,
        727.3182373046875
      ],
      "bbox_max": [
        -306.38427734375,
        -2297.0,
        729.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.247936653380748e-06,
        2.5881715828290908e-06,
        -1.0
      ],
      "plane_d": 715.3261108398438,
      "bbox_min": [
        -318.5,
        -2310.421875,
        715.3181762695312
      ],
      "bbox_max": [
        -304.53662109375,
        -2297.0,
        717.3182373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1410.877685546875,
      "bbox_min": [
        -318.5,
        -2308.57421875,
        715.3181762695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2297.0,
        717.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.49937511398457e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2308.58203125,
      "bbox_min": [
        -318.5,
        -2308.57421875,
        715.3181762695312
      ],
      "bbox_max": [
        -306.38427734375,
        -2297.0,
        717.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -306.38427734375,
      "bbox_min": [
        -306.38427734375,
        -2301.666748046875,
        715.3182373046875
      ],
      "bbox_max": [
        -306.38427734375,
        -2297.0,
        717.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5341558456420898,
        -0.5341463088989258,
        -0.6552596688270569
      ],
      "plane_d": -585.7737426757812,
      "bbox_min": [
        -308.450927734375,
        -2320.260009765625,
        746.0
      ],
      "bbox_max": [
        -294.697998046875,
        -2306.50732421875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": 2481.4453125,
      "bbox_min": [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -294.699462890625,
        -2320.260009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2375.3154296875,
      "bbox_min": [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -294.699462890625,
        -2320.260009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3713609576225281,
        0.896252453327179,
        -0.24253378808498383
      ],
      "plane_d": 2193.633544921875,
      "bbox_min": [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -294.699462890625,
        -2320.260009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827912509441376,
        0.9238348603248596,
        0.0
      ],
      "plane_d": 2078.644287109375,
      "bbox_min": [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -294.699462890625,
        -2320.260009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.961749255657196,
        0.2739313840866089
      ],
      "plane_d": 2081.724609375,
      "bbox_min": [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -294.699462890625,
        -2320.260009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -312.60009765625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2367.3154296875,
        735.3721313476562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -312.60009765625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -312.60009765625,
        -2367.3154296875,
        735.3721313476562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -312.60009765625,
        -2373.972412109375,
        729.6334228515625
      ],
      "bbox_max": [
        -312.60009765625,
        -2367.269775390625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -716.0,
      "bbox_min": [
        -318.5,
        -2357.699951171875,
        712.0
      ],
      "bbox_max": [
        -294.699462890625,
        -2320.260009765625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3828069269657135,
        0.9238283634185791,
        0.0
      ],
      "plane_d": 2059.008544921875,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        712.0
      ],
      "bbox_max": [
        -294.699462890625,
        -2350.89306640625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2355.699951171875,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        712.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2355.699951171875,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7566943764686584,
        -0.65376877784729
      ],
      "plane_d": -1268.0162353515625,
      "bbox_min": [
        -318.5,
        -2323.7158203125,
        746.0
      ],
      "bbox_max": [
        -303.5440368652344,
        -2320.260009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29901179671287537,
        -0.7216429114341736,
        -0.6243584752082825
      ],
      "plane_d": -1116.3973388671875,
      "bbox_min": [
        -308.450927734375,
        -2323.7158203125,
        746.0
      ],
      "bbox_max": [
        -305.9815979003906,
        -2320.260009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": 2385.87939453125,
      "bbox_min": [
        -312.60009765625,
        -2367.57177734375,
        748.7863159179688
      ],
      "bbox_max": [
        -310.39990234375,
        -2366.76416015625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -312.60009765625,
        -2367.57177734375,
        748.7863159179688
      ],
      "bbox_max": [
        -310.39990234375,
        -2366.76416015625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -312.60009765625,
        -2367.57177734375,
        748.7863159179688
      ],
      "bbox_max": [
        -312.60009765625,
        -2366.76416015625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37136074900627136,
        0.8962519764900208,
        -0.24253582954406738
      ],
      "plane_d": 2429.8193359375,
      "bbox_min": [
        -376.84716796875,
        -2371.97900390625,
        712.0
      ],
      "bbox_max": [
        -341.6529541015625,
        -2273.3037109375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3827912509441376,
        0.9238348603248596,
        0.0
      ],
      "plane_d": 2322.099609375,
      "bbox_min": [
        -376.84716796875,
        -2371.97900390625,
        712.0
      ],
      "bbox_max": [
        -341.6529541015625,
        -2273.3037109375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1909.8232421875,
      "bbox_min": [
        -376.84716796875,
        -2363.364013671875,
        712.0
      ],
      "bbox_max": [
        -341.6529541015625,
        -2273.3037109375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -716.0,
      "bbox_min": [
        -376.84716796875,
        -2352.9111328125,
        712.0
      ],
      "bbox_max": [
        -341.6529541015625,
        -2273.3037109375,
        750.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9238795638084412,
        0.3826833665370941,
        0.0
      ],
      "plane_d": 1231.6060791015625,
      "bbox_min": [
        -376.84716796875,
        -2352.9111328125,
        712.0
      ],
      "bbox_max": [
        -341.6546936035156,
        -2273.3037109375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        -0.382681667804718,
        0.0
      ],
      "plane_d": -1233.602294921875,
      "bbox_min": [
        -376.84716796875,
        -2331.314208984375,
        712.0
      ],
      "bbox_max": [
        -369.583740234375,
        -2313.778564453125,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1907.8232421875,
      "bbox_min": [
        -376.84716796875,
        -2352.9111328125,
        712.0
      ],
      "bbox_max": [
        -341.6546936035156,
        -2273.3037109375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3828097879886627,
        -0.9238271713256836,
        0.0
      ],
      "plane_d": -2304.471923828125,
      "bbox_min": [
        -352.46728515625,
        -2350.43212890625,
        712.0
      ],
      "bbox_max": [
        -347.6374816894531,
        -2348.4306640625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -526.3244018554688,
      "bbox_min": [
        -376.84716796875,
        -2352.9111328125,
        712.0
      ],
      "bbox_max": [
        -341.6546936035156,
        -2273.3037109375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.382681667804718,
        0.0
      ],
      "plane_d": 524.3202514648438,
      "bbox_min": [
        -376.84716796875,
        -2279.915771484375,
        712.0
      ],
      "bbox_max": [
        -374.1084289550781,
        -2273.3037109375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3828069269657135,
        0.9238283634185791,
        0.0
      ],
      "plane_d": 2302.473876953125,
      "bbox_min": [
        -351.334228515625,
        -2352.9111328125,
        712.0
      ],
      "bbox_max": [
        -341.6546936035156,
        -2346.7353515625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3828097879886627,
        -0.9238271713256836,
        0.0
      ],
      "plane_d": -2304.471923828125,
      "bbox_min": [
        -347.6374816894531,
        -2352.9111328125,
        712.0
      ],
      "bbox_max": [
        -341.6547546386719,
        -2350.43212890625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7598690986633301,
        1.9076609532930888e-05,
        -0.650076150894165
      ],
      "plane_d": 225.38882446289062,
      "bbox_min": [
        -345.0755310058594,
        -2311.36572265625,
        746.0
      ],
      "bbox_max": [
        -341.6529541015625,
        -2282.21728515625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5364111065864563,
        -0.5364397168159485,
        -0.6515332460403442
      ],
      "plane_d": -934.5252075195312,
      "bbox_min": [
        -345.0755310058594,
        -2311.36572265625,
        746.0
      ],
      "bbox_max": [
        -341.6529541015625,
        -2282.21728515625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5372592806816101,
        0.5372592806816101,
        -0.6501576900482178
      ],
      "plane_d": 1530.2041015625,
      "bbox_min": [
        -345.0755310058594,
        -2308.961669921875,
        746.0
      ],
      "bbox_max": [
        -341.6529541015625,
        -2282.21728515625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7249156832695007,
        -0.3002679944038391,
        -0.61994868516922
      ],
      "plane_d": -477.7586975097656,
      "bbox_min": [
        -345.0755310058594,
        -2308.961669921875,
        746.0
      ],
      "bbox_max": [
        -341.653076171875,
        -2284.621826171875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.725508987903595,
        0.30051371455192566,
        -0.6191350221633911
      ],
      "plane_d": 901.294677734375,
      "bbox_min": [
        -345.07513427734375,
        -2287.07861328125,
        746.0
      ],
      "bbox_max": [
        -341.653076171875,
        -2284.621826171875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707114577293396,
        0.7070989608764648,
        0.0
      ],
      "plane_d": 1927.423583984375,
      "bbox_min": [
        -376.84716796875,
        -2363.364013671875,
        712.0
      ],
      "bbox_max": [
        -359.6142578125,
        -2341.753662109375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -376.607177734375,
        -2358.548583984375,
        712.0
      ],
      "bbox_max": [
        -367.3384094238281,
        -2349.27978515625,
        730.4326171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1407.9442138671875,
      "bbox_min": [
        -367.414794921875,
        -2358.548583984375,
        712.0
      ],
      "bbox_max": [
        -367.3384094238281,
        -2358.47216796875,
        730.43212890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1394.9442138671875,
      "bbox_min": [
        -376.607177734375,
        -2349.356201171875,
        712.0
      ],
      "bbox_max": [
        -376.53070068359375,
        -2349.27978515625,
        730.4326171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6860026717185974,
        0.6859864592552185,
        -0.2425343543291092
      ],
      "plane_d": 2046.92529296875,
      "bbox_min": [
        -376.84716796875,
        -2363.364013671875,
        712.0
      ],
      "bbox_max": [
        -359.6142578125,
        -2341.753662109375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -376.84716796875,
        -2358.47216796875,
        729.9866943359375
      ],
      "bbox_max": [
        -363.802978515625,
        -2344.1884765625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1407.9442138671875,
      "bbox_min": [
        -367.3384094238281,
        -2358.47216796875,
        729.9866943359375
      ],
      "bbox_max": [
        -363.802978515625,
        -2354.936767578125,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1394.9442138671875,
      "bbox_min": [
        -376.84716796875,
        -2349.27978515625,
        729.9866943359375
      ],
      "bbox_max": [
        -372.9952087402344,
        -2344.1884765625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -376.84716796875,
        -2346.484619140625,
        737.0110473632812
      ],
      "bbox_max": [
        -374.551025390625,
        -2344.1884765625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -376.84716796875,
        -2358.47216796875,
        712.0
      ],
      "bbox_max": [
        -361.3681335449219,
        -2341.753662109375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1407.9442138671875,
      "bbox_min": [
        -367.3384094238281,
        -2358.47216796875,
        712.0
      ],
      "bbox_max": [
        -361.3681335449219,
        -2350.946044921875,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6801113486289978,
        0.6800045967102051,
        0.2739383578300476
      ],
      "plane_d": 1650.9686279296875,
      "bbox_min": [
        -366.864990234375,
        -2356.443115234375,
        712.0
      ],
      "bbox_max": [
        -361.3681335449219,
        -2350.946044921875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886816382408142,
        0.5886816382408142,
        -0.5539926886558533
      ],
      "plane_d": 2013.0999755859375,
      "bbox_min": [
        -363.494873046875,
        -2353.072998046875,
        748.7863159179688
      ],
      "bbox_max": [
        -361.3681335449219,
        -2350.946044921875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1394.9442138671875,
      "bbox_min": [
        -376.84716796875,
        -2349.27978515625,
        712.0
      ],
      "bbox_max": [
        -370.5605163574219,
        -2341.753662109375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -376.84716796875,
        -2347.250732421875,
        712.0
      ],
      "bbox_max": [
        -370.5605163574219,
        -2341.753662109375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5886816382408142,
        0.5886816382408142,
        -0.5539926886558533
      ],
      "plane_d": 2013.0999755859375,
      "bbox_min": [
        -372.687255859375,
        -2343.880615234375,
        748.7863159179688
      ],
      "bbox_max": [
        -370.5605163574219,
        -2341.753662109375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8962944149971008,
        0.3712576925754547,
        -0.2425367832183838
      ],
      "plane_d": 820.87255859375,
      "bbox_min": [
        -294.7000427246094,
        -2372.126220703125,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.306396484375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.0,
        -0.24253562092781067
      ],
      "plane_d": -55.33412170410156,
      "bbox_min": [
        -294.7000427246094,
        -2372.126220703125,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.306396484375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -244.53712463378906,
        -2304.60009765625,
        729.9993286132812
      ],
      "bbox_max": [
        -239.537109375,
        -2289.39990234375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -244.53712463378906,
        -2289.39990234375,
        729.9993286132812
      ],
      "bbox_max": [
        -239.537109375,
        -2289.39990234375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -244.53712463378906,
        -2304.60009765625,
        729.9993286132812
      ],
      "bbox_max": [
        -239.537109375,
        -2302.39990234375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -244.53712463378906,
        -2302.39990234375,
        729.9993286132812
      ],
      "bbox_max": [
        -239.537109375,
        -2302.39990234375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6860024333000183,
        0.6859862804412842,
        -0.24253544211387634
      ],
      "plane_d": 1610.6280517578125,
      "bbox_min": [
        -294.7000427246094,
        -2372.126220703125,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.306396484375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707114577293396,
        0.7070989608764648,
        0.0
      ],
      "plane_d": 1477.69873046875,
      "bbox_min": [
        -294.7000427246094,
        -2372.126220703125,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.306396484375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238787889480591,
        0.38268521428108215,
        0.0
      ],
      "plane_d": 663.6388549804688,
      "bbox_min": [
        -294.7000427246094,
        -2372.126220703125,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.306396484375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3713609576225281,
        0.896252453327179,
        -0.24253378808498383
      ],
      "plane_d": 2193.633544921875,
      "bbox_min": [
        -294.7000427246094,
        -2372.126220703125,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.306396484375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827912509441376,
        0.9238348603248596,
        0.0
      ],
      "plane_d": 2078.644287109375,
      "bbox_min": [
        -294.7000427246094,
        -2372.126220703125,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.306396484375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 257.15283203125,
      "bbox_min": [
        -294.6995849609375,
        -2357.737060546875,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.306396484375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238802790641785,
        -0.382681667804718,
        0.0
      ],
      "plane_d": -646.0144653320312,
      "bbox_min": [
        -294.6995849609375,
        -2357.737060546875,
        712.0
      ],
      "bbox_max": [
        -257.15283203125,
        -2273.306396484375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1460.103271484375,
      "bbox_min": [
        -294.6995849609375,
        -2353.057861328125,
        712.0
      ],
      "bbox_max": [
        -257.15283203125,
        -2273.306396484375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -716.0,
      "bbox_min": [
        -294.6995849609375,
        -2353.057861328125,
        712.0
      ],
      "bbox_max": [
        -257.15283203125,
        -2273.306396484375,
        750.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        0.3826833665370941,
        0.0
      ],
      "plane_d": 644.0186157226562,
      "bbox_min": [
        -294.6995849609375,
        -2353.057861328125,
        712.0
      ],
      "bbox_max": [
        -257.15283203125,
        -2273.306396484375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1458.1033935546875,
      "bbox_min": [
        -294.6995849609375,
        -2353.057861328125,
        712.0
      ],
      "bbox_max": [
        -257.15283203125,
        -2273.306396484375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3828097879886627,
        -0.9238271713256836,
        0.0
      ],
      "plane_d": -2061.0048828125,
      "bbox_min": [
        -288.36224365234375,
        -2350.431884765625,
        712.0
      ],
      "bbox_max": [
        -283.53271484375,
        -2348.4306640625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -259.15283203125,
      "bbox_min": [
        -294.6995849609375,
        -2353.057861328125,
        712.0
      ],
      "bbox_max": [
        -257.15283203125,
        -2273.306396484375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238802790641785,
        0.382681667804718,
        -0.0
      ],
      "plane_d": 1111.9080810546875,
      "bbox_min": [
        -259.15283203125,
        -2284.744140625,
        712.0
      ],
      "bbox_max": [
        -257.15283203125,
        -2279.91552734375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        -0.3826833665370941,
        -0.0
      ],
      "plane_d": -1113.9117431640625,
      "bbox_min": [
        -294.6995849609375,
        -2353.057861328125,
        712.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2273.306396484375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238802790641785,
        0.382681667804718,
        -0.0
      ],
      "plane_d": 1111.9080810546875,
      "bbox_min": [
        -261.89031982421875,
        -2279.91552734375,
        712.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2273.306640625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3828069269657135,
        0.9238283634185791,
        0.0
      ],
      "plane_d": 2059.008544921875,
      "bbox_min": [
        -294.6995849609375,
        -2353.057861328125,
        712.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2346.7353515625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3828097879886627,
        -0.9238271713256836,
        0.0
      ],
      "plane_d": -2061.0048828125,
      "bbox_min": [
        -294.6995849609375,
        -2353.057861328125,
        712.0
      ],
      "bbox_max": [
        -288.3622131347656,
        -2350.431884765625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553337812423706,
        0.0,
        -0.655340313911438
      ],
      "plane_d": 711.479248046875,
      "bbox_min": [
        -294.6980895996094,
        -2311.414306640625,
        746.0
      ],
      "bbox_max": [
        -291.2275390625,
        -2282.169677734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5341558456420898,
        -0.5341463088989258,
        -0.6552596688270569
      ],
      "plane_d": -585.7737426757812,
      "bbox_min": [
        -294.6980895996094,
        -2311.414306640625,
        746.0
      ],
      "bbox_max": [
        -291.2275390625,
        -2282.169677734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5349872708320618,
        0.5349872708320618,
        -0.6538938879966736
      ],
      "plane_d": 1869.0113525390625,
      "bbox_min": [
        -294.697998046875,
        -2308.96142578125,
        746.0
      ],
      "bbox_max": [
        -291.2275390625,
        -2282.169677734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.720969557762146,
        -0.2986334562301636,
        -0.6253166794776917
      ],
      "plane_d": -9.845726013183594,
      "bbox_min": [
        -294.697998046875,
        -2308.96142578125,
        746.0
      ],
      "bbox_max": [
        -291.2275390625,
        -2284.62158203125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7215692400932312,
        0.298881858587265,
        -0.6245057582855225
      ],
      "plane_d": 1362.08642578125,
      "bbox_min": [
        -294.697998046875,
        -2287.078369140625,
        746.0
      ],
      "bbox_max": [
        -291.2275390625,
        -2284.62158203125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1854.484130859375,
      "bbox_min": [
        -274.0576477050781,
        -2357.737060546875,
        712.0
      ],
      "bbox_max": [
        -257.262939453125,
        -2340.9423828125,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071468830108643,
        -0.7070667147636414,
        -1.4101900887908414e-05
      ],
      "plane_d": -1856.5904541015625,
      "bbox_min": [
        -274.0576477050781,
        -2357.737060546875,
        712.0
      ],
      "bbox_max": [
        -268.010986328125,
        -2350.134765625,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6800597310066223,
        0.6800597310066223,
        0.273929625749588
      ],
      "plane_d": 1218.4066162109375,
      "bbox_min": [
        -274.0576477050781,
        -2355.631591796875,
        712.0
      ],
      "bbox_max": [
        -268.560791015625,
        -2350.134765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5886849164962769,
        0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": 1638.560302734375,
      "bbox_min": [
        -274.0576477050781,
        -2352.261474609375,
        748.7863159179688
      ],
      "bbox_max": [
        -271.930908203125,
        -2350.134765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1841.484130859375,
      "bbox_min": [
        -264.8652648925781,
        -2348.544677734375,
        712.0
      ],
      "bbox_max": [
        -257.262939453125,
        -2340.9423828125,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071468830108643,
        -0.7070667147636414,
        -1.4101900887908414e-05
      ],
      "plane_d": -1843.5904541015625,
      "bbox_min": [
        -264.8652648925781,
        -2348.544677734375,
        712.0
      ],
      "bbox_max": [
        -258.818603515625,
        -2340.9423828125,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6800597310066223,
        0.6800597310066223,
        0.273929625749588
      ],
      "plane_d": 1218.4066162109375,
      "bbox_min": [
        -264.8652648925781,
        -2346.439208984375,
        712.0
      ],
      "bbox_max": [
        -259.368408203125,
        -2340.9423828125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5886849164962769,
        0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": 1638.560302734375,
      "bbox_min": [
        -264.8652648925781,
        -2343.069091796875,
        748.7863159179688
      ],
      "bbox_max": [
        -262.738525390625,
        -2340.9423828125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.896294891834259,
        -0.3712579011917114,
        -0.2425346076488495
      ],
      "plane_d": -884.5740356445312,
      "bbox_min": [
        -248.2350311279297,
        -2304.60009765625,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.30712890625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -248.08302307128906,
        -2304.60009765625,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.30712890625,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -248.08302307128906,
        -2291.60009765625,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.30712890625,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.961749255657196,
        0.0,
        0.2739313840866089
      ],
      "plane_d": -433.10260009765625,
      "bbox_min": [
        -248.08302307128906,
        -2291.60009765625,
        712.0
      ],
      "bbox_max": [
        -242.50927734375,
        -2289.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.832523763179779,
        -0.0,
        -0.5539893507957458
      ],
      "plane_d": 208.95700073242188,
      "bbox_min": [
        -248.08302307128906,
        -2291.60009765625,
        748.7863159179688
      ],
      "bbox_max": [
        -247.275390625,
        -2289.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238787889480591,
        -0.38268521428108215,
        -0.0
      ],
      "plane_d": -1094.300048828125,
      "bbox_min": [
        -242.82305908203125,
        -2281.239990234375,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2273.30712890625,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -248.08302307128906,
        -2304.60009765625,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2302.39990234375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -248.08302307128906,
        -2304.60009765625,
        712.0
      ],
      "bbox_max": [
        -239.537109375,
        -2302.39990234375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.961749255657196,
        0.0,
        0.2739313840866089
      ],
      "plane_d": -433.10260009765625,
      "bbox_min": [
        -248.08302307128906,
        -2304.60009765625,
        712.0
      ],
      "bbox_max": [
        -242.50927734375,
        -2302.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.832523763179779,
        -0.0,
        -0.5539893507957458
      ],
      "plane_d": 208.95700073242188,
      "bbox_min": [
        -248.08302307128906,
        -2304.60009765625,
        748.7863159179688
      ],
      "bbox_max": [
        -247.275390625,
        -2302.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6859944462776184,
        -0.6859944462776184,
        -0.24253489077091217
      ],
      "plane_d": -1540.60009765625,
      "bbox_min": [
        -376.84716796875,
        -2273.30712890625,
        712.0
      ],
      "bbox_max": [
        -242.82305908203125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3712579011917114,
        -0.896294891834259,
        -0.2425346076488495
      ],
      "plane_d": -1687.4219970703125,
      "bbox_min": [
        -376.84716796875,
        -2273.30712890625,
        712.0
      ],
      "bbox_max": [
        -242.82305908203125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3712576925754547,
        -0.8962944149971008,
        -0.2425367832183838
      ],
      "plane_d": -1923.539306640625,
      "bbox_min": [
        -376.84716796875,
        -2273.30712890625,
        712.0
      ],
      "bbox_max": [
        -242.82305908203125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -1975.0977783203125,
      "bbox_min": [
        -376.84716796875,
        -2273.30712890625,
        712.0
      ],
      "bbox_max": [
        -242.82305908203125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1770.5133056640625,
      "bbox_min": [
        -376.84716796875,
        -2273.30712890625,
        712.0
      ],
      "bbox_max": [
        -242.82305908203125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2218.38427734375,
      "bbox_min": [
        -376.84716796875,
        -2273.30712890625,
        712.0
      ],
      "bbox_max": [
        -242.82305908203125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38268521428108215,
        -0.9238787889480591,
        -0.0
      ],
      "plane_d": -2165.239501953125,
      "bbox_min": [
        -376.84716796875,
        -2273.30712890625,
        712.0
      ],
      "bbox_max": [
        -242.82305908203125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268521428108215,
        -0.9238787889480591,
        0.0
      ],
      "plane_d": -1921.8516845703125,
      "bbox_min": [
        -376.84716796875,
        -2273.30712890625,
        712.0
      ],
      "bbox_max": [
        -242.82305908203125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.896294891834259,
        -0.3712579011917114,
        -0.2425346076488495
      ],
      "plane_d": -884.5740356445312,
      "bbox_min": [
        -376.84716796875,
        -2273.30712890625,
        712.0
      ],
      "bbox_max": [
        -242.82305908203125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238787889480591,
        -0.38268521428108215,
        -0.0
      ],
      "plane_d": -1094.300048828125,
      "bbox_min": [
        -376.84716796875,
        -2273.30712890625,
        712.0
      ],
      "bbox_max": [
        -242.82305908203125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.382681667804718,
        0.9238802790641785,
        0.0
      ],
      "plane_d": 1939.471923828125,
      "bbox_min": [
        -376.84716796875,
        -2273.306640625,
        712.0
      ],
      "bbox_max": [
        -256.44775390625,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 1788.1290283203125,
      "bbox_min": [
        -374.1084289550781,
        -2273.306640625,
        712.0
      ],
      "bbox_max": [
        -256.44775390625,
        -2236.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1338.4091796875,
      "bbox_min": [
        -374.1084289550781,
        -2273.306640625,
        712.0
      ],
      "bbox_max": [
        -261.89031982421875,
        -2236.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.382681667804718,
        0.9238802790641785,
        -0.0
      ],
      "plane_d": 2182.857421875,
      "bbox_min": [
        -374.1084289550781,
        -2273.306640625,
        712.0
      ],
      "bbox_max": [
        -261.89031982421875,
        -2236.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2236.0,
      "bbox_min": [
        -374.1084289550781,
        -2273.306640625,
        712.0
      ],
      "bbox_max": [
        -261.89031982421875,
        -2236.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -716.0,
      "bbox_min": [
        -374.1084289550781,
        -2273.306640625,
        712.0
      ],
      "bbox_max": [
        -261.89031982421875,
        -2236.0,
        750.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.3826833665370941,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": -1941.4697265625,
      "bbox_min": [
        -374.1084289550781,
        -2273.306640625,
        712.0
      ],
      "bbox_max": [
        -261.89031982421875,
        -2238.0,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826833665370941,
        -0.9238795638084412,
        -0.0
      ],
      "plane_d": -2184.8564453125,
      "bbox_min": [
        -374.1084289550781,
        -2273.306640625,
        712.0
      ],
      "bbox_max": [
        -261.89031982421875,
        -2238.0,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -374.1084289550781,
        -2273.306640625,
        712.0
      ],
      "bbox_max": [
        -261.89031982421875,
        -2238.0,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1340.4090576171875,
      "bbox_min": [
        -374.1084289550781,
        -2273.306640625,
        712.0
      ],
      "bbox_max": [
        -261.89031982421875,
        -2246.958984375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.382681667804718,
        0.0
      ],
      "plane_d": 524.3202514648438,
      "bbox_min": [
        -371.5837097167969,
        -2267.20849609375,
        712.0
      ],
      "bbox_max": [
        -369.583740234375,
        -2262.380126953125,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1790.1290283203125,
      "bbox_min": [
        -374.1084289550781,
        -2273.306640625,
        712.0
      ],
      "bbox_max": [
        -261.89031982421875,
        -2246.958984375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238802790641785,
        0.382681667804718,
        -0.0
      ],
      "plane_d": 1111.9080810546875,
      "bbox_min": [
        -266.416259765625,
        -2267.20849609375,
        712.0
      ],
      "bbox_max": [
        -264.4162292480469,
        -2262.380126953125,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        -0.3826833665370941,
        -0.0
      ],
      "plane_d": -1113.9117431640625,
      "bbox_min": [
        -374.1084289550781,
        -2273.306640625,
        712.0
      ],
      "bbox_max": [
        -261.89031982421875,
        -2263.512939453125,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238802790641785,
        0.382681667804718,
        -0.0
      ],
      "plane_d": 1111.9080810546875,
      "bbox_min": [
        -264.4162292480469,
        -2273.306640625,
        712.0
      ],
      "bbox_max": [
        -261.89031982421875,
        -2267.20849609375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -526.3244018554688,
      "bbox_min": [
        -374.1084289550781,
        -2273.303955078125,
        712.0
      ],
      "bbox_max": [
        -367.88818359375,
        -2263.512939453125,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.382681667804718,
        0.0
      ],
      "plane_d": 524.3202514648438,
      "bbox_min": [
        -374.1084289550781,
        -2273.3037109375,
        712.0
      ],
      "bbox_max": [
        -371.5837097167969,
        -2267.20849609375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7584289312362671,
        -0.6517557501792908
      ],
      "plane_d": 2210.350341796875,
      "bbox_min": [
        -332.74102783203125,
        -2273.3056640625,
        746.0
      ],
      "bbox_max": [
        -303.5616760253906,
        -2269.86767578125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5349872708320618,
        0.5349872708320618,
        -0.6538938879966736
      ],
      "plane_d": 1869.0113525390625,
      "bbox_min": [
        -332.74102783203125,
        -2273.3056640625,
        746.0
      ],
      "bbox_max": [
        -303.5616760253906,
        -2269.86767578125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5372592806816101,
        0.5372592806816101,
        -0.6501576900482178
      ],
      "plane_d": 1530.2041015625,
      "bbox_min": [
        -332.74102783203125,
        -2273.305419921875,
        746.0
      ],
      "bbox_max": [
        -305.9817810058594,
        -2269.86767578125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29953300952911377,
        0.7231412529945374,
        -0.6223718523979187
      ],
      "plane_d": 2200.6015625,
      "bbox_min": [
        -330.3215026855469,
        -2273.305419921875,
        746.0
      ],
      "bbox_max": [
        -305.9817810058594,
        -2269.86767578125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3002129793167114,
        0.7247829437255859,
        -0.6201305389404297
      ],
      "plane_d": 2011.8299560546875,
      "bbox_min": [
        -330.3215026855469,
        -2273.304931640625,
        746.0
      ],
      "bbox_max": [
        -327.86468505859375,
        -2269.86767578125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -273.2424621582031,
        -2253.628173828125,
        712.0
      ],
      "bbox_max": [
        -256.44775390625,
        -2236.833251953125,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1407.9442138671875,
      "bbox_min": [
        -264.0500793457031,
        -2253.628173828125,
        712.0
      ],
      "bbox_max": [
        -256.44775390625,
        -2247.58154296875,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6800045967102051,
        -0.6801113486289978,
        0.2739383578300476
      ],
      "plane_d": -1905.729248046875,
      "bbox_min": [
        -264.0500793457031,
        -2253.628173828125,
        712.0
      ],
      "bbox_max": [
        -258.55322265625,
        -2248.131103515625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5887311100959778,
        -0.5886387228965759,
        -0.5539856553077698
      ],
      "plane_d": -1065.6221923828125,
      "bbox_min": [
        -264.0500793457031,
        -2253.628173828125,
        748.7863159179688
      ],
      "bbox_max": [
        -261.92333984375,
        -2251.501220703125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -273.2424621582031,
        -2244.435791015625,
        712.0
      ],
      "bbox_max": [
        -265.64013671875,
        -2236.833251953125,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1394.9442138671875,
      "bbox_min": [
        -273.2424621582031,
        -2244.435791015625,
        712.0
      ],
      "bbox_max": [
        -265.64013671875,
        -2238.38916015625,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6800045967102051,
        -0.6801113486289978,
        0.2739383578300476
      ],
      "plane_d": -1905.728271484375,
      "bbox_min": [
        -273.2424621582031,
        -2244.435791015625,
        712.0
      ],
      "bbox_max": [
        -267.74560546875,
        -2238.938720703125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5887311100959778,
        -0.5886387228965759,
        -0.5539856553077698
      ],
      "plane_d": -1065.623046875,
      "bbox_min": [
        -273.2424621582031,
        -2244.435791015625,
        748.7863159179688
      ],
      "bbox_max": [
        -271.11572265625,
        -2242.308837890625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1320.79345703125,
      "bbox_min": [
        -376.84716796875,
        -2252.816650390625,
        712.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2218.38427734375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1841.484130859375,
      "bbox_min": [
        -369.78564453125,
        -2237.62353515625,
        712.0
      ],
      "bbox_max": [
        -368.1839599609375,
        -2236.02197265625,
        730.26025390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071220278739929,
        -0.7070915102958679,
        0.0
      ],
      "plane_d": -1843.65576171875,
      "bbox_min": [
        -369.78564453125,
        -2237.62353515625,
        712.0
      ],
      "bbox_max": [
        -369.7396240234375,
        -2237.57763671875,
        730.26025390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6859944462776184,
        -0.6859944462776184,
        -0.24253489077091217
      ],
      "plane_d": -1104.3076171875,
      "bbox_min": [
        -376.84716796875,
        -2252.816650390625,
        712.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071074843406677,
        -0.7071060538291931,
        -8.376671758014709e-06
      ],
      "plane_d": -1843.6767578125,
      "bbox_min": [
        -376.84716796875,
        -2250.3515625,
        729.9920043945312
      ],
      "bbox_max": [
        -364.6484375,
        -2236.06787109375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071443796157837,
        0.7070691585540771,
        -2.1935584300081246e-05
      ],
      "plane_d": 1841.429931640625,
      "bbox_min": [
        -368.1839599609375,
        -2239.603271484375,
        729.9920043945312
      ],
      "bbox_max": [
        -364.6484375,
        -2236.06787109375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071443796157837,
        0.7070691585540771,
        -2.1935584300081246e-05
      ],
      "plane_d": 1854.429931640625,
      "bbox_min": [
        -376.84716796875,
        -2250.3515625,
        732.9930419921875
      ],
      "bbox_max": [
        -373.8407287597656,
        -2245.78955078125,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071074843406677,
        -0.7071060538291931,
        -8.376671758014709e-06
      ],
      "plane_d": -1856.6767578125,
      "bbox_min": [
        -376.84716796875,
        -2250.3515625,
        741.793701171875
      ],
      "bbox_max": [
        -375.3966369628906,
        -2248.901123046875,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -376.84716796875,
        -2252.816650390625,
        712.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2218.38427734375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -325.60009765625,
        -2226.935546875,
        712.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2218.38427734375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -312.60009765625,
        -2226.935546875,
        712.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2218.38427734375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.961749255657196,
        0.2739313840866089
      ],
      "plane_d": -2336.262451171875,
      "bbox_min": [
        -312.60009765625,
        -2226.935546875,
        712.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2221.36181640625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": -1438.4847412109375,
      "bbox_min": [
        -312.60009765625,
        -2226.935546875,
        748.7863159179688
      ],
      "bbox_max": [
        -310.39990234375,
        -2226.1279296875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -325.60009765625,
        -2226.935546875,
        712.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2218.38427734375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.961749255657196,
        0.2739313840866089
      ],
      "plane_d": -2336.262451171875,
      "bbox_min": [
        -325.60009765625,
        -2226.935546875,
        712.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2221.36181640625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": -1438.4847412109375,
      "bbox_min": [
        -325.60009765625,
        -2226.935546875,
        748.7863159179688
      ],
      "bbox_max": [
        -323.39990234375,
        -2226.1279296875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071074843406677,
        -0.7071060538291931,
        -8.376671758014709e-06
      ],
      "plane_d": -1843.6767578125,
      "bbox_min": [
        -376.84716796875,
        -2252.816650390625,
        712.0
      ],
      "bbox_max": [
        -362.1833190917969,
        -2236.06787109375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071443796157837,
        0.7070691585540771,
        -2.1935584300081246e-05
      ],
      "plane_d": 1841.429931640625,
      "bbox_min": [
        -368.1839599609375,
        -2243.624267578125,
        712.0
      ],
      "bbox_max": [
        -362.1833190917969,
        -2236.06787109375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6800597310066223,
        -0.6800597310066223,
        0.273929625749588
      ],
      "plane_d": -1472.9420166015625,
      "bbox_min": [
        -367.68017578125,
        -2243.624267578125,
        712.0
      ],
      "bbox_max": [
        -362.1833190917969,
        -2238.12744140625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886849164962769,
        -0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": -691.1708984375,
      "bbox_min": [
        -364.31005859375,
        -2243.624267578125,
        748.7863159179688
      ],
      "bbox_max": [
        -362.1833190917969,
        -2241.49755859375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6861807107925415,
        -0.6861807107925415,
        -0.24147887527942657
      ],
      "plane_d": -1108.3411865234375,
      "bbox_min": [
        -376.84716796875,
        -2252.816650390625,
        712.0
      ],
      "bbox_max": [
        -371.3757019042969,
        -2247.31982421875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071074843406677,
        -0.7071060538291931,
        -8.376671758014709e-06
      ],
      "plane_d": -1856.6767578125,
      "bbox_min": [
        -376.84716796875,
        -2252.458984375,
        729.7777099609375
      ],
      "bbox_max": [
        -373.2889404296875,
        -2248.90087890625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6800597310066223,
        -0.6800597310066223,
        0.273929625749588
      ],
      "plane_d": -1472.9420166015625,
      "bbox_min": [
        -376.84716796875,
        -2252.816650390625,
        712.0
      ],
      "bbox_max": [
        -371.3757019042969,
        -2247.31982421875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071220278739929,
        -0.7070915102958679,
        0.0
      ],
      "plane_d": -1856.65576171875,
      "bbox_min": [
        -376.84716796875,
        -2252.427001953125,
        712.0
      ],
      "bbox_max": [
        -373.3212890625,
        -2248.90087890625,
        729.50732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886849164962769,
        -0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": -691.1708984375,
      "bbox_min": [
        -373.50244140625,
        -2252.816650390625,
        748.7863159179688
      ],
      "bbox_max": [
        -371.3757019042969,
        -2250.68994140625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070724368095398,
        -0.707141101360321,
        -3.2387317332904786e-05
      ],
      "plane_d": -1856.7244873046875,
      "bbox_min": [
        -373.50244140625,
        -2252.816650390625,
        748.7863159179688
      ],
      "bbox_max": [
        -372.9313659667969,
        -2252.24560546875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2306.0,
      "bbox_min": [
        -435.0,
        -2348.96337890625,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2244.731201171875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.896294891834259,
        0.3712579011917114,
        -0.2425346076488495
      ],
      "plane_d": 1390.914794921875,
      "bbox_min": [
        -396.462890625,
        -2348.96337890625,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2306.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238787889480591,
        0.38268521428108215,
        0.0
      ],
      "plane_d": 1251.2257080078125,
      "bbox_min": [
        -396.462890625,
        -2348.96337890625,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2306.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        0.0,
        -0.24253562092781067
      ],
      "plane_d": 561.676513671875,
      "bbox_min": [
        -396.462890625,
        -2348.96337890625,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2306.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6860026717185974,
        0.6859864592552185,
        -0.2425343543291092
      ],
      "plane_d": 2046.92529296875,
      "bbox_min": [
        -396.462890625,
        -2348.96337890625,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2306.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -378.162841796875,
        -2347.80029296875,
        729.5681762695312
      ],
      "bbox_max": [
        -376.84716796875,
        -2346.484619140625,
        737.44287109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -378.162841796875,
        -2347.80029296875,
        712.0
      ],
      "bbox_max": [
        -378.0864562988281,
        -2347.723876953125,
        729.9871215820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 396.462890625,
      "bbox_min": [
        -396.462890625,
        -2347.726318359375,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2306.0,
        737.0110473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -378.84716796875,
        -2347.726318359375,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2306.0,
        737.0110473632812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -716.0,
      "bbox_min": [
        -378.84716796875,
        -2313.778564453125,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2306.0,
        716.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -378.84716796875,
      "bbox_min": [
        -378.84716796875,
        -2308.9501953125,
        712.0
      ],
      "bbox_max": [
        -378.84716796875,
        -2306.0,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2288.0,
      "bbox_min": [
        -435.0,
        -2306.0,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2244.731201171875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8962944149971008,
        -0.3712576925754547,
        -0.2425367832183838
      ],
      "plane_d": -314.528564453125,
      "bbox_min": [
        -396.462890625,
        -2288.0,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2244.731201171875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238787889480591,
        -0.38268521428108215,
        0.0
      ],
      "plane_d": -506.7131652832031,
      "bbox_min": [
        -396.462890625,
        -2288.0,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2244.731201171875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        0.0,
        -0.24253562092781067
      ],
      "plane_d": 561.676513671875,
      "bbox_min": [
        -396.462890625,
        -2288.0,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2244.731201171875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 396.462890625,
      "bbox_min": [
        -396.462890625,
        -2288.0,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2244.731201171875,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6859944462776184,
        -0.6859944462776184,
        -0.24253489077091217
      ],
      "plane_d": -1104.3076171875,
      "bbox_min": [
        -384.517578125,
        -2288.0,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2244.731201171875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071074843406677,
        -0.7071060538291931,
        -8.376671758014709e-06
      ],
      "plane_d": -1856.6767578125,
      "bbox_min": [
        -378.97802734375,
        -2248.901123046875,
        729.7393188476562
      ],
      "bbox_max": [
        -376.84716796875,
        -2245.21435546875,
        742.054443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071443796157837,
        0.7070691585540771,
        -2.1935584300081246e-05
      ],
      "plane_d": 1854.429931640625,
      "bbox_min": [
        -377.42236328125,
        -2245.78955078125,
        729.7393188476562
      ],
      "bbox_max": [
        -376.84716796875,
        -2245.21435546875,
        733.2537231445312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1854.484130859375,
      "bbox_min": [
        -378.97802734375,
        -2246.81591796875,
        712.0
      ],
      "bbox_max": [
        -377.3763427734375,
        -2245.21435546875,
        729.9921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071220278739929,
        -0.7070915102958679,
        0.0
      ],
      "plane_d": -1856.65576171875,
      "bbox_min": [
        -378.97802734375,
        -2246.81591796875,
        712.0
      ],
      "bbox_max": [
        -378.9320068359375,
        -2246.77001953125,
        729.9921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071220278739929,
        -0.7070915102958679,
        0.0
      ],
      "plane_d": -1856.65576171875,
      "bbox_min": [
        -378.9333190917969,
        -2288.0,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2245.259033203125,
        741.793701171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1854.484130859375,
      "bbox_min": [
        -377.3776550292969,
        -2248.90087890625,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2245.259033203125,
        732.9930419921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6800597310066223,
        -0.6800597310066223,
        0.273929625749588
      ],
      "plane_d": -1472.9420166015625,
      "bbox_min": [
        -376.87255859375,
        -2248.90087890625,
        729.50732421875
      ],
      "bbox_max": [
        -376.84716796875,
        -2248.85009765625,
        729.6334228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.382681667804718,
        0.0
      ],
      "plane_d": 524.3202514648438,
      "bbox_min": [
        -378.84716796875,
        -2288.0,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2279.915771484375,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -716.0,
      "bbox_min": [
        -378.84716796875,
        -2288.0,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2279.915771484375,
        716.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -378.84716796875,
      "bbox_min": [
        -378.84716796875,
        -2288.0,
        712.0
      ],
      "bbox_max": [
        -378.84716796875,
        -2284.744140625,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -435.0,
        -2306.0,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2288.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        0.0,
        -0.24253562092781067
      ],
      "plane_d": 561.676513671875,
      "bbox_min": [
        -396.462890625,
        -2306.0,
        730.0
      ],
      "bbox_max": [
        -387.91162109375,
        -2288.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -396.462890625,
        -2304.60009765625,
        730.0
      ],
      "bbox_max": [
        -387.91162109375,
        -2302.39990234375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9704055190086365,
        0.0,
        -0.24148114025592804
      ],
      "plane_d": 558.0330810546875,
      "bbox_min": [
        -393.3941345214844,
        -2304.60009765625,
        730.0
      ],
      "bbox_max": [
        -387.91162109375,
        -2302.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.832523763179779,
        0.0,
        -0.5539893507957458
      ],
      "plane_d": 738.4376220703125,
      "bbox_min": [
        -388.71923828125,
        -2304.60009765625,
        748.7863159179688
      ],
      "bbox_max": [
        -387.91162109375,
        -2302.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -396.462890625,
        -2291.60009765625,
        730.0
      ],
      "bbox_max": [
        -387.91162109375,
        -2289.39990234375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9704055190086365,
        0.0,
        -0.24148114025592804
      ],
      "plane_d": 558.0330810546875,
      "bbox_min": [
        -393.3941345214844,
        -2291.60009765625,
        730.0
      ],
      "bbox_max": [
        -387.91162109375,
        -2289.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.832523763179779,
        0.0,
        -0.5539893507957458
      ],
      "plane_d": 738.4376220703125,
      "bbox_min": [
        -388.71923828125,
        -2291.60009765625,
        748.7863159179688
      ],
      "bbox_max": [
        -387.91162109375,
        -2289.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": 2321.97509765625,
      "bbox_min": [
        -435.0,
        -2306.0,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2288.0,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 396.462890625,
      "bbox_min": [
        -396.462890625,
        -2306.0,
        727.0000610351562
      ],
      "bbox_max": [
        -393.3334045410156,
        -2304.0,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -396.462890625,
        -2304.60009765625,
        729.0999145507812
      ],
      "bbox_max": [
        -393.3334045410156,
        -2304.0,
        730.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9704055190086365,
        0.0,
        -0.24148114025592804
      ],
      "plane_d": 558.0330810546875,
      "bbox_min": [
        -393.4853515625,
        -2304.60009765625,
        729.6334228515625
      ],
      "bbox_max": [
        -393.3941345214844,
        -2304.0,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 396.462890625,
      "bbox_min": [
        -396.462890625,
        -2290.0,
        727.0000610351562
      ],
      "bbox_max": [
        -393.3333435058594,
        -2288.0,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -396.462890625,
        -2290.0,
        729.0997314453125
      ],
      "bbox_max": [
        -393.3333435058594,
        -2289.39990234375,
        730.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9704055190086365,
        0.0,
        -0.24148114025592804
      ],
      "plane_d": 558.0330810546875,
      "bbox_min": [
        -393.4853515625,
        -2290.0,
        729.6334228515625
      ],
      "bbox_max": [
        -393.3941345214844,
        -2289.39990234375,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 396.462890625,
      "bbox_min": [
        -396.462890625,
        -2306.0,
        712.0
      ],
      "bbox_max": [
        -378.84716796875,
        -2304.0,
        714.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.961749255657196,
        -0.0,
        0.2739313840866089
      ],
      "plane_d": 178.5647430419922,
      "bbox_min": [
        -388.676513671875,
        -2304.60009765625,
        712.0
      ],
      "bbox_max": [
        -378.84716796875,
        -2304.0,
        712.7501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -378.84716796875,
      "bbox_min": [
        -378.84716796875,
        -2304.60009765625,
        712.0
      ],
      "bbox_max": [
        -378.84716796875,
        -2304.0,
        712.7501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -378.84716796875,
      "bbox_min": [
        -378.84716796875,
        -2306.0,
        712.0
      ],
      "bbox_max": [
        -378.84716796875,
        -2304.60009765625,
        714.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7808688282966614,
        0.6246950626373291
      ],
      "plane_d": -2232.972412109375,
      "bbox_min": [
        -435.0,
        -2306.0,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2288.0,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 396.462890625,
      "bbox_min": [
        -396.462890625,
        -2290.0,
        712.0
      ],
      "bbox_max": [
        -378.84716796875,
        -2288.0,
        714.4996948242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.961749255657196,
        -0.0,
        0.2739313840866089
      ],
      "plane_d": 178.5647430419922,
      "bbox_min": [
        -388.676513671875,
        -2290.0,
        712.0
      ],
      "bbox_max": [
        -378.84716796875,
        -2289.39990234375,
        712.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -378.84716796875,
      "bbox_min": [
        -378.84716796875,
        -2289.999755859375,
        712.0
      ],
      "bbox_max": [
        -378.84716796875,
        -2289.39990234375,
        712.7498168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -378.84716796875,
      "bbox_min": [
        -378.84716796875,
        -2289.39990234375,
        712.0
      ],
      "bbox_max": [
        -378.84716796875,
        -2288.0,
        714.4996337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -378.84716796875,
      "bbox_min": [
        -398.0,
        -2306.0,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2288.0,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -716.0,
      "bbox_min": [
        -378.84716796875,
        -2306.0,
        716.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2288.0,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 396.462890625,
      "bbox_min": [
        -398.0,
        -2306.0,
        712.0
      ],
      "bbox_max": [
        -388.462890625,
        -2288.0,
        730.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -398.0,
      "bbox_min": [
        -398.0,
        -2306.0,
        712.0
      ],
      "bbox_max": [
        -396.462890625,
        -2288.0,
        730.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2299.8544921875,
      "bbox_min": [
        -398.0,
        -2299.8544921875,
        713.0
      ],
      "bbox_max": [
        -396.462890625,
        -2294.039794921875,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2294.039794921875,
      "bbox_min": [
        -398.0,
        -2299.8544921875,
        713.0
      ],
      "bbox_max": [
        -396.462890625,
        -2294.039794921875,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 721.0,
      "bbox_min": [
        -398.0,
        -2299.8544921875,
        713.0
      ],
      "bbox_max": [
        -396.462890625,
        -2294.039794921875,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -713.0,
      "bbox_min": [
        -398.0,
        -2299.8544921875,
        713.0
      ],
      "bbox_max": [
        -396.462890625,
        -2294.039794921875,
        713.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -396.462890625,
        -2304.60009765625,
        712.0
      ],
      "bbox_max": [
        -388.462890625,
        -2289.39990234375,
        730.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -396.462890625,
        -2304.60009765625,
        712.75
      ],
      "bbox_max": [
        -388.676513671875,
        -2304.60009765625,
        729.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9704055190086365,
        0.0,
        -0.24148114025592804
      ],
      "plane_d": 558.0330810546875,
      "bbox_min": [
        -393.4853515625,
        -2304.244384765625,
        729.6334228515625
      ],
      "bbox_max": [
        -393.3941345214844,
        -2302.39990234375,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -396.462890625,
        -2291.60009765625,
        712.0
      ],
      "bbox_max": [
        -388.462890625,
        -2289.39990234375,
        730.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -396.462890625,
        -2289.39990234375,
        712.75
      ],
      "bbox_max": [
        -388.676513671875,
        -2289.39990234375,
        729.0997924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3184986114501953,
        0.7686806917190552,
        -0.5546968579292297
      ],
      "plane_d": 2141.408447265625,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31849759817123413,
        0.7686783075332642,
        -0.5547007918357849
      ],
      "plane_d": 2343.970458984375,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -1061.293701171875,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31841254234313965,
        -0.7687152028083801,
        -0.5546984672546387
      ],
      "plane_d": -1187.2174072265625,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31841254234313965,
        -0.7687151432037354,
        -0.5546985864639282
      ],
      "plane_d": -1389.7275390625,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7687152028083801,
        -0.31841254234313965,
        -0.5546984672546387
      ],
      "plane_d": -498.6476745605469,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7687151432037354,
        0.31841254234313965,
        -0.5546985864639282
      ],
      "plane_d": 964.0422973632812,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7687152028083801,
        0.31841254234313965,
        -0.5546984672546387
      ],
      "plane_d": 1452.945068359375,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7687151432037354,
        -0.31841254234313965,
        -0.5546985864639282
      ],
      "plane_d": -9.744735717773438,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": -1433.9423828125,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        -0.0,
        -0.5547001957893372
      ],
      "plane_d": 212.5579833984375,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.0,
        -0.5547001957893372
      ],
      "plane_d": 741.741943359375,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883565545082092,
        0.5883404612541199,
        -0.5546999573707581
      ],
      "plane_d": 1641.380615234375,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": 2388.246826171875,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21233268082141876,
        0.5124491453170776,
        -0.8320521116256714
      ],
      "plane_d": 1781.218994140625,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2123335599899292,
        0.5124513506889343,
        -0.8320505023002625
      ],
      "plane_d": 1916.266845703125,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3922361731529236,
        0.3922291696071625,
        -0.8320499062538147
      ],
      "plane_d": 1447.8804931640625,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39223313331604004,
        -0.39223313331604004,
        -0.8320494890213013
      ],
      "plane_d": -353.9089050292969,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": -602.3402709960938,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        -0.0,
        -0.8320502638816833
      ],
      "plane_d": 495.32666015625,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        -0.8320502638816833
      ],
      "plane_d": 848.115966796875,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21227414906024933,
        -0.5124784708023071,
        -0.8320490121841431
      ],
      "plane_d": -437.861083984375,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124784708023071,
        -0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 21.191041946411133,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124784708023071,
        0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 1322.2498779296875,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2122735232114792,
        -0.5124768614768982,
        -0.832050085067749
      ],
      "plane_d": -572.86279296875,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124768614768982,
        0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 996.3134155273438,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124768614768982,
        -0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 347.1290283203125,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        -0.8320503234863281
      ],
      "plane_d": 1945.785888671875,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5372592806816101,
        0.5372592806816101,
        -0.6501576900482178
      ],
      "plane_d": 1530.2041015625,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5364239811897278,
        -0.536414384841919,
        -0.6515434980392456
      ],
      "plane_d": -934.4630126953125,
      "bbox_min": [
        -381.7206726074219,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2233.180908203125,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7598690986633301,
        1.9076609532930888e-05,
        -0.650076150894165
      ],
      "plane_d": 225.38882446289062,
      "bbox_min": [
        -374.6662292480469,
        -2360.500732421875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2233.180908203125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7249156832695007,
        -0.3002679944038391,
        -0.61994868516922
      ],
      "plane_d": -477.7586975097656,
      "bbox_min": [
        -366.462890625,
        -2360.500732421875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2233.180908203125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.725508987903595,
        0.30051371455192566,
        -0.6191350221633911
      ],
      "plane_d": 901.294677734375,
      "bbox_min": [
        -366.462890625,
        -2360.500732421875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2233.180908203125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7566943764686584,
        -0.65376877784729
      ],
      "plane_d": -1268.0162353515625,
      "bbox_min": [
        -366.45758056640625,
        -2360.500732421875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2233.180908203125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2996884286403656,
        -0.7232757806777954,
        -0.6221407055854797
      ],
      "plane_d": -1312.3388671875,
      "bbox_min": [
        -366.45758056640625,
        -2345.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2233.180908203125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5341558456420898,
        -0.5341463088989258,
        -0.6552596688270569
      ],
      "plane_d": -585.7737426757812,
      "bbox_min": [
        -366.45758056640625,
        -2345.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2233.180908203125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29901179671287537,
        -0.7216429114341736,
        -0.6243584752082825
      ],
      "plane_d": -1116.3973388671875,
      "bbox_min": [
        -366.45758056640625,
        -2345.3154296875,
        750.0
      ],
      "bbox_max": [
        -254.44439697265625,
        -2233.180908203125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553337812423706,
        0.0,
        -0.655340313911438
      ],
      "plane_d": 711.479248046875,
      "bbox_min": [
        -366.45758056640625,
        -2345.309814453125,
        750.0
      ],
      "bbox_max": [
        -254.44439697265625,
        -2233.180908203125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.720969557762146,
        -0.2986334562301636,
        -0.6253166794776917
      ],
      "plane_d": -9.845726013183594,
      "bbox_min": [
        -366.45758056640625,
        -2345.309814453125,
        750.0
      ],
      "bbox_max": [
        -269.537109375,
        -2233.180908203125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5349872708320618,
        0.5349872708320618,
        -0.6538938879966736
      ],
      "plane_d": 1869.0113525390625,
      "bbox_min": [
        -366.45758056640625,
        -2345.309814453125,
        750.0
      ],
      "bbox_max": [
        -269.537109375,
        -2233.180908203125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7215692400932312,
        0.298881858587265,
        -0.6245057582855225
      ],
      "plane_d": 1362.08642578125,
      "bbox_min": [
        -366.45758056640625,
        -2345.309814453125,
        750.0
      ],
      "bbox_max": [
        -269.537109375,
        -2240.265625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7584289312362671,
        -0.6517557501792908
      ],
      "plane_d": 2210.350341796875,
      "bbox_min": [
        -366.45758056640625,
        -2345.309814453125,
        750.0
      ],
      "bbox_max": [
        -269.54083251953125,
        -2240.265625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29953300952911377,
        0.7231412529945374,
        -0.6223718523979187
      ],
      "plane_d": 2200.6015625,
      "bbox_min": [
        -366.45758056640625,
        -2345.309814453125,
        750.0
      ],
      "bbox_max": [
        -269.54083251953125,
        -2248.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3002129793167114,
        0.7247829437255859,
        -0.6201305389404297
      ],
      "plane_d": 2011.8299560546875,
      "bbox_min": [
        -366.45758056640625,
        -2345.309814453125,
        750.0
      ],
      "bbox_max": [
        -269.54083251953125,
        -2248.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071011066436768,
        -0.7071124315261841,
        5.3263302106643096e-06
      ],
      "plane_d": -1407.9625244140625,
      "bbox_min": [
        -366.45758056640625,
        -2345.309814453125,
        774.40380859375
      ],
      "bbox_max": [
        -269.54083251953125,
        -2248.389892578125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -366.45758056640625,
        -2304.60009765625,
        774.40380859375
      ],
      "bbox_max": [
        -279.17462158203125,
        -2248.389892578125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -366.45758056640625,
        -2304.60009765625,
        774.91650390625
      ],
      "bbox_max": [
        -325.60009765625,
        -2248.389892578125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -366.45733642578125,
        -2289.39990234375,
        774.9186401367188
      ],
      "bbox_max": [
        -325.60009765625,
        -2248.389892578125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -325.60009765625,
        -2248.452880859375,
        774.9201049804688
      ],
      "bbox_max": [
        -325.60009765625,
        -2248.389892578125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -366.45758056640625,
        -2304.60009765625,
        774.91650390625
      ],
      "bbox_max": [
        -366.39190673828125,
        -2302.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -366.4575500488281,
        -2302.39990234375,
        774.9169311523438
      ],
      "bbox_max": [
        -366.3922119140625,
        -2302.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -312.60009765625,
        -2267.52978515625,
        774.40380859375
      ],
      "bbox_max": [
        -279.17462158203125,
        -2248.389892578125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071011066436768,
        -0.7071124315261841,
        5.3263302106643096e-06
      ],
      "plane_d": -1394.9625244140625,
      "bbox_min": [
        -287.1449890136719,
        -2267.52978515625,
        774.40380859375
      ],
      "bbox_max": [
        -279.17462158203125,
        -2259.56005859375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -279.5075988769531,
        -2267.52978515625,
        774.4052734375
      ],
      "bbox_max": [
        -279.17462158203125,
        -2267.19677734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -312.60009765625,
        -2248.452880859375,
        774.9201049804688
      ],
      "bbox_max": [
        -310.39990234375,
        -2248.389892578125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -312.60009765625,
        -2248.452880859375,
        774.9201049804688
      ],
      "bbox_max": [
        -312.60009765625,
        -2248.389892578125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1843.6842041015625,
      "bbox_min": [
        -325.60009765625,
        -2345.309814453125,
        774.6267700195312
      ],
      "bbox_max": [
        -269.54083251953125,
        -2289.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -278.66265869140625,
        -2325.798583984375,
        774.6270751953125
      ],
      "bbox_max": [
        -269.54083251953125,
        -2289.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070838809013367,
        0.7071296572685242,
        -4.8993464588420466e-05
      ],
      "plane_d": 1841.56884765625,
      "bbox_min": [
        -278.66265869140625,
        -2325.798583984375,
        774.6270751953125
      ],
      "bbox_max": [
        -269.54083251953125,
        -2304.60009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -269.5799560546875,
        -2304.60009765625,
        774.95068359375
      ],
      "bbox_max": [
        -269.54083251953125,
        -2304.60009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -269.5799560546875,
        -2291.60009765625,
        774.95068359375
      ],
      "bbox_max": [
        -269.54083251953125,
        -2289.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -269.5799560546875,
        -2289.39990234375,
        774.95068359375
      ],
      "bbox_max": [
        -269.54083251953125,
        -2289.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -325.60009765625,
        -2345.309814453125,
        774.6267700195312
      ],
      "bbox_max": [
        -287.645751953125,
        -2334.78173828125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -325.60009765625,
        -2345.309814453125,
        774.922607421875
      ],
      "bbox_max": [
        -312.60009765625,
        -2345.24853515625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -325.60009765625,
        -2345.309814453125,
        774.922607421875
      ],
      "bbox_max": [
        -325.60009765625,
        -2345.24853515625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -312.60009765625,
        -2345.309814453125,
        774.922607421875
      ],
      "bbox_max": [
        -312.60009765625,
        -2345.24853515625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1856.6842041015625,
      "bbox_min": [
        -289.4108581542969,
        -2336.546630859375,
        774.6267700195312
      ],
      "bbox_max": [
        -287.645751953125,
        -2334.78173828125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070838809013367,
        0.7071296572685242,
        -4.8993464588420466e-05
      ],
      "plane_d": 1854.56884765625,
      "bbox_min": [
        -287.85504150390625,
        -2334.990966796875,
        774.6270751953125
      ],
      "bbox_max": [
        -287.645751953125,
        -2334.78173828125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -325.60009765625,
        -2250.0625,
        767.6068115234375
      ],
      "bbox_max": [
        -310.39990234375,
        -2240.265625,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": -596.56494140625,
      "bbox_min": [
        -325.60009765625,
        -2250.0625,
        767.6068115234375
      ],
      "bbox_max": [
        -323.39990234375,
        -2241.48388671875,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -325.60009765625,
        -2250.0625,
        768.4148559570312
      ],
      "bbox_max": [
        -325.60009765625,
        -2241.48388671875,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -312.60009765625,
        -2250.0625,
        767.6395263671875
      ],
      "bbox_max": [
        -310.39990234375,
        -2240.3017578125,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": -596.56494140625,
      "bbox_min": [
        -312.60009765625,
        -2250.0625,
        767.6395263671875
      ],
      "bbox_max": [
        -310.39990234375,
        -2241.5146484375,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -310.39990234375,
        -2250.0625,
        768.4441528320312
      ],
      "bbox_max": [
        -310.39990234375,
        -2241.5146484375,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -312.60009765625,
        -2269.981201171875,
        762.81103515625
      ],
      "bbox_max": [
        -273.1952209472656,
        -2233.180908203125,
        774.9501342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3900126814842224,
        -0.3899514675140381,
        -0.8341630697250366
      ],
      "plane_d": -349.54376220703125,
      "bbox_min": [
        -289.595703125,
        -2269.981201171875,
        763.2664794921875
      ],
      "bbox_max": [
        -273.1952209472656,
        -2249.354736328125,
        774.9501342773438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071011066436768,
        -0.7071124315261841,
        5.3263302106643096e-06
      ],
      "plane_d": -1394.9625244140625,
      "bbox_min": [
        -288.0400390625,
        -2269.981201171875,
        764.069580078125
      ],
      "bbox_max": [
        -273.1952209472656,
        -2250.077880859375,
        774.9501342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -280.4033203125,
        -2269.981201171875,
        768.0119018554688
      ],
      "bbox_max": [
        -273.1952209472656,
        -2261.9169921875,
        774.9501342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071011066436768,
        -0.7071124315261841,
        5.3263302106643096e-06
      ],
      "plane_d": -1407.9625244140625,
      "bbox_min": [
        -278.84765625,
        -2269.981201171875,
        768.8150024414062
      ],
      "bbox_max": [
        -273.1952209472656,
        -2264.328857421875,
        774.9501342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -312.60009765625,
        -2243.923583984375,
        762.81103515625
      ],
      "bbox_max": [
        -310.39990234375,
        -2233.180908203125,
        770.4147338867188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": -596.56494140625,
      "bbox_min": [
        -312.60009765625,
        -2243.923583984375,
        762.81103515625
      ],
      "bbox_max": [
        -310.39990234375,
        -2234.285400390625,
        769.6069946289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -312.60009765625,
        -2242.70654296875,
        763.6400146484375
      ],
      "bbox_max": [
        -312.60009765625,
        -2234.285400390625,
        769.6069946289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": -1438.4847412109375,
      "bbox_min": [
        -310.5257873535156,
        -2235.505126953125,
        762.81103515625
      ],
      "bbox_max": [
        -310.39990234375,
        -2235.46044921875,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -279.7173156738281,
        -2304.60009765625,
        750.0
      ],
      "bbox_max": [
        -254.44439697265625,
        -2240.368896484375,
        774.9957885742188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5515210628509521,
        -0.0,
        -0.8341609835624695
      ],
      "plane_d": 494.81390380859375,
      "bbox_min": [
        -271.2099609375,
        -2304.60009765625,
        762.9635620117188
      ],
      "bbox_max": [
        -255.60604858398438,
        -2289.39990234375,
        774.9957885742188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -271.2099609375,
        -2304.60009765625,
        763.7667236328125
      ],
      "bbox_max": [
        -255.60604858398438,
        -2291.60009765625,
        774.9957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -271.2099609375,
        -2304.60009765625,
        767.7094116210938
      ],
      "bbox_max": [
        -261.5497741699219,
        -2302.39990234375,
        774.9957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -271.2099609375,
        -2304.60009765625,
        768.5126342773438
      ],
      "bbox_max": [
        -262.7607116699219,
        -2304.60009765625,
        774.9957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1394.9442138671875,
      "bbox_min": [
        -279.7173156738281,
        -2266.036865234375,
        750.0
      ],
      "bbox_max": [
        -259.983154296875,
        -2240.368896484375,
        770.7837524414062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5887311100959778,
        -0.5886387228965759,
        -0.5539856553077698
      ],
      "plane_d": -1065.623046875,
      "bbox_min": [
        -279.7173156738281,
        -2251.76953125,
        750.0
      ],
      "bbox_max": [
        -271.6867980957031,
        -2242.8798828125,
        764.069580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3900126814842224,
        -0.3899514675140381,
        -0.8341630697250366
      ],
      "plane_d": -349.54376220703125,
      "bbox_min": [
        -279.7173156738281,
        -2251.76953125,
        762.878173828125
      ],
      "bbox_max": [
        -277.746337890625,
        -2248.939453125,
        764.069580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1407.9442138671875,
      "bbox_min": [
        -275.60009765625,
        -2266.036865234375,
        750.0
      ],
      "bbox_max": [
        -259.983154296875,
        -2249.561279296875,
        770.7837524414062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5887311100959778,
        -0.5886387228965759,
        -0.5539856553077698
      ],
      "plane_d": -1065.6221923828125,
      "bbox_min": [
        -275.60009765625,
        -2266.036865234375,
        750.0
      ],
      "bbox_max": [
        -262.4944152832031,
        -2252.072265625,
        768.8150024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3900126814842224,
        -0.3899514675140381,
        -0.8341630697250366
      ],
      "plane_d": -349.543212890625,
      "bbox_min": [
        -275.60009765625,
        -2266.036865234375,
        762.878173828125
      ],
      "bbox_max": [
        -268.553955078125,
        -2258.1318359375,
        768.8150024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070838809013367,
        0.7071296572685242,
        -4.8993464588420466e-05
      ],
      "plane_d": 1841.56884765625,
      "bbox_min": [
        -290.410888671875,
        -2341.3662109375,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2289.39990234375,
        774.96826171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38998207449913025,
        0.38998207449913025,
        -0.8341630697250366
      ],
      "plane_d": 1441.8780517578125,
      "bbox_min": [
        -290.410888671875,
        -2341.3662109375,
        762.8990478515625
      ],
      "bbox_max": [
        -269.3914489746094,
        -2324.589111328125,
        774.96826171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1843.6842041015625,
      "bbox_min": [
        -290.410888671875,
        -2341.3662109375,
        763.70361328125
      ],
      "bbox_max": [
        -270.1214599609375,
        -2326.144775390625,
        774.96826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070838809013367,
        0.7071296572685242,
        -4.8993464588420466e-05
      ],
      "plane_d": 1854.56884765625,
      "bbox_min": [
        -290.410888671875,
        -2341.3662109375,
        767.6533813476562
      ],
      "bbox_max": [
        -281.9682922363281,
        -2333.781494140625,
        774.96826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1856.6842041015625,
      "bbox_min": [
        -290.410888671875,
        -2341.3662109375,
        768.4579467773438
      ],
      "bbox_max": [
        -284.3819580078125,
        -2335.337158203125,
        774.96826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -265.1745910644531,
        -2304.60009765625,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2289.39990234375,
        770.4803466796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.832523763179779,
        -0.0,
        -0.5539893507957458
      ],
      "plane_d": 208.95700073242188,
      "bbox_min": [
        -257.99652099609375,
        -2291.60009765625,
        750.0
      ],
      "bbox_max": [
        -248.08302307128906,
        -2289.39990234375,
        763.7667236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5515210628509521,
        -0.0,
        -0.8341609835624695
      ],
      "plane_d": 494.81390380859375,
      "bbox_min": [
        -257.99652099609375,
        -2291.60009765625,
        762.878173828125
      ],
      "bbox_max": [
        -256.652587890625,
        -2289.39990234375,
        763.7667236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -265.1745910644531,
        -2304.60009765625,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2302.39990234375,
        770.4803466796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.832523763179779,
        -0.0,
        -0.5539893507957458
      ],
      "plane_d": 208.95700073242188,
      "bbox_min": [
        -265.1745910644531,
        -2304.60009765625,
        750.0
      ],
      "bbox_max": [
        -248.08302307128906,
        -2302.39990234375,
        768.5126342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5515210628509521,
        -0.0,
        -0.8341609835624695
      ],
      "plane_d": 494.81390380859375,
      "bbox_min": [
        -265.1745910644531,
        -2304.60009765625,
        762.878173828125
      ],
      "bbox_max": [
        -256.652587890625,
        -2302.39990234375,
        768.5126342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -325.60009765625,
        -2360.500732421875,
        750.0
      ],
      "bbox_max": [
        -260.79833984375,
        -2334.860595703125,
        774.9935302734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": 1936.9571533203125,
      "bbox_min": [
        -325.60009765625,
        -2359.388427734375,
        762.8425903320312
      ],
      "bbox_max": [
        -310.39990234375,
        -2343.63720703125,
        774.9935302734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -325.60009765625,
        -2359.388427734375,
        763.660400390625
      ],
      "bbox_max": [
        -312.60009765625,
        -2343.63720703125,
        774.9935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -325.60009765625,
        -2353.41796875,
        767.6207275390625
      ],
      "bbox_max": [
        -323.39990234375,
        -2343.63720703125,
        774.9935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -325.60009765625,
        -2352.20166015625,
        768.427490234375
      ],
      "bbox_max": [
        -325.60009765625,
        -2343.63720703125,
        774.9935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": 2385.87939453125,
      "bbox_min": [
        -310.466796875,
        -2358.21826171875,
        762.8425903320312
      ],
      "bbox_max": [
        -310.39990234375,
        -2358.194580078125,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707072377204895,
        0.7071411609649658,
        -3.234087489545345e-05
      ],
      "plane_d": 1854.579833984375,
      "bbox_min": [
        -286.084716796875,
        -2354.20166015625,
        750.0
      ],
      "bbox_max": [
        -260.79833984375,
        -2334.860595703125,
        770.4290771484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5886849164962769,
        0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": 1638.560302734375,
      "bbox_min": [
        -286.084716796875,
        -2351.6904296875,
        750.0
      ],
      "bbox_max": [
        -272.5019836425781,
        -2338.96826171875,
        768.4579467773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38998207449913025,
        0.38998207449913025,
        -0.8341630697250366
      ],
      "plane_d": 1441.8780517578125,
      "bbox_min": [
        -286.084716796875,
        -2345.630859375,
        762.878173828125
      ],
      "bbox_max": [
        -278.5615234375,
        -2338.96826171875,
        768.4579467773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071413397789001,
        -0.7070721983909607,
        -3.2521289540454745e-05
      ],
      "plane_d": -1843.5880126953125,
      "bbox_min": [
        -271.8075866699219,
        -2345.00927734375,
        750.0
      ],
      "bbox_max": [
        -260.79833984375,
        -2334.860595703125,
        765.6557006835938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5886849164962769,
        0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": 1638.560302734375,
      "bbox_min": [
        -271.8075866699219,
        -2342.498046875,
        750.0
      ],
      "bbox_max": [
        -263.3096008300781,
        -2334.860595703125,
        763.70361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38998207449913025,
        0.38998207449913025,
        -0.8341630697250366
      ],
      "plane_d": 1441.8780517578125,
      "bbox_min": [
        -271.8075866699219,
        -2336.4384765625,
        762.878173828125
      ],
      "bbox_max": [
        -269.369140625,
        -2334.860595703125,
        763.70361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -374.6662292480469,
        -2304.60009765625,
        767.5505981445312
      ],
      "bbox_max": [
        -364.78466796875,
        -2289.39990234375,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5515210628509521,
        0.0,
        -0.8341609835624695
      ],
      "plane_d": 845.5783081054688,
      "bbox_min": [
        -373.4478454589844,
        -2291.60009765625,
        767.5505981445312
      ],
      "bbox_max": [
        -364.78466796875,
        -2289.39990234375,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -373.4478454589844,
        -2289.39990234375,
        768.3587646484375
      ],
      "bbox_max": [
        -364.78466796875,
        -2289.39990234375,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -374.4833984375,
        -2304.60009765625,
        767.675048828125
      ],
      "bbox_max": [
        -364.78466796875,
        -2302.39990234375,
        774.9933471679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5515210628509521,
        0.0,
        -0.8341609835624695
      ],
      "plane_d": 845.5783081054688,
      "bbox_min": [
        -373.2669982910156,
        -2304.60009765625,
        767.675048828125
      ],
      "bbox_max": [
        -364.78466796875,
        -2302.39990234375,
        774.9932861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -373.2669982910156,
        -2304.60009765625,
        768.4818725585938
      ],
      "bbox_max": [
        -364.78466796875,
        -2304.60009765625,
        774.9932861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883575081825256,
        0.588341474533081,
        -0.5546978712081909
      ],
      "plane_d": 2015.5765380859375,
      "bbox_min": [
        -381.7206726074219,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2302.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -374.62744140625,
        -2355.012939453125,
        750.0
      ],
      "bbox_max": [
        -356.67095947265625,
        -2337.056396484375,
        765.1295166015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071097493171692,
        -0.7071037888526917,
        9.465044968237635e-06
      ],
      "plane_d": -1407.9432373046875,
      "bbox_min": [
        -363.879150390625,
        -2355.012939453125,
        750.0
      ],
      "bbox_max": [
        -356.67095947265625,
        -2347.8046875,
        765.129150390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071097493171692,
        -0.7071037888526917,
        9.465044968237635e-06
      ],
      "plane_d": -1394.9432373046875,
      "bbox_min": [
        -374.62744140625,
        -2345.820556640625,
        750.0
      ],
      "bbox_max": [
        -365.86334228515625,
        -2337.056396484375,
        765.1295166015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -374.62744140625,
        -2344.264892578125,
        750.0
      ],
      "bbox_max": [
        -367.41888427734375,
        -2337.056396484375,
        765.1295166015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.39223402738571167,
        0.39222702383995056,
        -0.8320519328117371
      ],
      "plane_d": 1697.3385009765625,
      "bbox_min": [
        -381.7206726074219,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2302.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071245908737183,
        -0.7070889472961426,
        -5.613890243694186e-05
      ],
      "plane_d": -1394.85302734375,
      "bbox_min": [
        -367.4798583984375,
        -2347.86572265625,
        764.9998168945312
      ],
      "bbox_max": [
        -346.1705322265625,
        -2326.555908203125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071245908737183,
        -0.7070889472961426,
        -5.613890243694186e-05
      ],
      "plane_d": -1407.85302734375,
      "bbox_min": [
        -356.7318115234375,
        -2347.86572265625,
        765.0001220703125
      ],
      "bbox_max": [
        -346.1705322265625,
        -2337.30419921875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071245908737183,
        -0.7070889472961426,
        -5.613890243694186e-05
      ],
      "plane_d": -1407.85302734375,
      "bbox_min": [
        -363.8028869628906,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2334.5927734375,
        774.9572143554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3900159001350403,
        0.38995468616485596,
        -0.8341600298881531
      ],
      "plane_d": 1689.944580078125,
      "bbox_min": [
        -362.9237976074219,
        -2352.501953125,
        750.0
      ],
      "bbox_max": [
        -345.014892578125,
        -2334.5927734375,
        772.5030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886816382408142,
        0.5886816382408142,
        -0.5539926886558533
      ],
      "plane_d": 2013.0999755859375,
      "bbox_min": [
        -362.9237976074219,
        -2352.501953125,
        750.0
      ],
      "bbox_max": [
        -355.30859375,
        -2344.886474609375,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -325.60009765625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2349.80126953125,
        770.4036865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": 2385.87939453125,
      "bbox_min": [
        -325.60009765625,
        -2366.76416015625,
        750.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2349.80126953125,
        768.427490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": 1936.9571533203125,
      "bbox_min": [
        -325.60009765625,
        -2358.194580078125,
        762.878173828125
      ],
      "bbox_max": [
        -323.39990234375,
        -2349.80126953125,
        768.427490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -312.60009765625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2357.011474609375,
        765.6173706054688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": 1936.9571533203125,
      "bbox_min": [
        -312.60009765625,
        -2358.194580078125,
        762.878173828125
      ],
      "bbox_max": [
        -310.466796875,
        -2357.011474609375,
        763.660400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071245908737183,
        -0.7070889472961426,
        -5.613890243694186e-05
      ],
      "plane_d": -1394.85302734375,
      "bbox_min": [
        -372.99517822265625,
        -2345.744140625,
        750.0
      ],
      "bbox_max": [
        -354.207275390625,
        -2325.400390625,
        774.9572143554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3900159001350403,
        0.38995468616485596,
        -0.8341600298881531
      ],
      "plane_d": 1689.9451904296875,
      "bbox_min": [
        -372.1161804199219,
        -2343.3095703125,
        750.0
      ],
      "bbox_max": [
        -354.207275390625,
        -2325.400390625,
        772.5030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886816382408142,
        0.5886816382408142,
        -0.5539926886558533
      ],
      "plane_d": 2013.0999755859375,
      "bbox_min": [
        -372.1161804199219,
        -2343.3095703125,
        750.0
      ],
      "bbox_max": [
        -364.5009765625,
        -2335.694091796875,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -381.7206726074219,
        -2304.60009765625,
        762.7295532226562
      ],
      "bbox_max": [
        -370.8665771484375,
        -2302.39990234375,
        770.4583129882812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5515210628509521,
        0.0,
        -0.8341609835624695
      ],
      "plane_d": 845.5783081054688,
      "bbox_min": [
        -380.6463623046875,
        -2304.60009765625,
        762.7295532226562
      ],
      "bbox_max": [
        -370.8665771484375,
        -2302.39990234375,
        769.648193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -380.6463623046875,
        -2302.39990234375,
        763.5839233398438
      ],
      "bbox_max": [
        -372.0869140625,
        -2302.39990234375,
        769.648193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.832523763179779,
        0.0,
        -0.5539893507957458
      ],
      "plane_d": 738.4376220703125,
      "bbox_min": [
        -379.4409484863281,
        -2304.60009765625,
        762.7295532226562
      ],
      "bbox_max": [
        -379.342041015625,
        -2304.3212890625,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -687.1036987304688,
      "bbox_min": [
        -391.462890625,
        -2304.60009765625,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071412801742554,
        0.7070722579956055,
        -3.2557567465119064e-05
      ],
      "plane_d": 1854.4437255859375,
      "bbox_min": [
        -375.442626953125,
        -2257.459716796875,
        750.0
      ],
      "bbox_max": [
        -357.54046630859375,
        -2239.557373046875,
        765.078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7070724368095398,
        -0.707141101360321,
        -3.2387317332904786e-05
      ],
      "plane_d": -1856.7244873046875,
      "bbox_min": [
        -375.442626953125,
        -2257.459716796875,
        750.0
      ],
      "bbox_max": [
        -368.28863525390625,
        -2250.3056640625,
        765.078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071412801742554,
        0.7070722579956055,
        -3.2557567465119064e-05
      ],
      "plane_d": 1841.4437255859375,
      "bbox_min": [
        -366.250244140625,
        -2248.267333984375,
        750.0
      ],
      "bbox_max": [
        -357.54046630859375,
        -2239.557373046875,
        765.078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7070724368095398,
        -0.707141101360321,
        -3.2387317332904786e-05
      ],
      "plane_d": -1843.7244873046875,
      "bbox_min": [
        -366.250244140625,
        -2248.267333984375,
        750.0
      ],
      "bbox_max": [
        -359.09625244140625,
        -2241.11328125,
        765.078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.39223313331604004,
        -0.39223313331604004,
        -0.8320494890213013
      ],
      "plane_d": -104.44863891601562,
      "bbox_min": [
        -391.462890625,
        -2304.60009765625,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071124315261841,
        0.7071011066436768,
        5.3263302106643096e-06
      ],
      "plane_d": 1854.46923828125,
      "bbox_min": [
        -368.3254089355469,
        -2268.0048828125,
        765.0
      ],
      "bbox_max": [
        -346.9950866699219,
        -2246.674560546875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070788741111755,
        -0.7071346640586853,
        -4.192373307887465e-05
      ],
      "plane_d": -1843.705078125,
      "bbox_min": [
        -359.133056640625,
        -2258.8125,
        765.0001220703125
      ],
      "bbox_max": [
        -348.5507507324219,
        -2248.23046875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070788741111755,
        -0.7071346640586853,
        -4.192373307887465e-05
      ],
      "plane_d": -1856.7049560546875,
      "bbox_min": [
        -391.462890625,
        -2304.60009765625,
        750.0
      ],
      "bbox_max": [
        -355.0224609375,
        -2250.3515625,
        774.9771118164062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38998207449913025,
        -0.38998207449913025,
        -0.8341630697250366
      ],
      "plane_d": -101.48300170898438,
      "bbox_min": [
        -372.9313659667969,
        -2269.169921875,
        750.0
      ],
      "bbox_max": [
        -355.0224609375,
        -2251.260986328125,
        772.5030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886849164962769,
        -0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": -691.1708984375,
      "bbox_min": [
        -372.9313659667969,
        -2258.876220703125,
        750.0
      ],
      "bbox_max": [
        -365.316162109375,
        -2251.260986328125,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -391.462890625,
        -2304.60009765625,
        750.0
      ],
      "bbox_max": [
        -371.0527648925781,
        -2289.39990234375,
        770.337890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.832523763179779,
        0.0,
        -0.5539893507957458
      ],
      "plane_d": 738.4376220703125,
      "bbox_min": [
        -387.91162109375,
        -2291.60009765625,
        750.0
      ],
      "bbox_max": [
        -371.0527648925781,
        -2289.39990234375,
        768.3587646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5515210628509521,
        0.0,
        -0.8341609835624695
      ],
      "plane_d": 845.5783081054688,
      "bbox_min": [
        -379.342041015625,
        -2291.60009765625,
        762.878173828125
      ],
      "bbox_max": [
        -371.0527648925781,
        -2289.39990234375,
        768.3587646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -391.462890625,
        -2304.60009765625,
        750.0
      ],
      "bbox_max": [
        -378.27459716796875,
        -2302.39990234375,
        765.5437622070312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5515210628509521,
        0.0,
        -0.8341609835624695
      ],
      "plane_d": 845.5783081054688,
      "bbox_min": [
        -379.342041015625,
        -2304.3212890625,
        762.878173828125
      ],
      "bbox_max": [
        -378.27459716796875,
        -2302.39990234375,
        763.5839233398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070788741111755,
        -0.7071346640586853,
        -4.192373307887465e-05
      ],
      "plane_d": -1843.705078125,
      "bbox_min": [
        -366.204345703125,
        -2259.9775390625,
        750.0
      ],
      "bbox_max": [
        -345.830078125,
        -2241.1591796875,
        774.9771118164062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38998207449913025,
        -0.38998207449913025,
        -0.8341630697250366
      ],
      "plane_d": -101.48300170898438,
      "bbox_min": [
        -363.7389831542969,
        -2259.9775390625,
        750.0
      ],
      "bbox_max": [
        -345.830078125,
        -2242.068603515625,
        772.5030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886849164962769,
        -0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": -691.1708984375,
      "bbox_min": [
        -363.7389831542969,
        -2249.683837890625,
        750.0
      ],
      "bbox_max": [
        -356.123779296875,
        -2242.068603515625,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -325.60009765625,
        -2243.879150390625,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2223.38427734375,
        770.3942260742188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": -1438.4847412109375,
      "bbox_min": [
        -325.60009765625,
        -2243.879150390625,
        750.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2226.935546875,
        768.4148559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": -596.56494140625,
      "bbox_min": [
        -325.60009765625,
        -2243.879150390625,
        762.878173828125
      ],
      "bbox_max": [
        -323.39990234375,
        -2235.505126953125,
        768.4148559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -312.60009765625,
        -2236.657470703125,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2223.38427734375,
        765.6001586914062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": -596.56494140625,
      "bbox_min": [
        -312.60009765625,
        -2236.657470703125,
        762.878173828125
      ],
      "bbox_max": [
        -310.5257873535156,
        -2235.505126953125,
        763.6400146484375
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CGameArea piece: mt06a",
      "entity_class": "CGameArea",
      "piece_name": "mt06a",
      "offset": 54,
      "centroid": [
        -312.35228118896487,
        -2304.538623046875,
        641.8
      ],
      "bbox_min": [
        -376.84716796875,
        -2369.800048828125,
        608.0
      ],
      "bbox_max": [
        -259.02667236328125,
        -2238.0,
        660.0
      ],
      "dimensions_source": {
        "span_x": 117.82049560546875,
        "span_y": 131.800048828125,
        "height_z": 52.0,
        "door_width": 131.800048828125,
        "door_depth": 117.82049560546875,
        "leaf_depth": 117.82049560546875,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -327.6000061035156,
          -2238.0,
          637.0
        ],
        [
          -327.6000061035156,
          -2238.0,
          653.0
        ],
        [
          -308.6000061035156,
          -2238.0,
          653.0
        ],
        [
          -308.6000061035156,
          -2238.0,
          637.0
        ],
        [
          -259.02667236328125,
          -2314.781005859375,
          652.0
        ],
        [
          -263.61895751953125,
          -2325.867431640625,
          652.0
        ],
        [
          -263.61895751953125,
          -2325.867431640625,
          638.0
        ],
        [
          -259.02667236328125,
          -2314.781005859375,
          638.0
        ],
        [
          -376.84716796875,
          -2285.141845703125,
          630.0
        ],
        [
          -376.84716796875,
          -2285.141845703125,
          660.0
        ],
        [
          -367.88818359375,
          -2263.512939453125,
          660.0
        ],
        [
          -367.88818359375,
          -2263.512939453125,
          630.0
        ],
        [
          -367.88818359375,
          -2263.512939453125,
          630.0
        ],
        [
          -367.88818359375,
          -2263.512939453125,
          660.0
        ],
        [
          -351.334228515625,
          -2246.958984375,
          660.0
        ],
        [
          -351.334228515625,
          -2246.958984375,
          630.0
        ],
        [
          -284.665771484375,
          -2246.958984375,
          630.0
        ],
        [
          -284.665771484375,
          -2246.958984375,
          660.0
        ],
        [
          -268.11181640625,
          -2263.512939453125,
          660.0
        ],
        [
          -268.11181640625,
          -2263.512939453125,
          630.0
        ],
        [
          -268.11181640625,
          -2263.512939453125,
          630.0
        ],
        [
          -268.11181640625,
          -2263.512939453125,
          660.0
        ],
        [
          -259.15283203125,
          -2285.141845703125,
          660.0
        ],
        [
          -259.15283203125,
          -2285.141845703125,
          630.0
        ],
        [
          -284.665771484375,
          -2346.7353515625,
          630.0
        ],
        [
          -284.665771484375,
          -2346.7353515625,
          660.0
        ],
        [
          -306.300048828125,
          -2355.699951171875,
          660.0
        ],
        [
          -306.300048828125,
          -2355.699951171875,
          630.0
        ],
        [
          -306.300048828125,
          -2355.699951171875,
          630.0
        ],
        [
          -306.300048828125,
          -2355.699951171875,
          660.0
        ],
        [
          -329.699951171875,
          -2355.699951171875,
          660.0
        ],
        [
          -329.699951171875,
          -2355.699951171875,
          630.0
        ],
        [
          -329.699951171875,
          -2355.699951171875,
          630.0
        ],
        [
          -329.699951171875,
          -2355.699951171875,
          660.0
        ],
        [
          -351.334228515625,
          -2346.7353515625,
          660.0
        ],
        [
          -351.334228515625,
          -2346.7353515625,
          630.0
        ],
        [
          -329.79998779296875,
          -2369.800048828125,
          608.0
        ],
        [
          -306.3999938964844,
          -2369.800048828125,
          608.0
        ],
        [
          -306.3999938964844,
          -2369.800048828125,
          618.0
        ],
        [
          -329.79998779296875,
          -2369.800048828125,
          618.0
        ]
      ],
      "plane_distance": -2238.0
    },
    {
      "tag": "CSlidingDoor piece: cdr5",
      "entity_class": "CSlidingDoor",
      "piece_name": "cdr5",
      "offset": 8868,
      "centroid": [
        -401.5,
        -2326.0,
        641.75
      ],
      "bbox_min": [
        -402.20001220703125,
        -2333.5,
        637.0
      ],
      "bbox_max": [
        -400.79998779296875,
        -2318.5,
        646.5
      ],
      "dimensions_source": {
        "span_x": 1.4000244140625,
        "span_y": 15.0,
        "height_z": 9.5,
        "door_width": 15.0,
        "door_depth": 1.4000244140625,
        "leaf_depth": 1.3600244140625,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -402.20001220703125,
          -2333.5,
          637.0
        ],
        [
          -400.79998779296875,
          -2333.5,
          646.5
        ],
        [
          -400.79998779296875,
          -2333.5,
          637.0
        ],
        [
          -402.20001220703125,
          -2333.5,
          646.5
        ],
        [
          -402.20001220703125,
          -2318.5,
          637.0
        ],
        [
          -400.79998779296875,
          -2318.5,
          646.5
        ],
        [
          -400.79998779296875,
          -2318.5,
          637.0
        ],
        [
          -402.20001220703125,
          -2318.5,
          646.5
        ]
      ],
      "plane_distance": 637.0,
      "authentic_texture": "chkptdoor1"
    },
    {
      "tag": "CSlidingDoor piece: elev1dr1",
      "entity_class": "CSlidingDoor",
      "piece_name": "elev1dr1",
      "offset": 10011,
      "centroid": [
        -436.0,
        -2296.800048828125,
        652.2000122070312
      ],
      "bbox_min": [
        -436.6000061035156,
        -2302.60009765625,
        648.0
      ],
      "bbox_max": [
        -435.3999938964844,
        -2291.0,
        656.4000244140625
      ],
      "dimensions_source": {
        "span_x": 1.20001220703125,
        "span_y": 11.60009765625,
        "height_z": 8.4000244140625,
        "door_width": 11.60009765625,
        "door_depth": 1.20001220703125,
        "leaf_depth": 1.16001220703125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -436.6000061035156,
          -2302.60009765625,
          648.0
        ],
        [
          -436.6000061035156,
          -2302.60009765625,
          656.4000244140625
        ],
        [
          -435.3999938964844,
          -2302.60009765625,
          648.0
        ],
        [
          -435.3999938964844,
          -2302.60009765625,
          656.4000244140625
        ],
        [
          -436.6000061035156,
          -2291.0,
          648.0
        ],
        [
          -436.6000061035156,
          -2291.0,
          656.4000244140625
        ],
        [
          -435.3999938964844,
          -2291.0,
          648.0
        ],
        [
          -435.3999938964844,
          -2291.0,
          656.4000244140625
        ]
      ],
      "plane_distance": 648.0,
      "authentic_texture": "chkptdoor1"
    },
    {
      "tag": "CSlidingDoor piece: elev1dr2",
      "entity_class": "CSlidingDoor",
      "piece_name": "elev1dr2",
      "offset": 11168,
      "centroid": [
        -436.0,
        -2296.800048828125,
        716.4000244140625
      ],
      "bbox_min": [
        -436.6000061035156,
        -2302.60009765625,
        712.2000122070312
      ],
      "bbox_max": [
        -435.3999938964844,
        -2291.0,
        720.6000366210938
      ],
      "dimensions_source": {
        "span_x": 1.20001220703125,
        "span_y": 11.60009765625,
        "height_z": 8.4000244140625,
        "door_width": 11.60009765625,
        "door_depth": 1.20001220703125,
        "leaf_depth": 1.16001220703125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -436.6000061035156,
          -2302.60009765625,
          712.2000122070312
        ],
        [
          -436.6000061035156,
          -2302.60009765625,
          720.6000366210938
        ],
        [
          -435.3999938964844,
          -2302.60009765625,
          712.2000122070312
        ],
        [
          -435.3999938964844,
          -2302.60009765625,
          720.6000366210938
        ],
        [
          -436.6000061035156,
          -2291.0,
          712.2000122070312
        ],
        [
          -436.6000061035156,
          -2291.0,
          720.6000366210938
        ],
        [
          -435.3999938964844,
          -2291.0,
          712.2000122070312
        ],
        [
          -435.3999938964844,
          -2291.0,
          720.6000366210938
        ]
      ],
      "plane_distance": 712.2,
      "authentic_texture": "chkptdoor1"
    },
    {
      "tag": "CSlidingDoor piece: cdr6",
      "entity_class": "CSlidingDoor",
      "piece_name": "cdr6",
      "offset": 14126,
      "centroid": [
        -397.29998779296875,
        -2296.92724609375,
        717.0
      ],
      "bbox_min": [
        -397.79998779296875,
        -2299.8544921875,
        713.0
      ],
      "bbox_max": [
        -396.79998779296875,
        -2294.0,
        721.0
      ],
      "dimensions_source": {
        "span_x": 1.0,
        "span_y": 5.8544921875,
        "height_z": 8.0,
        "door_width": 5.8544921875,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -397.79998779296875,
          -2299.8544921875,
          713.0
        ],
        [
          -397.79998779296875,
          -2294.0,
          721.0
        ],
        [
          -397.79998779296875,
          -2299.8544921875,
          721.0
        ],
        [
          -397.79998779296875,
          -2294.0,
          713.0
        ],
        [
          -396.79998779296875,
          -2299.8544921875,
          713.0
        ],
        [
          -396.79998779296875,
          -2294.0,
          721.0
        ],
        [
          -396.79998779296875,
          -2299.8544921875,
          721.0
        ],
        [
          -396.79998779296875,
          -2294.0,
          713.0
        ]
      ],
      "plane_distance": -397.8,
      "authentic_texture": "spkdoor1nkd"
    }
  ],
  "tutorial_messages": []
}